var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/api/resources/admin/types/AuthType.ts
var AuthType;
var init_AuthType = __esm({
  "src/api/resources/admin/types/AuthType.ts"() {
    "use strict";
    AuthType = {
      Public: "public",
      Password: "password",
      Email: "email",
      App: "app"
    };
  }
});

// src/api/resources/admin/types/LogoInputType.ts
var init_LogoInputType = __esm({
  "src/api/resources/admin/types/LogoInputType.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/LimitExceededErrorBody.ts
var init_LimitExceededErrorBody = __esm({
  "src/api/resources/admin/types/LimitExceededErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/HostingInfo.ts
var init_HostingInfo = __esm({
  "src/api/resources/admin/types/HostingInfo.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/HostingDetails.ts
var HostingDetails;
var init_HostingDetails = __esm({
  "src/api/resources/admin/types/HostingDetails.ts"() {
    "use strict";
    init_src();
    HostingDetails = {
      applicationAuthLogin: (value) => {
        return {
          ...value,
          type: "application_auth_login",
          _visit: function(visitor) {
            return api_exports.HostingDetails._visit(this, visitor);
          }
        };
      },
      emailLogin: (value) => {
        return {
          ...value,
          type: "email_login",
          _visit: function(visitor) {
            return api_exports.HostingDetails._visit(this, visitor);
          }
        };
      },
      passwordLogin: (value) => {
        return {
          ...value,
          type: "password_login",
          _visit: function(visitor) {
            return api_exports.HostingDetails._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.HostingDetails._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.type) {
          case "application_auth_login":
            return visitor.applicationAuthLogin(value);
          case "email_login":
            return visitor.emailLogin(value);
          case "password_login":
            return visitor.passwordLogin(value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/types/PasswordLogin.ts
var init_PasswordLogin = __esm({
  "src/api/resources/admin/types/PasswordLogin.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/ApplicationAuthLogin.ts
var init_ApplicationAuthLogin = __esm({
  "src/api/resources/admin/types/ApplicationAuthLogin.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/EmailLogin.ts
var init_EmailLogin = __esm({
  "src/api/resources/admin/types/EmailLogin.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/VideoUsageEvent.ts
var init_VideoUsageEvent = __esm({
  "src/api/resources/admin/types/VideoUsageEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/ArticleUsageEvent.ts
var init_ArticleUsageEvent = __esm({
  "src/api/resources/admin/types/ArticleUsageEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/GetUsageRequest.ts
var init_GetUsageRequest = __esm({
  "src/api/resources/admin/types/GetUsageRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/GetVideoUsageResponse.ts
var init_GetVideoUsageResponse = __esm({
  "src/api/resources/admin/types/GetVideoUsageResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/GetArticleUsageResponse.ts
var init_GetArticleUsageResponse = __esm({
  "src/api/resources/admin/types/GetArticleUsageResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchAuthTypeRequest.ts
var init_FetchAuthTypeRequest = __esm({
  "src/api/resources/admin/types/FetchAuthTypeRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchAuthTypeResponse.ts
var init_FetchAuthTypeResponse = __esm({
  "src/api/resources/admin/types/FetchAuthTypeResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/SetAuthTypeRequest.ts
var init_SetAuthTypeRequest = __esm({
  "src/api/resources/admin/types/SetAuthTypeRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchPasswordAuthDetailsRequest.ts
var init_FetchPasswordAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/FetchPasswordAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchPasswordAuthDetailsResponse.ts
var init_FetchPasswordAuthDetailsResponse = __esm({
  "src/api/resources/admin/types/FetchPasswordAuthDetailsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/SetPasswordAuthDetailsRequest.ts
var init_SetPasswordAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/SetPasswordAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchAppAuthDetailsRequest.ts
var init_FetchAppAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/FetchAppAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchAppAuthDetailsResponse.ts
var init_FetchAppAuthDetailsResponse = __esm({
  "src/api/resources/admin/types/FetchAppAuthDetailsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/SetAppAuthDetailsRequest.ts
var init_SetAppAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/SetAppAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchEmailAuthDetailsRequest.ts
var init_FetchEmailAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/FetchEmailAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/FetchEmailAuthDetailsResponse.ts
var init_FetchEmailAuthDetailsResponse = __esm({
  "src/api/resources/admin/types/FetchEmailAuthDetailsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/SetEmailAuthDetailsRequest.ts
var init_SetEmailAuthDetailsRequest = __esm({
  "src/api/resources/admin/types/SetEmailAuthDetailsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/types/index.ts
var init_types = __esm({
  "src/api/resources/admin/types/index.ts"() {
    "use strict";
    init_AuthType();
    init_LogoInputType();
    init_LimitExceededErrorBody();
    init_HostingInfo();
    init_HostingDetails();
    init_PasswordLogin();
    init_ApplicationAuthLogin();
    init_EmailLogin();
    init_VideoUsageEvent();
    init_ArticleUsageEvent();
    init_GetUsageRequest();
    init_GetVideoUsageResponse();
    init_GetArticleUsageResponse();
    init_FetchAuthTypeRequest();
    init_FetchAuthTypeResponse();
    init_SetAuthTypeRequest();
    init_FetchPasswordAuthDetailsRequest();
    init_FetchPasswordAuthDetailsResponse();
    init_SetPasswordAuthDetailsRequest();
    init_FetchAppAuthDetailsRequest();
    init_FetchAppAuthDetailsResponse();
    init_SetAppAuthDetailsRequest();
    init_FetchEmailAuthDetailsRequest();
    init_FetchEmailAuthDetailsResponse();
    init_SetEmailAuthDetailsRequest();
  }
});

// src/api/resources/admin/client/requests/index.ts
var init_requests = __esm({
  "src/api/resources/admin/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/admin/client/getStagingJwt.ts
var getStagingJwt_exports = {};
__export(getStagingJwt_exports, {
  Error: () => Error2
});
var Error2;
var init_getStagingJwt = __esm({
  "src/api/resources/admin/client/getStagingJwt.ts"() {
    "use strict";
    init_src();
    Error2 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getStagingJwt.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getStagingJwt.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getStagingJwt.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getStagingJwt.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/createUser.ts
var createUser_exports = {};
__export(createUser_exports, {
  Error: () => Error3
});
var Error3;
var init_createUser = __esm({
  "src/api/resources/admin/client/createUser.ts"() {
    "use strict";
    init_src();
    Error3 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      limitExceededError: (value) => {
        return {
          content: value,
          error: "LimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      userAlreadyExistsError: () => {
        return {
          error: "UserAlreadyExistsError",
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.createUser.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "LimitExceededError":
            return visitor.limitExceededError(value.content);
          case "UserAlreadyExistsError":
            return visitor.userAlreadyExistsError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/deleteUser.ts
var deleteUser_exports = {};
__export(deleteUser_exports, {
  Error: () => Error4
});
var Error4;
var init_deleteUser = __esm({
  "src/api/resources/admin/client/deleteUser.ts"() {
    "use strict";
    init_src();
    Error4 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.deleteUser.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.deleteUser.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.deleteUser.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.deleteUser.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/getUsers.ts
var getUsers_exports = {};
__export(getUsers_exports, {
  Error: () => Error5
});
var Error5;
var init_getUsers = __esm({
  "src/api/resources/admin/client/getUsers.ts"() {
    "use strict";
    init_src();
    Error5 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsers.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getUsers.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsers.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getUsers.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/getHelpCenterConfig.ts
var getHelpCenterConfig_exports = {};
__export(getHelpCenterConfig_exports, {
  Error: () => Error6
});
var Error6;
var init_getHelpCenterConfig = __esm({
  "src/api/resources/admin/client/getHelpCenterConfig.ts"() {
    "use strict";
    init_src();
    Error6 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setHelpCenterConfig.ts
var setHelpCenterConfig_exports = {};
__export(setHelpCenterConfig_exports, {
  Error: () => Error7
});
var Error7;
var init_setHelpCenterConfig = __esm({
  "src/api/resources/admin/client/setHelpCenterConfig.ts"() {
    "use strict";
    init_src();
    Error7 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setHelpCenterConfig.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setLogo.ts
var setLogo_exports = {};
__export(setLogo_exports, {
  Error: () => Error8
});
var Error8;
var init_setLogo = __esm({
  "src/api/resources/admin/client/setLogo.ts"() {
    "use strict";
    init_src();
    Error8 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setLogo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setLogo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setLogo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setLogo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setFavicon.ts
var setFavicon_exports = {};
__export(setFavicon_exports, {
  Error: () => Error9
});
var Error9;
var init_setFavicon = __esm({
  "src/api/resources/admin/client/setFavicon.ts"() {
    "use strict";
    init_src();
    Error9 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setFavicon.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setFavicon.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setFavicon.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setFavicon.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/getHostingDetails.ts
var getHostingDetails_exports = {};
__export(getHostingDetails_exports, {
  Error: () => Error10
});
var Error10;
var init_getHostingDetails = __esm({
  "src/api/resources/admin/client/getHostingDetails.ts"() {
    "use strict";
    init_src();
    Error10 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setHostingDetails.ts
var setHostingDetails_exports = {};
__export(setHostingDetails_exports, {
  Error: () => Error11
});
var Error11;
var init_setHostingDetails = __esm({
  "src/api/resources/admin/client/setHostingDetails.ts"() {
    "use strict";
    init_src();
    Error11 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setHostingDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/fetchAuthType.ts
var fetchAuthType_exports = {};
__export(fetchAuthType_exports, {
  Error: () => Error12
});
var Error12;
var init_fetchAuthType = __esm({
  "src/api/resources/admin/client/fetchAuthType.ts"() {
    "use strict";
    init_src();
    Error12 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAuthType.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAuthType.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAuthType.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAuthType.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.fetchAuthType.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setAuthType.ts
var setAuthType_exports = {};
__export(setAuthType_exports, {
  Error: () => Error13
});
var Error13;
var init_setAuthType = __esm({
  "src/api/resources/admin/client/setAuthType.ts"() {
    "use strict";
    init_src();
    Error13 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setAuthType.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.setAuthType.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setAuthType.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setAuthType.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setAuthType.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/fetchPasswordAuthDetails.ts
var fetchPasswordAuthDetails_exports = {};
__export(fetchPasswordAuthDetails_exports, {
  Error: () => Error14
});
var Error14;
var init_fetchPasswordAuthDetails = __esm({
  "src/api/resources/admin/client/fetchPasswordAuthDetails.ts"() {
    "use strict";
    init_src();
    Error14 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.fetchPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.fetchPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setPasswordAuthDetails.ts
var setPasswordAuthDetails_exports = {};
__export(setPasswordAuthDetails_exports, {
  Error: () => Error15
});
var Error15;
var init_setPasswordAuthDetails = __esm({
  "src/api/resources/admin/client/setPasswordAuthDetails.ts"() {
    "use strict";
    init_src();
    Error15 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.setPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setPasswordAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/fetchAppAuthDetails.ts
var fetchAppAuthDetails_exports = {};
__export(fetchAppAuthDetails_exports, {
  Error: () => Error16
});
var Error16;
var init_fetchAppAuthDetails = __esm({
  "src/api/resources/admin/client/fetchAppAuthDetails.ts"() {
    "use strict";
    init_src();
    Error16 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.fetchAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setAppAuthDetails.ts
var setAppAuthDetails_exports = {};
__export(setAppAuthDetails_exports, {
  Error: () => Error17
});
var Error17;
var init_setAppAuthDetails = __esm({
  "src/api/resources/admin/client/setAppAuthDetails.ts"() {
    "use strict";
    init_src();
    Error17 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.setAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setAppAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/fetchEmailAuthDetails.ts
var fetchEmailAuthDetails_exports = {};
__export(fetchEmailAuthDetails_exports, {
  Error: () => Error18
});
var Error18;
var init_fetchEmailAuthDetails = __esm({
  "src/api/resources/admin/client/fetchEmailAuthDetails.ts"() {
    "use strict";
    init_src();
    Error18 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.fetchEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.fetchEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.fetchEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/setEmailAuthDetails.ts
var setEmailAuthDetails_exports = {};
__export(setEmailAuthDetails_exports, {
  Error: () => Error19
});
var Error19;
var init_setEmailAuthDetails = __esm({
  "src/api/resources/admin/client/setEmailAuthDetails.ts"() {
    "use strict";
    init_src();
    Error19 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.setEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.admin.setEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.setEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.setEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.setEmailAuthDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/getUsageVideo.ts
var getUsageVideo_exports = {};
__export(getUsageVideo_exports, {
  Error: () => Error20
});
var Error20;
var init_getUsageVideo = __esm({
  "src/api/resources/admin/client/getUsageVideo.ts"() {
    "use strict";
    init_src();
    Error20 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageVideo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageVideo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getUsageVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/getUsageArticle.ts
var getUsageArticle_exports = {};
__export(getUsageArticle_exports, {
  Error: () => Error21
});
var Error21;
var init_getUsageArticle = __esm({
  "src/api/resources/admin/client/getUsageArticle.ts"() {
    "use strict";
    init_src();
    Error21 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageArticle.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageArticle.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.admin.getUsageArticle.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.admin.getUsageArticle.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/admin/client/index.ts
var init_client = __esm({
  "src/api/resources/admin/client/index.ts"() {
    "use strict";
    init_requests();
    init_getStagingJwt();
    init_createUser();
    init_deleteUser();
    init_getUsers();
    init_getHelpCenterConfig();
    init_setHelpCenterConfig();
    init_setLogo();
    init_setFavicon();
    init_getHostingDetails();
    init_setHostingDetails();
    init_fetchAuthType();
    init_setAuthType();
    init_fetchPasswordAuthDetails();
    init_setPasswordAuthDetails();
    init_fetchAppAuthDetails();
    init_setAppAuthDetails();
    init_fetchEmailAuthDetails();
    init_setEmailAuthDetails();
    init_getUsageVideo();
    init_getUsageArticle();
  }
});

// src/api/resources/admin/index.ts
var admin_exports = {};
__export(admin_exports, {
  AuthType: () => AuthType,
  HostingDetails: () => HostingDetails,
  createUser: () => createUser_exports,
  deleteUser: () => deleteUser_exports,
  fetchAppAuthDetails: () => fetchAppAuthDetails_exports,
  fetchAuthType: () => fetchAuthType_exports,
  fetchEmailAuthDetails: () => fetchEmailAuthDetails_exports,
  fetchPasswordAuthDetails: () => fetchPasswordAuthDetails_exports,
  getHelpCenterConfig: () => getHelpCenterConfig_exports,
  getHostingDetails: () => getHostingDetails_exports,
  getStagingJwt: () => getStagingJwt_exports,
  getUsageArticle: () => getUsageArticle_exports,
  getUsageVideo: () => getUsageVideo_exports,
  getUsers: () => getUsers_exports,
  setAppAuthDetails: () => setAppAuthDetails_exports,
  setAuthType: () => setAuthType_exports,
  setEmailAuthDetails: () => setEmailAuthDetails_exports,
  setFavicon: () => setFavicon_exports,
  setHelpCenterConfig: () => setHelpCenterConfig_exports,
  setHostingDetails: () => setHostingDetails_exports,
  setLogo: () => setLogo_exports,
  setPasswordAuthDetails: () => setPasswordAuthDetails_exports
});
var init_admin = __esm({
  "src/api/resources/admin/index.ts"() {
    "use strict";
    init_types();
    init_client();
  }
});

// src/api/resources/analytics/types/EventsResponse.ts
var init_EventsResponse = __esm({
  "src/api/resources/analytics/types/EventsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/BaseResponse.ts
var init_BaseResponse = __esm({
  "src/api/resources/analytics/types/BaseResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ProjectAnalyticsTableResponse.ts
var init_ProjectAnalyticsTableResponse = __esm({
  "src/api/resources/analytics/types/ProjectAnalyticsTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ProjectAnalyticsTableResponseData.ts
var init_ProjectAnalyticsTableResponseData = __esm({
  "src/api/resources/analytics/types/ProjectAnalyticsTableResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ProjectRatingsTableResponse.ts
var init_ProjectRatingsTableResponse = __esm({
  "src/api/resources/analytics/types/ProjectRatingsTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ProjectRatingsTableResponseData.ts
var init_ProjectRatingsTableResponseData = __esm({
  "src/api/resources/analytics/types/ProjectRatingsTableResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/FeedbacksTableResponse.ts
var init_FeedbacksTableResponse = __esm({
  "src/api/resources/analytics/types/FeedbacksTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/FeedbacksTableResponseData.ts
var init_FeedbacksTableResponseData = __esm({
  "src/api/resources/analytics/types/FeedbacksTableResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/SearchAnalyticsTableResponse.ts
var init_SearchAnalyticsTableResponse = __esm({
  "src/api/resources/analytics/types/SearchAnalyticsTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/SearchAnalyticsTableResponseData.ts
var init_SearchAnalyticsTableResponseData = __esm({
  "src/api/resources/analytics/types/SearchAnalyticsTableResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/VideoAnalyticsTableResponse.ts
var init_VideoAnalyticsTableResponse = __esm({
  "src/api/resources/analytics/types/VideoAnalyticsTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ProjectsOpenedStackedBarGraphResponse.ts
var init_ProjectsOpenedStackedBarGraphResponse = __esm({
  "src/api/resources/analytics/types/ProjectsOpenedStackedBarGraphResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/VideosPlayedStackedBarGraphResponse.ts
var init_VideosPlayedStackedBarGraphResponse = __esm({
  "src/api/resources/analytics/types/VideosPlayedStackedBarGraphResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/GuidesTableResponse.ts
var init_GuidesTableResponse = __esm({
  "src/api/resources/analytics/types/GuidesTableResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/GuidesTableResponseData.ts
var init_GuidesTableResponseData = __esm({
  "src/api/resources/analytics/types/GuidesTableResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ImpressionsLineChartResponse.ts
var init_ImpressionsLineChartResponse = __esm({
  "src/api/resources/analytics/types/ImpressionsLineChartResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ImpressionsLineChartResponseData.ts
var init_ImpressionsLineChartResponseData = __esm({
  "src/api/resources/analytics/types/ImpressionsLineChartResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/VideoPlaysLineChartResponse.ts
var init_VideoPlaysLineChartResponse = __esm({
  "src/api/resources/analytics/types/VideoPlaysLineChartResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/VideoPlaysLineChartResponseData.ts
var init_VideoPlaysLineChartResponseData = __esm({
  "src/api/resources/analytics/types/VideoPlaysLineChartResponseData.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/index.ts
var init_types2 = __esm({
  "src/api/resources/analytics/types/index.ts"() {
    "use strict";
    init_EventsResponse();
    init_BaseResponse();
    init_ProjectAnalyticsTableResponse();
    init_ProjectAnalyticsTableResponseData();
    init_ProjectRatingsTableResponse();
    init_ProjectRatingsTableResponseData();
    init_FeedbacksTableResponse();
    init_FeedbacksTableResponseData();
    init_SearchAnalyticsTableResponse();
    init_SearchAnalyticsTableResponseData();
    init_VideoAnalyticsTableResponse();
    init_ProjectsOpenedStackedBarGraphResponse();
    init_VideosPlayedStackedBarGraphResponse();
    init_GuidesTableResponse();
    init_GuidesTableResponseData();
    init_ImpressionsLineChartResponse();
    init_ImpressionsLineChartResponseData();
    init_VideoPlaysLineChartResponse();
    init_VideoPlaysLineChartResponseData();
  }
});

// src/api/resources/analytics/client/requests/index.ts
var init_requests2 = __esm({
  "src/api/resources/analytics/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/client/getEventData.ts
var getEventData_exports = {};
__export(getEventData_exports, {
  Error: () => Error22
});
var Error22;
var init_getEventData = __esm({
  "src/api/resources/analytics/client/getEventData.ts"() {
    "use strict";
    init_src();
    Error22 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/analytics/client/index.ts
var init_client2 = __esm({
  "src/api/resources/analytics/client/index.ts"() {
    "use strict";
    init_requests2();
    init_getEventData();
  }
});

// src/api/resources/analytics/index.ts
var analytics_exports = {};
__export(analytics_exports, {
  getEventData: () => getEventData_exports
});
var init_analytics = __esm({
  "src/api/resources/analytics/index.ts"() {
    "use strict";
    init_types2();
    init_client2();
  }
});

// src/api/resources/audio/types/Transcript.ts
var init_Transcript = __esm({
  "src/api/resources/audio/types/Transcript.ts"() {
    "use strict";
  }
});

// src/api/resources/audio/types/SaveGuideAudioRequest.ts
var init_SaveGuideAudioRequest = __esm({
  "src/api/resources/audio/types/SaveGuideAudioRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/audio/types/InitiateBackgroundAudioUploadResponse.ts
var init_InitiateBackgroundAudioUploadResponse = __esm({
  "src/api/resources/audio/types/InitiateBackgroundAudioUploadResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/audio/types/index.ts
var init_types3 = __esm({
  "src/api/resources/audio/types/index.ts"() {
    "use strict";
    init_Transcript();
    init_SaveGuideAudioRequest();
    init_InitiateBackgroundAudioUploadResponse();
  }
});

// src/api/resources/audio/client/initiateBackgroundAudioUpload.ts
var initiateBackgroundAudioUpload_exports = {};
__export(initiateBackgroundAudioUpload_exports, {
  Error: () => Error23
});
var Error23;
var init_initiateBackgroundAudioUpload = __esm({
  "src/api/resources/audio/client/initiateBackgroundAudioUpload.ts"() {
    "use strict";
    init_src();
    Error23 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.initiateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.initiateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.initiateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.initiateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/finishCreateBackgroundAudioUpload.ts
var finishCreateBackgroundAudioUpload_exports = {};
__export(finishCreateBackgroundAudioUpload_exports, {
  Error: () => Error24
});
var Error24;
var init_finishCreateBackgroundAudioUpload = __esm({
  "src/api/resources/audio/client/finishCreateBackgroundAudioUpload.ts"() {
    "use strict";
    init_src();
    Error24 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/deleteAudio.ts
var deleteAudio_exports = {};
__export(deleteAudio_exports, {
  Error: () => Error25
});
var Error25;
var init_deleteAudio = __esm({
  "src/api/resources/audio/client/deleteAudio.ts"() {
    "use strict";
    init_src();
    Error25 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.deleteAudio.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.deleteAudio.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.deleteAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.deleteAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/favoriteAudio.ts
var favoriteAudio_exports = {};
__export(favoriteAudio_exports, {
  Error: () => Error26
});
var Error26;
var init_favoriteAudio = __esm({
  "src/api/resources/audio/client/favoriteAudio.ts"() {
    "use strict";
    init_src();
    Error26 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.favoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      existsInFavoritesError: () => {
        return {
          error: "ExistsInFavoritesError",
          _visit: function(visitor) {
            return api_exports.audio.favoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.favoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.favoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.favoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "ExistsInFavoritesError":
            return visitor.existsInFavoritesError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/unfavoriteAudio.ts
var unfavoriteAudio_exports = {};
__export(unfavoriteAudio_exports, {
  Error: () => Error27
});
var Error27;
var init_unfavoriteAudio = __esm({
  "src/api/resources/audio/client/unfavoriteAudio.ts"() {
    "use strict";
    init_src();
    Error27 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.unfavoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.unfavoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.unfavoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.unfavoriteAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/saveAudio.ts
var saveAudio_exports = {};
__export(saveAudio_exports, {
  Error: () => Error28
});
var Error28;
var init_saveAudio = __esm({
  "src/api/resources/audio/client/saveAudio.ts"() {
    "use strict";
    init_src();
    Error28 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/saveGuideAudio.ts
var saveGuideAudio_exports = {};
__export(saveGuideAudio_exports, {
  Error: () => Error29
});
var Error29;
var init_saveGuideAudio = __esm({
  "src/api/resources/audio/client/saveGuideAudio.ts"() {
    "use strict";
    init_src();
    Error29 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/saveGuideAudioUpdated.ts
var saveGuideAudioUpdated_exports = {};
__export(saveGuideAudioUpdated_exports, {
  Error: () => Error30
});
var Error30;
var init_saveGuideAudioUpdated = __esm({
  "src/api/resources/audio/client/saveGuideAudioUpdated.ts"() {
    "use strict";
    init_src();
    Error30 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudioUpdated.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudioUpdated.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudioUpdated.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudioUpdated.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/index.ts
var init_client3 = __esm({
  "src/api/resources/audio/client/index.ts"() {
    "use strict";
    init_initiateBackgroundAudioUpload();
    init_finishCreateBackgroundAudioUpload();
    init_deleteAudio();
    init_favoriteAudio();
    init_unfavoriteAudio();
    init_saveAudio();
    init_saveGuideAudio();
    init_saveGuideAudioUpdated();
  }
});

// src/api/resources/audio/index.ts
var audio_exports = {};
__export(audio_exports, {
  deleteAudio: () => deleteAudio_exports,
  favoriteAudio: () => favoriteAudio_exports,
  finishCreateBackgroundAudioUpload: () => finishCreateBackgroundAudioUpload_exports,
  initiateBackgroundAudioUpload: () => initiateBackgroundAudioUpload_exports,
  saveAudio: () => saveAudio_exports,
  saveGuideAudio: () => saveGuideAudio_exports,
  saveGuideAudioUpdated: () => saveGuideAudioUpdated_exports,
  unfavoriteAudio: () => unfavoriteAudio_exports
});
var init_audio = __esm({
  "src/api/resources/audio/index.ts"() {
    "use strict";
    init_types3();
    init_client3();
  }
});

// src/api/resources/auth/types/CreateUserRequest.ts
var init_CreateUserRequest = __esm({
  "src/api/resources/auth/types/CreateUserRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/UpdateUserRequest.ts
var init_UpdateUserRequest = __esm({
  "src/api/resources/auth/types/UpdateUserRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/UserInOrg.ts
var init_UserInOrg = __esm({
  "src/api/resources/auth/types/UserInOrg.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/AuthenticatedUser.ts
var init_AuthenticatedUser = __esm({
  "src/api/resources/auth/types/AuthenticatedUser.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/AuthenticatedUserWithOrg.ts
var init_AuthenticatedUserWithOrg = __esm({
  "src/api/resources/auth/types/AuthenticatedUserWithOrg.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/UpdateUserRoleRequest.ts
var init_UpdateUserRoleRequest = __esm({
  "src/api/resources/auth/types/UpdateUserRoleRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/types/Role.ts
var Role;
var init_Role = __esm({
  "src/api/resources/auth/types/Role.ts"() {
    "use strict";
    Role = {
      Admin: "admin",
      Editor: "editor",
      Viewer: "viewer"
    };
  }
});

// src/api/resources/auth/types/index.ts
var init_types4 = __esm({
  "src/api/resources/auth/types/index.ts"() {
    "use strict";
    init_CreateUserRequest();
    init_UpdateUserRequest();
    init_UserInOrg();
    init_AuthenticatedUser();
    init_AuthenticatedUserWithOrg();
    init_UpdateUserRoleRequest();
    init_Role();
  }
});

// src/api/resources/auth/client/requests/index.ts
var init_requests3 = __esm({
  "src/api/resources/auth/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/auth/client/createUserWebhook.ts
var createUserWebhook_exports = {};
__export(createUserWebhook_exports, {
  Error: () => Error31
});
var Error31;
var init_createUserWebhook = __esm({
  "src/api/resources/auth/client/createUserWebhook.ts"() {
    "use strict";
    init_src();
    Error31 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      userEntryAlreadyExistsError: () => {
        return {
          error: "UserEntryAlreadyExistsError",
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      invalidEventTypeForWebhookError: () => {
        return {
          error: "InvalidEventTypeForWebhookError",
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.auth.createUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UserEntryAlreadyExistsError":
            return visitor.userEntryAlreadyExistsError();
          case "InvalidEventTypeForWebhookError":
            return visitor.invalidEventTypeForWebhookError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/auth/client/updateUserWebhook.ts
var updateUserWebhook_exports = {};
__export(updateUserWebhook_exports, {
  Error: () => Error32
});
var Error32;
var init_updateUserWebhook = __esm({
  "src/api/resources/auth/client/updateUserWebhook.ts"() {
    "use strict";
    init_src();
    Error32 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      userEntryAlreadyExistsError: () => {
        return {
          error: "UserEntryAlreadyExistsError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      invalidEventTypeForWebhookError: () => {
        return {
          error: "InvalidEventTypeForWebhookError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.auth.updateUserWebhook.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UserEntryAlreadyExistsError":
            return visitor.userEntryAlreadyExistsError();
          case "InvalidEventTypeForWebhookError":
            return visitor.invalidEventTypeForWebhookError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/auth/client/updateUserRoleInOrg.ts
var updateUserRoleInOrg_exports = {};
__export(updateUserRoleInOrg_exports, {
  Error: () => Error33
});
var Error33;
var init_updateUserRoleInOrg = __esm({
  "src/api/resources/auth/client/updateUserRoleInOrg.ts"() {
    "use strict";
    init_src();
    Error33 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserRoleInOrg.Error._visit(this, visitor);
          }
        };
      },
      userNotInOrganizationError: (value) => {
        return {
          content: value,
          error: "UserNotInOrganizationError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserRoleInOrg.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserRoleInOrg.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.auth.updateUserRoleInOrg.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.auth.updateUserRoleInOrg.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UserNotInOrganizationError":
            return visitor.userNotInOrganizationError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/auth/client/index.ts
var init_client4 = __esm({
  "src/api/resources/auth/client/index.ts"() {
    "use strict";
    init_requests3();
    init_createUserWebhook();
    init_updateUserWebhook();
    init_updateUserRoleInOrg();
  }
});

// src/api/resources/auth/index.ts
var auth_exports = {};
__export(auth_exports, {
  Role: () => Role,
  createUserWebhook: () => createUserWebhook_exports,
  updateUserRoleInOrg: () => updateUserRoleInOrg_exports,
  updateUserWebhook: () => updateUserWebhook_exports
});
var init_auth = __esm({
  "src/api/resources/auth/index.ts"() {
    "use strict";
    init_types4();
    init_client4();
  }
});

// src/api/resources/baseTypes/types/Id.ts
function Id(value) {
  return value;
}
var init_Id = __esm({
  "src/api/resources/baseTypes/types/Id.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/PresignedUrl.ts
var init_PresignedUrl = __esm({
  "src/api/resources/baseTypes/types/PresignedUrl.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/HelpCenterTab.ts
var init_HelpCenterTab = __esm({
  "src/api/resources/baseTypes/types/HelpCenterTab.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/HelpCenterConfig.ts
var init_HelpCenterConfig = __esm({
  "src/api/resources/baseTypes/types/HelpCenterConfig.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/SimpleResponse.ts
var init_SimpleResponse = __esm({
  "src/api/resources/baseTypes/types/SimpleResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/InitiateUploadResponse.ts
var init_InitiateUploadResponse = __esm({
  "src/api/resources/baseTypes/types/InitiateUploadResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/GetChildrenRequest.ts
var init_GetChildrenRequest = __esm({
  "src/api/resources/baseTypes/types/GetChildrenRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/Coordinates.ts
var init_Coordinates = __esm({
  "src/api/resources/baseTypes/types/Coordinates.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/IdRequest.ts
var init_IdRequest = __esm({
  "src/api/resources/baseTypes/types/IdRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/Token.ts
var init_Token = __esm({
  "src/api/resources/baseTypes/types/Token.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/VideoFormat.ts
var init_VideoFormat = __esm({
  "src/api/resources/baseTypes/types/VideoFormat.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/S3Object.ts
var init_S3Object = __esm({
  "src/api/resources/baseTypes/types/S3Object.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/Language.ts
var init_Language = __esm({
  "src/api/resources/baseTypes/types/Language.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/UsageLimitExceededErrorBody.ts
var init_UsageLimitExceededErrorBody = __esm({
  "src/api/resources/baseTypes/types/UsageLimitExceededErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/index.ts
var init_types5 = __esm({
  "src/api/resources/baseTypes/types/index.ts"() {
    "use strict";
    init_Id();
    init_PresignedUrl();
    init_HelpCenterTab();
    init_HelpCenterConfig();
    init_SimpleResponse();
    init_InitiateUploadResponse();
    init_GetChildrenRequest();
    init_Coordinates();
    init_IdRequest();
    init_Token();
    init_VideoFormat();
    init_S3Object();
    init_Language();
    init_UsageLimitExceededErrorBody();
  }
});

// src/api/resources/baseTypes/index.ts
var baseTypes_exports = {};
__export(baseTypes_exports, {
  Id: () => Id
});
var init_baseTypes = __esm({
  "src/api/resources/baseTypes/index.ts"() {
    "use strict";
    init_types5();
  }
});

// src/api/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts
var init_MoveCollectionRequest = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/types/GetChildGuidesCreationStatusResponse.ts
var init_GetChildGuidesCreationStatusResponse = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/GetChildGuidesCreationStatusResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/types/GuideCreationStatus.ts
var init_GuideCreationStatus = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/GuideCreationStatus.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/types/index.ts
var init_types6 = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/index.ts"() {
    "use strict";
    init_MoveCollectionRequest();
    init_GetChildGuidesCreationStatusResponse();
    init_GuideCreationStatus();
  }
});

// src/api/resources/collections/resources/collectionMutations/client/requests/index.ts
var init_requests4 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/client/createCollection.ts
var createCollection_exports = {};
__export(createCollection_exports, {
  Error: () => Error34
});
var Error34;
var init_createCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/createCollection.ts"() {
    "use strict";
    init_src();
    Error34 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/updateCollection.ts
var updateCollection_exports = {};
__export(updateCollection_exports, {
  Error: () => Error35
});
var Error35;
var init_updateCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/updateCollection.ts"() {
    "use strict";
    init_src();
    Error35 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/moveCollection.ts
var moveCollection_exports = {};
__export(moveCollection_exports, {
  Error: () => Error36
});
var Error36;
var init_moveCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/moveCollection.ts"() {
    "use strict";
    init_src();
    Error36 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/deleteCollection.ts
var deleteCollection_exports = {};
__export(deleteCollection_exports, {
  Error: () => Error37
});
var Error37;
var init_deleteCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/deleteCollection.ts"() {
    "use strict";
    init_src();
    Error37 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/reorderCollection.ts
var reorderCollection_exports = {};
__export(reorderCollection_exports, {
  Error: () => Error38
});
var Error38;
var init_reorderCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/reorderCollection.ts"() {
    "use strict";
    init_src();
    Error38 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts
var setCollectionVisibility_exports = {};
__export(setCollectionVisibility_exports, {
  Error: () => Error39
});
var Error39;
var init_setCollectionVisibility = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts"() {
    "use strict";
    init_src();
    Error39 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/fetchCollectionData.ts
var fetchCollectionData_exports = {};
__export(fetchCollectionData_exports, {
  Error: () => Error40
});
var Error40;
var init_fetchCollectionData = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/fetchCollectionData.ts"() {
    "use strict";
    init_src();
    Error40 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.fetchCollectionData.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.fetchCollectionData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.fetchCollectionData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.fetchCollectionData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.fetchCollectionData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/getChildGuidesCreationStatus.ts
var getChildGuidesCreationStatus_exports = {};
__export(getChildGuidesCreationStatus_exports, {
  Error: () => Error41
});
var Error41;
var init_getChildGuidesCreationStatus = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/getChildGuidesCreationStatus.ts"() {
    "use strict";
    init_src();
    Error41 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/index.ts
var init_client5 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/index.ts"() {
    "use strict";
    init_requests4();
    init_createCollection();
    init_updateCollection();
    init_moveCollection();
    init_deleteCollection();
    init_reorderCollection();
    init_setCollectionVisibility();
    init_fetchCollectionData();
    init_getChildGuidesCreationStatus();
  }
});

// src/api/resources/collections/resources/collectionMutations/index.ts
var collectionMutations_exports = {};
__export(collectionMutations_exports, {
  createCollection: () => createCollection_exports,
  deleteCollection: () => deleteCollection_exports,
  fetchCollectionData: () => fetchCollectionData_exports,
  getChildGuidesCreationStatus: () => getChildGuidesCreationStatus_exports,
  moveCollection: () => moveCollection_exports,
  reorderCollection: () => reorderCollection_exports,
  setCollectionVisibility: () => setCollectionVisibility_exports,
  updateCollection: () => updateCollection_exports
});
var init_collectionMutations = __esm({
  "src/api/resources/collections/resources/collectionMutations/index.ts"() {
    "use strict";
    init_types6();
    init_client5();
  }
});

// src/api/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathRequest.ts
var init_ValidateCollectionUrlPathRequest = __esm({
  "src/api/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathResponse.ts
var init_ValidateCollectionUrlPathResponse = __esm({
  "src/api/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionQueries/types/index.ts
var init_types7 = __esm({
  "src/api/resources/collections/resources/collectionQueries/types/index.ts"() {
    "use strict";
    init_ValidateCollectionUrlPathRequest();
    init_ValidateCollectionUrlPathResponse();
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getCollections.ts
var getCollections_exports = {};
__export(getCollections_exports, {
  Error: () => Error42
});
var Error42;
var init_getCollections = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    Error42 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getAllChildren.ts
var getAllChildren_exports = {};
__export(getAllChildren_exports, {
  Error: () => Error43
});
var Error43;
var init_getAllChildren = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    Error43 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getAllCollections.ts
var getAllCollections_exports = {};
__export(getAllCollections_exports, {
  Error: () => Error44
});
var Error44;
var init_getAllCollections = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    Error44 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getAllActiveCutsCollections.ts
var getAllActiveCutsCollections_exports = {};
__export(getAllActiveCutsCollections_exports, {
  Error: () => Error45
});
var Error45;
var init_getAllActiveCutsCollections = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getAllActiveCutsCollections.ts"() {
    "use strict";
    init_src();
    Error45 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getPath.ts
var getPath_exports = {};
__export(getPath_exports, {
  Error: () => Error46
});
var Error46;
var init_getPath = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    Error46 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/validateCollectionUrlPath.ts
var validateCollectionUrlPath_exports = {};
__export(validateCollectionUrlPath_exports, {
  Error: () => Error47
});
var Error47;
var init_validateCollectionUrlPath = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/validateCollectionUrlPath.ts"() {
    "use strict";
    init_src();
    Error47 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/index.ts
var init_client6 = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/index.ts"() {
    "use strict";
    init_getCollections();
    init_getAllChildren();
    init_getAllCollections();
    init_getAllActiveCutsCollections();
    init_getPath();
    init_validateCollectionUrlPath();
  }
});

// src/api/resources/collections/resources/collectionQueries/index.ts
var collectionQueries_exports = {};
__export(collectionQueries_exports, {
  getAllActiveCutsCollections: () => getAllActiveCutsCollections_exports,
  getAllChildren: () => getAllChildren_exports,
  getAllCollections: () => getAllCollections_exports,
  getCollections: () => getCollections_exports,
  getPath: () => getPath_exports,
  validateCollectionUrlPath: () => validateCollectionUrlPath_exports
});
var init_collectionQueries = __esm({
  "src/api/resources/collections/resources/collectionQueries/index.ts"() {
    "use strict";
    init_types7();
    init_client6();
  }
});

// src/api/resources/collections/resources/collectionTypes/types/CollectionInput.ts
var init_CollectionInput = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/CollectionInput.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/Collection.ts
var init_Collection = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/Collection.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts
var init_GetCollectionsResponse = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts
var init_GetAllChildrenResponse = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/CutsVideoSection.ts
var init_CutsVideoSection = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/CutsVideoSection.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/CutsVideoChapters.ts
var init_CutsVideoChapters = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/CutsVideoChapters.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/SplitsState.ts
var SplitsState;
var init_SplitsState = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/SplitsState.ts"() {
    "use strict";
    SplitsState = {
      Splitting: "splitting",
      SplitsReady: "splits_ready",
      GeneratingGuides: "generating_guides"
    };
  }
});

// src/api/resources/collections/resources/collectionTypes/types/index.ts
var init_types8 = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/index.ts"() {
    "use strict";
    init_CollectionInput();
    init_Collection();
    init_GetCollectionsResponse();
    init_GetAllChildrenResponse();
    init_CutsVideoSection();
    init_CutsVideoChapters();
    init_SplitsState();
  }
});

// src/api/resources/collections/resources/collectionTypes/index.ts
var collectionTypes_exports = {};
__export(collectionTypes_exports, {
  SplitsState: () => SplitsState
});
var init_collectionTypes = __esm({
  "src/api/resources/collections/resources/collectionTypes/index.ts"() {
    "use strict";
    init_types8();
  }
});

// src/api/resources/collections/resources/index.ts
var init_resources = __esm({
  "src/api/resources/collections/resources/index.ts"() {
    "use strict";
    init_collectionMutations();
    init_types6();
    init_collectionQueries();
    init_types7();
    init_collectionTypes();
    init_types8();
    init_requests4();
  }
});

// src/api/resources/collections/client/index.ts
var init_client7 = __esm({
  "src/api/resources/collections/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/index.ts
var collections_exports = {};
__export(collections_exports, {
  SplitsState: () => SplitsState,
  collectionMutations: () => collectionMutations_exports,
  collectionQueries: () => collectionQueries_exports,
  collectionTypes: () => collectionTypes_exports
});
var init_collections = __esm({
  "src/api/resources/collections/index.ts"() {
    "use strict";
    init_resources();
    init_client7();
  }
});

// src/api/resources/elementEdit/types/ElementGeo.ts
var ElementGeo;
var init_ElementGeo = __esm({
  "src/api/resources/elementEdit/types/ElementGeo.ts"() {
    "use strict";
    ElementGeo = {
      Rectangle: "rectangle",
      Blur: "blur",
      Text: "text",
      Image: "image",
      Callout: "callout",
      Arrow: "arrow",
      Spotlight: "spotlight"
    };
  }
});

// src/api/resources/elementEdit/types/ElementEdit.ts
var init_ElementEdit = __esm({
  "src/api/resources/elementEdit/types/ElementEdit.ts"() {
    "use strict";
  }
});

// src/api/resources/elementEdit/types/TextData.ts
var init_TextData = __esm({
  "src/api/resources/elementEdit/types/TextData.ts"() {
    "use strict";
  }
});

// src/api/resources/elementEdit/types/TextAlignment.ts
var TextAlignment;
var init_TextAlignment = __esm({
  "src/api/resources/elementEdit/types/TextAlignment.ts"() {
    "use strict";
    TextAlignment = {
      Left: "left",
      Right: "right",
      Center: "center"
    };
  }
});

// src/api/resources/elementEdit/types/Crop.ts
var init_Crop = __esm({
  "src/api/resources/elementEdit/types/Crop.ts"() {
    "use strict";
  }
});

// src/api/resources/elementEdit/types/ImageType.ts
var ImageType;
var init_ImageType = __esm({
  "src/api/resources/elementEdit/types/ImageType.ts"() {
    "use strict";
    ImageType = {
      Frame: "frame",
      Logo: "logo",
      Upload: "upload"
    };
  }
});

// src/api/resources/elementEdit/types/ShapeData.ts
var init_ShapeData = __esm({
  "src/api/resources/elementEdit/types/ShapeData.ts"() {
    "use strict";
  }
});

// src/api/resources/elementEdit/types/ImageData.ts
var init_ImageData = __esm({
  "src/api/resources/elementEdit/types/ImageData.ts"() {
    "use strict";
  }
});

// src/api/resources/elementEdit/types/index.ts
var init_types9 = __esm({
  "src/api/resources/elementEdit/types/index.ts"() {
    "use strict";
    init_ElementGeo();
    init_ElementEdit();
    init_TextData();
    init_TextAlignment();
    init_Crop();
    init_ImageType();
    init_ShapeData();
    init_ImageData();
  }
});

// src/api/resources/elementEdit/index.ts
var elementEdit_exports = {};
__export(elementEdit_exports, {
  ElementGeo: () => ElementGeo,
  ImageType: () => ImageType,
  TextAlignment: () => TextAlignment
});
var init_elementEdit = __esm({
  "src/api/resources/elementEdit/index.ts"() {
    "use strict";
    init_types9();
  }
});

// src/api/resources/guides/resources/aiEnhance/types/TranslateGuideRequest.ts
var init_TranslateGuideRequest = __esm({
  "src/api/resources/guides/resources/aiEnhance/types/TranslateGuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/aiEnhance/types/EnhanceTextRequest.ts
var init_EnhanceTextRequest = __esm({
  "src/api/resources/guides/resources/aiEnhance/types/EnhanceTextRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/aiEnhance/types/index.ts
var init_types10 = __esm({
  "src/api/resources/guides/resources/aiEnhance/types/index.ts"() {
    "use strict";
    init_TranslateGuideRequest();
    init_EnhanceTextRequest();
  }
});

// src/api/resources/guides/resources/aiEnhance/client/enhanceArticleAsync.ts
var enhanceArticleAsync_exports = {};
__export(enhanceArticleAsync_exports, {
  Error: () => Error48
});
var Error48;
var init_enhanceArticleAsync = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/enhanceArticleAsync.ts"() {
    "use strict";
    init_src();
    Error48 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/aiEnhance/client/enhanceVideoTranscriptAsync.ts
var enhanceVideoTranscriptAsync_exports = {};
__export(enhanceVideoTranscriptAsync_exports, {
  Error: () => Error49
});
var Error49;
var init_enhanceVideoTranscriptAsync = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/enhanceVideoTranscriptAsync.ts"() {
    "use strict";
    init_src();
    Error49 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/aiEnhance/client/translateGuideAndDuplicate.ts
var translateGuideAndDuplicate_exports = {};
__export(translateGuideAndDuplicate_exports, {
  Error: () => Error50
});
var Error50;
var init_translateGuideAndDuplicate = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/translateGuideAndDuplicate.ts"() {
    "use strict";
    init_src();
    Error50 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/aiEnhance/client/inlineEnhanceText.ts
var inlineEnhanceText_exports = {};
__export(inlineEnhanceText_exports, {
  Error: () => Error51
});
var Error51;
var init_inlineEnhanceText = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/inlineEnhanceText.ts"() {
    "use strict";
    init_src();
    Error51 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/aiEnhance/client/index.ts
var init_client8 = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/index.ts"() {
    "use strict";
    init_enhanceArticleAsync();
    init_enhanceVideoTranscriptAsync();
    init_translateGuideAndDuplicate();
    init_inlineEnhanceText();
  }
});

// src/api/resources/guides/resources/aiEnhance/index.ts
var aiEnhance_exports = {};
__export(aiEnhance_exports, {
  enhanceArticleAsync: () => enhanceArticleAsync_exports,
  enhanceVideoTranscriptAsync: () => enhanceVideoTranscriptAsync_exports,
  inlineEnhanceText: () => inlineEnhanceText_exports,
  translateGuideAndDuplicate: () => translateGuideAndDuplicate_exports
});
var init_aiEnhance = __esm({
  "src/api/resources/guides/resources/aiEnhance/index.ts"() {
    "use strict";
    init_types10();
    init_client8();
  }
});

// src/api/resources/guides/resources/broadcasts/types/BroadcastPlatform.ts
var BroadcastPlatform;
var init_BroadcastPlatform = __esm({
  "src/api/resources/guides/resources/broadcasts/types/BroadcastPlatform.ts"() {
    "use strict";
    BroadcastPlatform = {
      Slack: "slack",
      Discord: "discord",
      Whatsapp: "whatsapp",
      Teams: "teams"
    };
  }
});

// src/api/resources/guides/resources/broadcasts/types/BroadcastStatus.ts
var BroadcastStatus;
var init_BroadcastStatus = __esm({
  "src/api/resources/guides/resources/broadcasts/types/BroadcastStatus.ts"() {
    "use strict";
    BroadcastStatus = {
      Scheduled: "scheduled",
      Sent: "sent",
      Draft: "draft",
      Sending: "sending"
    };
  }
});

// src/api/resources/guides/resources/broadcasts/types/Broadcast.ts
var init_Broadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/types/Broadcast.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/broadcasts/types/BroadcastBot.ts
var init_BroadcastBot = __esm({
  "src/api/resources/guides/resources/broadcasts/types/BroadcastBot.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/broadcasts/types/GetBroadcastResponse.ts
var init_GetBroadcastResponse = __esm({
  "src/api/resources/guides/resources/broadcasts/types/GetBroadcastResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/broadcasts/types/index.ts
var init_types11 = __esm({
  "src/api/resources/guides/resources/broadcasts/types/index.ts"() {
    "use strict";
    init_BroadcastPlatform();
    init_BroadcastStatus();
    init_Broadcast();
    init_BroadcastBot();
    init_GetBroadcastResponse();
  }
});

// src/api/resources/guides/resources/broadcasts/client/requests/index.ts
var init_requests5 = __esm({
  "src/api/resources/guides/resources/broadcasts/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/broadcasts/client/getBroadcasts.ts
var getBroadcasts_exports = {};
__export(getBroadcasts_exports, {
  Error: () => Error52
});
var Error52;
var init_getBroadcasts = __esm({
  "src/api/resources/guides/resources/broadcasts/client/getBroadcasts.ts"() {
    "use strict";
    init_src();
    Error52 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcasts.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcasts.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcasts.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcasts.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/getBroadcast.ts
var getBroadcast_exports = {};
__export(getBroadcast_exports, {
  Error: () => Error53
});
var Error53;
var init_getBroadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/client/getBroadcast.ts"() {
    "use strict";
    init_src();
    Error53 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.getBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/createBroadcast.ts
var createBroadcast_exports = {};
__export(createBroadcast_exports, {
  Error: () => Error54
});
var Error54;
var init_createBroadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/client/createBroadcast.ts"() {
    "use strict";
    init_src();
    Error54 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.createBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.createBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.createBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.createBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/deleteBroadcast.ts
var deleteBroadcast_exports = {};
__export(deleteBroadcast_exports, {
  Error: () => Error55
});
var Error55;
var init_deleteBroadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/client/deleteBroadcast.ts"() {
    "use strict";
    init_src();
    Error55 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.deleteBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.deleteBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.deleteBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.deleteBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/updateBroadcast.ts
var updateBroadcast_exports = {};
__export(updateBroadcast_exports, {
  Error: () => Error56
});
var Error56;
var init_updateBroadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/client/updateBroadcast.ts"() {
    "use strict";
    init_src();
    Error56 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.updateBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.updateBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.updateBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.updateBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/sendBroadcast.ts
var sendBroadcast_exports = {};
__export(sendBroadcast_exports, {
  Error: () => Error57
});
var Error57;
var init_sendBroadcast = __esm({
  "src/api/resources/guides/resources/broadcasts/client/sendBroadcast.ts"() {
    "use strict";
    init_src();
    Error57 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/initiateBroadcastIconUpload.ts
var initiateBroadcastIconUpload_exports = {};
__export(initiateBroadcastIconUpload_exports, {
  Error: () => Error58
});
var Error58;
var init_initiateBroadcastIconUpload = __esm({
  "src/api/resources/guides/resources/broadcasts/client/initiateBroadcastIconUpload.ts"() {
    "use strict";
    init_src();
    Error58 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/customizeBroadcastBot.ts
var customizeBroadcastBot_exports = {};
__export(customizeBroadcastBot_exports, {
  Error: () => Error59
});
var Error59;
var init_customizeBroadcastBot = __esm({
  "src/api/resources/guides/resources/broadcasts/client/customizeBroadcastBot.ts"() {
    "use strict";
    init_src();
    Error59 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/index.ts
var init_client9 = __esm({
  "src/api/resources/guides/resources/broadcasts/client/index.ts"() {
    "use strict";
    init_requests5();
    init_getBroadcasts();
    init_getBroadcast();
    init_createBroadcast();
    init_deleteBroadcast();
    init_updateBroadcast();
    init_sendBroadcast();
    init_initiateBroadcastIconUpload();
    init_customizeBroadcastBot();
  }
});

// src/api/resources/guides/resources/broadcasts/index.ts
var broadcasts_exports = {};
__export(broadcasts_exports, {
  BroadcastPlatform: () => BroadcastPlatform,
  BroadcastStatus: () => BroadcastStatus,
  createBroadcast: () => createBroadcast_exports,
  customizeBroadcastBot: () => customizeBroadcastBot_exports,
  deleteBroadcast: () => deleteBroadcast_exports,
  getBroadcast: () => getBroadcast_exports,
  getBroadcasts: () => getBroadcasts_exports,
  initiateBroadcastIconUpload: () => initiateBroadcastIconUpload_exports,
  sendBroadcast: () => sendBroadcast_exports,
  updateBroadcast: () => updateBroadcast_exports
});
var init_broadcasts = __esm({
  "src/api/resources/guides/resources/broadcasts/index.ts"() {
    "use strict";
    init_types11();
    init_client9();
  }
});

// src/api/resources/guides/resources/guideAiChat/types/GuideAiChatMessage.ts
var init_GuideAiChatMessage = __esm({
  "src/api/resources/guides/resources/guideAiChat/types/GuideAiChatMessage.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideAiChat/types/GuideAiChatContentType.ts
var GuideAiChatContentType;
var init_GuideAiChatContentType = __esm({
  "src/api/resources/guides/resources/guideAiChat/types/GuideAiChatContentType.ts"() {
    "use strict";
    GuideAiChatContentType = {
      Article: "article",
      Video: "video"
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/types/GuideAiChatSenderRole.ts
var GuideAiChatSenderRole;
var init_GuideAiChatSenderRole = __esm({
  "src/api/resources/guides/resources/guideAiChat/types/GuideAiChatSenderRole.ts"() {
    "use strict";
    GuideAiChatSenderRole = {
      Ai: "ai",
      User: "user"
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/types/index.ts
var init_types12 = __esm({
  "src/api/resources/guides/resources/guideAiChat/types/index.ts"() {
    "use strict";
    init_GuideAiChatMessage();
    init_GuideAiChatContentType();
    init_GuideAiChatSenderRole();
  }
});

// src/api/resources/guides/resources/guideAiChat/client/requests/index.ts
var init_requests6 = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideAiChat/client/sendMessage.ts
var sendMessage_exports = {};
__export(sendMessage_exports, {
  Error: () => Error60
});
var Error60;
var init_sendMessage = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/sendMessage.ts"() {
    "use strict";
    init_src();
    Error60 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.sendMessage.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.sendMessage.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.sendMessage.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.sendMessage.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/client/deleteChatForAGuide.ts
var deleteChatForAGuide_exports = {};
__export(deleteChatForAGuide_exports, {
  Error: () => Error61
});
var Error61;
var init_deleteChatForAGuide = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/deleteChatForAGuide.ts"() {
    "use strict";
    init_src();
    Error61 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/client/deleteMessageById.ts
var deleteMessageById_exports = {};
__export(deleteMessageById_exports, {
  Error: () => Error62
});
var Error62;
var init_deleteMessageById = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/deleteMessageById.ts"() {
    "use strict";
    init_src();
    Error62 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteMessageById.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteMessageById.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteMessageById.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideAiChat.deleteMessageById.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/client/index.ts
var init_client10 = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/index.ts"() {
    "use strict";
    init_requests6();
    init_sendMessage();
    init_deleteChatForAGuide();
    init_deleteMessageById();
  }
});

// src/api/resources/guides/resources/guideAiChat/index.ts
var guideAiChat_exports = {};
__export(guideAiChat_exports, {
  GuideAiChatContentType: () => GuideAiChatContentType,
  GuideAiChatSenderRole: () => GuideAiChatSenderRole,
  deleteChatForAGuide: () => deleteChatForAGuide_exports,
  deleteMessageById: () => deleteMessageById_exports,
  sendMessage: () => sendMessage_exports
});
var init_guideAiChat = __esm({
  "src/api/resources/guides/resources/guideAiChat/index.ts"() {
    "use strict";
    init_types12();
    init_client10();
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportRequest.ts
var init_ExportRequest = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportGifRequest.ts
var init_ExportGifRequest = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportGifRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/GifSettings.ts
var init_GifSettings = __esm({
  "src/api/resources/guides/resources/guideExports/types/GifSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/VideoSettings.ts
var init_VideoSettings = __esm({
  "src/api/resources/guides/resources/guideExports/types/VideoSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/GetPastExportsRequest.ts
var init_GetPastExportsRequest = __esm({
  "src/api/resources/guides/resources/guideExports/types/GetPastExportsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/GetPastExportsResponse.ts
var init_GetPastExportsResponse = __esm({
  "src/api/resources/guides/resources/guideExports/types/GetPastExportsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportProcess.ts
var ExportProcess;
var init_ExportProcess = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportProcess.ts"() {
    "use strict";
    ExportProcess = {
      Export: "export",
      Publish: "publish"
    };
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportArticleResponse.ts
var init_ExportArticleResponse = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportArticleResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/ConvertToGifResponse.ts
var init_ConvertToGifResponse = __esm({
  "src/api/resources/guides/resources/guideExports/types/ConvertToGifResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/MasterDataForVideoExporter.ts
var init_MasterDataForVideoExporter = __esm({
  "src/api/resources/guides/resources/guideExports/types/MasterDataForVideoExporter.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportDetails.ts
var init_ExportDetails = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportProcessType.ts
var ExportProcessType;
var init_ExportProcessType = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportProcessType.ts"() {
    "use strict";
    ExportProcessType = {
      Export: "export",
      Publish: "publish"
    };
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportStatus.ts
var ExportStatus;
var init_ExportStatus = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportStatus.ts"() {
    "use strict";
    ExportStatus = {
      Queued: "queued",
      Waitlisted: "waitlisted",
      Inprogress: "inprogress",
      Pending: "pending",
      Completed: "completed",
      Failed: "failed"
    };
  }
});

// src/api/resources/guides/resources/guideExports/types/ExportExecutionSpeed.ts
var ExportExecutionSpeed;
var init_ExportExecutionSpeed = __esm({
  "src/api/resources/guides/resources/guideExports/types/ExportExecutionSpeed.ts"() {
    "use strict";
    ExportExecutionSpeed = {
      Slow: "slow",
      Medium: "medium",
      Fast: "fast"
    };
  }
});

// src/api/resources/guides/resources/guideExports/types/index.ts
var init_types13 = __esm({
  "src/api/resources/guides/resources/guideExports/types/index.ts"() {
    "use strict";
    init_ExportRequest();
    init_ExportGifRequest();
    init_GifSettings();
    init_VideoSettings();
    init_GetPastExportsRequest();
    init_GetPastExportsResponse();
    init_ExportProcess();
    init_ExportArticleResponse();
    init_ConvertToGifResponse();
    init_MasterDataForVideoExporter();
    init_ExportDetails();
    init_ExportProcessType();
    init_ExportStatus();
    init_ExportExecutionSpeed();
  }
});

// src/api/resources/guides/resources/guideExports/client/exportVideo.ts
var exportVideo_exports = {};
__export(exportVideo_exports, {
  Error: () => Error63
});
var Error63;
var init_exportVideo = __esm({
  "src/api/resources/guides/resources/guideExports/client/exportVideo.ts"() {
    "use strict";
    init_src();
    Error63 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideo.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/exportVideoV2.ts
var exportVideoV2_exports = {};
__export(exportVideoV2_exports, {
  Error: () => Error64
});
var Error64;
var init_exportVideoV2 = __esm({
  "src/api/resources/guides/resources/guideExports/client/exportVideoV2.ts"() {
    "use strict";
    init_src();
    Error64 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      errorWhileProcessingVideoExportRequest: () => {
        return {
          error: "ErrorWhileProcessingVideoExportRequest",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportVideoV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "ErrorWhileProcessingVideoExportRequest":
            return visitor.errorWhileProcessingVideoExportRequest();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/convertToGif.ts
var convertToGif_exports = {};
__export(convertToGif_exports, {
  Error: () => Error65
});
var Error65;
var init_convertToGif = __esm({
  "src/api/resources/guides/resources/guideExports/client/convertToGif.ts"() {
    "use strict";
    init_src();
    Error65 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.convertToGif.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.convertToGif.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.convertToGif.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.convertToGif.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/exportGif.ts
var exportGif_exports = {};
__export(exportGif_exports, {
  Error: () => Error66
});
var Error66;
var init_exportGif = __esm({
  "src/api/resources/guides/resources/guideExports/client/exportGif.ts"() {
    "use strict";
    init_src();
    Error66 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGif.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGif.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGif.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/exportGifV2.ts
var exportGifV2_exports = {};
__export(exportGifV2_exports, {
  Error: () => Error67
});
var Error67;
var init_exportGifV2 = __esm({
  "src/api/resources/guides/resources/guideExports/client/exportGifV2.ts"() {
    "use strict";
    init_src();
    Error67 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      errorWhileProcessingVideoExportRequest: () => {
        return {
          error: "ErrorWhileProcessingVideoExportRequest",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportGifV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "ErrorWhileProcessingVideoExportRequest":
            return visitor.errorWhileProcessingVideoExportRequest();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/exportArticle.ts
var exportArticle_exports = {};
__export(exportArticle_exports, {
  Error: () => Error68
});
var Error68;
var init_exportArticle = __esm({
  "src/api/resources/guides/resources/guideExports/client/exportArticle.ts"() {
    "use strict";
    init_src();
    Error68 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportArticle.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportArticle.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportArticle.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportArticle.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.exportArticle.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/getPastExports.ts
var getPastExports_exports = {};
__export(getPastExports_exports, {
  Error: () => Error69
});
var Error69;
var init_getPastExports = __esm({
  "src/api/resources/guides/resources/guideExports/client/getPastExports.ts"() {
    "use strict";
    init_src();
    Error69 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.getPastExports.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.getPastExports.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.getPastExports.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideExports.getPastExports.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideExports.getPastExports.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/index.ts
var init_client11 = __esm({
  "src/api/resources/guides/resources/guideExports/client/index.ts"() {
    "use strict";
    init_exportVideo();
    init_exportVideoV2();
    init_convertToGif();
    init_exportGif();
    init_exportGifV2();
    init_exportArticle();
    init_getPastExports();
  }
});

// src/api/resources/guides/resources/guideExports/index.ts
var guideExports_exports = {};
__export(guideExports_exports, {
  ExportExecutionSpeed: () => ExportExecutionSpeed,
  ExportProcess: () => ExportProcess,
  ExportProcessType: () => ExportProcessType,
  ExportStatus: () => ExportStatus,
  convertToGif: () => convertToGif_exports,
  exportArticle: () => exportArticle_exports,
  exportGif: () => exportGif_exports,
  exportGifV2: () => exportGifV2_exports,
  exportVideo: () => exportVideo_exports,
  exportVideoV2: () => exportVideoV2_exports,
  getPastExports: () => getPastExports_exports
});
var init_guideExports = __esm({
  "src/api/resources/guides/resources/guideExports/index.ts"() {
    "use strict";
    init_types13();
    init_client11();
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsRequest.ts
var init_InitiateUploadAndSuggestSplitsRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsResponse.ts
var init_InitiateUploadAndSuggestSplitsResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/RestoreVersionResponse.ts
var init_RestoreVersionResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/RestoreVersionResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts
var init_InitiateCreateGuideRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateUploadCreateRequest.ts
var init_InitiateUploadCreateRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateUploadCreateRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/AdvancedSettings.ts
var AdvancedSettings;
var init_AdvancedSettings = __esm({
  "src/api/resources/guides/resources/guideMutations/types/AdvancedSettings.ts"() {
    "use strict";
    init_src();
    AdvancedSettings = {
      ppt: (value) => {
        return {
          ...value,
          type: "ppt",
          _visit: function(visitor) {
            return api_exports.guides.AdvancedSettings._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.guides.AdvancedSettings._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.type) {
          case "ppt":
            return visitor.ppt(value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/types/PptAdvancedSettings.ts
var init_PptAdvancedSettings = __esm({
  "src/api/resources/guides/resources/guideMutations/types/PptAdvancedSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/PptContentMode.ts
var PptContentMode;
var init_PptContentMode = __esm({
  "src/api/resources/guides/resources/guideMutations/types/PptContentMode.ts"() {
    "use strict";
    PptContentMode = {
      SpeakerNotesOnly: "SPEAKER_NOTES_ONLY",
      SpeakerNotesAndSlides: "SPEAKER_NOTES_AND_SLIDES",
      SlidesOnly: "SLIDES_ONLY",
      None: "NONE"
    };
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateUploadCreateResponse.ts
var init_InitiateUploadCreateResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateUploadCreateResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts
var init_InitiateCreateVideoGuideResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts
var init_MoveGuideRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/PlainDocRequest.ts
var init_PlainDocRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/PlainDocRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts
var init_GenerateVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts
var init_GenerateBookendsVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/UpdateOriginalEditsRequest.ts
var init_UpdateOriginalEditsRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/UpdateOriginalEditsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts
var init_UploadChunkRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts
var init_CompileVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts
var init_CompileVideoResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts
var init_ExportGuideResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/ValidateGuideUrlRequest.ts
var init_ValidateGuideUrlRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/ValidateGuideUrlRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/ValidateGuideUrlResponse.ts
var init_ValidateGuideUrlResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/ValidateGuideUrlResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/UpdateLatestThumbnailRequest.ts
var init_UpdateLatestThumbnailRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/UpdateLatestThumbnailRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/PublishGuideV2Response.ts
var init_PublishGuideV2Response = __esm({
  "src/api/resources/guides/resources/guideMutations/types/PublishGuideV2Response.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/index.ts
var init_types14 = __esm({
  "src/api/resources/guides/resources/guideMutations/types/index.ts"() {
    "use strict";
    init_InitiateUploadAndSuggestSplitsRequest();
    init_InitiateUploadAndSuggestSplitsResponse();
    init_RestoreVersionResponse();
    init_InitiateCreateGuideRequest();
    init_InitiateUploadCreateRequest();
    init_AdvancedSettings();
    init_PptAdvancedSettings();
    init_PptContentMode();
    init_InitiateUploadCreateResponse();
    init_InitiateCreateVideoGuideResponse();
    init_MoveGuideRequest();
    init_PlainDocRequest();
    init_GenerateVideoRequest();
    init_GenerateBookendsVideoRequest();
    init_UpdateOriginalEditsRequest();
    init_UploadChunkRequest();
    init_CompileVideoRequest();
    init_CompileVideoResponse();
    init_ExportGuideResponse();
    init_ValidateGuideUrlRequest();
    init_ValidateGuideUrlResponse();
    init_UpdateLatestThumbnailRequest();
    init_PublishGuideV2Response();
  }
});

// src/api/resources/guides/resources/guideMutations/client/requests/index.ts
var init_requests7 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/client/generateVoiceover.ts
var generateVoiceover_exports = {};
__export(generateVoiceover_exports, {
  Error: () => Error70
});
var Error70;
var init_generateVoiceover = __esm({
  "src/api/resources/guides/resources/guideMutations/client/generateVoiceover.ts"() {
    "use strict";
    init_src();
    Error70 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      guideIncompatibleError: () => {
        return {
          error: "GuideIncompatibleError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      transcriptionMatchingError: (value) => {
        return {
          content: value,
          error: "TranscriptionMatchingError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      screenshotOrderingError: (value) => {
        return {
          content: value,
          error: "ScreenshotOrderingError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      unsubscribedOrgError: (value) => {
        return {
          content: value,
          error: "UnsubscribedOrgError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVoiceover.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "GuideIncompatibleError":
            return visitor.guideIncompatibleError();
          case "TranscriptionMatchingError":
            return visitor.transcriptionMatchingError(value.content);
          case "ScreenshotOrderingError":
            return visitor.screenshotOrderingError(value.content);
          case "UnsubscribedOrgError":
            return visitor.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/publishGuide.ts
var publishGuide_exports = {};
__export(publishGuide_exports, {
  Error: () => Error71
});
var Error71;
var init_publishGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/publishGuide.ts"() {
    "use strict";
    init_src();
    Error71 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuide.Error._visit(this, visitor);
          }
        };
      },
      guideIncompatibleError: () => {
        return {
          error: "GuideIncompatibleError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "GuideIncompatibleError":
            return visitor.guideIncompatibleError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/publishGuideV2.ts
var publishGuideV2_exports = {};
__export(publishGuideV2_exports, {
  Error: () => Error72
});
var Error72;
var init_publishGuideV2 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/publishGuideV2.ts"() {
    "use strict";
    init_src();
    Error72 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuideV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuideV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuideV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.publishGuideV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishCreateGuide.ts
var finishCreateGuide_exports = {};
__export(finishCreateGuide_exports, {
  Error: () => Error73
});
var Error73;
var init_finishCreateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishCreateGuide.ts"() {
    "use strict";
    init_src();
    Error73 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/autoUpdateGuideVideo.ts
var autoUpdateGuideVideo_exports = {};
__export(autoUpdateGuideVideo_exports, {
  Error: () => Error74
});
var Error74;
var init_autoUpdateGuideVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/autoUpdateGuideVideo.ts"() {
    "use strict";
    init_src();
    Error74 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts
var initiateCreateGuide_exports = {};
__export(initiateCreateGuide_exports, {
  Error: () => Error75
});
var Error75;
var init_initiateCreateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts"() {
    "use strict";
    init_src();
    Error75 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateUploadCreate.ts
var initiateUploadCreate_exports = {};
__export(initiateUploadCreate_exports, {
  Error: () => Error76
});
var Error76;
var init_initiateUploadCreate = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateUploadCreate.ts"() {
    "use strict";
    init_src();
    Error76 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/uploadImage.ts
var uploadImage_exports = {};
__export(uploadImage_exports, {
  Error: () => Error77
});
var Error77;
var init_uploadImage = __esm({
  "src/api/resources/guides/resources/guideMutations/client/uploadImage.ts"() {
    "use strict";
    init_src();
    Error77 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts
var uploadVideoChunk_exports = {};
__export(uploadVideoChunk_exports, {
  Error: () => Error78
});
var Error78;
var init_uploadVideoChunk = __esm({
  "src/api/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts"() {
    "use strict";
    init_src();
    Error78 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/compileVideo.ts
var compileVideo_exports = {};
__export(compileVideo_exports, {
  Error: () => Error79
});
var Error79;
var init_compileVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/compileVideo.ts"() {
    "use strict";
    init_src();
    Error79 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateGuideData.ts
var updateGuideData_exports = {};
__export(updateGuideData_exports, {
  Error: () => Error80
});
var Error80;
var init_updateGuideData = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateGuideData.ts"() {
    "use strict";
    init_src();
    Error80 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateOriginalEdits.ts
var updateOriginalEdits_exports = {};
__export(updateOriginalEdits_exports, {
  Error: () => Error81
});
var Error81;
var init_updateOriginalEdits = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateOriginalEdits.ts"() {
    "use strict";
    init_src();
    Error81 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateOriginalEdits.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateOriginalEdits.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateOriginalEdits.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateOriginalEdits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateOriginalEdits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateUploadSource.ts
var initiateUploadSource_exports = {};
__export(initiateUploadSource_exports, {
  Error: () => Error82
});
var Error82;
var init_initiateUploadSource = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateUploadSource.ts"() {
    "use strict";
    init_src();
    Error82 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadSource.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadSource.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadSource.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadSource.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUploadSource.ts
var finishUploadSource_exports = {};
__export(finishUploadSource_exports, {
  Error: () => Error83
});
var Error83;
var init_finishUploadSource = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUploadSource.ts"() {
    "use strict";
    init_src();
    Error83 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadSource.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadSource.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadSource.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadSource.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts
var finishUpdateGuideData_exports = {};
__export(finishUpdateGuideData_exports, {
  Error: () => Error84
});
var Error84;
var init_finishUpdateGuideData = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts"() {
    "use strict";
    init_src();
    Error84 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts
var createEmptyTextGuide_exports = {};
__export(createEmptyTextGuide_exports, {
  Error: () => Error85
});
var Error85;
var init_createEmptyTextGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts"() {
    "use strict";
    init_src();
    Error85 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateGuidePreview.ts
var updateGuidePreview_exports = {};
__export(updateGuidePreview_exports, {
  Error: () => Error86
});
var Error86;
var init_updateGuidePreview = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateGuidePreview.ts"() {
    "use strict";
    init_src();
    Error86 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/pinGuide.ts
var pinGuide_exports = {};
__export(pinGuide_exports, {
  Error: () => Error87
});
var Error87;
var init_pinGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/pinGuide.ts"() {
    "use strict";
    init_src();
    Error87 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/deleteGuide.ts
var deleteGuide_exports = {};
__export(deleteGuide_exports, {
  Error: () => Error88
});
var Error88;
var init_deleteGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/deleteGuide.ts"() {
    "use strict";
    init_src();
    Error88 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.deleteGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.deleteGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.deleteGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/moveGuide.ts
var moveGuide_exports = {};
__export(moveGuide_exports, {
  Error: () => Error89
});
var Error89;
var init_moveGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/moveGuide.ts"() {
    "use strict";
    init_src();
    Error89 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/reorderGuide.ts
var reorderGuide_exports = {};
__export(reorderGuide_exports, {
  Error: () => Error90
});
var Error90;
var init_reorderGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/reorderGuide.ts"() {
    "use strict";
    init_src();
    Error90 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.reorderGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.reorderGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.reorderGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUploadCreate.ts
var finishUploadCreate_exports = {};
__export(finishUploadCreate_exports, {
  Error: () => Error91
});
var Error91;
var init_finishUploadCreate = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUploadCreate.ts"() {
    "use strict";
    init_src();
    Error91 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadCreate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/duplicateGuide.ts
var duplicateGuide_exports = {};
__export(duplicateGuide_exports, {
  Error: () => Error92
});
var Error92;
var init_duplicateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/duplicateGuide.ts"() {
    "use strict";
    init_src();
    Error92 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/restoreVersion.ts
var restoreVersion_exports = {};
__export(restoreVersion_exports, {
  Error: () => Error93
});
var Error93;
var init_restoreVersion = __esm({
  "src/api/resources/guides/resources/guideMutations/client/restoreVersion.ts"() {
    "use strict";
    init_src();
    Error93 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.restoreVersion.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.restoreVersion.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.restoreVersion.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.restoreVersion.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.restoreVersion.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/validateGuideUrlPath.ts
var validateGuideUrlPath_exports = {};
__export(validateGuideUrlPath_exports, {
  Error: () => Error94
});
var Error94;
var init_validateGuideUrlPath = __esm({
  "src/api/resources/guides/resources/guideMutations/client/validateGuideUrlPath.ts"() {
    "use strict";
    init_src();
    Error94 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updatedLatestThumbnail.ts
var updatedLatestThumbnail_exports = {};
__export(updatedLatestThumbnail_exports, {
  Error: () => Error95
});
var Error95;
var init_updatedLatestThumbnail = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updatedLatestThumbnail.ts"() {
    "use strict";
    init_src();
    Error95 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateUploadAndSuggestSplits.ts
var initiateUploadAndSuggestSplits_exports = {};
__export(initiateUploadAndSuggestSplits_exports, {
  Error: () => Error96
});
var Error96;
var init_initiateUploadAndSuggestSplits = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateUploadAndSuggestSplits.ts"() {
    "use strict";
    init_src();
    Error96 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUploadAndSuggestSplits.ts
var finishUploadAndSuggestSplits_exports = {};
__export(finishUploadAndSuggestSplits_exports, {
  Error: () => Error97
});
var Error97;
var init_finishUploadAndSuggestSplits = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUploadAndSuggestSplits.ts"() {
    "use strict";
    init_src();
    Error97 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/generateGuidesBasedOnSplits.ts
var generateGuidesBasedOnSplits_exports = {};
__export(generateGuidesBasedOnSplits_exports, {
  Error: () => Error98
});
var Error98;
var init_generateGuidesBasedOnSplits = __esm({
  "src/api/resources/guides/resources/guideMutations/client/generateGuidesBasedOnSplits.ts"() {
    "use strict";
    init_src();
    Error98 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/index.ts
var init_client12 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/index.ts"() {
    "use strict";
    init_requests7();
    init_generateVoiceover();
    init_publishGuide();
    init_publishGuideV2();
    init_finishCreateGuide();
    init_autoUpdateGuideVideo();
    init_initiateCreateGuide();
    init_initiateUploadCreate();
    init_uploadImage();
    init_uploadVideoChunk();
    init_compileVideo();
    init_updateGuideData();
    init_updateOriginalEdits();
    init_initiateUploadSource();
    init_finishUploadSource();
    init_finishUpdateGuideData();
    init_createEmptyTextGuide();
    init_updateGuidePreview();
    init_pinGuide();
    init_deleteGuide();
    init_moveGuide();
    init_reorderGuide();
    init_finishUploadCreate();
    init_duplicateGuide();
    init_restoreVersion();
    init_validateGuideUrlPath();
    init_updatedLatestThumbnail();
    init_initiateUploadAndSuggestSplits();
    init_finishUploadAndSuggestSplits();
    init_generateGuidesBasedOnSplits();
  }
});

// src/api/resources/guides/resources/guideMutations/index.ts
var guideMutations_exports = {};
__export(guideMutations_exports, {
  AdvancedSettings: () => AdvancedSettings,
  PptContentMode: () => PptContentMode,
  autoUpdateGuideVideo: () => autoUpdateGuideVideo_exports,
  compileVideo: () => compileVideo_exports,
  createEmptyTextGuide: () => createEmptyTextGuide_exports,
  deleteGuide: () => deleteGuide_exports,
  duplicateGuide: () => duplicateGuide_exports,
  finishCreateGuide: () => finishCreateGuide_exports,
  finishUpdateGuideData: () => finishUpdateGuideData_exports,
  finishUploadAndSuggestSplits: () => finishUploadAndSuggestSplits_exports,
  finishUploadCreate: () => finishUploadCreate_exports,
  finishUploadSource: () => finishUploadSource_exports,
  generateGuidesBasedOnSplits: () => generateGuidesBasedOnSplits_exports,
  generateVoiceover: () => generateVoiceover_exports,
  initiateCreateGuide: () => initiateCreateGuide_exports,
  initiateUploadAndSuggestSplits: () => initiateUploadAndSuggestSplits_exports,
  initiateUploadCreate: () => initiateUploadCreate_exports,
  initiateUploadSource: () => initiateUploadSource_exports,
  moveGuide: () => moveGuide_exports,
  pinGuide: () => pinGuide_exports,
  publishGuide: () => publishGuide_exports,
  publishGuideV2: () => publishGuideV2_exports,
  reorderGuide: () => reorderGuide_exports,
  restoreVersion: () => restoreVersion_exports,
  updateGuideData: () => updateGuideData_exports,
  updateGuidePreview: () => updateGuidePreview_exports,
  updateOriginalEdits: () => updateOriginalEdits_exports,
  updatedLatestThumbnail: () => updatedLatestThumbnail_exports,
  uploadImage: () => uploadImage_exports,
  uploadVideoChunk: () => uploadVideoChunk_exports,
  validateGuideUrlPath: () => validateGuideUrlPath_exports
});
var init_guideMutations = __esm({
  "src/api/resources/guides/resources/guideMutations/index.ts"() {
    "use strict";
    init_types14();
    init_client12();
  }
});

// src/api/resources/guides/resources/guideQueryCore/types/GetGuidePreviewRequest.ts
var init_GetGuidePreviewRequest = __esm({
  "src/api/resources/guides/resources/guideQueryCore/types/GetGuidePreviewRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideQueryCore/types/GetGuideDataRequest.ts
var init_GetGuideDataRequest = __esm({
  "src/api/resources/guides/resources/guideQueryCore/types/GetGuideDataRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideQueryCore/types/index.ts
var init_types15 = __esm({
  "src/api/resources/guides/resources/guideQueryCore/types/index.ts"() {
    "use strict";
    init_GetGuidePreviewRequest();
    init_GetGuideDataRequest();
  }
});

// src/api/resources/guides/resources/guideQueryCore/index.ts
var guideQueryCore_exports = {};
var init_guideQueryCore = __esm({
  "src/api/resources/guides/resources/guideQueryCore/index.ts"() {
    "use strict";
    init_types15();
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoObject.ts
var init_VideoObject = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoObject.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoRecordingType.ts
var VideoRecordingType;
var init_VideoRecordingType = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoRecordingType.ts"() {
    "use strict";
    VideoRecordingType = {
      Default: "default",
      Loom: "loom"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/PublishedVideoType.ts
var PublishedVideoType;
var init_PublishedVideoType = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PublishedVideoType.ts"() {
    "use strict";
    PublishedVideoType = {
      Ai: "ai",
      Original: "original",
      None: "none"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoMetadata.ts
var init_VideoMetadata = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoMetadata.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts
var init_PresignedUrlsForGuide = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts
var init_PresignedUrlsResponse = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Guide.ts
var init_Guide = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Guide.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideHeader.ts
var init_GuideHeader = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideHeader.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuidePreview.ts
var init_GuidePreview = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuidePreview.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuidePlatformStatus.ts
var init_GuidePlatformStatus = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuidePlatformStatus.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/OperationError.ts
var init_OperationError = __esm({
  "src/api/resources/guides/resources/guideTypes/types/OperationError.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/AsyncOperationError.ts
var AsyncOperationError;
var init_AsyncOperationError = __esm({
  "src/api/resources/guides/resources/guideTypes/types/AsyncOperationError.ts"() {
    "use strict";
    init_src();
    AsyncOperationError = {
      generatingVoiceover: (value) => {
        return {
          value,
          type: "generating_voiceover",
          _visit: function(visitor) {
            return api_exports.guides.AsyncOperationError._visit(this, visitor);
          }
        };
      },
      exportingVideo: (value) => {
        return {
          value,
          type: "exporting_video",
          _visit: function(visitor) {
            return api_exports.guides.AsyncOperationError._visit(this, visitor);
          }
        };
      },
      youtubePublish: (value) => {
        return {
          value,
          type: "youtube_publish",
          _visit: function(visitor) {
            return api_exports.guides.AsyncOperationError._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.guides.AsyncOperationError._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.type) {
          case "generating_voiceover":
            return visitor.generatingVoiceover(value.value);
          case "exporting_video":
            return visitor.exportingVideo(value.value);
          case "youtube_publish":
            return visitor.youtubePublish(value.value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/YouTubePublishError.ts
var YouTubePublishError;
var init_YouTubePublishError = __esm({
  "src/api/resources/guides/resources/guideTypes/types/YouTubePublishError.ts"() {
    "use strict";
    init_src();
    YouTubePublishError = {
      uploadLimitExceeded: (value) => {
        return {
          ...value,
          errorType: "uploadLimitExceeded",
          _visit: function(visitor) {
            return api_exports.guides.YouTubePublishError._visit(this, visitor);
          }
        };
      },
      exportVideoError: (value) => {
        return {
          ...value,
          errorType: "exportVideoError",
          _visit: function(visitor) {
            return api_exports.guides.YouTubePublishError._visit(this, visitor);
          }
        };
      },
      other: (value) => {
        return {
          ...value,
          errorType: "other",
          _visit: function(visitor) {
            return api_exports.guides.YouTubePublishError._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.guides.YouTubePublishError._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.errorType) {
          case "uploadLimitExceeded":
            return visitor.uploadLimitExceeded(value);
          case "exportVideoError":
            return visitor.exportVideoError(value);
          case "other":
            return visitor.other(value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/ExportingVideoYoutubeErrorBody.ts
var init_ExportingVideoYoutubeErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/ExportingVideoYoutubeErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/ExportingVideoError.ts
var ExportingVideoError;
var init_ExportingVideoError = __esm({
  "src/api/resources/guides/resources/guideTypes/types/ExportingVideoError.ts"() {
    "use strict";
    init_src();
    ExportingVideoError = {
      blurEffects: (value) => {
        return {
          ...value,
          errorType: "blurEffects",
          _visit: function(visitor) {
            return api_exports.guides.ExportingVideoError._visit(this, visitor);
          }
        };
      },
      unsubscribedOrg: (value) => {
        return {
          ...value,
          errorType: "unsubscribedOrg",
          _visit: function(visitor) {
            return api_exports.guides.ExportingVideoError._visit(this, visitor);
          }
        };
      },
      errorRenderingVideo: (value) => {
        return {
          ...value,
          errorType: "errorRenderingVideo",
          _visit: function(visitor) {
            return api_exports.guides.ExportingVideoError._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.guides.ExportingVideoError._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.errorType) {
          case "blurEffects":
            return visitor.blurEffects(value);
          case "unsubscribedOrg":
            return visitor.unsubscribedOrg(value);
          case "errorRenderingVideo":
            return visitor.errorRenderingVideo(value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/YouTubeUploadErrorBody.ts
var init_YouTubeUploadErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/YouTubeUploadErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GeneratingVoiceoverError.ts
var GeneratingVoiceoverError;
var init_GeneratingVoiceoverError = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GeneratingVoiceoverError.ts"() {
    "use strict";
    init_src();
    GeneratingVoiceoverError = {
      transcriptionMatching: (value) => {
        return {
          ...value,
          errorType: "transcriptionMatching",
          _visit: function(visitor) {
            return api_exports.guides.GeneratingVoiceoverError._visit(this, visitor);
          }
        };
      },
      screenshotOrdering: (value) => {
        return {
          ...value,
          errorType: "screenshotOrdering",
          _visit: function(visitor) {
            return api_exports.guides.GeneratingVoiceoverError._visit(this, visitor);
          }
        };
      },
      unsubscribedOrg: (value) => {
        return {
          ...value,
          errorType: "unsubscribedOrg",
          _visit: function(visitor) {
            return api_exports.guides.GeneratingVoiceoverError._visit(this, visitor);
          }
        };
      },
      unknown: (value) => {
        return {
          value,
          errorType: "unknown",
          _visit: function(visitor) {
            return api_exports.guides.GeneratingVoiceoverError._visit(this, visitor);
          }
        };
      },
      _unknown: (value) => {
        return {
          ...value,
          _visit: function(visitor) {
            return api_exports.guides.GeneratingVoiceoverError._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.errorType) {
          case "transcriptionMatching":
            return visitor.transcriptionMatching(value);
          case "screenshotOrdering":
            return visitor.screenshotOrdering(value);
          case "unsubscribedOrg":
            return visitor.unsubscribedOrg(value);
          case "unknown":
            return visitor.unknown(value.value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideData.ts
var init_GuideData = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideData.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuidePlatformData.ts
var init_GuidePlatformData = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuidePlatformData.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideVersion.ts
var init_GuideVersion = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideVersion.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoObjectVersion.ts
var VideoObjectVersion;
var init_VideoObjectVersion = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoObjectVersion.ts"() {
    "use strict";
    VideoObjectVersion = {
      Dec152023: "dec152023"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/NewVideoObject.ts
var init_NewVideoObject = __esm({
  "src/api/resources/guides/resources/guideTypes/types/NewVideoObject.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideSettings.ts
var init_GuideSettings = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PlainDoc.ts
var init_PlainDoc = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PlainDoc.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/DocStep.ts
var init_DocStep = __esm({
  "src/api/resources/guides/resources/guideTypes/types/DocStep.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/AutoProgressable.ts
var AutoProgressable;
var init_AutoProgressable = __esm({
  "src/api/resources/guides/resources/guideTypes/types/AutoProgressable.ts"() {
    "use strict";
    AutoProgressable = {
      Auto: "auto",
      NewButton: "newButton"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/TourStep.ts
var init_TourStep = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TourStep.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/TourStepMetadata.ts
var init_TourStepMetadata = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TourStepMetadata.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/CustomSelector.ts
var init_CustomSelector = __esm({
  "src/api/resources/guides/resources/guideTypes/types/CustomSelector.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/DomElementData.ts
var init_DomElementData = __esm({
  "src/api/resources/guides/resources/guideTypes/types/DomElementData.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GeneratedVideo.ts
var init_GeneratedVideo = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GeneratedVideo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/TranscribedWord.ts
var init_TranscribedWord = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TranscribedWord.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/ExportedVideo.ts
var init_ExportedVideo = __esm({
  "src/api/resources/guides/resources/guideTypes/types/ExportedVideo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoSource.ts
var init_VideoSource = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoSource.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/OriginalEdits.ts
var init_OriginalEdits = __esm({
  "src/api/resources/guides/resources/guideTypes/types/OriginalEdits.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoClip.ts
var init_VideoClip = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoClip.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/EditedVideo.ts
var init_EditedVideo = __esm({
  "src/api/resources/guides/resources/guideTypes/types/EditedVideo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Gender.ts
var Gender;
var init_Gender = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Gender.ts"() {
    "use strict";
    Gender = {
      Male: "male",
      Female: "female"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/VoiceEdits.ts
var init_VoiceEdits = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VoiceEdits.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Voice.ts
var init_Voice = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Voice.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VoiceEngine.ts
var VoiceEngine;
var init_VoiceEngine = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VoiceEngine.ts"() {
    "use strict";
    VoiceEngine = {
      Google: "google",
      Play: "play",
      Eleven: "eleven",
      Wellsaid: "wellsaid",
      Cartesia: "cartesia",
      Openai: "openai"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideRequest.ts
var init_GuideRequest = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/TranscriptionMatchingErrorBody.ts
var init_TranscriptionMatchingErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TranscriptionMatchingErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/ScreenshotOrderingErrorBody.ts
var init_ScreenshotOrderingErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/ScreenshotOrderingErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/UnsubscribedErrorBody.ts
var init_UnsubscribedErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/UnsubscribedErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/UploadFailedErrorBody.ts
var init_UploadFailedErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/UploadFailedErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/BlurringErrorBody.ts
var init_BlurringErrorBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/BlurringErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/ErrorRenderingVideoBody.ts
var init_ErrorRenderingVideoBody = __esm({
  "src/api/resources/guides/resources/guideTypes/types/ErrorRenderingVideoBody.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/OriginalEditsVersion.ts
var OriginalEditsVersion;
var init_OriginalEditsVersion = __esm({
  "src/api/resources/guides/resources/guideTypes/types/OriginalEditsVersion.ts"() {
    "use strict";
    OriginalEditsVersion = {
      July082024: "july082024"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/Author.ts
var init_Author = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Author.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideCreationType.ts
var GuideCreationType;
var init_GuideCreationType = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideCreationType.ts"() {
    "use strict";
    GuideCreationType = {
      SlideDeck: "SLIDE_DECK",
      Video: "VIDEO"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/FileFormat.ts
var FileFormat;
var init_FileFormat = __esm({
  "src/api/resources/guides/resources/guideTypes/types/FileFormat.ts"() {
    "use strict";
    FileFormat = {
      Jpeg: "jpeg",
      Jpg: "jpg",
      Mov: "mov",
      Mp4: "mp4",
      Pdf: "pdf",
      Png: "png",
      Ppt: "ppt",
      Pptx: "pptx",
      Wav: "wav",
      Webm: "webm"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/index.ts
var init_types16 = __esm({
  "src/api/resources/guides/resources/guideTypes/types/index.ts"() {
    "use strict";
    init_VideoObject();
    init_VideoRecordingType();
    init_PublishedVideoType();
    init_VideoMetadata();
    init_PresignedUrlsForGuide();
    init_PresignedUrlsResponse();
    init_Guide();
    init_GuideHeader();
    init_GuidePreview();
    init_GuidePlatformStatus();
    init_OperationError();
    init_AsyncOperationError();
    init_YouTubePublishError();
    init_ExportingVideoYoutubeErrorBody();
    init_ExportingVideoError();
    init_YouTubeUploadErrorBody();
    init_GeneratingVoiceoverError();
    init_GuideData();
    init_GuidePlatformData();
    init_GuideVersion();
    init_VideoObjectVersion();
    init_NewVideoObject();
    init_GuideSettings();
    init_PlainDoc();
    init_DocStep();
    init_AutoProgressable();
    init_TourStep();
    init_TourStepMetadata();
    init_CustomSelector();
    init_DomElementData();
    init_GeneratedVideo();
    init_TranscribedWord();
    init_ExportedVideo();
    init_VideoSource();
    init_OriginalEdits();
    init_VideoClip();
    init_EditedVideo();
    init_Gender();
    init_VoiceEdits();
    init_Voice();
    init_VoiceEngine();
    init_GuideRequest();
    init_TranscriptionMatchingErrorBody();
    init_ScreenshotOrderingErrorBody();
    init_UnsubscribedErrorBody();
    init_UploadFailedErrorBody();
    init_BlurringErrorBody();
    init_ErrorRenderingVideoBody();
    init_OriginalEditsVersion();
    init_Author();
    init_GuideCreationType();
    init_FileFormat();
  }
});

// src/api/resources/guides/resources/guideTypes/index.ts
var guideTypes_exports = {};
__export(guideTypes_exports, {
  AsyncOperationError: () => AsyncOperationError,
  AutoProgressable: () => AutoProgressable,
  ExportingVideoError: () => ExportingVideoError,
  FileFormat: () => FileFormat,
  Gender: () => Gender,
  GeneratingVoiceoverError: () => GeneratingVoiceoverError,
  GuideCreationType: () => GuideCreationType,
  OriginalEditsVersion: () => OriginalEditsVersion,
  PublishedVideoType: () => PublishedVideoType,
  VideoObjectVersion: () => VideoObjectVersion,
  VideoRecordingType: () => VideoRecordingType,
  VoiceEngine: () => VoiceEngine,
  YouTubePublishError: () => YouTubePublishError
});
var init_guideTypes = __esm({
  "src/api/resources/guides/resources/guideTypes/index.ts"() {
    "use strict";
    init_types16();
  }
});

// src/api/resources/guides/resources/prompts/types/GetPromptsResponse.ts
var init_GetPromptsResponse = __esm({
  "src/api/resources/guides/resources/prompts/types/GetPromptsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/prompts/types/PromptType.ts
var PromptType;
var init_PromptType = __esm({
  "src/api/resources/guides/resources/prompts/types/PromptType.ts"() {
    "use strict";
    PromptType = {
      EnhanceArticle: "enhance_article",
      EnhanceVideo: "enhance_video",
      TranslateVideo: "translate_video",
      TranslateArticle: "translate_article"
    };
  }
});

// src/api/resources/guides/resources/prompts/types/Prompt.ts
var init_Prompt = __esm({
  "src/api/resources/guides/resources/prompts/types/Prompt.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/prompts/types/PromptOption.ts
var init_PromptOption = __esm({
  "src/api/resources/guides/resources/prompts/types/PromptOption.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/prompts/types/Logo.ts
var init_Logo = __esm({
  "src/api/resources/guides/resources/prompts/types/Logo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/prompts/types/index.ts
var init_types17 = __esm({
  "src/api/resources/guides/resources/prompts/types/index.ts"() {
    "use strict";
    init_GetPromptsResponse();
    init_PromptType();
    init_Prompt();
    init_PromptOption();
    init_Logo();
  }
});

// src/api/resources/guides/resources/prompts/client/requests/index.ts
var init_requests8 = __esm({
  "src/api/resources/guides/resources/prompts/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/prompts/client/getPrompts.ts
var getPrompts_exports = {};
__export(getPrompts_exports, {
  Error: () => Error99
});
var Error99;
var init_getPrompts = __esm({
  "src/api/resources/guides/resources/prompts/client/getPrompts.ts"() {
    "use strict";
    init_src();
    Error99 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.getPrompts.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.getPrompts.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.getPrompts.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.prompts.getPrompts.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/createPrompt.ts
var createPrompt_exports = {};
__export(createPrompt_exports, {
  Error: () => Error100
});
var Error100;
var init_createPrompt = __esm({
  "src/api/resources/guides/resources/prompts/client/createPrompt.ts"() {
    "use strict";
    init_src();
    Error100 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.createPrompt.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.createPrompt.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.createPrompt.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.prompts.createPrompt.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/deletePrompt.ts
var deletePrompt_exports = {};
__export(deletePrompt_exports, {
  Error: () => Error101
});
var Error101;
var init_deletePrompt = __esm({
  "src/api/resources/guides/resources/prompts/client/deletePrompt.ts"() {
    "use strict";
    init_src();
    Error101 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.deletePrompt.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.deletePrompt.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.deletePrompt.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.prompts.deletePrompt.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/updatePrompt.ts
var updatePrompt_exports = {};
__export(updatePrompt_exports, {
  Error: () => Error102
});
var Error102;
var init_updatePrompt = __esm({
  "src/api/resources/guides/resources/prompts/client/updatePrompt.ts"() {
    "use strict";
    init_src();
    Error102 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.updatePrompt.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.updatePrompt.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.updatePrompt.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.prompts.updatePrompt.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/applyPrompt.ts
var applyPrompt_exports = {};
__export(applyPrompt_exports, {
  Error: () => Error103
});
var Error103;
var init_applyPrompt = __esm({
  "src/api/resources/guides/resources/prompts/client/applyPrompt.ts"() {
    "use strict";
    init_src();
    Error103 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.applyPrompt.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.applyPrompt.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.prompts.applyPrompt.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.prompts.applyPrompt.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/index.ts
var init_client13 = __esm({
  "src/api/resources/guides/resources/prompts/client/index.ts"() {
    "use strict";
    init_requests8();
    init_getPrompts();
    init_createPrompt();
    init_deletePrompt();
    init_updatePrompt();
    init_applyPrompt();
  }
});

// src/api/resources/guides/resources/prompts/index.ts
var prompts_exports = {};
__export(prompts_exports, {
  PromptType: () => PromptType,
  applyPrompt: () => applyPrompt_exports,
  createPrompt: () => createPrompt_exports,
  deletePrompt: () => deletePrompt_exports,
  getPrompts: () => getPrompts_exports,
  updatePrompt: () => updatePrompt_exports
});
var init_prompts = __esm({
  "src/api/resources/guides/resources/prompts/index.ts"() {
    "use strict";
    init_types17();
    init_client13();
  }
});

// src/api/resources/guides/resources/guidePlatformStatus/client/getStatus.ts
var getStatus_exports = {};
__export(getStatus_exports, {
  Error: () => Error104
});
var Error104;
var init_getStatus = __esm({
  "src/api/resources/guides/resources/guidePlatformStatus/client/getStatus.ts"() {
    "use strict";
    init_src();
    Error104 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.getStatus.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.getStatus.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.getStatus.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.getStatus.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guidePlatformStatus/client/markErrorViewed.ts
var markErrorViewed_exports = {};
__export(markErrorViewed_exports, {
  Error: () => Error105
});
var Error105;
var init_markErrorViewed = __esm({
  "src/api/resources/guides/resources/guidePlatformStatus/client/markErrorViewed.ts"() {
    "use strict";
    init_src();
    Error105 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guidePlatformStatus/client/index.ts
var init_client14 = __esm({
  "src/api/resources/guides/resources/guidePlatformStatus/client/index.ts"() {
    "use strict";
    init_getStatus();
    init_markErrorViewed();
  }
});

// src/api/resources/guides/resources/guidePlatformStatus/index.ts
var guidePlatformStatus_exports = {};
__export(guidePlatformStatus_exports, {
  getStatus: () => getStatus_exports,
  markErrorViewed: () => markErrorViewed_exports
});
var init_guidePlatformStatus = __esm({
  "src/api/resources/guides/resources/guidePlatformStatus/index.ts"() {
    "use strict";
    init_client14();
  }
});

// src/api/resources/guides/resources/guideQueries/client/requests/index.ts
var init_requests9 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideQueries/client/search.ts
var search_exports = {};
__export(search_exports, {
  Error: () => Error106
});
var Error106;
var init_search = __esm({
  "src/api/resources/guides/resources/guideQueries/client/search.ts"() {
    "use strict";
    init_src();
    Error106 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports = {};
__export(getGuidePreviews_exports, {
  Error: () => Error107
});
var Error107;
var init_getGuidePreviews = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error107 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports = {};
__export(getAllGuidePreviews_exports, {
  Error: () => Error108
});
var Error108;
var init_getAllGuidePreviews = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error108 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getRecentGuidePreviews.ts
var getRecentGuidePreviews_exports = {};
__export(getRecentGuidePreviews_exports, {
  Error: () => Error109
});
var Error109;
var init_getRecentGuidePreviews = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getRecentGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error109 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuideData.ts
var getGuideData_exports = {};
__export(getGuideData_exports, {
  Error: () => Error110
});
var Error110;
var init_getGuideData = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    Error110 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuidePlatformData.ts
var getGuidePlatformData_exports = {};
__export(getGuidePlatformData_exports, {
  Error: () => Error111
});
var Error111;
var init_getGuidePlatformData = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuidePlatformData.ts"() {
    "use strict";
    init_src();
    Error111 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePlatformData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePlatformData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePlatformData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePlatformData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuidePreview.ts
var getGuidePreview_exports = {};
__export(getGuidePreview_exports, {
  Error: () => Error112
});
var Error112;
var init_getGuidePreview = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    Error112 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      noAccessError: () => {
        return {
          error: "NoAccessError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "NoAccessError":
            return visitor.noAccessError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getAllVersions.ts
var getAllVersions_exports = {};
__export(getAllVersions_exports, {
  Error: () => Error113
});
var Error113;
var init_getAllVersions = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getAllVersions.ts"() {
    "use strict";
    init_src();
    Error113 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllVersions.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllVersions.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllVersions.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllVersions.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllVersions.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/index.ts
var init_client15 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/index.ts"() {
    "use strict";
    init_requests9();
    init_search();
    init_getGuidePreviews();
    init_getAllGuidePreviews();
    init_getRecentGuidePreviews();
    init_getGuideData();
    init_getGuidePlatformData();
    init_getGuidePreview();
    init_getAllVersions();
  }
});

// src/api/resources/guides/resources/guideQueries/index.ts
var guideQueries_exports = {};
__export(guideQueries_exports, {
  getAllGuidePreviews: () => getAllGuidePreviews_exports,
  getAllVersions: () => getAllVersions_exports,
  getGuideData: () => getGuideData_exports,
  getGuidePlatformData: () => getGuidePlatformData_exports,
  getGuidePreview: () => getGuidePreview_exports,
  getGuidePreviews: () => getGuidePreviews_exports,
  getRecentGuidePreviews: () => getRecentGuidePreviews_exports,
  search: () => search_exports
});
var init_guideQueries = __esm({
  "src/api/resources/guides/resources/guideQueries/index.ts"() {
    "use strict";
    init_client15();
  }
});

// src/api/resources/guides/resources/index.ts
var init_resources2 = __esm({
  "src/api/resources/guides/resources/index.ts"() {
    "use strict";
    init_aiEnhance();
    init_types10();
    init_broadcasts();
    init_types11();
    init_guideAiChat();
    init_types12();
    init_guideExports();
    init_types13();
    init_guideMutations();
    init_types14();
    init_guideQueryCore();
    init_types15();
    init_guideTypes();
    init_types16();
    init_prompts();
    init_types17();
    init_guidePlatformStatus();
    init_guideQueries();
    init_requests5();
    init_requests6();
    init_requests7();
    init_requests9();
    init_requests8();
  }
});

// src/api/resources/guides/client/index.ts
var init_client16 = __esm({
  "src/api/resources/guides/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/index.ts
var guides_exports = {};
__export(guides_exports, {
  AdvancedSettings: () => AdvancedSettings,
  AsyncOperationError: () => AsyncOperationError,
  AutoProgressable: () => AutoProgressable,
  BroadcastPlatform: () => BroadcastPlatform,
  BroadcastStatus: () => BroadcastStatus,
  ExportExecutionSpeed: () => ExportExecutionSpeed,
  ExportProcess: () => ExportProcess,
  ExportProcessType: () => ExportProcessType,
  ExportStatus: () => ExportStatus,
  ExportingVideoError: () => ExportingVideoError,
  FileFormat: () => FileFormat,
  Gender: () => Gender,
  GeneratingVoiceoverError: () => GeneratingVoiceoverError,
  GuideAiChatContentType: () => GuideAiChatContentType,
  GuideAiChatSenderRole: () => GuideAiChatSenderRole,
  GuideCreationType: () => GuideCreationType,
  OriginalEditsVersion: () => OriginalEditsVersion,
  PptContentMode: () => PptContentMode,
  PromptType: () => PromptType,
  PublishedVideoType: () => PublishedVideoType,
  VideoObjectVersion: () => VideoObjectVersion,
  VideoRecordingType: () => VideoRecordingType,
  VoiceEngine: () => VoiceEngine,
  YouTubePublishError: () => YouTubePublishError,
  aiEnhance: () => aiEnhance_exports,
  broadcasts: () => broadcasts_exports,
  guideAiChat: () => guideAiChat_exports,
  guideExports: () => guideExports_exports,
  guideMutations: () => guideMutations_exports,
  guidePlatformStatus: () => guidePlatformStatus_exports,
  guideQueries: () => guideQueries_exports,
  guideQueryCore: () => guideQueryCore_exports,
  guideTypes: () => guideTypes_exports,
  prompts: () => prompts_exports
});
var init_guides = __esm({
  "src/api/resources/guides/index.ts"() {
    "use strict";
    init_resources2();
    init_client16();
  }
});

// src/api/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts
var init_InvalidSessionErrorBody = __esm({
  "src/api/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenterQueries/types/OrgAndConfig.ts
var init_OrgAndConfig = __esm({
  "src/api/resources/helpcenterQueries/types/OrgAndConfig.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenterQueries/types/index.ts
var init_types18 = __esm({
  "src/api/resources/helpcenterQueries/types/index.ts"() {
    "use strict";
    init_InvalidSessionErrorBody();
    init_OrgAndConfig();
  }
});

// src/api/resources/helpcenterQueries/client/requests/index.ts
var init_requests10 = __esm({
  "src/api/resources/helpcenterQueries/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenterQueries/client/validateToken.ts
var validateToken_exports = {};
__export(validateToken_exports, {
  Error: () => Error114
});
var Error114;
var init_validateToken = __esm({
  "src/api/resources/helpcenterQueries/client/validateToken.ts"() {
    "use strict";
    init_src();
    Error114 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getOrganization.ts
var getOrganization_exports = {};
__export(getOrganization_exports, {
  Error: () => Error115
});
var Error115;
var init_getOrganization = __esm({
  "src/api/resources/helpcenterQueries/client/getOrganization.ts"() {
    "use strict";
    init_src();
    Error115 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getOrgAndConfig.ts
var getOrgAndConfig_exports = {};
__export(getOrgAndConfig_exports, {
  Error: () => Error116
});
var Error116;
var init_getOrgAndConfig = __esm({
  "src/api/resources/helpcenterQueries/client/getOrgAndConfig.ts"() {
    "use strict";
    init_src();
    Error116 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrgAndConfig.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrgAndConfig.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrgAndConfig.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrgAndConfig.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/search.ts
var search_exports2 = {};
__export(search_exports2, {
  Error: () => Error117
});
var Error117;
var init_search2 = __esm({
  "src/api/resources/helpcenterQueries/client/search.ts"() {
    "use strict";
    init_src();
    Error117 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports2 = {};
__export(getGuidePreviews_exports2, {
  Error: () => Error118
});
var Error118;
var init_getGuidePreviews2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error118 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports2 = {};
__export(getAllGuidePreviews_exports2, {
  Error: () => Error119
});
var Error119;
var init_getAllGuidePreviews2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error119 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuideData.ts
var getGuideData_exports2 = {};
__export(getGuideData_exports2, {
  Error: () => Error120
});
var Error120;
var init_getGuideData2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    Error120 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuidePreview.ts
var getGuidePreview_exports2 = {};
__export(getGuidePreview_exports2, {
  Error: () => Error121
});
var Error121;
var init_getGuidePreview2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    Error121 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getCollections.ts
var getCollections_exports2 = {};
__export(getCollections_exports2, {
  Error: () => Error122
});
var Error122;
var init_getCollections2 = __esm({
  "src/api/resources/helpcenterQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    Error122 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllChildren.ts
var getAllChildren_exports2 = {};
__export(getAllChildren_exports2, {
  Error: () => Error123
});
var Error123;
var init_getAllChildren2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    Error123 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllCollections.ts
var getAllCollections_exports2 = {};
__export(getAllCollections_exports2, {
  Error: () => Error124
});
var Error124;
var init_getAllCollections2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    Error124 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getPath.ts
var getPath_exports2 = {};
__export(getPath_exports2, {
  Error: () => Error125
});
var Error125;
var init_getPath2 = __esm({
  "src/api/resources/helpcenterQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    Error125 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/index.ts
var init_client17 = __esm({
  "src/api/resources/helpcenterQueries/client/index.ts"() {
    "use strict";
    init_requests10();
    init_validateToken();
    init_getOrganization();
    init_getOrgAndConfig();
    init_search2();
    init_getGuidePreviews2();
    init_getAllGuidePreviews2();
    init_getGuideData2();
    init_getGuidePreview2();
    init_getCollections2();
    init_getAllChildren2();
    init_getAllCollections2();
    init_getPath2();
  }
});

// src/api/resources/helpcenterQueries/index.ts
var helpcenterQueries_exports = {};
__export(helpcenterQueries_exports, {
  getAllChildren: () => getAllChildren_exports2,
  getAllCollections: () => getAllCollections_exports2,
  getAllGuidePreviews: () => getAllGuidePreviews_exports2,
  getCollections: () => getCollections_exports2,
  getGuideData: () => getGuideData_exports2,
  getGuidePreview: () => getGuidePreview_exports2,
  getGuidePreviews: () => getGuidePreviews_exports2,
  getOrgAndConfig: () => getOrgAndConfig_exports,
  getOrganization: () => getOrganization_exports,
  getPath: () => getPath_exports2,
  search: () => search_exports2,
  validateToken: () => validateToken_exports
});
var init_helpcenterQueries = __esm({
  "src/api/resources/helpcenterQueries/index.ts"() {
    "use strict";
    init_types18();
    init_client17();
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupRequest.ts
var init_CustomDomainSetupRequest = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupResponse.ts
var init_CustomDomainSetupResponse = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/DnsEntry.ts
var init_DnsEntry = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/DnsEntry.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/UpdateOrValidateDnsRecordRequest.ts
var init_UpdateOrValidateDnsRecordRequest = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/UpdateOrValidateDnsRecordRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/GetDnsStatusResponse.ts
var init_GetDnsStatusResponse = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/GetDnsStatusResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/GetHelpCentersUrlsResponse.ts
var init_GetHelpCentersUrlsResponse = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/GetHelpCentersUrlsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/ValidateDnsRecordResponse.ts
var init_ValidateDnsRecordResponse = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/ValidateDnsRecordResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/VerifyDnsRecordResponse.ts
var init_VerifyDnsRecordResponse = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/VerifyDnsRecordResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/DnsVerificationStatus.ts
var DnsVerificationStatus;
var init_DnsVerificationStatus = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/DnsVerificationStatus.ts"() {
    "use strict";
    DnsVerificationStatus = {
      Verified: "VERIFIED",
      Failed: "FAILED",
      Pending: "PENDING"
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/types/index.ts
var init_types19 = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/types/index.ts"() {
    "use strict";
    init_CustomDomainSetupRequest();
    init_CustomDomainSetupResponse();
    init_DnsEntry();
    init_UpdateOrValidateDnsRecordRequest();
    init_GetDnsStatusResponse();
    init_GetHelpCentersUrlsResponse();
    init_ValidateDnsRecordResponse();
    init_VerifyDnsRecordResponse();
    init_DnsVerificationStatus();
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/getDnsStatus.ts
var getDnsStatus_exports = {};
__export(getDnsStatus_exports, {
  Error: () => Error126
});
var Error126;
var init_getDnsStatus = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/getDnsStatus.ts"() {
    "use strict";
    init_src();
    Error126 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/validateDnsRecord.ts
var validateDnsRecord_exports = {};
__export(validateDnsRecord_exports, {
  Error: () => Error127
});
var Error127;
var init_validateDnsRecord = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/validateDnsRecord.ts"() {
    "use strict";
    init_src();
    Error127 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/updateDnsRecord.ts
var updateDnsRecord_exports = {};
__export(updateDnsRecord_exports, {
  Error: () => Error128
});
var Error128;
var init_updateDnsRecord = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/updateDnsRecord.ts"() {
    "use strict";
    init_src();
    Error128 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      recordAlreadyInUseError: () => {
        return {
          error: "RecordAlreadyInUseError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "RecordAlreadyInUseError":
            return visitor.recordAlreadyInUseError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/customDomainSetup.ts
var customDomainSetup_exports = {};
__export(customDomainSetup_exports, {
  Error: () => Error129
});
var Error129;
var init_customDomainSetup = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/customDomainSetup.ts"() {
    "use strict";
    init_src();
    Error129 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      recordAlreadyInUseError: () => {
        return {
          error: "RecordAlreadyInUseError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "RecordAlreadyInUseError":
            return visitor.recordAlreadyInUseError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/deleteDomain.ts
var deleteDomain_exports = {};
__export(deleteDomain_exports, {
  Error: () => Error130
});
var Error130;
var init_deleteDomain = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/deleteDomain.ts"() {
    "use strict";
    init_src();
    Error130 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/verifyDomainSetup.ts
var verifyDomainSetup_exports = {};
__export(verifyDomainSetup_exports, {
  Error: () => Error131
});
var Error131;
var init_verifyDomainSetup = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/verifyDomainSetup.ts"() {
    "use strict";
    init_src();
    Error131 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/getHelpcenterUrls.ts
var getHelpcenterUrls_exports = {};
__export(getHelpcenterUrls_exports, {
  Error: () => Error132
});
var Error132;
var init_getHelpcenterUrls = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/getHelpcenterUrls.ts"() {
    "use strict";
    init_src();
    Error132 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/index.ts
var init_client18 = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/index.ts"() {
    "use strict";
    init_getDnsStatus();
    init_validateDnsRecord();
    init_updateDnsRecord();
    init_customDomainSetup();
    init_deleteDomain();
    init_verifyDomainSetup();
    init_getHelpcenterUrls();
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/index.ts
var helpcenterMutations_exports = {};
__export(helpcenterMutations_exports, {
  DnsVerificationStatus: () => DnsVerificationStatus,
  customDomainSetup: () => customDomainSetup_exports,
  deleteDomain: () => deleteDomain_exports,
  getDnsStatus: () => getDnsStatus_exports,
  getHelpcenterUrls: () => getHelpcenterUrls_exports,
  updateDnsRecord: () => updateDnsRecord_exports,
  validateDnsRecord: () => validateDnsRecord_exports,
  verifyDomainSetup: () => verifyDomainSetup_exports
});
var init_helpcenterMutations = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/index.ts"() {
    "use strict";
    init_types19();
    init_client18();
  }
});

// src/api/resources/helpcenter/resources/index.ts
var init_resources3 = __esm({
  "src/api/resources/helpcenter/resources/index.ts"() {
    "use strict";
    init_helpcenterMutations();
    init_types19();
  }
});

// src/api/resources/helpcenter/client/index.ts
var init_client19 = __esm({
  "src/api/resources/helpcenter/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenter/index.ts
var helpcenter_exports = {};
__export(helpcenter_exports, {
  DnsVerificationStatus: () => DnsVerificationStatus,
  helpcenterMutations: () => helpcenterMutations_exports
});
var init_helpcenter = __esm({
  "src/api/resources/helpcenter/index.ts"() {
    "use strict";
    init_resources3();
    init_client19();
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/GetIntegrationAuthUrlRequest.ts
var init_GetIntegrationAuthUrlRequest = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/GetIntegrationAuthUrlRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/IntegrationAuthUrlResponse.ts
var init_IntegrationAuthUrlResponse = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/IntegrationAuthUrlResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/IntegrationOAuthCallbackRequest.ts
var init_IntegrationOAuthCallbackRequest = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/IntegrationOAuthCallbackRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/DisconnectIntegrationRequest.ts
var init_DisconnectIntegrationRequest = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/DisconnectIntegrationRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/IntegrationDetails.ts
var init_IntegrationDetails = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/IntegrationDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/IntegrationApp.ts
var IntegrationApp;
var init_IntegrationApp = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/IntegrationApp.ts"() {
    "use strict";
    IntegrationApp = {
      Slack: "slack",
      Youtube: "youtube",
      Discord: "discord",
      Whatsapp: "whatsapp",
      Teams: "teams"
    };
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/LoadIntegrationsResponse.ts
var init_LoadIntegrationsResponse = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/LoadIntegrationsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/integrationSetup/types/index.ts
var init_types20 = __esm({
  "src/api/resources/integrations/resources/integrationSetup/types/index.ts"() {
    "use strict";
    init_GetIntegrationAuthUrlRequest();
    init_IntegrationAuthUrlResponse();
    init_IntegrationOAuthCallbackRequest();
    init_DisconnectIntegrationRequest();
    init_IntegrationDetails();
    init_IntegrationApp();
    init_LoadIntegrationsResponse();
  }
});

// src/api/resources/integrations/resources/integrationSetup/client/loadIntegrations.ts
var loadIntegrations_exports = {};
__export(loadIntegrations_exports, {
  Error: () => Error133
});
var Error133;
var init_loadIntegrations = __esm({
  "src/api/resources/integrations/resources/integrationSetup/client/loadIntegrations.ts"() {
    "use strict";
    init_src();
    Error133 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.integrationSetup.loadIntegrations.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.integrationSetup.loadIntegrations.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.integrationSetup.loadIntegrations.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.integrationSetup.loadIntegrations.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/integrationSetup/client/index.ts
var init_client20 = __esm({
  "src/api/resources/integrations/resources/integrationSetup/client/index.ts"() {
    "use strict";
    init_loadIntegrations();
  }
});

// src/api/resources/integrations/resources/integrationSetup/index.ts
var integrationSetup_exports = {};
__export(integrationSetup_exports, {
  IntegrationApp: () => IntegrationApp,
  loadIntegrations: () => loadIntegrations_exports
});
var init_integrationSetup = __esm({
  "src/api/resources/integrations/resources/integrationSetup/index.ts"() {
    "use strict";
    init_types20();
    init_client20();
  }
});

// src/api/resources/integrations/resources/slack/types/WorkspaceStatusResponse.ts
var init_WorkspaceStatusResponse = __esm({
  "src/api/resources/integrations/resources/slack/types/WorkspaceStatusResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/WorkspaceInfo.ts
var init_WorkspaceInfo = __esm({
  "src/api/resources/integrations/resources/slack/types/WorkspaceInfo.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/ChannelsResponse.ts
var init_ChannelsResponse = __esm({
  "src/api/resources/integrations/resources/slack/types/ChannelsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/SlackChannel.ts
var init_SlackChannel = __esm({
  "src/api/resources/integrations/resources/slack/types/SlackChannel.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/SlackChannelConfig.ts
var init_SlackChannelConfig = __esm({
  "src/api/resources/integrations/resources/slack/types/SlackChannelConfig.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/AppearanceSettings.ts
var init_AppearanceSettings = __esm({
  "src/api/resources/integrations/resources/slack/types/AppearanceSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/MessageCustomization.ts
var init_MessageCustomization = __esm({
  "src/api/resources/integrations/resources/slack/types/MessageCustomization.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/AnnouncementType.ts
var AnnouncementType;
var init_AnnouncementType = __esm({
  "src/api/resources/integrations/resources/slack/types/AnnouncementType.ts"() {
    "use strict";
    AnnouncementType = {
      NewGuidePublished: "new_guide_published",
      GuideUpdated: "guide_updated",
      NewTeamMember: "new_team_member",
      CustomAnnouncement: "custom_announcement"
    };
  }
});

// src/api/resources/integrations/resources/slack/types/FailedChannel.ts
var init_FailedChannel = __esm({
  "src/api/resources/integrations/resources/slack/types/FailedChannel.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/types/index.ts
var init_types21 = __esm({
  "src/api/resources/integrations/resources/slack/types/index.ts"() {
    "use strict";
    init_WorkspaceStatusResponse();
    init_WorkspaceInfo();
    init_ChannelsResponse();
    init_SlackChannel();
    init_SlackChannelConfig();
    init_AppearanceSettings();
    init_MessageCustomization();
    init_AnnouncementType();
    init_FailedChannel();
  }
});

// src/api/resources/integrations/resources/slack/client/requests/index.ts
var init_requests11 = __esm({
  "src/api/resources/integrations/resources/slack/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/slack/client/checkSlackIntegration.ts
var checkSlackIntegration_exports = {};
__export(checkSlackIntegration_exports, {
  Error: () => Error134
});
var Error134;
var init_checkSlackIntegration = __esm({
  "src/api/resources/integrations/resources/slack/client/checkSlackIntegration.ts"() {
    "use strict";
    init_src();
    Error134 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.checkSlackIntegration.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.checkSlackIntegration.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.checkSlackIntegration.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.checkSlackIntegration.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/getAuthUrl.ts
var getAuthUrl_exports = {};
__export(getAuthUrl_exports, {
  Error: () => Error135
});
var Error135;
var init_getAuthUrl = __esm({
  "src/api/resources/integrations/resources/slack/client/getAuthUrl.ts"() {
    "use strict";
    init_src();
    Error135 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/handleOAuthCallback.ts
var handleOAuthCallback_exports = {};
__export(handleOAuthCallback_exports, {
  Error: () => Error136
});
var Error136;
var init_handleOAuthCallback = __esm({
  "src/api/resources/integrations/resources/slack/client/handleOAuthCallback.ts"() {
    "use strict";
    init_src();
    Error136 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/disconnectIntegration.ts
var disconnectIntegration_exports = {};
__export(disconnectIntegration_exports, {
  Error: () => Error137
});
var Error137;
var init_disconnectIntegration = __esm({
  "src/api/resources/integrations/resources/slack/client/disconnectIntegration.ts"() {
    "use strict";
    init_src();
    Error137 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/getChannels.ts
var getChannels_exports = {};
__export(getChannels_exports, {
  Error: () => Error138
});
var Error138;
var init_getChannels = __esm({
  "src/api/resources/integrations/resources/slack/client/getChannels.ts"() {
    "use strict";
    init_src();
    Error138 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getChannels.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getChannels.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.getChannels.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.getChannels.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/sendBroadcast.ts
var sendBroadcast_exports2 = {};
__export(sendBroadcast_exports2, {
  Error: () => Error139
});
var Error139;
var init_sendBroadcast2 = __esm({
  "src/api/resources/integrations/resources/slack/client/sendBroadcast.ts"() {
    "use strict";
    init_src();
    Error139 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.slack.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.slack.sendBroadcast.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/index.ts
var init_client21 = __esm({
  "src/api/resources/integrations/resources/slack/client/index.ts"() {
    "use strict";
    init_requests11();
    init_checkSlackIntegration();
    init_getAuthUrl();
    init_handleOAuthCallback();
    init_disconnectIntegration();
    init_getChannels();
    init_sendBroadcast2();
  }
});

// src/api/resources/integrations/resources/slack/index.ts
var slack_exports = {};
__export(slack_exports, {
  AnnouncementType: () => AnnouncementType,
  checkSlackIntegration: () => checkSlackIntegration_exports,
  disconnectIntegration: () => disconnectIntegration_exports,
  getAuthUrl: () => getAuthUrl_exports,
  getChannels: () => getChannels_exports,
  handleOAuthCallback: () => handleOAuthCallback_exports,
  sendBroadcast: () => sendBroadcast_exports2
});
var init_slack = __esm({
  "src/api/resources/integrations/resources/slack/index.ts"() {
    "use strict";
    init_types21();
    init_client21();
  }
});

// src/api/resources/integrations/resources/youtube/types/GetPlaylistsResponse.ts
var init_GetPlaylistsResponse = __esm({
  "src/api/resources/integrations/resources/youtube/types/GetPlaylistsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/youtube/types/Playlist.ts
var init_Playlist = __esm({
  "src/api/resources/integrations/resources/youtube/types/Playlist.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/youtube/types/PublishToYouTubeRequest.ts
var init_PublishToYouTubeRequest = __esm({
  "src/api/resources/integrations/resources/youtube/types/PublishToYouTubeRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/resources/youtube/types/VisibilityStatus.ts
var VisibilityStatus;
var init_VisibilityStatus = __esm({
  "src/api/resources/integrations/resources/youtube/types/VisibilityStatus.ts"() {
    "use strict";
    VisibilityStatus = {
      Public: "PUBLIC",
      Private: "PRIVATE",
      Unlisted: "UNLISTED"
    };
  }
});

// src/api/resources/integrations/resources/youtube/types/index.ts
var init_types22 = __esm({
  "src/api/resources/integrations/resources/youtube/types/index.ts"() {
    "use strict";
    init_GetPlaylistsResponse();
    init_Playlist();
    init_PublishToYouTubeRequest();
    init_VisibilityStatus();
  }
});

// src/api/resources/integrations/resources/youtube/client/getIntegrationDetails.ts
var getIntegrationDetails_exports = {};
__export(getIntegrationDetails_exports, {
  Error: () => Error140
});
var Error140;
var init_getIntegrationDetails = __esm({
  "src/api/resources/integrations/resources/youtube/client/getIntegrationDetails.ts"() {
    "use strict";
    init_src();
    Error140 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getIntegrationDetails.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getIntegrationDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getIntegrationDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getIntegrationDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getIntegrationDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/getAuthUrl.ts
var getAuthUrl_exports2 = {};
__export(getAuthUrl_exports2, {
  Error: () => Error141
});
var Error141;
var init_getAuthUrl2 = __esm({
  "src/api/resources/integrations/resources/youtube/client/getAuthUrl.ts"() {
    "use strict";
    init_src();
    Error141 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getAuthUrl.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/handleOAuthCallback.ts
var handleOAuthCallback_exports2 = {};
__export(handleOAuthCallback_exports2, {
  Error: () => Error142
});
var Error142;
var init_handleOAuthCallback2 = __esm({
  "src/api/resources/integrations/resources/youtube/client/handleOAuthCallback.ts"() {
    "use strict";
    init_src();
    Error142 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      noChannelFoundError: () => {
        return {
          error: "NoChannelFoundError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.handleOAuthCallback.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "NoChannelFoundError":
            return visitor.noChannelFoundError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/disconnectIntegration.ts
var disconnectIntegration_exports2 = {};
__export(disconnectIntegration_exports2, {
  Error: () => Error143
});
var Error143;
var init_disconnectIntegration2 = __esm({
  "src/api/resources/integrations/resources/youtube/client/disconnectIntegration.ts"() {
    "use strict";
    init_src();
    Error143 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.disconnectIntegration.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/getPlayListsDetails.ts
var getPlayListsDetails_exports = {};
__export(getPlayListsDetails_exports, {
  Error: () => Error144
});
var Error144;
var init_getPlayListsDetails = __esm({
  "src/api/resources/integrations/resources/youtube/client/getPlayListsDetails.ts"() {
    "use strict";
    init_src();
    Error144 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getPlayListsDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getPlayListsDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.getPlayListsDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/publishToYouTube.ts
var publishToYouTube_exports = {};
__export(publishToYouTube_exports, {
  Error: () => Error145
});
var Error145;
var init_publishToYouTube = __esm({
  "src/api/resources/integrations/resources/youtube/client/publishToYouTube.ts"() {
    "use strict";
    init_src();
    Error145 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.publishToYouTube.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.publishToYouTube.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.publishToYouTube.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.integrations.youtube.publishToYouTube.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.integrations.youtube.publishToYouTube.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/index.ts
var init_client22 = __esm({
  "src/api/resources/integrations/resources/youtube/client/index.ts"() {
    "use strict";
    init_getIntegrationDetails();
    init_getAuthUrl2();
    init_handleOAuthCallback2();
    init_disconnectIntegration2();
    init_getPlayListsDetails();
    init_publishToYouTube();
  }
});

// src/api/resources/integrations/resources/youtube/index.ts
var youtube_exports = {};
__export(youtube_exports, {
  VisibilityStatus: () => VisibilityStatus,
  disconnectIntegration: () => disconnectIntegration_exports2,
  getAuthUrl: () => getAuthUrl_exports2,
  getIntegrationDetails: () => getIntegrationDetails_exports,
  getPlayListsDetails: () => getPlayListsDetails_exports,
  handleOAuthCallback: () => handleOAuthCallback_exports2,
  publishToYouTube: () => publishToYouTube_exports
});
var init_youtube = __esm({
  "src/api/resources/integrations/resources/youtube/index.ts"() {
    "use strict";
    init_types22();
    init_client22();
  }
});

// src/api/resources/integrations/resources/index.ts
var init_resources4 = __esm({
  "src/api/resources/integrations/resources/index.ts"() {
    "use strict";
    init_integrationSetup();
    init_types20();
    init_slack();
    init_types21();
    init_youtube();
    init_types22();
    init_requests11();
  }
});

// src/api/resources/integrations/client/index.ts
var init_client23 = __esm({
  "src/api/resources/integrations/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/integrations/index.ts
var integrations_exports = {};
__export(integrations_exports, {
  AnnouncementType: () => AnnouncementType,
  IntegrationApp: () => IntegrationApp,
  VisibilityStatus: () => VisibilityStatus,
  integrationSetup: () => integrationSetup_exports,
  slack: () => slack_exports,
  youtube: () => youtube_exports
});
var init_integrations = __esm({
  "src/api/resources/integrations/index.ts"() {
    "use strict";
    init_resources4();
    init_client23();
  }
});

// src/api/resources/organizations/resources/organizationBranding/types/OrganizationLogo.ts
var init_OrganizationLogo = __esm({
  "src/api/resources/organizations/resources/organizationBranding/types/OrganizationLogo.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationBranding/types/index.ts
var init_types23 = __esm({
  "src/api/resources/organizations/resources/organizationBranding/types/index.ts"() {
    "use strict";
    init_OrganizationLogo();
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/requests/index.ts
var init_requests12 = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/initiateLogoUpload.ts
var initiateLogoUpload_exports = {};
__export(initiateLogoUpload_exports, {
  Error: () => Error146
});
var Error146;
var init_initiateLogoUpload = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/initiateLogoUpload.ts"() {
    "use strict";
    init_src();
    Error146 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/finishLogoUpload.ts
var finishLogoUpload_exports = {};
__export(finishLogoUpload_exports, {
  Error: () => Error147
});
var Error147;
var init_finishLogoUpload = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/finishLogoUpload.ts"() {
    "use strict";
    init_src();
    Error147 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/deleteLogo.ts
var deleteLogo_exports = {};
__export(deleteLogo_exports, {
  Error: () => Error148
});
var Error148;
var init_deleteLogo = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/deleteLogo.ts"() {
    "use strict";
    init_src();
    Error148 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.deleteLogo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.deleteLogo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.deleteLogo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.deleteLogo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/updateLogo.ts
var updateLogo_exports = {};
__export(updateLogo_exports, {
  Error: () => Error149
});
var Error149;
var init_updateLogo = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/updateLogo.ts"() {
    "use strict";
    init_src();
    Error149 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.updateLogo.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.updateLogo.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.updateLogo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.updateLogo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/getLogos.ts
var getLogos_exports = {};
__export(getLogos_exports, {
  Error: () => Error150
});
var Error150;
var init_getLogos = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/getLogos.ts"() {
    "use strict";
    init_src();
    Error150 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.getLogos.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.getLogos.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.getLogos.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationBranding.getLogos.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/index.ts
var init_client24 = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/index.ts"() {
    "use strict";
    init_requests12();
    init_initiateLogoUpload();
    init_finishLogoUpload();
    init_deleteLogo();
    init_updateLogo();
    init_getLogos();
  }
});

// src/api/resources/organizations/resources/organizationBranding/index.ts
var organizationBranding_exports = {};
__export(organizationBranding_exports, {
  deleteLogo: () => deleteLogo_exports,
  finishLogoUpload: () => finishLogoUpload_exports,
  getLogos: () => getLogos_exports,
  initiateLogoUpload: () => initiateLogoUpload_exports,
  updateLogo: () => updateLogo_exports
});
var init_organizationBranding = __esm({
  "src/api/resources/organizations/resources/organizationBranding/index.ts"() {
    "use strict";
    init_types23();
    init_client24();
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/CreateOrganizationRequest.ts
var init_CreateOrganizationRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/CreateOrganizationRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForNewOrg.ts
var init_AnalyticsForNewOrg = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForNewOrg.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForNewUser.ts
var init_AnalyticsForNewUser = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForNewUser.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForSignupWorkflow.ts
var init_AnalyticsForSignupWorkflow = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/AnalyticsForSignupWorkflow.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/CreateOrganizationDetails.ts
var init_CreateOrganizationDetails = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/CreateOrganizationDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/JoinOrganizationRequest.ts
var init_JoinOrganizationRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/JoinOrganizationRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/JoinOrganizationDetails.ts
var init_JoinOrganizationDetails = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/JoinOrganizationDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/AddUserToOrganizationRequest.ts
var init_AddUserToOrganizationRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/AddUserToOrganizationRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/RemoveUserFromOrgRequest.ts
var init_RemoveUserFromOrgRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/RemoveUserFromOrgRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/CreatorInCurrentOrganization.ts
var init_CreatorInCurrentOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/CreatorInCurrentOrganization.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/ChangeOpenDoorPolicyRequest.ts
var init_ChangeOpenDoorPolicyRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/ChangeOpenDoorPolicyRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/ChangeRoleForUserRequest.ts
var init_ChangeRoleForUserRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/ChangeRoleForUserRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/ChangeNameRequest.ts
var init_ChangeNameRequest = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/ChangeNameRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationMutations/types/index.ts
var init_types24 = __esm({
  "src/api/resources/organizations/resources/organizationMutations/types/index.ts"() {
    "use strict";
    init_CreateOrganizationRequest();
    init_AnalyticsForNewOrg();
    init_AnalyticsForNewUser();
    init_AnalyticsForSignupWorkflow();
    init_CreateOrganizationDetails();
    init_JoinOrganizationRequest();
    init_JoinOrganizationDetails();
    init_AddUserToOrganizationRequest();
    init_RemoveUserFromOrgRequest();
    init_CreatorInCurrentOrganization();
    init_ChangeOpenDoorPolicyRequest();
    init_ChangeRoleForUserRequest();
    init_ChangeNameRequest();
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/createOrganization.ts
var createOrganization_exports = {};
__export(createOrganization_exports, {
  Error: () => Error151
});
var Error151;
var init_createOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/createOrganization.ts"() {
    "use strict";
    init_src();
    Error151 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      organizationAlreadyExistsError: (value) => {
        return {
          content: value,
          error: "OrganizationAlreadyExistsError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.createOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "OrganizationAlreadyExistsError":
            return visitor.organizationAlreadyExistsError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/listEligibleOrganizations.ts
var listEligibleOrganizations_exports = {};
__export(listEligibleOrganizations_exports, {
  Error: () => Error152
});
var Error152;
var init_listEligibleOrganizations = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/listEligibleOrganizations.ts"() {
    "use strict";
    init_src();
    Error152 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/joinOrganization.ts
var joinOrganization_exports = {};
__export(joinOrganization_exports, {
  Error: () => Error153
});
var Error153;
var init_joinOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/joinOrganization.ts"() {
    "use strict";
    init_src();
    Error153 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      limitExceededError: (value) => {
        return {
          content: value,
          error: "LimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      userAlreadyInOrganizationError: (value) => {
        return {
          content: value,
          error: "UserAlreadyInOrganizationError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.joinOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "LimitExceededError":
            return visitor.limitExceededError(value.content);
          case "UserAlreadyInOrganizationError":
            return visitor.userAlreadyInOrganizationError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/addUserToOrganization.ts
var addUserToOrganization_exports = {};
__export(addUserToOrganization_exports, {
  Error: () => Error154
});
var Error154;
var init_addUserToOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/addUserToOrganization.ts"() {
    "use strict";
    init_src();
    Error154 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      limitExceededError: (value) => {
        return {
          content: value,
          error: "LimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      userAlreadyInOrganizationError: (value) => {
        return {
          content: value,
          error: "UserAlreadyInOrganizationError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      ssoEnabledOrgExternalInviteError: () => {
        return {
          error: "SSOEnabledOrg_ExternalInviteError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "LimitExceededError":
            return visitor.limitExceededError(value.content);
          case "UserAlreadyInOrganizationError":
            return visitor.userAlreadyInOrganizationError(value.content);
          case "SSOEnabledOrg_ExternalInviteError":
            return visitor.ssoEnabledOrgExternalInviteError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/listOrganizationsUserIsIn.ts
var listOrganizationsUserIsIn_exports = {};
__export(listOrganizationsUserIsIn_exports, {
  Error: () => Error155
});
var Error155;
var init_listOrganizationsUserIsIn = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/listOrganizationsUserIsIn.ts"() {
    "use strict";
    init_src();
    Error155 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/leaveOrganization.ts
var leaveOrganization_exports = {};
__export(leaveOrganization_exports, {
  Error: () => Error156
});
var Error156;
var init_leaveOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/leaveOrganization.ts"() {
    "use strict";
    init_src();
    Error156 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      userNotInOrganizationError: (value) => {
        return {
          content: value,
          error: "UserNotInOrganizationError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.leaveOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UserNotInOrganizationError":
            return visitor.userNotInOrganizationError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/removeUserFromOrganization.ts
var removeUserFromOrganization_exports = {};
__export(removeUserFromOrganization_exports, {
  Error: () => Error157
});
var Error157;
var init_removeUserFromOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/removeUserFromOrganization.ts"() {
    "use strict";
    init_src();
    Error157 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      userNotInOrganizationError: (value) => {
        return {
          content: value,
          error: "UserNotInOrganizationError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UserNotInOrganizationError":
            return visitor.userNotInOrganizationError(value.content);
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/listCreatorsInCurrentOrganization.ts
var listCreatorsInCurrentOrganization_exports = {};
__export(listCreatorsInCurrentOrganization_exports, {
  Error: () => Error158
});
var Error158;
var init_listCreatorsInCurrentOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/listCreatorsInCurrentOrganization.ts"() {
    "use strict";
    init_src();
    Error158 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/listInvitedUsersInCurrentOrganization.ts
var listInvitedUsersInCurrentOrganization_exports = {};
__export(listInvitedUsersInCurrentOrganization_exports, {
  Error: () => Error159
});
var Error159;
var init_listInvitedUsersInCurrentOrganization = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/listInvitedUsersInCurrentOrganization.ts"() {
    "use strict";
    init_src();
    Error159 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/getOpenDoorPolicy.ts
var getOpenDoorPolicy_exports = {};
__export(getOpenDoorPolicy_exports, {
  Error: () => Error160
});
var Error160;
var init_getOpenDoorPolicy = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/getOpenDoorPolicy.ts"() {
    "use strict";
    init_src();
    Error160 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/changeOpenDoorPolicy.ts
var changeOpenDoorPolicy_exports = {};
__export(changeOpenDoorPolicy_exports, {
  Error: () => Error161
});
var Error161;
var init_changeOpenDoorPolicy = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/changeOpenDoorPolicy.ts"() {
    "use strict";
    init_src();
    Error161 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/changeRoleForUser.ts
var changeRoleForUser_exports = {};
__export(changeRoleForUser_exports, {
  Error: () => Error162
});
var Error162;
var init_changeRoleForUser = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/changeRoleForUser.ts"() {
    "use strict";
    init_src();
    Error162 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/getName.ts
var getName_exports = {};
__export(getName_exports, {
  Error: () => Error163
});
var Error163;
var init_getName = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/getName.ts"() {
    "use strict";
    init_src();
    Error163 = {
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getName.Error._visit(this, visitor);
          }
        };
      },
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getName.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getName.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getName.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.getName.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/changeName.ts
var changeName_exports = {};
__export(changeName_exports, {
  Error: () => Error164
});
var Error164;
var init_changeName = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/changeName.ts"() {
    "use strict";
    init_src();
    Error164 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeName.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeName.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeName.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeName.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organizationMutations.changeName.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/index.ts
var init_client25 = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/index.ts"() {
    "use strict";
    init_createOrganization();
    init_listEligibleOrganizations();
    init_joinOrganization();
    init_addUserToOrganization();
    init_listOrganizationsUserIsIn();
    init_leaveOrganization();
    init_removeUserFromOrganization();
    init_listCreatorsInCurrentOrganization();
    init_listInvitedUsersInCurrentOrganization();
    init_getOpenDoorPolicy();
    init_changeOpenDoorPolicy();
    init_changeRoleForUser();
    init_getName();
    init_changeName();
  }
});

// src/api/resources/organizations/resources/organizationMutations/index.ts
var organizationMutations_exports = {};
__export(organizationMutations_exports, {
  addUserToOrganization: () => addUserToOrganization_exports,
  changeName: () => changeName_exports,
  changeOpenDoorPolicy: () => changeOpenDoorPolicy_exports,
  changeRoleForUser: () => changeRoleForUser_exports,
  createOrganization: () => createOrganization_exports,
  getName: () => getName_exports,
  getOpenDoorPolicy: () => getOpenDoorPolicy_exports,
  joinOrganization: () => joinOrganization_exports,
  leaveOrganization: () => leaveOrganization_exports,
  listCreatorsInCurrentOrganization: () => listCreatorsInCurrentOrganization_exports,
  listEligibleOrganizations: () => listEligibleOrganizations_exports,
  listInvitedUsersInCurrentOrganization: () => listInvitedUsersInCurrentOrganization_exports,
  listOrganizationsUserIsIn: () => listOrganizationsUserIsIn_exports,
  removeUserFromOrganization: () => removeUserFromOrganization_exports
});
var init_organizationMutations = __esm({
  "src/api/resources/organizations/resources/organizationMutations/index.ts"() {
    "use strict";
    init_types24();
    init_client25();
  }
});

// src/api/resources/organizations/resources/organizationTypes/types/OrganizationInput.ts
var init_OrganizationInput = __esm({
  "src/api/resources/organizations/resources/organizationTypes/types/OrganizationInput.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationTypes/types/Organization.ts
var init_Organization = __esm({
  "src/api/resources/organizations/resources/organizationTypes/types/Organization.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationTypes/types/OrganizationWithListOfUsers.ts
var init_OrganizationWithListOfUsers = __esm({
  "src/api/resources/organizations/resources/organizationTypes/types/OrganizationWithListOfUsers.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organizationTypes/types/index.ts
var init_types25 = __esm({
  "src/api/resources/organizations/resources/organizationTypes/types/index.ts"() {
    "use strict";
    init_OrganizationInput();
    init_Organization();
    init_OrganizationWithListOfUsers();
  }
});

// src/api/resources/organizations/resources/organizationTypes/index.ts
var organizationTypes_exports = {};
var init_organizationTypes = __esm({
  "src/api/resources/organizations/resources/organizationTypes/index.ts"() {
    "use strict";
    init_types25();
  }
});

// src/api/resources/organizations/resources/organization/types/GetAllDefaultVoicesResponse.ts
var init_GetAllDefaultVoicesResponse = __esm({
  "src/api/resources/organizations/resources/organization/types/GetAllDefaultVoicesResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/OrganizationPlatform.ts
var init_OrganizationPlatform = __esm({
  "src/api/resources/organizations/resources/organization/types/OrganizationPlatform.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/GetAllOrganizationsResponse.ts
var init_GetAllOrganizationsResponse = __esm({
  "src/api/resources/organizations/resources/organization/types/GetAllOrganizationsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/PlatformDetails.ts
var init_PlatformDetails = __esm({
  "src/api/resources/organizations/resources/organization/types/PlatformDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/OrganizationBackgroundDataToReturn.ts
var init_OrganizationBackgroundDataToReturn = __esm({
  "src/api/resources/organizations/resources/organization/types/OrganizationBackgroundDataToReturn.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/BackgroundsCategory.ts
var BackgroundsCategory;
var init_BackgroundsCategory = __esm({
  "src/api/resources/organizations/resources/organization/types/BackgroundsCategory.ts"() {
    "use strict";
    BackgroundsCategory = {
      Starred: "starred",
      Patterns: "patterns",
      Images: "images"
    };
  }
});

// src/api/resources/organizations/resources/organization/types/GetAllLanguagesResponse.ts
var init_GetAllLanguagesResponse = __esm({
  "src/api/resources/organizations/resources/organization/types/GetAllLanguagesResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/GetVoicesResponse.ts
var init_GetVoicesResponse = __esm({
  "src/api/resources/organizations/resources/organization/types/GetVoicesResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/AudioTrack.ts
var init_AudioTrack = __esm({
  "src/api/resources/organizations/resources/organization/types/AudioTrack.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/CoverList.ts
var init_CoverList = __esm({
  "src/api/resources/organizations/resources/organization/types/CoverList.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/BackgroundList.ts
var init_BackgroundList = __esm({
  "src/api/resources/organizations/resources/organization/types/BackgroundList.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/types/index.ts
var init_types26 = __esm({
  "src/api/resources/organizations/resources/organization/types/index.ts"() {
    "use strict";
    init_GetAllDefaultVoicesResponse();
    init_OrganizationPlatform();
    init_GetAllOrganizationsResponse();
    init_PlatformDetails();
    init_OrganizationBackgroundDataToReturn();
    init_BackgroundsCategory();
    init_GetAllLanguagesResponse();
    init_GetVoicesResponse();
    init_AudioTrack();
    init_CoverList();
    init_BackgroundList();
  }
});

// src/api/resources/organizations/resources/organization/client/requests/index.ts
var init_requests13 = __esm({
  "src/api/resources/organizations/resources/organization/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/organization/client/getOrganization.ts
var getOrganization_exports2 = {};
__export(getOrganization_exports2, {
  Error: () => Error165
});
var Error165;
var init_getOrganization2 = __esm({
  "src/api/resources/organizations/resources/organization/client/getOrganization.ts"() {
    "use strict";
    init_src();
    Error165 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getHostname.ts
var getHostname_exports = {};
__export(getHostname_exports, {
  Error: () => Error166
});
var Error166;
var init_getHostname = __esm({
  "src/api/resources/organizations/resources/organization/client/getHostname.ts"() {
    "use strict";
    init_src();
    Error166 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getPlatformDetails.ts
var getPlatformDetails_exports = {};
__export(getPlatformDetails_exports, {
  Error: () => Error167
});
var Error167;
var init_getPlatformDetails = __esm({
  "src/api/resources/organizations/resources/organization/client/getPlatformDetails.ts"() {
    "use strict";
    init_src();
    Error167 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getPlatformDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getPlatformDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getPlatformDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getPlatformDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getAllLanguages.ts
var getAllLanguages_exports = {};
__export(getAllLanguages_exports, {
  Error: () => Error168
});
var Error168;
var init_getAllLanguages = __esm({
  "src/api/resources/organizations/resources/organization/client/getAllLanguages.ts"() {
    "use strict";
    init_src();
    Error168 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguages.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguages.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguages.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguages.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getAllLanguagesChrext.ts
var getAllLanguagesChrext_exports = {};
__export(getAllLanguagesChrext_exports, {
  Error: () => Error169
});
var Error169;
var init_getAllLanguagesChrext = __esm({
  "src/api/resources/organizations/resources/organization/client/getAllLanguagesChrext.ts"() {
    "use strict";
    init_src();
    Error169 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguagesChrext.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguagesChrext.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguagesChrext.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllLanguagesChrext.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getVoices.ts
var getVoices_exports = {};
__export(getVoices_exports, {
  Error: () => Error170
});
var Error170;
var init_getVoices = __esm({
  "src/api/resources/organizations/resources/organization/client/getVoices.ts"() {
    "use strict";
    init_src();
    Error170 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getVoices.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getVoices.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getVoices.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getVoices.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getOrganizationFromId.ts
var getOrganizationFromId_exports = {};
__export(getOrganizationFromId_exports, {
  Error: () => Error171
});
var Error171;
var init_getOrganizationFromId = __esm({
  "src/api/resources/organizations/resources/organization/client/getOrganizationFromId.ts"() {
    "use strict";
    init_src();
    Error171 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getHostnameFromId.ts
var getHostnameFromId_exports = {};
__export(getHostnameFromId_exports, {
  Error: () => Error172
});
var Error172;
var init_getHostnameFromId = __esm({
  "src/api/resources/organizations/resources/organization/client/getHostnameFromId.ts"() {
    "use strict";
    init_src();
    Error172 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getOrganizationFromHostName.ts
var getOrganizationFromHostName_exports = {};
__export(getOrganizationFromHostName_exports, {
  Error: () => Error173
});
var Error173;
var init_getOrganizationFromHostName = __esm({
  "src/api/resources/organizations/resources/organization/client/getOrganizationFromHostName.ts"() {
    "use strict";
    init_src();
    Error173 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromHostName.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromHostName.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromHostName.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getOrganizationFromHostName.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/setDefaultVoice.ts
var setDefaultVoice_exports = {};
__export(setDefaultVoice_exports, {
  Error: () => Error174
});
var Error174;
var init_setDefaultVoice = __esm({
  "src/api/resources/organizations/resources/organization/client/setDefaultVoice.ts"() {
    "use strict";
    init_src();
    Error174 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.setDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      mutationFailedError: () => {
        return {
          error: "MutationFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.setDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.setDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.setDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.setDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "MutationFailedError":
            return visitor.mutationFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/getAllDefaultVoices.ts
var getAllDefaultVoices_exports = {};
__export(getAllDefaultVoices_exports, {
  Error: () => Error175
});
var Error175;
var init_getAllDefaultVoices = __esm({
  "src/api/resources/organizations/resources/organization/client/getAllDefaultVoices.ts"() {
    "use strict";
    init_src();
    Error175 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllDefaultVoices.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllDefaultVoices.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllDefaultVoices.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.getAllDefaultVoices.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/deleteDefaultVoice.ts
var deleteDefaultVoice_exports = {};
__export(deleteDefaultVoice_exports, {
  Error: () => Error176
});
var Error176;
var init_deleteDefaultVoice = __esm({
  "src/api/resources/organizations/resources/organization/client/deleteDefaultVoice.ts"() {
    "use strict";
    init_src();
    Error176 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.deleteDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      mutationFailedError: () => {
        return {
          error: "MutationFailedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.deleteDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.deleteDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.organization.deleteDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.organization.deleteDefaultVoice.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "MutationFailedError":
            return visitor.mutationFailedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/index.ts
var init_client26 = __esm({
  "src/api/resources/organizations/resources/organization/client/index.ts"() {
    "use strict";
    init_requests13();
    init_getOrganization2();
    init_getHostname();
    init_getPlatformDetails();
    init_getAllLanguages();
    init_getAllLanguagesChrext();
    init_getVoices();
    init_getOrganizationFromId();
    init_getHostnameFromId();
    init_getOrganizationFromHostName();
    init_setDefaultVoice();
    init_getAllDefaultVoices();
    init_deleteDefaultVoice();
  }
});

// src/api/resources/organizations/resources/organization/index.ts
var organization_exports = {};
__export(organization_exports, {
  BackgroundsCategory: () => BackgroundsCategory,
  deleteDefaultVoice: () => deleteDefaultVoice_exports,
  getAllDefaultVoices: () => getAllDefaultVoices_exports,
  getAllLanguages: () => getAllLanguages_exports,
  getAllLanguagesChrext: () => getAllLanguagesChrext_exports,
  getHostname: () => getHostname_exports,
  getHostnameFromId: () => getHostnameFromId_exports,
  getOrganization: () => getOrganization_exports2,
  getOrganizationFromHostName: () => getOrganizationFromHostName_exports,
  getOrganizationFromId: () => getOrganizationFromId_exports,
  getPlatformDetails: () => getPlatformDetails_exports,
  getVoices: () => getVoices_exports,
  setDefaultVoice: () => setDefaultVoice_exports
});
var init_organization = __esm({
  "src/api/resources/organizations/resources/organization/index.ts"() {
    "use strict";
    init_types26();
    init_client26();
  }
});

// src/api/resources/organizations/resources/subscriptions/types/BasePlanStatus.ts
var init_BasePlanStatus = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/BasePlanStatus.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/types/BasePlanDetails.ts
var init_BasePlanDetails = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/BasePlanDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/types/PricingDetails.ts
var init_PricingDetails = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/PricingDetails.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/types/BasePlanType.ts
var BasePlanType;
var init_BasePlanType = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/BasePlanType.ts"() {
    "use strict";
    BasePlanType = {
      Trial: "TRIAL",
      Pro: "PRO",
      None: "NONE"
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/types/BasePlanName.ts
var BasePlanName;
var init_BasePlanName = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/BasePlanName.ts"() {
    "use strict";
    BasePlanName = {
      Starter: "STARTER",
      Growth: "GROWTH",
      Enterprise: "ENTERPRISE",
      Legacy: "LEGACY",
      None: "NONE",
      Trial: "TRIAL"
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/types/CheckoutRequest.ts
var init_CheckoutRequest = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/CheckoutRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/types/CheckoutResponse.ts
var init_CheckoutResponse = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/CheckoutResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/types/index.ts
var init_types27 = __esm({
  "src/api/resources/organizations/resources/subscriptions/types/index.ts"() {
    "use strict";
    init_BasePlanStatus();
    init_BasePlanDetails();
    init_PricingDetails();
    init_BasePlanType();
    init_BasePlanName();
    init_CheckoutRequest();
    init_CheckoutResponse();
  }
});

// src/api/resources/organizations/resources/subscriptions/client/requests/index.ts
var init_requests14 = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/subscriptions/client/getBasePlanDetails.ts
var getBasePlanDetails_exports = {};
__export(getBasePlanDetails_exports, {
  Error: () => Error177
});
var Error177;
var init_getBasePlanDetails = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/getBasePlanDetails.ts"() {
    "use strict";
    init_src();
    Error177 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/checkout.ts
var checkout_exports = {};
__export(checkout_exports, {
  Error: () => Error178
});
var Error178;
var init_checkout = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/checkout.ts"() {
    "use strict";
    init_src();
    Error178 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      invalidPlanError: () => {
        return {
          error: "InvalidPlanError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      downgradedPlanExistsForNextCycleError: () => {
        return {
          error: "DowngradedPlanExistsForNextCycleError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkout.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "InvalidPlanError":
            return visitor.invalidPlanError();
          case "DowngradedPlanExistsForNextCycleError":
            return visitor.downgradedPlanExistsForNextCycleError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/viewStripePortal.ts
var viewStripePortal_exports = {};
__export(viewStripePortal_exports, {
  Error: () => Error179
});
var Error179;
var init_viewStripePortal = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/viewStripePortal.ts"() {
    "use strict";
    init_src();
    Error179 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.viewStripePortal.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.viewStripePortal.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.viewStripePortal.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.viewStripePortal.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/validateCheckout.ts
var validateCheckout_exports = {};
__export(validateCheckout_exports, {
  Error: () => Error180
});
var Error180;
var init_validateCheckout = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/validateCheckout.ts"() {
    "use strict";
    init_src();
    Error180 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.validateCheckout.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.validateCheckout.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.validateCheckout.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.validateCheckout.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/isSingleUseAvailable.ts
var isSingleUseAvailable_exports = {};
__export(isSingleUseAvailable_exports, {
  Error: () => Error181
});
var Error181;
var init_isSingleUseAvailable = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/isSingleUseAvailable.ts"() {
    "use strict";
    init_src();
    Error181 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.isSingleUseAvailable.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.isSingleUseAvailable.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.isSingleUseAvailable.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/checkFeatureAvailablity.ts
var checkFeatureAvailablity_exports = {};
__export(checkFeatureAvailablity_exports, {
  Error: () => Error182
});
var Error182;
var init_checkFeatureAvailablity = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/checkFeatureAvailablity.ts"() {
    "use strict";
    init_src();
    Error182 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/index.ts
var init_client27 = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/index.ts"() {
    "use strict";
    init_requests14();
    init_getBasePlanDetails();
    init_checkout();
    init_viewStripePortal();
    init_validateCheckout();
    init_isSingleUseAvailable();
    init_checkFeatureAvailablity();
  }
});

// src/api/resources/organizations/resources/subscriptions/index.ts
var subscriptions_exports = {};
__export(subscriptions_exports, {
  BasePlanName: () => BasePlanName,
  BasePlanType: () => BasePlanType,
  checkFeatureAvailablity: () => checkFeatureAvailablity_exports,
  checkout: () => checkout_exports,
  getBasePlanDetails: () => getBasePlanDetails_exports,
  isSingleUseAvailable: () => isSingleUseAvailable_exports,
  validateCheckout: () => validateCheckout_exports,
  viewStripePortal: () => viewStripePortal_exports
});
var init_subscriptions = __esm({
  "src/api/resources/organizations/resources/subscriptions/index.ts"() {
    "use strict";
    init_types27();
    init_client27();
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/BasicUsageInActivePlan.ts
var init_BasicUsageInActivePlan = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/BasicUsageInActivePlan.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UtilizationRequest.ts
var init_UtilizationRequest = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UtilizationRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UtilizationResponse.ts
var init_UtilizationResponse = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UtilizationResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UtilizationLog.ts
var init_UtilizationLog = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UtilizationLog.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UsageMetricsRequest.ts
var init_UsageMetricsRequest = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UsageMetricsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UsageMetricsResponse.ts
var init_UsageMetricsResponse = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UsageMetricsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/UsageValue.ts
var init_UsageValue = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/UsageValue.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/SubscriptionCycle.ts
var init_SubscriptionCycle = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/SubscriptionCycle.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/PlanWithSubscription.ts
var init_PlanWithSubscription = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/PlanWithSubscription.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/PlanType.ts
var PlanType;
var init_PlanType = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/PlanType.ts"() {
    "use strict";
    PlanType = {
      Base: "base",
      Addon: "addon"
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/BillingCycle.ts
var BillingCycle;
var init_BillingCycle = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/BillingCycle.ts"() {
    "use strict";
    BillingCycle = {
      Monthly: "monthly",
      Quarterly: "quarterly",
      Halfyearly: "half-yearly",
      Annually: "annually"
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/types/index.ts
var init_types28 = __esm({
  "src/api/resources/organizations/resources/usageMetrics/types/index.ts"() {
    "use strict";
    init_BasicUsageInActivePlan();
    init_UtilizationRequest();
    init_UtilizationResponse();
    init_UtilizationLog();
    init_UsageMetricsRequest();
    init_UsageMetricsResponse();
    init_UsageValue();
    init_SubscriptionCycle();
    init_PlanWithSubscription();
    init_PlanType();
    init_BillingCycle();
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/getBasicUsageInActivePlan.ts
var getBasicUsageInActivePlan_exports = {};
__export(getBasicUsageInActivePlan_exports, {
  Error: () => Error183
});
var Error183;
var init_getBasicUsageInActivePlan = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/getBasicUsageInActivePlan.ts"() {
    "use strict";
    init_src();
    Error183 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/getSubscriptionCycles.ts
var getSubscriptionCycles_exports = {};
__export(getSubscriptionCycles_exports, {
  Error: () => Error184
});
var Error184;
var init_getSubscriptionCycles = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/getSubscriptionCycles.ts"() {
    "use strict";
    init_src();
    Error184 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getSubscriptionCycles.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getSubscriptionCycles.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getSubscriptionCycles.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/getUsageInSubscriptionCycle.ts
var getUsageInSubscriptionCycle_exports = {};
__export(getUsageInSubscriptionCycle_exports, {
  Error: () => Error185
});
var Error185;
var init_getUsageInSubscriptionCycle = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/getUsageInSubscriptionCycle.ts"() {
    "use strict";
    init_src();
    Error185 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/getUtilizationInACycle.ts
var getUtilizationInACycle_exports = {};
__export(getUtilizationInACycle_exports, {
  Error: () => Error186
});
var Error186;
var init_getUtilizationInACycle = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/getUtilizationInACycle.ts"() {
    "use strict";
    init_src();
    Error186 = {
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUtilizationInACycle.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUtilizationInACycle.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organizations.usageMetrics.getUtilizationInACycle.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/index.ts
var init_client28 = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/index.ts"() {
    "use strict";
    init_getBasicUsageInActivePlan();
    init_getSubscriptionCycles();
    init_getUsageInSubscriptionCycle();
    init_getUtilizationInACycle();
  }
});

// src/api/resources/organizations/resources/usageMetrics/index.ts
var usageMetrics_exports = {};
__export(usageMetrics_exports, {
  BillingCycle: () => BillingCycle,
  PlanType: () => PlanType,
  getBasicUsageInActivePlan: () => getBasicUsageInActivePlan_exports,
  getSubscriptionCycles: () => getSubscriptionCycles_exports,
  getUsageInSubscriptionCycle: () => getUsageInSubscriptionCycle_exports,
  getUtilizationInACycle: () => getUtilizationInACycle_exports
});
var init_usageMetrics = __esm({
  "src/api/resources/organizations/resources/usageMetrics/index.ts"() {
    "use strict";
    init_types28();
    init_client28();
  }
});

// src/api/resources/organizations/resources/index.ts
var init_resources5 = __esm({
  "src/api/resources/organizations/resources/index.ts"() {
    "use strict";
    init_organizationBranding();
    init_types23();
    init_organizationMutations();
    init_types24();
    init_organizationTypes();
    init_types25();
    init_organization();
    init_types26();
    init_subscriptions();
    init_types27();
    init_usageMetrics();
    init_types28();
    init_requests12();
    init_requests13();
    init_requests14();
  }
});

// src/api/resources/organizations/client/index.ts
var init_client29 = __esm({
  "src/api/resources/organizations/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/organizations/index.ts
var organizations_exports = {};
__export(organizations_exports, {
  BackgroundsCategory: () => BackgroundsCategory,
  BasePlanName: () => BasePlanName,
  BasePlanType: () => BasePlanType,
  BillingCycle: () => BillingCycle,
  PlanType: () => PlanType,
  organization: () => organization_exports,
  organizationBranding: () => organizationBranding_exports,
  organizationMutations: () => organizationMutations_exports,
  organizationTypes: () => organizationTypes_exports,
  subscriptions: () => subscriptions_exports,
  usageMetrics: () => usageMetrics_exports
});
var init_organizations = __esm({
  "src/api/resources/organizations/index.ts"() {
    "use strict";
    init_resources5();
    init_client29();
  }
});

// src/api/resources/posthog/types/CaputreEventRequest.ts
var init_CaputreEventRequest = __esm({
  "src/api/resources/posthog/types/CaputreEventRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/posthog/types/index.ts
var init_types29 = __esm({
  "src/api/resources/posthog/types/index.ts"() {
    "use strict";
    init_CaputreEventRequest();
  }
});

// src/api/resources/posthog/client/captureEvent.ts
var captureEvent_exports = {};
__export(captureEvent_exports, {
  Error: () => Error187
});
var Error187;
var init_captureEvent = __esm({
  "src/api/resources/posthog/client/captureEvent.ts"() {
    "use strict";
    init_src();
    Error187 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.posthog.captureEvent.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.posthog.captureEvent.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.posthog.captureEvent.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.posthog.captureEvent.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/posthog/client/index.ts
var init_client30 = __esm({
  "src/api/resources/posthog/client/index.ts"() {
    "use strict";
    init_captureEvent();
  }
});

// src/api/resources/posthog/index.ts
var posthog_exports = {};
__export(posthog_exports, {
  captureEvent: () => captureEvent_exports
});
var init_posthog = __esm({
  "src/api/resources/posthog/index.ts"() {
    "use strict";
    init_types29();
    init_client30();
  }
});

// src/api/resources/settings/types/FeatureFlags.ts
var init_FeatureFlags = __esm({
  "src/api/resources/settings/types/FeatureFlags.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/GetFeatureFlagsResponse.ts
var init_GetFeatureFlagsResponse = __esm({
  "src/api/resources/settings/types/GetFeatureFlagsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/SetFeatureFlagsRequest.ts
var init_SetFeatureFlagsRequest = __esm({
  "src/api/resources/settings/types/SetFeatureFlagsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/GetPronDictRequest.ts
var init_GetPronDictRequest = __esm({
  "src/api/resources/settings/types/GetPronDictRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/PronDictEntry.ts
var init_PronDictEntry = __esm({
  "src/api/resources/settings/types/PronDictEntry.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/GeneratePreviewAudioRequest.ts
var init_GeneratePreviewAudioRequest = __esm({
  "src/api/resources/settings/types/GeneratePreviewAudioRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/PronDictEntryRequest.ts
var init_PronDictEntryRequest = __esm({
  "src/api/resources/settings/types/PronDictEntryRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/GetPronDictEntryRequest.ts
var init_GetPronDictEntryRequest = __esm({
  "src/api/resources/settings/types/GetPronDictEntryRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/settings/types/index.ts
var init_types30 = __esm({
  "src/api/resources/settings/types/index.ts"() {
    "use strict";
    init_FeatureFlags();
    init_GetFeatureFlagsResponse();
    init_SetFeatureFlagsRequest();
    init_GetPronDictRequest();
    init_PronDictEntry();
    init_GeneratePreviewAudioRequest();
    init_PronDictEntryRequest();
    init_GetPronDictEntryRequest();
  }
});

// src/api/resources/settings/client/fetchPronDict.ts
var fetchPronDict_exports = {};
__export(fetchPronDict_exports, {
  Error: () => Error188
});
var Error188;
var init_fetchPronDict = __esm({
  "src/api/resources/settings/client/fetchPronDict.ts"() {
    "use strict";
    init_src();
    Error188 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.fetchPronDict.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.fetchPronDict.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.fetchPronDict.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.fetchPronDict.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/addPronDictEntry.ts
var addPronDictEntry_exports = {};
__export(addPronDictEntry_exports, {
  Error: () => Error189
});
var Error189;
var init_addPronDictEntry = __esm({
  "src/api/resources/settings/client/addPronDictEntry.ts"() {
    "use strict";
    init_src();
    Error189 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.addPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      entryAlreadyExistsError: () => {
        return {
          error: "EntryAlreadyExistsError",
          _visit: function(visitor) {
            return api_exports.settings.addPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.addPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.addPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.addPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "EntryAlreadyExistsError":
            return visitor.entryAlreadyExistsError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/getPronDictEntry.ts
var getPronDictEntry_exports = {};
__export(getPronDictEntry_exports, {
  Error: () => Error190
});
var Error190;
var init_getPronDictEntry = __esm({
  "src/api/resources/settings/client/getPronDictEntry.ts"() {
    "use strict";
    init_src();
    Error190 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.getPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      entryNotFoundError: () => {
        return {
          error: "EntryNotFoundError",
          _visit: function(visitor) {
            return api_exports.settings.getPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.getPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.getPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.getPronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "EntryNotFoundError":
            return visitor.entryNotFoundError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/deletePronDictEntry.ts
var deletePronDictEntry_exports = {};
__export(deletePronDictEntry_exports, {
  Error: () => Error191
});
var Error191;
var init_deletePronDictEntry = __esm({
  "src/api/resources/settings/client/deletePronDictEntry.ts"() {
    "use strict";
    init_src();
    Error191 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.deletePronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.deletePronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.deletePronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.deletePronDictEntry.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/returnPreviewAudioBytes.ts
var returnPreviewAudioBytes_exports = {};
__export(returnPreviewAudioBytes_exports, {
  Error: () => Error192
});
var Error192;
var init_returnPreviewAudioBytes = __esm({
  "src/api/resources/settings/client/returnPreviewAudioBytes.ts"() {
    "use strict";
    init_src();
    Error192 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.returnPreviewAudioBytes.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.returnPreviewAudioBytes.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.returnPreviewAudioBytes.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.returnPreviewAudioBytes.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/getFeatureFlags.ts
var getFeatureFlags_exports = {};
__export(getFeatureFlags_exports, {
  Error: () => Error193
});
var Error193;
var init_getFeatureFlags = __esm({
  "src/api/resources/settings/client/getFeatureFlags.ts"() {
    "use strict";
    init_src();
    Error193 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.getFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.getFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.getFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.getFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/setFeatureFlags.ts
var setFeatureFlags_exports = {};
__export(setFeatureFlags_exports, {
  Error: () => Error194
});
var Error194;
var init_setFeatureFlags = __esm({
  "src/api/resources/settings/client/setFeatureFlags.ts"() {
    "use strict";
    init_src();
    Error194 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.settings.setFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.settings.setFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.settings.setFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.settings.setFeatureFlags.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/settings/client/index.ts
var init_client31 = __esm({
  "src/api/resources/settings/client/index.ts"() {
    "use strict";
    init_fetchPronDict();
    init_addPronDictEntry();
    init_getPronDictEntry();
    init_deletePronDictEntry();
    init_returnPreviewAudioBytes();
    init_getFeatureFlags();
    init_setFeatureFlags();
  }
});

// src/api/resources/settings/index.ts
var settings_exports = {};
__export(settings_exports, {
  addPronDictEntry: () => addPronDictEntry_exports,
  deletePronDictEntry: () => deletePronDictEntry_exports,
  fetchPronDict: () => fetchPronDict_exports,
  getFeatureFlags: () => getFeatureFlags_exports,
  getPronDictEntry: () => getPronDictEntry_exports,
  returnPreviewAudioBytes: () => returnPreviewAudioBytes_exports,
  setFeatureFlags: () => setFeatureFlags_exports
});
var init_settings = __esm({
  "src/api/resources/settings/index.ts"() {
    "use strict";
    init_types30();
    init_client31();
  }
});

// src/api/resources/templates/types/CoverVersion.ts
var CoverVersion;
var init_CoverVersion = __esm({
  "src/api/resources/templates/types/CoverVersion.ts"() {
    "use strict";
    CoverVersion = {
      Aug012024: "aug012024"
    };
  }
});

// src/api/resources/templates/types/BackgroundType.ts
var BackgroundType;
var init_BackgroundType = __esm({
  "src/api/resources/templates/types/BackgroundType.ts"() {
    "use strict";
    BackgroundType = {
      Image: "image",
      Pattern: "pattern"
    };
  }
});

// src/api/resources/templates/types/Logo.ts
var init_Logo2 = __esm({
  "src/api/resources/templates/types/Logo.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/CoverFormat.ts
var CoverFormat;
var init_CoverFormat = __esm({
  "src/api/resources/templates/types/CoverFormat.ts"() {
    "use strict";
    CoverFormat = {
      Video: "video",
      Image: "image"
    };
  }
});

// src/api/resources/templates/types/CoverType.ts
var CoverType;
var init_CoverType = __esm({
  "src/api/resources/templates/types/CoverType.ts"() {
    "use strict";
    CoverType = {
      Intro: "intro",
      Outro: "outro"
    };
  }
});

// src/api/resources/templates/types/CoverOption.ts
var init_CoverOption = __esm({
  "src/api/resources/templates/types/CoverOption.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/BackgroundOption.ts
var init_BackgroundOption = __esm({
  "src/api/resources/templates/types/BackgroundOption.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/Cover.ts
var init_Cover = __esm({
  "src/api/resources/templates/types/Cover.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/Background.ts
var init_Background = __esm({
  "src/api/resources/templates/types/Background.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/Border.ts
var init_Border = __esm({
  "src/api/resources/templates/types/Border.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/BorderType.ts
var BorderType;
var init_BorderType = __esm({
  "src/api/resources/templates/types/BorderType.ts"() {
    "use strict";
    BorderType = {
      Browser: "browser",
      Solid: "solid",
      Glass: "glass",
      Animated: "animated",
      None: "none",
      Notch: "notch"
    };
  }
});

// src/api/resources/templates/types/Transition.ts
var init_Transition = __esm({
  "src/api/resources/templates/types/Transition.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/Audio.ts
var init_Audio = __esm({
  "src/api/resources/templates/types/Audio.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/OrganizationBackground.ts
var init_OrganizationBackground = __esm({
  "src/api/resources/templates/types/OrganizationBackground.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/PremadeBackground.ts
var init_PremadeBackground = __esm({
  "src/api/resources/templates/types/PremadeBackground.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/OrganizationTemplate.ts
var init_OrganizationTemplate = __esm({
  "src/api/resources/templates/types/OrganizationTemplate.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/AspectRatio.ts
var init_AspectRatio = __esm({
  "src/api/resources/templates/types/AspectRatio.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/types/index.ts
var init_types31 = __esm({
  "src/api/resources/templates/types/index.ts"() {
    "use strict";
    init_CoverVersion();
    init_BackgroundType();
    init_Logo2();
    init_CoverFormat();
    init_CoverType();
    init_CoverOption();
    init_BackgroundOption();
    init_Cover();
    init_Background();
    init_Border();
    init_BorderType();
    init_Transition();
    init_Audio();
    init_OrganizationBackground();
    init_PremadeBackground();
    init_OrganizationTemplate();
    init_AspectRatio();
  }
});

// src/api/resources/templates/client/requests/index.ts
var init_requests15 = __esm({
  "src/api/resources/templates/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/templates/client/initiateLogoUpload.ts
var initiateLogoUpload_exports2 = {};
__export(initiateLogoUpload_exports2, {
  Error: () => Error195
});
var Error195;
var init_initiateLogoUpload2 = __esm({
  "src/api/resources/templates/client/initiateLogoUpload.ts"() {
    "use strict";
    init_src();
    Error195 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.initiateLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/finishLogoUpload.ts
var finishLogoUpload_exports2 = {};
__export(finishLogoUpload_exports2, {
  Error: () => Error196
});
var Error196;
var init_finishLogoUpload2 = __esm({
  "src/api/resources/templates/client/finishLogoUpload.ts"() {
    "use strict";
    init_src();
    Error196 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.templates.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.finishLogoUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/initiateAssetUpload.ts
var initiateAssetUpload_exports = {};
__export(initiateAssetUpload_exports, {
  Error: () => Error197
});
var Error197;
var init_initiateAssetUpload = __esm({
  "src/api/resources/templates/client/initiateAssetUpload.ts"() {
    "use strict";
    init_src();
    Error197 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.initiateAssetUpload.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.initiateAssetUpload.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.initiateAssetUpload.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.initiateAssetUpload.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/createCover.ts
var createCover_exports = {};
__export(createCover_exports, {
  Error: () => Error198
});
var Error198;
var init_createCover = __esm({
  "src/api/resources/templates/client/createCover.ts"() {
    "use strict";
    init_src();
    Error198 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.createCover.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.templates.createCover.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.createCover.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.createCover.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.createCover.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/setDefaultCover.ts
var setDefaultCover_exports = {};
__export(setDefaultCover_exports, {
  Error: () => Error199
});
var Error199;
var init_setDefaultCover = __esm({
  "src/api/resources/templates/client/setDefaultCover.ts"() {
    "use strict";
    init_src();
    Error199 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultCover.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultCover.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultCover.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.setDefaultCover.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/createBackground.ts
var createBackground_exports = {};
__export(createBackground_exports, {
  Error: () => Error200
});
var Error200;
var init_createBackground = __esm({
  "src/api/resources/templates/client/createBackground.ts"() {
    "use strict";
    init_src();
    Error200 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.createBackground.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.templates.createBackground.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.createBackground.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.createBackground.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.createBackground.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/setDefaultBackground.ts
var setDefaultBackground_exports = {};
__export(setDefaultBackground_exports, {
  Error: () => Error201
});
var Error201;
var init_setDefaultBackground = __esm({
  "src/api/resources/templates/client/setDefaultBackground.ts"() {
    "use strict";
    init_src();
    Error201 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackground.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackground.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackground.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackground.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/setDefaultTransition.ts
var setDefaultTransition_exports = {};
__export(setDefaultTransition_exports, {
  Error: () => Error202
});
var Error202;
var init_setDefaultTransition = __esm({
  "src/api/resources/templates/client/setDefaultTransition.ts"() {
    "use strict";
    init_src();
    Error202 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTransition.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTransition.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTransition.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTransition.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/deleteCover.ts
var deleteCover_exports = {};
__export(deleteCover_exports, {
  Error: () => Error203
});
var Error203;
var init_deleteCover = __esm({
  "src/api/resources/templates/client/deleteCover.ts"() {
    "use strict";
    init_src();
    Error203 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteCover.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.deleteCover.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteCover.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.deleteCover.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/deleteBackground.ts
var deleteBackground_exports = {};
__export(deleteBackground_exports, {
  Error: () => Error204
});
var Error204;
var init_deleteBackground = __esm({
  "src/api/resources/templates/client/deleteBackground.ts"() {
    "use strict";
    init_src();
    Error204 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackground.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackground.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackground.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.deleteBackground.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/updateCover.ts
var updateCover_exports = {};
__export(updateCover_exports, {
  Error: () => Error205
});
var Error205;
var init_updateCover = __esm({
  "src/api/resources/templates/client/updateCover.ts"() {
    "use strict";
    init_src();
    Error205 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.updateCover.Error._visit(this, visitor);
          }
        };
      },
      corruptedFileError: () => {
        return {
          error: "CorruptedFileError",
          _visit: function(visitor) {
            return api_exports.templates.updateCover.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.updateCover.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.updateCover.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.updateCover.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "CorruptedFileError":
            return visitor.corruptedFileError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/addBackgroundToOrganization.ts
var addBackgroundToOrganization_exports = {};
__export(addBackgroundToOrganization_exports, {
  Error: () => Error206
});
var Error206;
var init_addBackgroundToOrganization = __esm({
  "src/api/resources/templates/client/addBackgroundToOrganization.ts"() {
    "use strict";
    init_src();
    Error206 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.addBackgroundToOrganization.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.addBackgroundToOrganization.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.addBackgroundToOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.addBackgroundToOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/toggleStarBackground.ts
var toggleStarBackground_exports = {};
__export(toggleStarBackground_exports, {
  Error: () => Error207
});
var Error207;
var init_toggleStarBackground = __esm({
  "src/api/resources/templates/client/toggleStarBackground.ts"() {
    "use strict";
    init_src();
    Error207 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.toggleStarBackground.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.toggleStarBackground.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.toggleStarBackground.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.toggleStarBackground.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/deleteBackgroundV2.ts
var deleteBackgroundV2_exports = {};
__export(deleteBackgroundV2_exports, {
  Error: () => Error208
});
var Error208;
var init_deleteBackgroundV2 = __esm({
  "src/api/resources/templates/client/deleteBackgroundV2.ts"() {
    "use strict";
    init_src();
    Error208 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.deleteBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/createOrganizationTemplate.ts
var createOrganizationTemplate_exports = {};
__export(createOrganizationTemplate_exports, {
  Error: () => Error209
});
var Error209;
var init_createOrganizationTemplate = __esm({
  "src/api/resources/templates/client/createOrganizationTemplate.ts"() {
    "use strict";
    init_src();
    Error209 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.createOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.createOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.createOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.createOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/deleteOrganizationTemplate.ts
var deleteOrganizationTemplate_exports = {};
__export(deleteOrganizationTemplate_exports, {
  Error: () => Error210
});
var Error210;
var init_deleteOrganizationTemplate = __esm({
  "src/api/resources/templates/client/deleteOrganizationTemplate.ts"() {
    "use strict";
    init_src();
    Error210 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.deleteOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.deleteOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.deleteOrganizationTemplate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/setDefaultTemplate.ts
var setDefaultTemplate_exports = {};
__export(setDefaultTemplate_exports, {
  Error: () => Error211
});
var Error211;
var init_setDefaultTemplate = __esm({
  "src/api/resources/templates/client/setDefaultTemplate.ts"() {
    "use strict";
    init_src();
    Error211 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTemplate.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTemplate.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTemplate.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.setDefaultTemplate.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/setDefaultBackgroundV2.ts
var setDefaultBackgroundV2_exports = {};
__export(setDefaultBackgroundV2_exports, {
  Error: () => Error212
});
var Error212;
var init_setDefaultBackgroundV2 = __esm({
  "src/api/resources/templates/client/setDefaultBackgroundV2.ts"() {
    "use strict";
    init_src();
    Error212 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.templates.setDefaultBackgroundV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/templates/client/index.ts
var init_client32 = __esm({
  "src/api/resources/templates/client/index.ts"() {
    "use strict";
    init_requests15();
    init_initiateLogoUpload2();
    init_finishLogoUpload2();
    init_initiateAssetUpload();
    init_createCover();
    init_setDefaultCover();
    init_createBackground();
    init_setDefaultBackground();
    init_setDefaultTransition();
    init_deleteCover();
    init_deleteBackground();
    init_updateCover();
    init_addBackgroundToOrganization();
    init_toggleStarBackground();
    init_deleteBackgroundV2();
    init_createOrganizationTemplate();
    init_deleteOrganizationTemplate();
    init_setDefaultTemplate();
    init_setDefaultBackgroundV2();
  }
});

// src/api/resources/templates/index.ts
var templates_exports = {};
__export(templates_exports, {
  BackgroundType: () => BackgroundType,
  BorderType: () => BorderType,
  CoverFormat: () => CoverFormat,
  CoverType: () => CoverType,
  CoverVersion: () => CoverVersion,
  addBackgroundToOrganization: () => addBackgroundToOrganization_exports,
  createBackground: () => createBackground_exports,
  createCover: () => createCover_exports,
  createOrganizationTemplate: () => createOrganizationTemplate_exports,
  deleteBackground: () => deleteBackground_exports,
  deleteBackgroundV2: () => deleteBackgroundV2_exports,
  deleteCover: () => deleteCover_exports,
  deleteOrganizationTemplate: () => deleteOrganizationTemplate_exports,
  finishLogoUpload: () => finishLogoUpload_exports2,
  initiateAssetUpload: () => initiateAssetUpload_exports,
  initiateLogoUpload: () => initiateLogoUpload_exports2,
  setDefaultBackground: () => setDefaultBackground_exports,
  setDefaultBackgroundV2: () => setDefaultBackgroundV2_exports,
  setDefaultCover: () => setDefaultCover_exports,
  setDefaultTemplate: () => setDefaultTemplate_exports,
  setDefaultTransition: () => setDefaultTransition_exports,
  toggleStarBackground: () => toggleStarBackground_exports,
  updateCover: () => updateCover_exports
});
var init_templates = __esm({
  "src/api/resources/templates/index.ts"() {
    "use strict";
    init_types31();
    init_client32();
  }
});

// src/api/resources/users/types/UserRole.ts
var UserRole;
var init_UserRole = __esm({
  "src/api/resources/users/types/UserRole.ts"() {
    "use strict";
    UserRole = {
      Editor: "editor",
      Admin: "admin"
    };
  }
});

// src/api/resources/users/types/User.ts
var init_User = __esm({
  "src/api/resources/users/types/User.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/LoginResponse.ts
var init_LoginResponse = __esm({
  "src/api/resources/users/types/LoginResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/InitRequest.ts
var init_InitRequest = __esm({
  "src/api/resources/users/types/InitRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/InitResponse.ts
var init_InitResponse = __esm({
  "src/api/resources/users/types/InitResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/ExtendedInitResponse.ts
var init_ExtendedInitResponse = __esm({
  "src/api/resources/users/types/ExtendedInitResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/LoginResponseOldVersion.ts
var init_LoginResponseOldVersion = __esm({
  "src/api/resources/users/types/LoginResponseOldVersion.ts"() {
    "use strict";
  }
});

// src/api/resources/users/types/index.ts
var init_types32 = __esm({
  "src/api/resources/users/types/index.ts"() {
    "use strict";
    init_UserRole();
    init_User();
    init_LoginResponse();
    init_InitRequest();
    init_InitResponse();
    init_ExtendedInitResponse();
    init_LoginResponseOldVersion();
  }
});

// src/api/resources/users/client/login.ts
var login_exports = {};
__export(login_exports, {
  Error: () => Error213
});
var Error213;
var init_login = __esm({
  "src/api/resources/users/client/login.ts"() {
    "use strict";
    init_src();
    Error213 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      ssoEnabledEmailOrganizationCreationNotAllowed: () => {
        return {
          error: "SSOEnabledEmail_OrganizationCreationNotAllowed",
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      ssoEnabledEmailExternalEmailError: () => {
        return {
          error: "SSOEnabledEmail_ExternalEmailError",
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.login.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            return visitor.ssoEnabledEmailOrganizationCreationNotAllowed();
          case "SSOEnabledEmail_ExternalEmailError":
            return visitor.ssoEnabledEmailExternalEmailError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/loginV2.ts
var loginV2_exports = {};
__export(loginV2_exports, {
  Error: () => Error214
});
var Error214;
var init_loginV2 = __esm({
  "src/api/resources/users/client/loginV2.ts"() {
    "use strict";
    init_src();
    Error214 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      ssoEnabledEmailOrganizationCreationNotAllowed: () => {
        return {
          error: "SSOEnabledEmail_OrganizationCreationNotAllowed",
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      ssoEnabledEmailExternalEmailError: () => {
        return {
          error: "SSOEnabledEmail_ExternalEmailError",
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.loginV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            return visitor.ssoEnabledEmailOrganizationCreationNotAllowed();
          case "SSOEnabledEmail_ExternalEmailError":
            return visitor.ssoEnabledEmailExternalEmailError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/getUsers.ts
var getUsers_exports2 = {};
__export(getUsers_exports2, {
  Error: () => Error215
});
var Error215;
var init_getUsers2 = __esm({
  "src/api/resources/users/client/getUsers.ts"() {
    "use strict";
    init_src();
    Error215 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.getUsers.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.getUsers.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.getUsers.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.getUsers.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/initialize.ts
var initialize_exports = {};
__export(initialize_exports, {
  Error: () => Error216
});
var Error216;
var init_initialize = __esm({
  "src/api/resources/users/client/initialize.ts"() {
    "use strict";
    init_src();
    Error216 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.initialize.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.initialize.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.initialize.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.initialize.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/initializeV2.ts
var initializeV2_exports = {};
__export(initializeV2_exports, {
  Error: () => Error217
});
var Error217;
var init_initializeV2 = __esm({
  "src/api/resources/users/client/initializeV2.ts"() {
    "use strict";
    init_src();
    Error217 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.initializeV2.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.initializeV2.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.initializeV2.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.initializeV2.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/getAssociatedOrgs.ts
var getAssociatedOrgs_exports = {};
__export(getAssociatedOrgs_exports, {
  Error: () => Error218
});
var Error218;
var init_getAssociatedOrgs = __esm({
  "src/api/resources/users/client/getAssociatedOrgs.ts"() {
    "use strict";
    init_src();
    Error218 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.getAssociatedOrgs.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.getAssociatedOrgs.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.getAssociatedOrgs.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.getAssociatedOrgs.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/getUserForGuide.ts
var getUserForGuide_exports = {};
__export(getUserForGuide_exports, {
  Error: () => Error219
});
var Error219;
var init_getUserForGuide = __esm({
  "src/api/resources/users/client/getUserForGuide.ts"() {
    "use strict";
    init_src();
    Error219 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.users.getUserForGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.users.getUserForGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.users.getUserForGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.users.getUserForGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/users/client/index.ts
var init_client33 = __esm({
  "src/api/resources/users/client/index.ts"() {
    "use strict";
    init_login();
    init_loginV2();
    init_getUsers2();
    init_initialize();
    init_initializeV2();
    init_getAssociatedOrgs();
    init_getUserForGuide();
  }
});

// src/api/resources/users/index.ts
var users_exports = {};
__export(users_exports, {
  UserRole: () => UserRole,
  getAssociatedOrgs: () => getAssociatedOrgs_exports,
  getUserForGuide: () => getUserForGuide_exports,
  getUsers: () => getUsers_exports2,
  initialize: () => initialize_exports,
  initializeV2: () => initializeV2_exports,
  login: () => login_exports,
  loginV2: () => loginV2_exports
});
var init_users = __esm({
  "src/api/resources/users/index.ts"() {
    "use strict";
    init_types32();
    init_client33();
  }
});

// src/api/resources/video/resources/videoEdits/types/Version.ts
var Version;
var init_Version = __esm({
  "src/api/resources/video/resources/videoEdits/types/Version.ts"() {
    "use strict";
    Version = {
      Oct162023: "oct162023",
      May012024: "may012024",
      Aug012024: "aug012024"
    };
  }
});

// src/api/resources/video/resources/videoEdits/types/ZoomEdit.ts
var init_ZoomEdit = __esm({
  "src/api/resources/video/resources/videoEdits/types/ZoomEdit.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/VideoEdits.ts
var init_VideoEdits = __esm({
  "src/api/resources/video/resources/videoEdits/types/VideoEdits.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/Crop.ts
var init_Crop2 = __esm({
  "src/api/resources/video/resources/videoEdits/types/Crop.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/SubtitlesSettings.ts
var init_SubtitlesSettings = __esm({
  "src/api/resources/video/resources/videoEdits/types/SubtitlesSettings.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/index.ts
var init_types33 = __esm({
  "src/api/resources/video/resources/videoEdits/types/index.ts"() {
    "use strict";
    init_Version();
    init_ZoomEdit();
    init_VideoEdits();
    init_Crop2();
    init_SubtitlesSettings();
  }
});

// src/api/resources/video/resources/videoEdits/index.ts
var videoEdits_exports = {};
__export(videoEdits_exports, {
  Version: () => Version
});
var init_videoEdits = __esm({
  "src/api/resources/video/resources/videoEdits/index.ts"() {
    "use strict";
    init_types33();
  }
});

// src/api/resources/video/resources/index.ts
var init_resources6 = __esm({
  "src/api/resources/video/resources/index.ts"() {
    "use strict";
    init_videoEdits();
    init_types33();
  }
});

// src/api/resources/video/index.ts
var video_exports = {};
__export(video_exports, {
  Version: () => Version,
  videoEdits: () => videoEdits_exports
});
var init_video = __esm({
  "src/api/resources/video/index.ts"() {
    "use strict";
    init_resources6();
  }
});

// src/api/resources/externalAuth/client/requests/index.ts
var init_requests16 = __esm({
  "src/api/resources/externalAuth/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/externalAuth/client/createToken.ts
var createToken_exports = {};
__export(createToken_exports, {
  Error: () => Error220
});
var Error220;
var init_createToken = __esm({
  "src/api/resources/externalAuth/client/createToken.ts"() {
    "use strict";
    init_src();
    Error220 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/externalAuth/client/index.ts
var init_client34 = __esm({
  "src/api/resources/externalAuth/client/index.ts"() {
    "use strict";
    init_requests16();
    init_createToken();
  }
});

// src/api/resources/externalAuth/index.ts
var externalAuth_exports = {};
__export(externalAuth_exports, {
  createToken: () => createToken_exports
});
var init_externalAuth = __esm({
  "src/api/resources/externalAuth/index.ts"() {
    "use strict";
    init_client34();
  }
});

// src/api/resources/healthcheck/client/healthcheck.ts
var healthcheck_exports = {};
__export(healthcheck_exports, {
  Error: () => Error221
});
var Error221;
var init_healthcheck = __esm({
  "src/api/resources/healthcheck/client/healthcheck.ts"() {
    "use strict";
    init_src();
    Error221 = {
      unavailabilityError: () => {
        return {
          error: "UnavailabilityError",
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnavailabilityError":
            return visitor.unavailabilityError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/healthcheck/client/index.ts
var init_client35 = __esm({
  "src/api/resources/healthcheck/client/index.ts"() {
    "use strict";
    init_healthcheck();
  }
});

// src/api/resources/healthcheck/index.ts
var healthcheck_exports2 = {};
__export(healthcheck_exports2, {
  healthcheck: () => healthcheck_exports
});
var init_healthcheck2 = __esm({
  "src/api/resources/healthcheck/index.ts"() {
    "use strict";
    init_client35();
  }
});

// src/api/resources/internal/resources/exporter/client/getGuide.ts
var getGuide_exports = {};
__export(getGuide_exports, {
  Error: () => Error222
});
var Error222;
var init_getGuide = __esm({
  "src/api/resources/internal/resources/exporter/client/getGuide.ts"() {
    "use strict";
    init_src();
    Error222 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.internal.exporter.getGuide.Error._visit(this, visitor);
          }
        };
      },
      usageLimitExceededError: (value) => {
        return {
          content: value,
          error: "UsageLimitExceededError",
          _visit: function(visitor) {
            return api_exports.internal.exporter.getGuide.Error._visit(this, visitor);
          }
        };
      },
      actionNotPermittedError: () => {
        return {
          error: "ActionNotPermittedError",
          _visit: function(visitor) {
            return api_exports.internal.exporter.getGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.internal.exporter.getGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "UsageLimitExceededError":
            return visitor.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return visitor.actionNotPermittedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/internal/resources/exporter/client/index.ts
var init_client36 = __esm({
  "src/api/resources/internal/resources/exporter/client/index.ts"() {
    "use strict";
    init_getGuide();
  }
});

// src/api/resources/internal/resources/exporter/index.ts
var exporter_exports = {};
__export(exporter_exports, {
  getGuide: () => getGuide_exports
});
var init_exporter = __esm({
  "src/api/resources/internal/resources/exporter/index.ts"() {
    "use strict";
    init_client36();
  }
});

// src/api/resources/internal/resources/index.ts
var init_resources7 = __esm({
  "src/api/resources/internal/resources/index.ts"() {
    "use strict";
    init_exporter();
  }
});

// src/api/resources/internal/client/index.ts
var init_client37 = __esm({
  "src/api/resources/internal/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/internal/index.ts
var internal_exports = {};
__export(internal_exports, {
  exporter: () => exporter_exports
});
var init_internal = __esm({
  "src/api/resources/internal/index.ts"() {
    "use strict";
    init_resources7();
    init_client37();
  }
});

// src/api/resources/index.ts
var init_resources8 = __esm({
  "src/api/resources/index.ts"() {
    "use strict";
    init_admin();
    init_types();
    init_analytics();
    init_types2();
    init_audio();
    init_types3();
    init_auth();
    init_types4();
    init_baseTypes();
    init_types5();
    init_collections();
    init_elementEdit();
    init_types9();
    init_guides();
    init_helpcenterQueries();
    init_types18();
    init_helpcenter();
    init_integrations();
    init_organizations();
    init_posthog();
    init_types29();
    init_settings();
    init_types30();
    init_templates();
    init_types31();
    init_users();
    init_types32();
    init_video();
    init_externalAuth();
    init_healthcheck2();
    init_internal();
    init_requests();
    init_requests2();
    init_requests3();
    init_requests16();
    init_requests10();
    init_requests15();
  }
});

// src/api/index.ts
var api_exports = {};
__export(api_exports, {
  AuthType: () => AuthType,
  BackgroundType: () => BackgroundType,
  BorderType: () => BorderType,
  CoverFormat: () => CoverFormat,
  CoverType: () => CoverType,
  CoverVersion: () => CoverVersion,
  ElementGeo: () => ElementGeo,
  HostingDetails: () => HostingDetails,
  Id: () => Id,
  ImageType: () => ImageType,
  Role: () => Role,
  TextAlignment: () => TextAlignment,
  UserRole: () => UserRole,
  admin: () => admin_exports,
  analytics: () => analytics_exports,
  audio: () => audio_exports,
  auth: () => auth_exports,
  baseTypes: () => baseTypes_exports,
  collections: () => collections_exports,
  elementEdit: () => elementEdit_exports,
  externalAuth: () => externalAuth_exports,
  guides: () => guides_exports,
  healthcheck: () => healthcheck_exports2,
  helpcenter: () => helpcenter_exports,
  helpcenterQueries: () => helpcenterQueries_exports,
  integrations: () => integrations_exports,
  internal: () => internal_exports,
  organizations: () => organizations_exports,
  posthog: () => posthog_exports,
  settings: () => settings_exports,
  templates: () => templates_exports,
  users: () => users_exports,
  video: () => video_exports
});
var init_api = __esm({
  "src/api/index.ts"() {
    "use strict";
    init_resources8();
  }
});

// src/core/schemas/Schema.ts
var SchemaType;
var init_Schema = __esm({
  "src/core/schemas/Schema.ts"() {
    "use strict";
    SchemaType = {
      DATE: "date",
      ENUM: "enum",
      LIST: "list",
      STRING_LITERAL: "stringLiteral",
      OBJECT: "object",
      ANY: "any",
      BOOLEAN: "boolean",
      NUMBER: "number",
      STRING: "string",
      UNKNOWN: "unknown",
      RECORD: "record",
      SET: "set",
      UNION: "union",
      OPTIONAL: "optional"
    };
  }
});

// src/core/schemas/builders/schema-utils/stringifyValidationErrors.ts
function stringifyValidationError(error) {
  if (error.path.length === 0) {
    return error.message;
  }
  return `${error.path.join(" -> ")}: ${error.message}`;
}
var init_stringifyValidationErrors = __esm({
  "src/core/schemas/builders/schema-utils/stringifyValidationErrors.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/schema-utils/JsonError.ts
var JsonError;
var init_JsonError = __esm({
  "src/core/schemas/builders/schema-utils/JsonError.ts"() {
    "use strict";
    init_stringifyValidationErrors();
    JsonError = class extends Error {
      constructor(errors) {
        super(errors.map(stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, JsonError.prototype);
      }
    };
  }
});

// src/core/schemas/builders/schema-utils/ParseError.ts
var ParseError;
var init_ParseError = __esm({
  "src/core/schemas/builders/schema-utils/ParseError.ts"() {
    "use strict";
    init_stringifyValidationErrors();
    ParseError = class extends Error {
      constructor(errors) {
        super(errors.map(stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, ParseError.prototype);
      }
    };
  }
});

// src/core/schemas/builders/schema-utils/getSchemaUtils.ts
function getSchemaUtils(schema) {
  return {
    optional: () => optional(schema),
    transform: (transformer) => transform(schema, transformer),
    parseOrThrow: async (raw, opts) => {
      const parsed = await schema.parse(raw, opts);
      if (parsed.ok) {
        return parsed.value;
      }
      throw new ParseError(parsed.errors);
    },
    jsonOrThrow: async (parsed, opts) => {
      const raw = await schema.json(parsed, opts);
      if (raw.ok) {
        return raw.value;
      }
      throw new JsonError(raw.errors);
    }
  };
}
function optional(schema) {
  const baseSchema = {
    parse: (raw, opts) => {
      if (raw == null) {
        return {
          ok: true,
          value: void 0
        };
      }
      return schema.parse(raw, opts);
    },
    json: (parsed, opts) => {
      if (parsed == null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.json(parsed, opts);
    },
    getType: () => SchemaType.OPTIONAL
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function transform(schema, transformer) {
  const baseSchema = {
    parse: async (raw, opts) => {
      const parsed = await schema.parse(raw, opts);
      if (!parsed.ok) {
        return parsed;
      }
      return {
        ok: true,
        value: transformer.transform(parsed.value)
      };
    },
    json: async (transformed, opts) => {
      const parsed = await transformer.untransform(transformed);
      return schema.json(parsed, opts);
    },
    getType: () => schema.getType()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_getSchemaUtils = __esm({
  "src/core/schemas/builders/schema-utils/getSchemaUtils.ts"() {
    "use strict";
    init_Schema();
    init_JsonError();
    init_ParseError();
  }
});

// src/core/schemas/builders/schema-utils/index.ts
var init_schema_utils = __esm({
  "src/core/schemas/builders/schema-utils/index.ts"() {
    "use strict";
    init_getSchemaUtils();
    init_JsonError();
    init_ParseError();
  }
});

// src/core/schemas/builders/date/date.ts
function date() {
  const baseSchema = {
    parse: (raw) => {
      if (typeof raw === "string" && ISO_8601_REGEX.test(raw)) {
        return {
          ok: true,
          value: new Date(raw)
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not an ISO 8601 date string"
            }
          ]
        };
      }
    },
    json: (date2) => {
      if (date2 instanceof Date) {
        return {
          ok: true,
          value: date2.toISOString()
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a Date object"
            }
          ]
        };
      }
    },
    getType: () => SchemaType.DATE
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var ISO_8601_REGEX;
var init_date = __esm({
  "src/core/schemas/builders/date/date.ts"() {
    "use strict";
    init_Schema();
    init_schema_utils();
    ISO_8601_REGEX = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
  }
});

// src/core/schemas/builders/date/index.ts
var init_date2 = __esm({
  "src/core/schemas/builders/date/index.ts"() {
    "use strict";
    init_date();
  }
});

// src/core/schemas/utils/createIdentitySchemaCreator.ts
function createIdentitySchemaCreator(schemaType, validate) {
  return () => {
    const baseSchema = {
      parse: validate,
      json: validate,
      getType: () => schemaType
    };
    return {
      ...baseSchema,
      ...getSchemaUtils(baseSchema)
    };
  };
}
var init_createIdentitySchemaCreator = __esm({
  "src/core/schemas/utils/createIdentitySchemaCreator.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/enum/enum.ts
function enum_(values) {
  const validValues = new Set(values);
  const schemaCreator = createIdentitySchemaCreator(SchemaType.ENUM, (value, { allowUnknownKeys = false } = {}) => {
    if (typeof value === "string" && (validValues.has(value) || allowUnknownKeys)) {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [],
            message: "Not one of the allowed values"
          }
        ]
      };
    }
  });
  return schemaCreator();
}
var init_enum = __esm({
  "src/core/schemas/builders/enum/enum.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/enum/index.ts
var init_enum2 = __esm({
  "src/core/schemas/builders/enum/index.ts"() {
    "use strict";
    init_enum();
  }
});

// src/core/schemas/builders/lazy/lazy.ts
function lazy(getter) {
  const baseSchema = constructLazyBaseSchema(getter);
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function constructLazyBaseSchema(getter) {
  return {
    parse: async (raw, opts) => (await getMemoizedSchema(getter)).parse(raw, opts),
    json: async (parsed, opts) => (await getMemoizedSchema(getter)).json(parsed, opts),
    getType: async () => (await getMemoizedSchema(getter)).getType()
  };
}
async function getMemoizedSchema(getter) {
  const castedGetter = getter;
  if (castedGetter.__zurg_memoized == null) {
    castedGetter.__zurg_memoized = await getter();
  }
  return castedGetter.__zurg_memoized;
}
var init_lazy = __esm({
  "src/core/schemas/builders/lazy/lazy.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/utils/entries.ts
function entries(object2) {
  return Object.entries(object2);
}
var init_entries = __esm({
  "src/core/schemas/utils/entries.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/filterObject.ts
function filterObject(obj, keysToInclude) {
  const keysToIncludeSet = new Set(keysToInclude);
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (keysToIncludeSet.has(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
var init_filterObject = __esm({
  "src/core/schemas/utils/filterObject.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/isPlainObject.ts
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  let proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(value) === proto;
}
var NOT_AN_OBJECT_ERROR_MESSAGE;
var init_isPlainObject = __esm({
  "src/core/schemas/utils/isPlainObject.ts"() {
    "use strict";
    NOT_AN_OBJECT_ERROR_MESSAGE = "Not an object";
  }
});

// src/core/schemas/utils/keys.ts
function keys(object2) {
  return Object.keys(object2);
}
var init_keys = __esm({
  "src/core/schemas/utils/keys.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/partition.ts
function partition(items, predicate) {
  const trueItems = [], falseItems = [];
  for (const item of items) {
    if (predicate(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  }
  return [trueItems, falseItems];
}
var init_partition = __esm({
  "src/core/schemas/utils/partition.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object-like/getObjectLikeUtils.ts
function getObjectLikeUtils(schema) {
  return {
    withParsedProperties: (properties) => withParsedProperties(schema, properties)
  };
}
function withParsedProperties(objectLike, properties) {
  const objectSchema = {
    parse: async (raw, opts) => {
      const parsedObject = await objectLike.parse(raw, opts);
      if (!parsedObject.ok) {
        return parsedObject;
      }
      const additionalProperties = Object.entries(properties).reduce(
        (processed, [key, value]) => {
          return {
            ...processed,
            [key]: typeof value === "function" ? value(parsedObject.value) : value
          };
        },
        {}
      );
      return {
        ok: true,
        value: {
          ...parsedObject.value,
          ...additionalProperties
        }
      };
    },
    json: (parsed, opts) => {
      if (!isPlainObject(parsed)) {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: NOT_AN_OBJECT_ERROR_MESSAGE
            }
          ]
        };
      }
      const addedPropertyKeys = new Set(Object.keys(properties));
      const parsedWithoutAddedProperties = filterObject(
        parsed,
        Object.keys(parsed).filter((key) => !addedPropertyKeys.has(key))
      );
      return objectLike.json(parsedWithoutAddedProperties, opts);
    },
    getType: () => objectLike.getType()
  };
  return {
    ...objectSchema,
    ...getSchemaUtils(objectSchema),
    ...getObjectLikeUtils(objectSchema)
  };
}
var init_getObjectLikeUtils = __esm({
  "src/core/schemas/builders/object-like/getObjectLikeUtils.ts"() {
    "use strict";
    init_filterObject();
    init_isPlainObject();
    init_schema_utils();
  }
});

// src/core/schemas/builders/object-like/index.ts
var init_object_like = __esm({
  "src/core/schemas/builders/object-like/index.ts"() {
    "use strict";
    init_getObjectLikeUtils();
  }
});

// src/core/schemas/builders/object/property.ts
function property(rawKey, valueSchema) {
  return {
    rawKey,
    valueSchema,
    isProperty: true
  };
}
function isProperty(maybeProperty) {
  return maybeProperty.isProperty;
}
var init_property = __esm({
  "src/core/schemas/builders/object/property.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object/object.ts
function object(schemas) {
  const baseSchema = {
    _getRawProperties: () => Promise.resolve(
      Object.entries(schemas).map(
        ([parsedKey, propertySchema]) => isProperty(propertySchema) ? propertySchema.rawKey : parsedKey
      )
    ),
    _getParsedProperties: () => Promise.resolve(keys(schemas)),
    parse: async (raw, opts) => {
      const rawKeyToProperty = {};
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const rawKey = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.rawKey : parsedKey;
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        const property2 = {
          rawKey,
          parsedKey,
          valueSchema
        };
        rawKeyToProperty[rawKey] = property2;
        if (await isSchemaRequired(valueSchema)) {
          requiredKeys.push(rawKey);
        }
      }
      return validateAndTransformObject({
        value: raw,
        requiredKeys,
        getProperty: (rawKey) => {
          const property2 = rawKeyToProperty[rawKey];
          if (property2 == null) {
            return void 0;
          }
          return {
            transformedKey: property2.parsedKey,
            transform: (propertyValue) => property2.valueSchema.parse(propertyValue, opts)
          };
        },
        allowUnknownKeys: opts?.allowUnknownKeys ?? false
      });
    },
    json: async (parsed, opts) => {
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        if (await isSchemaRequired(valueSchema)) {
          requiredKeys.push(parsedKey);
        }
      }
      return validateAndTransformObject({
        value: parsed,
        requiredKeys,
        getProperty: (parsedKey) => {
          const property2 = schemas[parsedKey];
          if (property2 == null) {
            return void 0;
          }
          if (isProperty(property2)) {
            return {
              transformedKey: property2.rawKey,
              transform: (propertyValue) => property2.valueSchema.json(propertyValue, opts)
            };
          } else {
            return {
              transformedKey: parsedKey,
              transform: (propertyValue) => property2.json(propertyValue, opts)
            };
          }
        },
        allowUnknownKeys: opts?.allowUnknownKeys ?? false
      });
    },
    getType: () => SchemaType.OBJECT
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
async function validateAndTransformObject({
  value,
  requiredKeys,
  getProperty,
  allowUnknownKeys
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  const missingRequiredKeys = new Set(requiredKeys);
  const errors = [];
  const transformed = {};
  for (const [preTransformedKey, preTransformedItemValue] of Object.entries(value)) {
    const property2 = getProperty(preTransformedKey);
    if (property2 != null) {
      missingRequiredKeys.delete(preTransformedKey);
      const value2 = await property2.transform(preTransformedItemValue);
      if (value2.ok) {
        transformed[property2.transformedKey] = value2.value;
      } else {
        errors.push(
          ...value2.errors.map((error) => ({
            path: [preTransformedKey, ...error.path],
            message: error.message
          }))
        );
      }
    } else if (allowUnknownKeys) {
      transformed[preTransformedKey] = preTransformedItemValue;
    } else {
      errors.push({
        path: [preTransformedKey],
        message: `Unrecognized key "${preTransformedKey}"`
      });
    }
  }
  errors.push(
    ...requiredKeys.filter((key) => missingRequiredKeys.has(key)).map((key) => ({
      path: [],
      message: `Missing required key "${key}"`
    }))
  );
  if (errors.length === 0) {
    return {
      ok: true,
      value: transformed
    };
  } else {
    return {
      ok: false,
      errors
    };
  }
}
function getObjectUtils(schema) {
  return {
    extend: (extension) => {
      const baseSchema = {
        _getParsedProperties: async () => [
          ...await schema._getParsedProperties(),
          ...await extension._getParsedProperties()
        ],
        _getRawProperties: async () => [
          ...await schema._getRawProperties(),
          ...await extension._getRawProperties()
        ],
        parse: async (raw, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: await extension._getRawProperties(),
            value: raw,
            transformBase: (rawBase) => schema.parse(rawBase, opts),
            transformExtension: (rawExtension) => extension.parse(rawExtension, opts)
          });
        },
        json: async (parsed, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: await extension._getParsedProperties(),
            value: parsed,
            transformBase: (parsedBase) => schema.json(parsedBase, opts),
            transformExtension: (parsedExtension) => extension.json(parsedExtension, opts)
          });
        },
        getType: () => SchemaType.OBJECT
      };
      return {
        ...baseSchema,
        ...getSchemaUtils(baseSchema),
        ...getObjectLikeUtils(baseSchema),
        ...getObjectUtils(baseSchema)
      };
    }
  };
}
async function validateAndTransformExtendedObject({
  extensionKeys,
  value,
  transformBase,
  transformExtension
}) {
  const extensionPropertiesSet = new Set(extensionKeys);
  const [extensionProperties, baseProperties] = partition(
    keys(value),
    (key) => extensionPropertiesSet.has(key)
  );
  const transformedBase = await transformBase(filterObject(value, baseProperties));
  const transformedExtension = await transformExtension(filterObject(value, extensionProperties));
  if (transformedBase.ok && transformedExtension.ok) {
    return {
      ok: true,
      value: {
        ...transformedBase.value,
        ...transformedExtension.value
      }
    };
  } else {
    return {
      ok: false,
      errors: [
        ...transformedBase.ok ? [] : transformedBase.errors,
        ...transformedExtension.ok ? [] : transformedExtension.errors
      ]
    };
  }
}
async function isSchemaRequired(schema) {
  return !await isSchemaOptional(schema);
}
async function isSchemaOptional(schema) {
  switch (await schema.getType()) {
    case SchemaType.ANY:
    case SchemaType.UNKNOWN:
    case SchemaType.OPTIONAL:
      return true;
    default:
      return false;
  }
}
var init_object = __esm({
  "src/core/schemas/builders/object/object.ts"() {
    "use strict";
    init_Schema();
    init_entries();
    init_filterObject();
    init_isPlainObject();
    init_keys();
    init_partition();
    init_object_like();
    init_schema_utils();
    init_property();
  }
});

// src/core/schemas/builders/object/index.ts
var init_object2 = __esm({
  "src/core/schemas/builders/object/index.ts"() {
    "use strict";
    init_object();
    init_property();
  }
});

// src/core/schemas/builders/lazy/lazyObject.ts
function lazyObject(getter) {
  const baseSchema = {
    ...constructLazyBaseSchema(getter),
    _getRawProperties: async () => (await getMemoizedSchema(getter))._getRawProperties(),
    _getParsedProperties: async () => (await getMemoizedSchema(getter))._getParsedProperties()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
var init_lazyObject = __esm({
  "src/core/schemas/builders/lazy/lazyObject.ts"() {
    "use strict";
    init_object2();
    init_object_like();
    init_schema_utils();
    init_lazy();
  }
});

// src/core/schemas/builders/lazy/index.ts
var init_lazy2 = __esm({
  "src/core/schemas/builders/lazy/index.ts"() {
    "use strict";
    init_lazy();
    init_lazyObject();
  }
});

// src/core/schemas/builders/list/list.ts
function list(schema) {
  const baseSchema = {
    parse: async (raw, opts) => validateAndTransformArray(raw, (item) => schema.parse(item, opts)),
    json: (parsed, opts) => validateAndTransformArray(parsed, (item) => schema.json(item, opts)),
    getType: () => SchemaType.LIST
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
async function validateAndTransformArray(value, transformItem) {
  if (!Array.isArray(value)) {
    return {
      ok: false,
      errors: [
        {
          message: "Not a list",
          path: []
        }
      ]
    };
  }
  const maybeValidItems = await Promise.all(value.map((item) => transformItem(item)));
  return maybeValidItems.reduce(
    (acc, item, index) => {
      if (acc.ok && item.ok) {
        return {
          ok: true,
          value: [...acc.value, item.value]
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!item.ok) {
        errors.push(
          ...item.errors.map((error) => ({
            path: [`[${index}]`, ...error.path],
            message: error.message
          }))
        );
      }
      return {
        ok: false,
        errors
      };
    },
    { ok: true, value: [] }
  );
}
var init_list = __esm({
  "src/core/schemas/builders/list/list.ts"() {
    "use strict";
    init_Schema();
    init_schema_utils();
  }
});

// src/core/schemas/builders/list/index.ts
var init_list2 = __esm({
  "src/core/schemas/builders/list/index.ts"() {
    "use strict";
    init_list();
  }
});

// src/core/schemas/builders/literals/stringLiteral.ts
function stringLiteral(literal) {
  const schemaCreator = createIdentitySchemaCreator(SchemaType.STRING_LITERAL, (value) => {
    if (value === literal) {
      return {
        ok: true,
        value: literal
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [],
            message: `Not equal to "${literal}"`
          }
        ]
      };
    }
  });
  return schemaCreator();
}
var init_stringLiteral = __esm({
  "src/core/schemas/builders/literals/stringLiteral.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/literals/index.ts
var init_literals = __esm({
  "src/core/schemas/builders/literals/index.ts"() {
    "use strict";
    init_stringLiteral();
  }
});

// src/core/schemas/builders/primitives/any.ts
var any;
var init_any = __esm({
  "src/core/schemas/builders/primitives/any.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    any = createIdentitySchemaCreator(SchemaType.ANY, (value) => ({ ok: true, value }));
  }
});

// src/core/schemas/builders/primitives/boolean.ts
var boolean;
var init_boolean = __esm({
  "src/core/schemas/builders/primitives/boolean.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    boolean = createIdentitySchemaCreator(SchemaType.BOOLEAN, (value) => {
      if (typeof value === "boolean") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a boolean"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/number.ts
var number;
var init_number = __esm({
  "src/core/schemas/builders/primitives/number.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    number = createIdentitySchemaCreator(SchemaType.NUMBER, (value) => {
      if (typeof value === "number") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a number"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/string.ts
var string;
var init_string = __esm({
  "src/core/schemas/builders/primitives/string.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    string = createIdentitySchemaCreator(SchemaType.STRING, (value) => {
      if (typeof value === "string") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a string"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/unknown.ts
var unknown;
var init_unknown = __esm({
  "src/core/schemas/builders/primitives/unknown.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    unknown = createIdentitySchemaCreator(SchemaType.UNKNOWN, (value) => ({ ok: true, value }));
  }
});

// src/core/schemas/builders/primitives/index.ts
var init_primitives = __esm({
  "src/core/schemas/builders/primitives/index.ts"() {
    "use strict";
    init_any();
    init_boolean();
    init_number();
    init_string();
    init_unknown();
  }
});

// src/core/schemas/builders/record/record.ts
function record(keySchema, valueSchema) {
  const baseSchema = {
    parse: async (raw, opts) => {
      return validateAndTransformRecord({
        value: raw,
        isKeyNumeric: await keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.parse(key, opts),
        transformValue: (value) => valueSchema.parse(value, opts)
      });
    },
    json: async (parsed, opts) => {
      return validateAndTransformRecord({
        value: parsed,
        isKeyNumeric: await keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.json(key, opts),
        transformValue: (value) => valueSchema.json(value, opts)
      });
    },
    getType: () => SchemaType.RECORD
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
async function validateAndTransformRecord({
  value,
  isKeyNumeric,
  transformKey,
  transformValue
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  return entries(value).reduce(
    async (accPromise, [stringKey, value2]) => {
      if (value2 == null) {
        return accPromise;
      }
      const acc = await accPromise;
      let key = stringKey;
      if (isKeyNumeric) {
        const numberKey = stringKey.length > 0 ? Number(stringKey) : NaN;
        if (!isNaN(numberKey)) {
          key = numberKey;
        }
      }
      const transformedKey = await transformKey(key);
      const transformedValue = await transformValue(value2);
      if (acc.ok && transformedKey.ok && transformedValue.ok) {
        return {
          ok: true,
          value: {
            ...acc.value,
            [transformedKey.value]: transformedValue.value
          }
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!transformedKey.ok) {
        errors.push(
          ...transformedKey.errors.map((error) => ({
            path: [`${key} (key)`, ...error.path],
            message: error.message
          }))
        );
      }
      if (!transformedValue.ok) {
        errors.push(
          ...transformedValue.errors.map((error) => ({
            path: [stringKey, ...error.path],
            message: error.message
          }))
        );
      }
      return {
        ok: false,
        errors
      };
    },
    Promise.resolve({ ok: true, value: {} })
  );
}
var init_record = __esm({
  "src/core/schemas/builders/record/record.ts"() {
    "use strict";
    init_Schema();
    init_entries();
    init_isPlainObject();
    init_schema_utils();
  }
});

// src/core/schemas/builders/record/index.ts
var init_record2 = __esm({
  "src/core/schemas/builders/record/index.ts"() {
    "use strict";
    init_record();
  }
});

// src/core/schemas/builders/set/set.ts
function set(schema) {
  const listSchema = list(schema);
  const baseSchema = {
    parse: async (raw, opts) => {
      const parsedList = await listSchema.parse(raw, opts);
      if (parsedList.ok) {
        return {
          ok: true,
          value: new Set(parsedList.value)
        };
      } else {
        return parsedList;
      }
    },
    json: async (parsed, opts) => {
      if (!(parsed instanceof Set)) {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a Set"
            }
          ]
        };
      }
      const jsonList = await listSchema.json([...parsed], opts);
      return jsonList;
    },
    getType: () => SchemaType.SET
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_set = __esm({
  "src/core/schemas/builders/set/set.ts"() {
    "use strict";
    init_Schema();
    init_list2();
    init_schema_utils();
  }
});

// src/core/schemas/builders/set/index.ts
var init_set2 = __esm({
  "src/core/schemas/builders/set/index.ts"() {
    "use strict";
    init_set();
  }
});

// src/core/schemas/builders/union/discriminant.ts
function discriminant(parsedDiscriminant, rawDiscriminant) {
  return {
    parsedDiscriminant,
    rawDiscriminant
  };
}
var init_discriminant = __esm({
  "src/core/schemas/builders/union/discriminant.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/union/union.ts
function union(discriminant2, union2) {
  const rawDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.rawDiscriminant;
  const parsedDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.parsedDiscriminant;
  const discriminantValueSchema = enum_(keys(union2));
  const baseSchema = {
    parse: async (raw, opts) => {
      return transformAndValidateUnion(
        raw,
        rawDiscriminant,
        parsedDiscriminant,
        (discriminantValue) => discriminantValueSchema.parse(discriminantValue, opts),
        (discriminantValue) => union2[discriminantValue],
        opts?.allowUnknownKeys ?? false,
        (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.parse(additionalProperties, opts)
      );
    },
    json: async (parsed, opts) => {
      return transformAndValidateUnion(
        parsed,
        parsedDiscriminant,
        rawDiscriminant,
        (discriminantValue) => discriminantValueSchema.json(discriminantValue, opts),
        (discriminantValue) => union2[discriminantValue],
        opts?.allowUnknownKeys ?? false,
        (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.json(additionalProperties, opts)
      );
    },
    getType: () => SchemaType.UNION
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema)
  };
}
async function transformAndValidateUnion(value, discriminant2, transformedDiscriminant, transformDiscriminantValue, getAdditionalPropertiesSchema, allowUnknownKeys, transformAdditionalProperties) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  const { [discriminant2]: discriminantValue, ...additionalProperties } = value;
  if (discriminantValue == null) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: `Missing discriminant ("${discriminant2}")`
        }
      ]
    };
  }
  const transformedDiscriminantValue = await transformDiscriminantValue(discriminantValue);
  if (!transformedDiscriminantValue.ok) {
    return {
      ok: false,
      errors: transformedDiscriminantValue.errors.map((error) => ({
        path: [discriminant2, ...error.path],
        message: error.message
      }))
    };
  }
  const additionalPropertiesSchema = getAdditionalPropertiesSchema(transformedDiscriminantValue.value);
  if (additionalPropertiesSchema == null) {
    if (allowUnknownKeys) {
      return {
        ok: true,
        value: {
          [transformedDiscriminant]: transformedDiscriminantValue.value,
          ...additionalProperties
        }
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [discriminant2],
            message: "Unrecognized discriminant value"
          }
        ]
      };
    }
  }
  const transformedAdditionalProperties = await transformAdditionalProperties(
    additionalProperties,
    additionalPropertiesSchema
  );
  if (!transformedAdditionalProperties.ok) {
    return transformedAdditionalProperties;
  }
  return {
    ok: true,
    value: {
      [transformedDiscriminant]: discriminantValue,
      ...transformedAdditionalProperties.value
    }
  };
}
var init_union = __esm({
  "src/core/schemas/builders/union/union.ts"() {
    "use strict";
    init_Schema();
    init_isPlainObject();
    init_keys();
    init_enum2();
    init_object_like();
    init_schema_utils();
  }
});

// src/core/schemas/builders/union/index.ts
var init_union2 = __esm({
  "src/core/schemas/builders/union/index.ts"() {
    "use strict";
    init_discriminant();
    init_union();
  }
});

// src/core/schemas/builders/index.ts
var init_builders = __esm({
  "src/core/schemas/builders/index.ts"() {
    "use strict";
    init_date2();
    init_enum2();
    init_lazy2();
    init_list2();
    init_literals();
    init_object2();
    init_object_like();
    init_primitives();
    init_record2();
    init_schema_utils();
    init_set2();
    init_union2();
  }
});

// src/core/schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  JsonError: () => JsonError,
  ParseError: () => ParseError,
  any: () => any,
  boolean: () => boolean,
  date: () => date,
  discriminant: () => discriminant,
  enum_: () => enum_,
  getObjectLikeUtils: () => getObjectLikeUtils,
  getObjectUtils: () => getObjectUtils,
  getSchemaUtils: () => getSchemaUtils,
  isProperty: () => isProperty,
  lazy: () => lazy,
  lazyObject: () => lazyObject,
  list: () => list,
  number: () => number,
  object: () => object,
  optional: () => optional,
  property: () => property,
  record: () => record,
  set: () => set,
  string: () => string,
  stringLiteral: () => stringLiteral,
  transform: () => transform,
  union: () => union,
  unknown: () => unknown,
  withParsedProperties: () => withParsedProperties
});
var init_schemas = __esm({
  "src/core/schemas/index.ts"() {
    "use strict";
    init_builders();
    init_Schema();
  }
});

// node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
  }
});

// node_modules/buffer/index.js
var require_buffer = __commonJS({
  "node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports.Buffer = Buffer2;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports.kMaxLength = K_MAX_LENGTH;
    Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer2.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer2.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length);
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function Buffer2(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe(arg);
      }
      return from(arg, encodingOrOffset, length);
    }
    Buffer2.poolSize = 8192;
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof value === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer2.from(valueOf, encodingOrOffset, length);
      }
      const b = fromObject(value);
      if (b)
        return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    Buffer2.from = function(value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length);
    };
    Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer2, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer2.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer2.allocUnsafe = function(size) {
      return allocUnsafe(size);
    };
    Buffer2.allocUnsafeSlow = function(size) {
      return allocUnsafe(size);
    };
    function fromString(string2, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length = byteLength(string2, encoding) | 0;
      let buf = createBuffer(length);
      const actual = buf.write(string2, encoding);
      if (actual !== length) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array) {
      const length = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length);
      for (let i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length === void 0) {
        buf = new Uint8Array(array);
      } else if (length === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length);
      }
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer2.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer2.alloc(+length);
    }
    Buffer2.isBuffer = function isBuffer(b) {
      return b != null && b._isBuffer === true && b !== Buffer2.prototype;
    };
    Buffer2.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array))
        a = Buffer2.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array))
        b = Buffer2.from(b, b.offset, b.byteLength);
      if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b)
        return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    Buffer2.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer2.concat = function concat(list2, length) {
      if (!Array.isArray(list2)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list2.length === 0) {
        return Buffer2.alloc(0);
      }
      let i;
      if (length === void 0) {
        length = 0;
        for (i = 0; i < list2.length; ++i) {
          length += list2[i].length;
        }
      }
      const buffer = Buffer2.allocUnsafe(length);
      let pos = 0;
      for (i = 0; i < list2.length; ++i) {
        let buf = list2[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer2.isBuffer(buf))
              buf = Buffer2.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer2.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string2, encoding) {
      if (Buffer2.isBuffer(string2)) {
        return string2.length;
      }
      if (ArrayBuffer.isView(string2) || isInstance(string2, ArrayBuffer)) {
        return string2.byteLength;
      }
      if (typeof string2 !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string2
        );
      }
      const len = string2.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0)
        return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string2).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string2).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string2).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.prototype._isBuffer = true;
    function swap(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer2.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer2.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer2.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer2.prototype.toString = function toString() {
      const length = this.length;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
    Buffer2.prototype.equals = function equals(b) {
      if (!Buffer2.isBuffer(b))
        throw new TypeError("Argument must be a Buffer");
      if (this === b)
        return true;
      return Buffer2.compare(this, b) === 0;
    };
    Buffer2.prototype.inspect = function inspect() {
      let str = "";
      const max = exports.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max)
        str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
    }
    Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer2.from(target, target.offset, target.byteLength);
      }
      if (!Buffer2.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
        );
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val === "string") {
        val = Buffer2.from(val, encoding);
      }
      if (Buffer2.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i;
            if (i - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found)
            return i;
        }
      }
      return -1;
    }
    Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string2, offset, length) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      const strLen = string2.length;
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      let i;
      for (i = 0; i < length; ++i) {
        const parsed = parseInt(string2.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
          return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string2, offset, length) {
      return blitBuffer(utf8ToBytes(string2, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string2, offset, length) {
      return blitBuffer(asciiToBytes(string2), buf, offset, length);
    }
    function base64Write(buf, string2, offset, length) {
      return blitBuffer(base64ToBytes(string2), buf, offset, length);
    }
    function ucs2Write(buf, string2, offset, length) {
      return blitBuffer(utf16leToBytes(string2, buf.length - offset), buf, offset, length);
    }
    Buffer2.prototype.write = function write(string2, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
          length = length >>> 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string2.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string2, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string2, offset, length);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string2, offset, length);
          case "base64":
            return base64Write(this, string2, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string2, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer2.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer2.prototype.slice = function slice(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer2.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
    });
    Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer2.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
      if (!Buffer2.isBuffer(target))
        throw new TypeError("argument should be a Buffer");
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("Index out of range");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        );
      }
      return len;
    };
    Buffer2.prototype.fill = function fill(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val)
        val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base) {
      errors[sym] = class NodeError extends Base {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name) {
        if (name) {
          return `${name} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
          received = addNumericalSeparator(String(input));
        } else if (typeof input === "bigint") {
          received = String(input);
          if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
            received = addNumericalSeparator(received);
          }
          received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min, max, buf, offset, byteLength2) {
      if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength2 > 3) {
          if (min === 0 || min === BigInt(0)) {
            range = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        } else {
          range = `>= ${min}${n} and <= ${max}${n}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length, type) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
      }
      if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type || "offset",
        `>= ${type ? 1 : 0} and <= ${length}`,
        value
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string2, units) {
      units = units || Infinity;
      let codePoint;
      const length = string2.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length; ++i) {
        codePoint = string2.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
          break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      let i;
      for (i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
          break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    }();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// node_modules/safe-buffer/index.js
var require_safe_buffer = __commonJS({
  "node_modules/safe-buffer/index.js"(exports, module) {
    var buffer = require_buffer();
    var Buffer2 = buffer.Buffer;
    function copyProps(src, dst) {
      for (var key in src) {
        dst[key] = src[key];
      }
    }
    if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) {
      module.exports = buffer;
    } else {
      copyProps(buffer, exports);
      exports.Buffer = SafeBuffer;
    }
    function SafeBuffer(arg, encodingOrOffset, length) {
      return Buffer2(arg, encodingOrOffset, length);
    }
    copyProps(Buffer2, SafeBuffer);
    SafeBuffer.from = function(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        throw new TypeError("Argument must not be a number");
      }
      return Buffer2(arg, encodingOrOffset, length);
    };
    SafeBuffer.alloc = function(size, fill, encoding) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      var buf = Buffer2(size);
      if (fill !== void 0) {
        if (typeof encoding === "string") {
          buf.fill(fill, encoding);
        } else {
          buf.fill(fill);
        }
      } else {
        buf.fill(0);
      }
      return buf;
    };
    SafeBuffer.allocUnsafe = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return Buffer2(size);
    };
    SafeBuffer.allocUnsafeSlow = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return buffer.SlowBuffer(size);
    };
  }
});

// node_modules/basic-auth/index.js
var require_basic_auth = __commonJS({
  "node_modules/basic-auth/index.js"(exports, module) {
    "use strict";
    var Buffer2 = require_safe_buffer().Buffer;
    module.exports = auth;
    module.exports.parse = parse2;
    var CREDENTIALS_REGEXP = /^ *(?:[Bb][Aa][Ss][Ii][Cc]) +([A-Za-z0-9._~+/-]+=*) *$/;
    var USER_PASS_REGEXP = /^([^:]*):(.*)$/;
    function auth(req) {
      if (!req) {
        throw new TypeError("argument req is required");
      }
      if (typeof req !== "object") {
        throw new TypeError("argument req is required to be an object");
      }
      var header = getAuthorization(req);
      return parse2(header);
    }
    function decodeBase64(str) {
      return Buffer2.from(str, "base64").toString();
    }
    function getAuthorization(req) {
      if (!req.headers || typeof req.headers !== "object") {
        throw new TypeError("argument req is required to have headers property");
      }
      return req.headers.authorization;
    }
    function parse2(string2) {
      if (typeof string2 !== "string") {
        return void 0;
      }
      var match = CREDENTIALS_REGEXP.exec(string2);
      if (!match) {
        return void 0;
      }
      var userPass = USER_PASS_REGEXP.exec(decodeBase64(match[1]));
      if (!userPass) {
        return void 0;
      }
      return new Credentials(userPass[1], userPass[2]);
    }
    function Credentials(name, pass) {
      this.name = name;
      this.pass = pass;
    }
  }
});

// node_modules/js-base64/base64.mjs
var _TD, _TE, b64ch, b64chs, b64tab, _fromCC, _U8Afrom;
var init_base64 = __esm({
  "node_modules/js-base64/base64.mjs"() {
    _TD = typeof TextDecoder === "function" ? new TextDecoder() : void 0;
    _TE = typeof TextEncoder === "function" ? new TextEncoder() : void 0;
    b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    b64chs = Array.prototype.slice.call(b64ch);
    b64tab = ((a) => {
      let tab = {};
      a.forEach((c, i) => tab[c] = i);
      return tab;
    })(b64chs);
    _fromCC = String.fromCharCode.bind(String);
    _U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it, fn = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
  }
});

// src/core/auth/BasicAuth.ts
var import_basic_auth;
var init_BasicAuth = __esm({
  "src/core/auth/BasicAuth.ts"() {
    "use strict";
    import_basic_auth = __toESM(require_basic_auth());
    init_base64();
  }
});

// src/core/auth/BearerToken.ts
var BEARER_AUTH_HEADER_PREFIX, BearerToken;
var init_BearerToken = __esm({
  "src/core/auth/BearerToken.ts"() {
    "use strict";
    BEARER_AUTH_HEADER_PREFIX = /^Bearer /i;
    BearerToken = {
      toAuthorizationHeader: (token) => {
        if (token == null) {
          return void 0;
        }
        return `Bearer ${token}`;
      },
      fromAuthorizationHeader: (header) => {
        return header.replace(BEARER_AUTH_HEADER_PREFIX, "").trim();
      }
    };
  }
});

// src/core/auth/index.ts
var init_auth2 = __esm({
  "src/core/auth/index.ts"() {
    "use strict";
    init_BasicAuth();
    init_BearerToken();
  }
});

// node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    var kindOf = function(cache) {
      return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
      };
    }(/* @__PURE__ */ Object.create(null));
    function kindOfTest(type) {
      type = type.toLowerCase();
      return function isKindOf(thing) {
        return kindOf(thing) === type;
      };
    }
    function isArray(val) {
      return Array.isArray(val);
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    var isArrayBuffer = kindOfTest("ArrayBuffer");
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && isArrayBuffer(val.buffer);
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject2(val) {
      if (kindOf(val) !== "object") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    var isDate = kindOfTest("Date");
    var isFile = kindOfTest("File");
    var isBlob = kindOfTest("Blob");
    var isFileList = kindOfTest("FileList");
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isFormData(thing) {
      var pattern = "[object FormData]";
      return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
    }
    var isURLSearchParams = kindOfTest("URLSearchParams");
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject2(result[key]) && isPlainObject2(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject2(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    function inherits(constructor, superConstructor, props, descriptors) {
      constructor.prototype = Object.create(superConstructor.prototype, descriptors);
      constructor.prototype.constructor = constructor;
      props && Object.assign(constructor.prototype, props);
    }
    function toFlatObject(sourceObj, destObj, filter) {
      var props;
      var i;
      var prop;
      var merged = {};
      destObj = destObj || {};
      do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while (i-- > 0) {
          prop = props[i];
          if (!merged[prop]) {
            destObj[prop] = sourceObj[prop];
            merged[prop] = true;
          }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
      } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
      return destObj;
    }
    function endsWith(str, searchString, position) {
      str = String(str);
      if (position === void 0 || position > str.length) {
        position = str.length;
      }
      position -= searchString.length;
      var lastIndex = str.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
    function toArray(thing) {
      if (!thing)
        return null;
      var i = thing.length;
      if (isUndefined(i))
        return null;
      var arr = new Array(i);
      while (i-- > 0) {
        arr[i] = thing[i];
      }
      return arr;
    }
    var isTypedArray = function(TypedArray) {
      return function(thing) {
        return TypedArray && thing instanceof TypedArray;
      };
    }(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
    module.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject: isPlainObject2,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM,
      inherits,
      toFlatObject,
      kindOf,
      kindOfTest,
      endsWith,
      toArray,
      isTypedArray,
      isFileList
    };
  }
});

// node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/axios/lib/core/AxiosError.js
var require_AxiosError = __commonJS({
  "node_modules/axios/lib/core/AxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function AxiosError2(message, code, config, request, response) {
      Error.call(this);
      this.message = message;
      this.name = "AxiosError";
      code && (this.code = code);
      config && (this.config = config);
      request && (this.request = request);
      response && (this.response = response);
    }
    utils.inherits(AxiosError2, Error, {
      toJSON: function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var prototype = AxiosError2.prototype;
    var descriptors = {};
    [
      "ERR_BAD_OPTION_VALUE",
      "ERR_BAD_OPTION",
      "ECONNABORTED",
      "ETIMEDOUT",
      "ERR_NETWORK",
      "ERR_FR_TOO_MANY_REDIRECTS",
      "ERR_DEPRECATED",
      "ERR_BAD_RESPONSE",
      "ERR_BAD_REQUEST",
      "ERR_CANCELED"
      // eslint-disable-next-line func-names
    ].forEach(function(code) {
      descriptors[code] = { value: code };
    });
    Object.defineProperties(AxiosError2, descriptors);
    Object.defineProperty(prototype, "isAxiosError", { value: true });
    AxiosError2.from = function(error, code, config, request, response, customProps) {
      var axiosError = Object.create(prototype);
      utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
      });
      AxiosError2.call(axiosError, error.message, code, config, request, response);
      axiosError.name = error.name;
      customProps && Object.assign(axiosError, customProps);
      return axiosError;
    };
    module.exports = AxiosError2;
  }
});

// node_modules/axios/lib/defaults/transitional.js
var require_transitional = __commonJS({
  "node_modules/axios/lib/defaults/transitional.js"(exports, module) {
    "use strict";
    module.exports = {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    };
  }
});

// node_modules/axios/lib/helpers/toFormData.js
var require_toFormData = __commonJS({
  "node_modules/axios/lib/helpers/toFormData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function toFormData(obj, formData) {
      formData = formData || new FormData();
      var stack = [];
      function convertValue(value) {
        if (value === null)
          return "";
        if (utils.isDate(value)) {
          return value.toISOString();
        }
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
          return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
        }
        return value;
      }
      function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
          if (stack.indexOf(data) !== -1) {
            throw Error("Circular reference detected in " + parentKey);
          }
          stack.push(data);
          utils.forEach(data, function each(value, key) {
            if (utils.isUndefined(value))
              return;
            var fullKey = parentKey ? parentKey + "." + key : key;
            var arr;
            if (value && !parentKey && typeof value === "object") {
              if (utils.endsWith(key, "{}")) {
                value = JSON.stringify(value);
              } else if (utils.endsWith(key, "[]") && (arr = utils.toArray(value))) {
                arr.forEach(function(el) {
                  !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                });
                return;
              }
            }
            build(value, fullKey);
          });
          stack.pop();
        } else {
          formData.append(parentKey, convertValue(data));
        }
      }
      build(obj);
      return formData;
    }
    module.exports = toFormData;
  }
});

// node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(new AxiosError2(
          "Request failed with status code " + response.status,
          [AxiosError2.ERR_BAD_REQUEST, AxiosError2.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
          response.config,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }() : function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }();
  }
});

// node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    };
  }
});

// node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();
  }
});

// node_modules/axios/lib/cancel/CanceledError.js
var require_CanceledError = __commonJS({
  "node_modules/axios/lib/cancel/CanceledError.js"(exports, module) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    var utils = require_utils();
    function CanceledError(message) {
      AxiosError2.call(this, message == null ? "canceled" : message, AxiosError2.ERR_CANCELED);
      this.name = "CanceledError";
    }
    utils.inherits(CanceledError, AxiosError2, {
      __CANCEL__: true
    });
    module.exports = CanceledError;
  }
});

// node_modules/axios/lib/helpers/parseProtocol.js
var require_parseProtocol = __commonJS({
  "node_modules/axios/lib/helpers/parseProtocol.js"(exports, module) {
    "use strict";
    module.exports = function parseProtocol(url) {
      var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
      return match && match[1] || "";
    };
  }
});

// node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var transitionalDefaults = require_transitional();
    var AxiosError2 = require_AxiosError();
    var CanceledError = require_CanceledError();
    var parseProtocol = require_parseProtocol();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(new AxiosError2("Request aborted", AxiosError2.ECONNABORTED, config, request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(new AxiosError2("Network Error", AxiosError2.ERR_NETWORK, config, request, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || transitionalDefaults;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(new AxiosError2(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? AxiosError2.ETIMEDOUT : AxiosError2.ECONNABORTED,
            config,
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        var protocol = parseProtocol(fullPath);
        if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
          reject(new AxiosError2("Unsupported protocol " + protocol + ":", AxiosError2.ERR_BAD_REQUEST, config));
          return;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/axios/lib/helpers/null.js
var require_null = __commonJS({
  "node_modules/axios/lib/helpers/null.js"(exports, module) {
    module.exports = null;
  }
});

// node_modules/axios/lib/defaults/index.js
var require_defaults = __commonJS({
  "node_modules/axios/lib/defaults/index.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var AxiosError2 = require_AxiosError();
    var transitionalDefaults = require_transitional();
    var toFormData = require_toFormData();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: transitionalDefaults,
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        var isObjectPayload = utils.isObject(data);
        var contentType = headers && headers["Content-Type"];
        var isFileList;
        if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
          var _FormData = this.env && this.env.FormData;
          return toFormData(isFileList ? { "files[]": data } : data, _FormData && new _FormData());
        } else if (isObjectPayload || contentType === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw AxiosError2.from(e, AxiosError2.ERR_BAD_RESPONSE, this, null, this.response);
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: require_null()
      },
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform2(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var CanceledError = require_CanceledError();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new CanceledError();
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.27.2"
    };
  }
});

// node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var AxiosError2 = require_AxiosError();
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new AxiosError2(
            formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
            AxiosError2.ERR_DEPRECATED
          );
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new AxiosError2("options must be an object", AxiosError2.ERR_BAD_OPTION_VALUE);
      }
      var keys2 = Object.keys(options);
      var i = keys2.length;
      while (i-- > 0) {
        var opt = keys2[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new AxiosError2("option " + opt + " must be " + result, AxiosError2.ERR_BAD_OPTION_VALUE);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw new AxiosError2("Unknown option " + opt, AxiosError2.ERR_BAD_OPTION);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var buildFullPath = require_buildFullPath();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      var fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
          return this.request(mergeConfig(config || {}, {
            method,
            headers: isForm ? {
              "Content-Type": "multipart/form-data"
            } : {},
            url,
            data
          }));
        };
      }
      Axios.prototype[method] = generateHTTPMethod();
      Axios.prototype[method + "Form"] = generateHTTPMethod(true);
    });
    module.exports = Axios;
  }
});

// node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var CanceledError = require_CanceledError();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.CanceledError = require_CanceledError();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.VERSION = require_data().version;
    axios2.toFormData = require_toFormData();
    axios2.AxiosError = require_AxiosError();
    axios2.Cancel = axios2.CanceledError;
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module.exports = axios2;
    module.exports.default = axios2;
  }
});

// node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// src/core/fetcher/Fetcher.ts
var import_axios, fetcher;
var init_Fetcher = __esm({
  "src/core/fetcher/Fetcher.ts"() {
    "use strict";
    import_axios = __toESM(require_axios2());
    fetcher = async (args) => {
      const headers = {
        "Content-Type": "application/json"
      };
      if (args.headers != null) {
        for (const [key, value] of Object.entries(args.headers)) {
          if (value != null) {
            headers[key] = value;
          }
        }
      }
      try {
        const response = await (0, import_axios.default)({
          url: args.url,
          params: args.queryParameters,
          method: args.method,
          headers,
          data: args.body,
          validateStatus: () => true,
          transformResponse: (response2) => response2,
          timeout: args.timeoutMs ?? 6e4,
          transitional: {
            clarifyTimeoutError: true
          },
          withCredentials: args.withCredentials
        });
        let body;
        if (response.data != null && response.data.length > 0) {
          try {
            body = JSON.parse(response.data) ?? void 0;
          } catch {
            return {
              ok: false,
              error: {
                reason: "non-json",
                statusCode: response.status,
                rawBody: response.data
              }
            };
          }
        }
        if (response.status >= 200 && response.status < 300) {
          return {
            ok: true,
            body
          };
        } else {
          return {
            ok: false,
            error: {
              reason: "status-code",
              statusCode: response.status,
              body
            }
          };
        }
      } catch (error) {
        if (error.code === "ETIMEDOUT") {
          return {
            ok: false,
            error: {
              reason: "timeout"
            }
          };
        }
        return {
          ok: false,
          error: {
            reason: "unknown",
            errorMessage: error.message
          }
        };
      }
    };
  }
});

// src/core/fetcher/Supplier.ts
var Supplier;
var init_Supplier = __esm({
  "src/core/fetcher/Supplier.ts"() {
    "use strict";
    Supplier = {
      get: async (supplier) => {
        if (typeof supplier === "function") {
          return supplier();
        } else {
          return supplier;
        }
      }
    };
  }
});

// src/core/fetcher/index.ts
var init_fetcher = __esm({
  "src/core/fetcher/index.ts"() {
    "use strict";
    init_Fetcher();
    init_Supplier();
  }
});

// src/core/index.ts
var init_core = __esm({
  "src/core/index.ts"() {
    "use strict";
    init_schemas();
    init_auth2();
    init_fetcher();
  }
});

// node_modules/url-join/lib/url-join.js
var require_url_join = __commonJS({
  "node_modules/url-join/lib/url-join.js"(exports, module) {
    (function(name, context, definition) {
      if (typeof module !== "undefined" && module.exports)
        module.exports = definition();
      else if (typeof define === "function" && define.amd)
        define(definition);
      else
        context[name] = definition();
    })("urljoin", exports, function() {
      function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) {
          return "";
        }
        if (typeof strArray[0] !== "string") {
          throw new TypeError("Url must be a string. Received " + strArray[0]);
        }
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
          var first = strArray.shift();
          strArray[0] = first + strArray[0];
        }
        if (strArray[0].match(/^file:\/\/\//)) {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
        } else {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        }
        for (var i = 0; i < strArray.length; i++) {
          var component = strArray[i];
          if (typeof component !== "string") {
            throw new TypeError("Url must be a string. Received " + component);
          }
          if (component === "") {
            continue;
          }
          if (i > 0) {
            component = component.replace(/^[\/]+/, "");
          }
          if (i < strArray.length - 1) {
            component = component.replace(/[\/]+$/, "");
          } else {
            component = component.replace(/[\/]+$/, "/");
          }
          resultArray.push(component);
        }
        var str = resultArray.join("/");
        str = str.replace(/\/(\?|&|#[^!])/g, "$1");
        var parts = str.split("?");
        str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        return str;
      }
      return function() {
        var input;
        if (typeof arguments[0] === "object") {
          input = arguments[0];
        } else {
          input = [].slice.call(arguments);
        }
        return normalize(input);
      };
    });
  }
});

// src/serialization/resources/admin/types/AuthType.ts
var AuthType2;
var init_AuthType2 = __esm({
  "src/serialization/resources/admin/types/AuthType.ts"() {
    "use strict";
    init_core();
    AuthType2 = schemas_exports.enum_(["public", "password", "email", "app"]);
  }
});

// src/serialization/resources/admin/types/LogoInputType.ts
var LogoInputType;
var init_LogoInputType2 = __esm({
  "src/serialization/resources/admin/types/LogoInputType.ts"() {
    "use strict";
    init_core();
    LogoInputType = schemas_exports.object({
      lightMode: schemas_exports.property("light_mode", schemas_exports.string().optional()),
      darkMode: schemas_exports.property("dark_mode", schemas_exports.string().optional()),
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      staging: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/admin/types/LimitExceededErrorBody.ts
var LimitExceededErrorBody;
var init_LimitExceededErrorBody2 = __esm({
  "src/serialization/resources/admin/types/LimitExceededErrorBody.ts"() {
    "use strict";
    init_core();
    LimitExceededErrorBody = schemas_exports.object({
      limit: schemas_exports.number()
    });
  }
});

// src/serialization/resources/admin/types/HostingInfo.ts
var HostingInfo;
var init_HostingInfo2 = __esm({
  "src/serialization/resources/admin/types/HostingInfo.ts"() {
    "use strict";
    init_core();
    HostingInfo = schemas_exports.object({
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      details: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HostingDetails).optional()
    });
  }
});

// src/serialization/resources/admin/types/HostingDetails.ts
var HostingDetails2;
var init_HostingDetails2 = __esm({
  "src/serialization/resources/admin/types/HostingDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    HostingDetails2 = schemas_exports.union("type", {
      application_auth_login: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ApplicationAuthLogin
      ),
      email_login: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).EmailLogin),
      password_login: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PasswordLogin)
    }).transform({
      transform: (value) => {
        switch (value.type) {
          case "application_auth_login":
            return api_exports.HostingDetails.applicationAuthLogin(value);
          case "email_login":
            return api_exports.HostingDetails.emailLogin(value);
          case "password_login":
            return api_exports.HostingDetails.passwordLogin(value);
          default:
            return api_exports.HostingDetails._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/types/PasswordLogin.ts
var PasswordLogin;
var init_PasswordLogin2 = __esm({
  "src/serialization/resources/admin/types/PasswordLogin.ts"() {
    "use strict";
    init_core();
    PasswordLogin = schemas_exports.object({
      password: schemas_exports.string()
    });
  }
});

// src/serialization/resources/admin/types/ApplicationAuthLogin.ts
var ApplicationAuthLogin;
var init_ApplicationAuthLogin2 = __esm({
  "src/serialization/resources/admin/types/ApplicationAuthLogin.ts"() {
    "use strict";
    init_core();
    ApplicationAuthLogin = schemas_exports.object({
      jwtKey: schemas_exports.property("jwt_key", schemas_exports.string()),
      redirectUrl: schemas_exports.property("redirect_url", schemas_exports.string())
    });
  }
});

// src/serialization/resources/admin/types/EmailLogin.ts
var EmailLogin;
var init_EmailLogin2 = __esm({
  "src/serialization/resources/admin/types/EmailLogin.ts"() {
    "use strict";
    init_core();
    EmailLogin = schemas_exports.object({
      allowedEmails: schemas_exports.property(
        "allowed_emails",
        schemas_exports.list(schemas_exports.string()).optional()
      ),
      enableDomainLogin: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/admin/types/VideoUsageEvent.ts
var VideoUsageEvent;
var init_VideoUsageEvent2 = __esm({
  "src/serialization/resources/admin/types/VideoUsageEvent.ts"() {
    "use strict";
    init_core();
    VideoUsageEvent = schemas_exports.object({
      guideId: schemas_exports.property(
        "guide_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      name: schemas_exports.string(),
      userId: schemas_exports.property("user_id", schemas_exports.string()),
      timestamp: schemas_exports.date(),
      duration: schemas_exports.number()
    });
  }
});

// src/serialization/resources/admin/types/ArticleUsageEvent.ts
var ArticleUsageEvent;
var init_ArticleUsageEvent2 = __esm({
  "src/serialization/resources/admin/types/ArticleUsageEvent.ts"() {
    "use strict";
    init_core();
    ArticleUsageEvent = schemas_exports.object({
      guideId: schemas_exports.property(
        "guide_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      name: schemas_exports.string(),
      userId: schemas_exports.property("user_id", schemas_exports.string()),
      timestamp: schemas_exports.date()
    });
  }
});

// src/serialization/resources/admin/types/GetUsageRequest.ts
var GetUsageRequest;
var init_GetUsageRequest2 = __esm({
  "src/serialization/resources/admin/types/GetUsageRequest.ts"() {
    "use strict";
    init_core();
    GetUsageRequest = schemas_exports.object({
      start: schemas_exports.date(),
      end: schemas_exports.date(),
      userId: schemas_exports.property("user_id", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/admin/types/GetVideoUsageResponse.ts
var GetVideoUsageResponse;
var init_GetVideoUsageResponse2 = __esm({
  "src/serialization/resources/admin/types/GetVideoUsageResponse.ts"() {
    "use strict";
    init_core();
    GetVideoUsageResponse = schemas_exports.object({
      videoUsage: schemas_exports.property(
        "video_usage",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoUsageEvent))
      ),
      total: schemas_exports.number()
    });
  }
});

// src/serialization/resources/admin/types/GetArticleUsageResponse.ts
var GetArticleUsageResponse;
var init_GetArticleUsageResponse2 = __esm({
  "src/serialization/resources/admin/types/GetArticleUsageResponse.ts"() {
    "use strict";
    init_core();
    GetArticleUsageResponse = schemas_exports.object({
      articleUsage: schemas_exports.property(
        "article_usage",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ArticleUsageEvent))
      ),
      total: schemas_exports.number()
    });
  }
});

// src/serialization/resources/admin/types/FetchAuthTypeRequest.ts
var FetchAuthTypeRequest;
var init_FetchAuthTypeRequest2 = __esm({
  "src/serialization/resources/admin/types/FetchAuthTypeRequest.ts"() {
    "use strict";
    init_core();
    FetchAuthTypeRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/admin/types/FetchAuthTypeResponse.ts
var FetchAuthTypeResponse;
var init_FetchAuthTypeResponse2 = __esm({
  "src/serialization/resources/admin/types/FetchAuthTypeResponse.ts"() {
    "use strict";
    init_core();
    FetchAuthTypeResponse = schemas_exports.object({
      currentAuthType: schemas_exports.property(
        "current_auth_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthType)
      )
    });
  }
});

// src/serialization/resources/admin/types/SetAuthTypeRequest.ts
var SetAuthTypeRequest;
var init_SetAuthTypeRequest2 = __esm({
  "src/serialization/resources/admin/types/SetAuthTypeRequest.ts"() {
    "use strict";
    init_core();
    SetAuthTypeRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      newAuthType: schemas_exports.property(
        "new_auth_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthType)
      )
    });
  }
});

// src/serialization/resources/admin/types/FetchPasswordAuthDetailsRequest.ts
var FetchPasswordAuthDetailsRequest;
var init_FetchPasswordAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/FetchPasswordAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    FetchPasswordAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/admin/types/FetchPasswordAuthDetailsResponse.ts
var FetchPasswordAuthDetailsResponse;
var init_FetchPasswordAuthDetailsResponse2 = __esm({
  "src/serialization/resources/admin/types/FetchPasswordAuthDetailsResponse.ts"() {
    "use strict";
    init_core();
    FetchPasswordAuthDetailsResponse = schemas_exports.object({
      currentPassword: schemas_exports.property("current_password", schemas_exports.string())
    });
  }
});

// src/serialization/resources/admin/types/SetPasswordAuthDetailsRequest.ts
var SetPasswordAuthDetailsRequest;
var init_SetPasswordAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/SetPasswordAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    SetPasswordAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      newPassword: schemas_exports.property("new_password", schemas_exports.string())
    });
  }
});

// src/serialization/resources/admin/types/FetchAppAuthDetailsRequest.ts
var FetchAppAuthDetailsRequest;
var init_FetchAppAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/FetchAppAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    FetchAppAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/admin/types/FetchAppAuthDetailsResponse.ts
var FetchAppAuthDetailsResponse;
var init_FetchAppAuthDetailsResponse2 = __esm({
  "src/serialization/resources/admin/types/FetchAppAuthDetailsResponse.ts"() {
    "use strict";
    init_core();
    FetchAppAuthDetailsResponse = schemas_exports.object({
      jwtKey: schemas_exports.property("jwt_key", schemas_exports.string()),
      redirectUrl: schemas_exports.property("redirect_url", schemas_exports.string())
    });
  }
});

// src/serialization/resources/admin/types/SetAppAuthDetailsRequest.ts
var SetAppAuthDetailsRequest;
var init_SetAppAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/SetAppAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    SetAppAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      redirectUrl: schemas_exports.property("redirect_url", schemas_exports.string())
    });
  }
});

// src/serialization/resources/admin/types/FetchEmailAuthDetailsRequest.ts
var FetchEmailAuthDetailsRequest;
var init_FetchEmailAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/FetchEmailAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    FetchEmailAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/admin/types/FetchEmailAuthDetailsResponse.ts
var FetchEmailAuthDetailsResponse;
var init_FetchEmailAuthDetailsResponse2 = __esm({
  "src/serialization/resources/admin/types/FetchEmailAuthDetailsResponse.ts"() {
    "use strict";
    init_core();
    FetchEmailAuthDetailsResponse = schemas_exports.object({
      allowedEmails: schemas_exports.property("allowed_emails", schemas_exports.list(schemas_exports.string()))
    });
  }
});

// src/serialization/resources/admin/types/SetEmailAuthDetailsRequest.ts
var SetEmailAuthDetailsRequest;
var init_SetEmailAuthDetailsRequest2 = __esm({
  "src/serialization/resources/admin/types/SetEmailAuthDetailsRequest.ts"() {
    "use strict";
    init_core();
    SetEmailAuthDetailsRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      allowedEmails: schemas_exports.property("allowed_emails", schemas_exports.list(schemas_exports.string()))
    });
  }
});

// src/serialization/resources/admin/types/index.ts
var init_types34 = __esm({
  "src/serialization/resources/admin/types/index.ts"() {
    "use strict";
    init_AuthType2();
    init_LogoInputType2();
    init_LimitExceededErrorBody2();
    init_HostingInfo2();
    init_HostingDetails2();
    init_PasswordLogin2();
    init_ApplicationAuthLogin2();
    init_EmailLogin2();
    init_VideoUsageEvent2();
    init_ArticleUsageEvent2();
    init_GetUsageRequest2();
    init_GetVideoUsageResponse2();
    init_GetArticleUsageResponse2();
    init_FetchAuthTypeRequest2();
    init_FetchAuthTypeResponse2();
    init_SetAuthTypeRequest2();
    init_FetchPasswordAuthDetailsRequest2();
    init_FetchPasswordAuthDetailsResponse2();
    init_SetPasswordAuthDetailsRequest2();
    init_FetchAppAuthDetailsRequest2();
    init_FetchAppAuthDetailsResponse2();
    init_SetAppAuthDetailsRequest2();
    init_FetchEmailAuthDetailsRequest2();
    init_FetchEmailAuthDetailsResponse2();
    init_SetEmailAuthDetailsRequest2();
  }
});

// src/serialization/resources/admin/client/getStagingJwt.ts
var getStagingJwt_exports2 = {};
__export(getStagingJwt_exports2, {
  Error: () => Error223,
  Response: () => Response
});
var Response, Error223;
var init_getStagingJwt2 = __esm({
  "src/serialization/resources/admin/client/getStagingJwt.ts"() {
    "use strict";
    init_core();
    init_src();
    Response = schemas_exports.string();
    Error223 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getStagingJwt.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getStagingJwt.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getStagingJwt.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/createUser.ts
var createUser_exports2 = {};
__export(createUser_exports2, {
  Error: () => Error224
});
var Error224;
var init_createUser2 = __esm({
  "src/serialization/resources/admin/client/createUser.ts"() {
    "use strict";
    init_src();
    init_core();
    Error224 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      LimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LimitExceededErrorBody)
      }),
      UserAlreadyExistsError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.createUser.Error.unauthorizedError();
          case "LimitExceededError":
            return api_exports.admin.createUser.Error.limitExceededError(value.content);
          case "UserAlreadyExistsError":
            return api_exports.admin.createUser.Error.userAlreadyExistsError();
          case "UsageLimitExceededError":
            return api_exports.admin.createUser.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.createUser.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/deleteUser.ts
var deleteUser_exports2 = {};
__export(deleteUser_exports2, {
  Error: () => Error225,
  Request: () => Request,
  Response: () => Response2
});
var Request, Response2, Error225;
var init_deleteUser2 = __esm({
  "src/serialization/resources/admin/client/deleteUser.ts"() {
    "use strict";
    init_core();
    init_src();
    Request = schemas_exports.string();
    Response2 = schemas_exports.boolean();
    Error225 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.deleteUser.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.deleteUser.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.deleteUser.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/getUsers.ts
var getUsers_exports3 = {};
__export(getUsers_exports3, {
  Error: () => Error226,
  Response: () => Response3
});
var Response3, Error226;
var init_getUsers3 = __esm({
  "src/serialization/resources/admin/client/getUsers.ts"() {
    "use strict";
    init_src();
    init_core();
    Response3 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).User));
    Error226 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getUsers.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getUsers.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getUsers.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/getHelpCenterConfig.ts
var getHelpCenterConfig_exports2 = {};
__export(getHelpCenterConfig_exports2, {
  Error: () => Error227,
  Response: () => Response4
});
var Response4, Error227;
var init_getHelpCenterConfig2 = __esm({
  "src/serialization/resources/admin/client/getHelpCenterConfig.ts"() {
    "use strict";
    init_src();
    init_core();
    Response4 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HelpCenterConfig).optional();
    Error227 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getHelpCenterConfig.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getHelpCenterConfig.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getHelpCenterConfig.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setHelpCenterConfig.ts
var setHelpCenterConfig_exports2 = {};
__export(setHelpCenterConfig_exports2, {
  Error: () => Error228
});
var Error228;
var init_setHelpCenterConfig2 = __esm({
  "src/serialization/resources/admin/client/setHelpCenterConfig.ts"() {
    "use strict";
    init_src();
    init_core();
    Error228 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setHelpCenterConfig.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setHelpCenterConfig.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setHelpCenterConfig.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setLogo.ts
var setLogo_exports2 = {};
__export(setLogo_exports2, {
  Error: () => Error229,
  Response: () => Response5
});
var Response5, Error229;
var init_setLogo2 = __esm({
  "src/serialization/resources/admin/client/setLogo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response5 = schemas_exports.boolean();
    Error229 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setLogo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setLogo.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setLogo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setFavicon.ts
var setFavicon_exports2 = {};
__export(setFavicon_exports2, {
  Error: () => Error230,
  Response: () => Response6
});
var Response6, Error230;
var init_setFavicon2 = __esm({
  "src/serialization/resources/admin/client/setFavicon.ts"() {
    "use strict";
    init_core();
    init_src();
    Response6 = schemas_exports.boolean();
    Error230 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setFavicon.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setFavicon.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setFavicon.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/getHostingDetails.ts
var getHostingDetails_exports2 = {};
__export(getHostingDetails_exports2, {
  Error: () => Error231
});
var Error231;
var init_getHostingDetails2 = __esm({
  "src/serialization/resources/admin/client/getHostingDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error231 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getHostingDetails.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getHostingDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getHostingDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setHostingDetails.ts
var setHostingDetails_exports2 = {};
__export(setHostingDetails_exports2, {
  Error: () => Error232
});
var Error232;
var init_setHostingDetails2 = __esm({
  "src/serialization/resources/admin/client/setHostingDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error232 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setHostingDetails.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setHostingDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setHostingDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/fetchAuthType.ts
var fetchAuthType_exports2 = {};
__export(fetchAuthType_exports2, {
  Error: () => Error233
});
var Error233;
var init_fetchAuthType2 = __esm({
  "src/serialization/resources/admin/client/fetchAuthType.ts"() {
    "use strict";
    init_src();
    init_core();
    Error233 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.fetchAuthType.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.fetchAuthType.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.fetchAuthType.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.fetchAuthType.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setAuthType.ts
var setAuthType_exports2 = {};
__export(setAuthType_exports2, {
  Error: () => Error234,
  Response: () => Response7
});
var Response7, Error234;
var init_setAuthType2 = __esm({
  "src/serialization/resources/admin/client/setAuthType.ts"() {
    "use strict";
    init_core();
    init_src();
    Response7 = schemas_exports.boolean();
    Error234 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setAuthType.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.setAuthType.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setAuthType.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setAuthType.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/fetchPasswordAuthDetails.ts
var fetchPasswordAuthDetails_exports2 = {};
__export(fetchPasswordAuthDetails_exports2, {
  Error: () => Error235
});
var Error235;
var init_fetchPasswordAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/fetchPasswordAuthDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error235 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.fetchPasswordAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.fetchPasswordAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.fetchPasswordAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.fetchPasswordAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setPasswordAuthDetails.ts
var setPasswordAuthDetails_exports2 = {};
__export(setPasswordAuthDetails_exports2, {
  Error: () => Error236,
  Response: () => Response8
});
var Response8, Error236;
var init_setPasswordAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/setPasswordAuthDetails.ts"() {
    "use strict";
    init_core();
    init_src();
    Response8 = schemas_exports.boolean();
    Error236 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setPasswordAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.setPasswordAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setPasswordAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setPasswordAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/fetchAppAuthDetails.ts
var fetchAppAuthDetails_exports2 = {};
__export(fetchAppAuthDetails_exports2, {
  Error: () => Error237
});
var Error237;
var init_fetchAppAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/fetchAppAuthDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error237 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.fetchAppAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.fetchAppAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.fetchAppAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.fetchAppAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setAppAuthDetails.ts
var setAppAuthDetails_exports2 = {};
__export(setAppAuthDetails_exports2, {
  Error: () => Error238,
  Response: () => Response9
});
var Response9, Error238;
var init_setAppAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/setAppAuthDetails.ts"() {
    "use strict";
    init_core();
    init_src();
    Response9 = schemas_exports.boolean();
    Error238 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setAppAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.setAppAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setAppAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setAppAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/fetchEmailAuthDetails.ts
var fetchEmailAuthDetails_exports2 = {};
__export(fetchEmailAuthDetails_exports2, {
  Error: () => Error239
});
var Error239;
var init_fetchEmailAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/fetchEmailAuthDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error239 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.fetchEmailAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.fetchEmailAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.fetchEmailAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.fetchEmailAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/setEmailAuthDetails.ts
var setEmailAuthDetails_exports2 = {};
__export(setEmailAuthDetails_exports2, {
  Error: () => Error240,
  Response: () => Response10
});
var Response10, Error240;
var init_setEmailAuthDetails2 = __esm({
  "src/serialization/resources/admin/client/setEmailAuthDetails.ts"() {
    "use strict";
    init_core();
    init_src();
    Response10 = schemas_exports.boolean();
    Error240 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.setEmailAuthDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.admin.setEmailAuthDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.admin.setEmailAuthDetails.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.setEmailAuthDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/getUsageVideo.ts
var getUsageVideo_exports2 = {};
__export(getUsageVideo_exports2, {
  Error: () => Error241
});
var Error241;
var init_getUsageVideo2 = __esm({
  "src/serialization/resources/admin/client/getUsageVideo.ts"() {
    "use strict";
    init_src();
    init_core();
    Error241 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getUsageVideo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getUsageVideo.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getUsageVideo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/getUsageArticle.ts
var getUsageArticle_exports2 = {};
__export(getUsageArticle_exports2, {
  Error: () => Error242
});
var Error242;
var init_getUsageArticle2 = __esm({
  "src/serialization/resources/admin/client/getUsageArticle.ts"() {
    "use strict";
    init_src();
    init_core();
    Error242 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.admin.getUsageArticle.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.admin.getUsageArticle.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.admin.getUsageArticle.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/admin/client/requests/GetHelpCenterConfigRequest.ts
var GetHelpCenterConfigRequest;
var init_GetHelpCenterConfigRequest = __esm({
  "src/serialization/resources/admin/client/requests/GetHelpCenterConfigRequest.ts"() {
    "use strict";
    init_core();
    GetHelpCenterConfigRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      staging: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/admin/client/requests/SetHelpCenterConfigRequest.ts
var SetHelpCenterConfigRequest;
var init_SetHelpCenterConfigRequest = __esm({
  "src/serialization/resources/admin/client/requests/SetHelpCenterConfigRequest.ts"() {
    "use strict";
    init_core();
    SetHelpCenterConfigRequest = schemas_exports.object({
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      staging: schemas_exports.boolean(),
      value: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HelpCenterConfig)
    });
  }
});

// src/serialization/resources/admin/client/requests/FaviconInputType.ts
var FaviconInputType;
var init_FaviconInputType = __esm({
  "src/serialization/resources/admin/client/requests/FaviconInputType.ts"() {
    "use strict";
    init_core();
    FaviconInputType = schemas_exports.object({
      faviconData: schemas_exports.property("favicon_data", schemas_exports.string()),
      helpcenterId: schemas_exports.property(
        "helpcenter_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      staging: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/admin/client/requests/index.ts
var init_requests17 = __esm({
  "src/serialization/resources/admin/client/requests/index.ts"() {
    "use strict";
    init_GetHelpCenterConfigRequest();
    init_SetHelpCenterConfigRequest();
    init_FaviconInputType();
  }
});

// src/serialization/resources/admin/client/index.ts
var init_client38 = __esm({
  "src/serialization/resources/admin/client/index.ts"() {
    "use strict";
    init_getStagingJwt2();
    init_createUser2();
    init_deleteUser2();
    init_getUsers3();
    init_getHelpCenterConfig2();
    init_setHelpCenterConfig2();
    init_setLogo2();
    init_setFavicon2();
    init_getHostingDetails2();
    init_setHostingDetails2();
    init_fetchAuthType2();
    init_setAuthType2();
    init_fetchPasswordAuthDetails2();
    init_setPasswordAuthDetails2();
    init_fetchAppAuthDetails2();
    init_setAppAuthDetails2();
    init_fetchEmailAuthDetails2();
    init_setEmailAuthDetails2();
    init_getUsageVideo2();
    init_getUsageArticle2();
    init_requests17();
  }
});

// src/serialization/resources/admin/index.ts
var admin_exports2 = {};
__export(admin_exports2, {
  ApplicationAuthLogin: () => ApplicationAuthLogin,
  ArticleUsageEvent: () => ArticleUsageEvent,
  AuthType: () => AuthType2,
  EmailLogin: () => EmailLogin,
  FaviconInputType: () => FaviconInputType,
  FetchAppAuthDetailsRequest: () => FetchAppAuthDetailsRequest,
  FetchAppAuthDetailsResponse: () => FetchAppAuthDetailsResponse,
  FetchAuthTypeRequest: () => FetchAuthTypeRequest,
  FetchAuthTypeResponse: () => FetchAuthTypeResponse,
  FetchEmailAuthDetailsRequest: () => FetchEmailAuthDetailsRequest,
  FetchEmailAuthDetailsResponse: () => FetchEmailAuthDetailsResponse,
  FetchPasswordAuthDetailsRequest: () => FetchPasswordAuthDetailsRequest,
  FetchPasswordAuthDetailsResponse: () => FetchPasswordAuthDetailsResponse,
  GetArticleUsageResponse: () => GetArticleUsageResponse,
  GetHelpCenterConfigRequest: () => GetHelpCenterConfigRequest,
  GetUsageRequest: () => GetUsageRequest,
  GetVideoUsageResponse: () => GetVideoUsageResponse,
  HostingDetails: () => HostingDetails2,
  HostingInfo: () => HostingInfo,
  LimitExceededErrorBody: () => LimitExceededErrorBody,
  LogoInputType: () => LogoInputType,
  PasswordLogin: () => PasswordLogin,
  SetAppAuthDetailsRequest: () => SetAppAuthDetailsRequest,
  SetAuthTypeRequest: () => SetAuthTypeRequest,
  SetEmailAuthDetailsRequest: () => SetEmailAuthDetailsRequest,
  SetHelpCenterConfigRequest: () => SetHelpCenterConfigRequest,
  SetPasswordAuthDetailsRequest: () => SetPasswordAuthDetailsRequest,
  VideoUsageEvent: () => VideoUsageEvent,
  createUser: () => createUser_exports2,
  deleteUser: () => deleteUser_exports2,
  fetchAppAuthDetails: () => fetchAppAuthDetails_exports2,
  fetchAuthType: () => fetchAuthType_exports2,
  fetchEmailAuthDetails: () => fetchEmailAuthDetails_exports2,
  fetchPasswordAuthDetails: () => fetchPasswordAuthDetails_exports2,
  getHelpCenterConfig: () => getHelpCenterConfig_exports2,
  getHostingDetails: () => getHostingDetails_exports2,
  getStagingJwt: () => getStagingJwt_exports2,
  getUsageArticle: () => getUsageArticle_exports2,
  getUsageVideo: () => getUsageVideo_exports2,
  getUsers: () => getUsers_exports3,
  setAppAuthDetails: () => setAppAuthDetails_exports2,
  setAuthType: () => setAuthType_exports2,
  setEmailAuthDetails: () => setEmailAuthDetails_exports2,
  setFavicon: () => setFavicon_exports2,
  setHelpCenterConfig: () => setHelpCenterConfig_exports2,
  setHostingDetails: () => setHostingDetails_exports2,
  setLogo: () => setLogo_exports2,
  setPasswordAuthDetails: () => setPasswordAuthDetails_exports2
});
var init_admin2 = __esm({
  "src/serialization/resources/admin/index.ts"() {
    "use strict";
    init_types34();
    init_client38();
  }
});

// src/serialization/resources/analytics/types/EventsResponse.ts
var EventsResponse;
var init_EventsResponse2 = __esm({
  "src/serialization/resources/analytics/types/EventsResponse.ts"() {
    "use strict";
    init_core();
    EventsResponse = schemas_exports.object({
      projectAnalyticsTable: schemas_exports.property(
        "ProjectAnalyticsTable",
        schemas_exports.unknown().optional()
      ),
      feedbacksTable: schemas_exports.property("FeedbacksTable", schemas_exports.unknown().optional()),
      searchAnalyticsTable: schemas_exports.property("SearchAnalyticsTable", schemas_exports.unknown().optional()),
      guidesTable: schemas_exports.property("GuidesTable", schemas_exports.unknown().optional()),
      ratingsChart: schemas_exports.property("RatingsChart", schemas_exports.unknown().optional()),
      impressionsLineChart: schemas_exports.property("ImpressionsLineChart", schemas_exports.unknown().optional()),
      videoPlaysLineChart: schemas_exports.property("VideoPlaysLineChart", schemas_exports.unknown().optional()),
      videoAnalyticsChart: schemas_exports.property("VideoAnalyticsChart", schemas_exports.unknown().optional()),
      topLocationsChart: schemas_exports.property("TopLocationsChart", schemas_exports.unknown().optional())
    });
  }
});

// src/serialization/resources/analytics/types/BaseResponse.ts
var BaseResponse;
var init_BaseResponse2 = __esm({
  "src/serialization/resources/analytics/types/BaseResponse.ts"() {
    "use strict";
    init_core();
    BaseResponse = schemas_exports.object({
      isError: schemas_exports.boolean(),
      message: schemas_exports.string(),
      codeForClient: schemas_exports.string(),
      status: schemas_exports.number()
    });
  }
});

// src/serialization/resources/analytics/types/ProjectAnalyticsTableResponse.ts
var ProjectAnalyticsTableResponse;
var init_ProjectAnalyticsTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/ProjectAnalyticsTableResponse.ts"() {
    "use strict";
    init_core();
    ProjectAnalyticsTableResponse = schemas_exports.object({
      data: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ProjectAnalyticsTableResponseData)
      ).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/ProjectAnalyticsTableResponseData.ts
var ProjectAnalyticsTableResponseData;
var init_ProjectAnalyticsTableResponseData2 = __esm({
  "src/serialization/resources/analytics/types/ProjectAnalyticsTableResponseData.ts"() {
    "use strict";
    init_core();
    ProjectAnalyticsTableResponseData = schemas_exports.object({
      guideId: schemas_exports.property("guide_id", schemas_exports.string()),
      views: schemas_exports.number(),
      plays: schemas_exports.number(),
      guideName: schemas_exports.property("guide_name", schemas_exports.string())
    });
  }
});

// src/serialization/resources/analytics/types/ProjectRatingsTableResponse.ts
var ProjectRatingsTableResponse;
var init_ProjectRatingsTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/ProjectRatingsTableResponse.ts"() {
    "use strict";
    init_core();
    ProjectRatingsTableResponse = schemas_exports.object({
      data: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ProjectRatingsTableResponseData)).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/ProjectRatingsTableResponseData.ts
var ProjectRatingsTableResponseData;
var init_ProjectRatingsTableResponseData2 = __esm({
  "src/serialization/resources/analytics/types/ProjectRatingsTableResponseData.ts"() {
    "use strict";
    init_core();
    ProjectRatingsTableResponseData = schemas_exports.object({
      guideId: schemas_exports.property("guide_id", schemas_exports.string()),
      guideName: schemas_exports.property("guide_name", schemas_exports.string()),
      totalRatings: schemas_exports.property("total_ratings", schemas_exports.number()),
      averageRating: schemas_exports.property("average_rating", schemas_exports.number())
    });
  }
});

// src/serialization/resources/analytics/types/FeedbacksTableResponse.ts
var FeedbacksTableResponse;
var init_FeedbacksTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/FeedbacksTableResponse.ts"() {
    "use strict";
    init_core();
    FeedbacksTableResponse = schemas_exports.object({
      data: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).FeedbacksTableResponseData)).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/FeedbacksTableResponseData.ts
var FeedbacksTableResponseData;
var init_FeedbacksTableResponseData2 = __esm({
  "src/serialization/resources/analytics/types/FeedbacksTableResponseData.ts"() {
    "use strict";
    init_core();
    FeedbacksTableResponseData = schemas_exports.object({
      guideId: schemas_exports.property("guide_id", schemas_exports.string()),
      guideName: schemas_exports.property("guide_name", schemas_exports.string()),
      date: schemas_exports.date(),
      feedback: schemas_exports.string()
    });
  }
});

// src/serialization/resources/analytics/types/SearchAnalyticsTableResponse.ts
var SearchAnalyticsTableResponse;
var init_SearchAnalyticsTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/SearchAnalyticsTableResponse.ts"() {
    "use strict";
    init_core();
    SearchAnalyticsTableResponse = schemas_exports.object({
      data: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).SearchAnalyticsTableResponseData)
      ).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/SearchAnalyticsTableResponseData.ts
var SearchAnalyticsTableResponseData;
var init_SearchAnalyticsTableResponseData2 = __esm({
  "src/serialization/resources/analytics/types/SearchAnalyticsTableResponseData.ts"() {
    "use strict";
    init_core();
    SearchAnalyticsTableResponseData = schemas_exports.object({
      guideNameClicked: schemas_exports.property("guide_name_clicked", schemas_exports.string()),
      guideIdClicked: schemas_exports.property("guide_id_clicked", schemas_exports.string()),
      date: schemas_exports.date(),
      searchQuery: schemas_exports.property("search_query", schemas_exports.string())
    });
  }
});

// src/serialization/resources/analytics/types/VideoAnalyticsTableResponse.ts
var VideoAnalyticsTableResponse;
var init_VideoAnalyticsTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/VideoAnalyticsTableResponse.ts"() {
    "use strict";
    init_core();
    VideoAnalyticsTableResponse = schemas_exports.object({
      data: schemas_exports.unknown().optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/ProjectsOpenedStackedBarGraphResponse.ts
var ProjectsOpenedStackedBarGraphResponse;
var init_ProjectsOpenedStackedBarGraphResponse2 = __esm({
  "src/serialization/resources/analytics/types/ProjectsOpenedStackedBarGraphResponse.ts"() {
    "use strict";
    init_core();
    ProjectsOpenedStackedBarGraphResponse = schemas_exports.object({
      data: schemas_exports.unknown().optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/VideosPlayedStackedBarGraphResponse.ts
var VideosPlayedStackedBarGraphResponse;
var init_VideosPlayedStackedBarGraphResponse2 = __esm({
  "src/serialization/resources/analytics/types/VideosPlayedStackedBarGraphResponse.ts"() {
    "use strict";
    init_core();
    VideosPlayedStackedBarGraphResponse = schemas_exports.object({
      data: schemas_exports.unknown().optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/GuidesTableResponse.ts
var GuidesTableResponse;
var init_GuidesTableResponse2 = __esm({
  "src/serialization/resources/analytics/types/GuidesTableResponse.ts"() {
    "use strict";
    init_core();
    GuidesTableResponse = schemas_exports.object({
      data: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).GuidesTableResponseData)).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/GuidesTableResponseData.ts
var GuidesTableResponseData;
var init_GuidesTableResponseData2 = __esm({
  "src/serialization/resources/analytics/types/GuidesTableResponseData.ts"() {
    "use strict";
    init_core();
    GuidesTableResponseData = schemas_exports.object({
      guideName: schemas_exports.property("guide_name", schemas_exports.string()),
      guideId: schemas_exports.property("guide_id", schemas_exports.string())
    });
  }
});

// src/serialization/resources/analytics/types/ImpressionsLineChartResponse.ts
var ImpressionsLineChartResponse;
var init_ImpressionsLineChartResponse2 = __esm({
  "src/serialization/resources/analytics/types/ImpressionsLineChartResponse.ts"() {
    "use strict";
    init_core();
    ImpressionsLineChartResponse = schemas_exports.object({
      data: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ImpressionsLineChartResponseData)
      ).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/ImpressionsLineChartResponseData.ts
var ImpressionsLineChartResponseData;
var init_ImpressionsLineChartResponseData2 = __esm({
  "src/serialization/resources/analytics/types/ImpressionsLineChartResponseData.ts"() {
    "use strict";
    init_core();
    ImpressionsLineChartResponseData = schemas_exports.object({
      date: schemas_exports.date(),
      impressions: schemas_exports.number()
    });
  }
});

// src/serialization/resources/analytics/types/VideoPlaysLineChartResponse.ts
var VideoPlaysLineChartResponse;
var init_VideoPlaysLineChartResponse2 = __esm({
  "src/serialization/resources/analytics/types/VideoPlaysLineChartResponse.ts"() {
    "use strict";
    init_core();
    VideoPlaysLineChartResponse = schemas_exports.object({
      data: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoPlaysLineChartResponseData)).optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BaseResponse));
  }
});

// src/serialization/resources/analytics/types/VideoPlaysLineChartResponseData.ts
var VideoPlaysLineChartResponseData;
var init_VideoPlaysLineChartResponseData2 = __esm({
  "src/serialization/resources/analytics/types/VideoPlaysLineChartResponseData.ts"() {
    "use strict";
    init_core();
    VideoPlaysLineChartResponseData = schemas_exports.object({
      date: schemas_exports.date(),
      plays: schemas_exports.number()
    });
  }
});

// src/serialization/resources/analytics/types/index.ts
var init_types35 = __esm({
  "src/serialization/resources/analytics/types/index.ts"() {
    "use strict";
    init_EventsResponse2();
    init_BaseResponse2();
    init_ProjectAnalyticsTableResponse2();
    init_ProjectAnalyticsTableResponseData2();
    init_ProjectRatingsTableResponse2();
    init_ProjectRatingsTableResponseData2();
    init_FeedbacksTableResponse2();
    init_FeedbacksTableResponseData2();
    init_SearchAnalyticsTableResponse2();
    init_SearchAnalyticsTableResponseData2();
    init_VideoAnalyticsTableResponse2();
    init_ProjectsOpenedStackedBarGraphResponse2();
    init_VideosPlayedStackedBarGraphResponse2();
    init_GuidesTableResponse2();
    init_GuidesTableResponseData2();
    init_ImpressionsLineChartResponse2();
    init_ImpressionsLineChartResponseData2();
    init_VideoPlaysLineChartResponse2();
    init_VideoPlaysLineChartResponseData2();
  }
});

// src/serialization/resources/analytics/client/getEventData.ts
var getEventData_exports2 = {};
__export(getEventData_exports2, {
  Error: () => Error243
});
var Error243;
var init_getEventData2 = __esm({
  "src/serialization/resources/analytics/client/getEventData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error243 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.analytics.getEventData.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.analytics.getEventData.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.analytics.getEventData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/analytics/client/index.ts
var init_client39 = __esm({
  "src/serialization/resources/analytics/client/index.ts"() {
    "use strict";
    init_getEventData2();
  }
});

// src/serialization/resources/analytics/index.ts
var analytics_exports2 = {};
__export(analytics_exports2, {
  BaseResponse: () => BaseResponse,
  EventsResponse: () => EventsResponse,
  FeedbacksTableResponse: () => FeedbacksTableResponse,
  FeedbacksTableResponseData: () => FeedbacksTableResponseData,
  GuidesTableResponse: () => GuidesTableResponse,
  GuidesTableResponseData: () => GuidesTableResponseData,
  ImpressionsLineChartResponse: () => ImpressionsLineChartResponse,
  ImpressionsLineChartResponseData: () => ImpressionsLineChartResponseData,
  ProjectAnalyticsTableResponse: () => ProjectAnalyticsTableResponse,
  ProjectAnalyticsTableResponseData: () => ProjectAnalyticsTableResponseData,
  ProjectRatingsTableResponse: () => ProjectRatingsTableResponse,
  ProjectRatingsTableResponseData: () => ProjectRatingsTableResponseData,
  ProjectsOpenedStackedBarGraphResponse: () => ProjectsOpenedStackedBarGraphResponse,
  SearchAnalyticsTableResponse: () => SearchAnalyticsTableResponse,
  SearchAnalyticsTableResponseData: () => SearchAnalyticsTableResponseData,
  VideoAnalyticsTableResponse: () => VideoAnalyticsTableResponse,
  VideoPlaysLineChartResponse: () => VideoPlaysLineChartResponse,
  VideoPlaysLineChartResponseData: () => VideoPlaysLineChartResponseData,
  VideosPlayedStackedBarGraphResponse: () => VideosPlayedStackedBarGraphResponse,
  getEventData: () => getEventData_exports2
});
var init_analytics2 = __esm({
  "src/serialization/resources/analytics/index.ts"() {
    "use strict";
    init_types35();
    init_client39();
  }
});

// src/serialization/resources/audio/types/Transcript.ts
var Transcript;
var init_Transcript2 = __esm({
  "src/serialization/resources/audio/types/Transcript.ts"() {
    "use strict";
    init_core();
    Transcript = schemas_exports.unknown();
  }
});

// src/serialization/resources/audio/types/SaveGuideAudioRequest.ts
var SaveGuideAudioRequest;
var init_SaveGuideAudioRequest2 = __esm({
  "src/serialization/resources/audio/types/SaveGuideAudioRequest.ts"() {
    "use strict";
    init_core();
    SaveGuideAudioRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      updateId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/audio/types/InitiateBackgroundAudioUploadResponse.ts
var InitiateBackgroundAudioUploadResponse;
var init_InitiateBackgroundAudioUploadResponse2 = __esm({
  "src/serialization/resources/audio/types/InitiateBackgroundAudioUploadResponse.ts"() {
    "use strict";
    init_core();
    InitiateBackgroundAudioUploadResponse = schemas_exports.object({
      src: schemas_exports.string(),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
    });
  }
});

// src/serialization/resources/audio/types/index.ts
var init_types36 = __esm({
  "src/serialization/resources/audio/types/index.ts"() {
    "use strict";
    init_Transcript2();
    init_SaveGuideAudioRequest2();
    init_InitiateBackgroundAudioUploadResponse2();
  }
});

// src/serialization/resources/audio/client/initiateBackgroundAudioUpload.ts
var initiateBackgroundAudioUpload_exports2 = {};
__export(initiateBackgroundAudioUpload_exports2, {
  Error: () => Error244
});
var Error244;
var init_initiateBackgroundAudioUpload2 = __esm({
  "src/serialization/resources/audio/client/initiateBackgroundAudioUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error244 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.initiateBackgroundAudioUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.initiateBackgroundAudioUpload.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.initiateBackgroundAudioUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/finishCreateBackgroundAudioUpload.ts
var finishCreateBackgroundAudioUpload_exports2 = {};
__export(finishCreateBackgroundAudioUpload_exports2, {
  Error: () => Error245,
  Response: () => Response11
});
var Response11, Error245;
var init_finishCreateBackgroundAudioUpload2 = __esm({
  "src/serialization/resources/audio/client/finishCreateBackgroundAudioUpload.ts"() {
    "use strict";
    init_core();
    init_src();
    Response11 = schemas_exports.boolean();
    Error245 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.audio.finishCreateBackgroundAudioUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/deleteAudio.ts
var deleteAudio_exports2 = {};
__export(deleteAudio_exports2, {
  Error: () => Error246,
  Response: () => Response12
});
var Response12, Error246;
var init_deleteAudio2 = __esm({
  "src/serialization/resources/audio/client/deleteAudio.ts"() {
    "use strict";
    init_core();
    init_src();
    Response12 = schemas_exports.boolean();
    Error246 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.deleteAudio.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.deleteAudio.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.deleteAudio.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/favoriteAudio.ts
var favoriteAudio_exports2 = {};
__export(favoriteAudio_exports2, {
  Error: () => Error247,
  Response: () => Response13
});
var Response13, Error247;
var init_favoriteAudio2 = __esm({
  "src/serialization/resources/audio/client/favoriteAudio.ts"() {
    "use strict";
    init_core();
    init_src();
    Response13 = schemas_exports.boolean();
    Error247 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      ExistsInFavoritesError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.favoriteAudio.Error.unauthorizedError();
          case "ExistsInFavoritesError":
            return api_exports.audio.favoriteAudio.Error.existsInFavoritesError();
          case "UsageLimitExceededError":
            return api_exports.audio.favoriteAudio.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.favoriteAudio.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/unfavoriteAudio.ts
var unfavoriteAudio_exports2 = {};
__export(unfavoriteAudio_exports2, {
  Error: () => Error248,
  Response: () => Response14
});
var Response14, Error248;
var init_unfavoriteAudio2 = __esm({
  "src/serialization/resources/audio/client/unfavoriteAudio.ts"() {
    "use strict";
    init_core();
    init_src();
    Response14 = schemas_exports.boolean();
    Error248 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.unfavoriteAudio.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.unfavoriteAudio.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.unfavoriteAudio.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/saveAudio.ts
var saveAudio_exports2 = {};
__export(saveAudio_exports2, {
  Error: () => Error249
});
var Error249;
var init_saveAudio2 = __esm({
  "src/serialization/resources/audio/client/saveAudio.ts"() {
    "use strict";
    init_src();
    init_core();
    Error249 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.saveAudio.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.saveAudio.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.saveAudio.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/saveGuideAudio.ts
var saveGuideAudio_exports2 = {};
__export(saveGuideAudio_exports2, {
  Error: () => Error250
});
var Error250;
var init_saveGuideAudio2 = __esm({
  "src/serialization/resources/audio/client/saveGuideAudio.ts"() {
    "use strict";
    init_src();
    init_core();
    Error250 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.saveGuideAudio.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.saveGuideAudio.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.saveGuideAudio.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/saveGuideAudioUpdated.ts
var saveGuideAudioUpdated_exports2 = {};
__export(saveGuideAudioUpdated_exports2, {
  Error: () => Error251
});
var Error251;
var init_saveGuideAudioUpdated2 = __esm({
  "src/serialization/resources/audio/client/saveGuideAudioUpdated.ts"() {
    "use strict";
    init_src();
    init_core();
    Error251 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.saveGuideAudioUpdated.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.audio.saveGuideAudioUpdated.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.audio.saveGuideAudioUpdated.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/index.ts
var init_client40 = __esm({
  "src/serialization/resources/audio/client/index.ts"() {
    "use strict";
    init_initiateBackgroundAudioUpload2();
    init_finishCreateBackgroundAudioUpload2();
    init_deleteAudio2();
    init_favoriteAudio2();
    init_unfavoriteAudio2();
    init_saveAudio2();
    init_saveGuideAudio2();
    init_saveGuideAudioUpdated2();
  }
});

// src/serialization/resources/audio/index.ts
var audio_exports2 = {};
__export(audio_exports2, {
  InitiateBackgroundAudioUploadResponse: () => InitiateBackgroundAudioUploadResponse,
  SaveGuideAudioRequest: () => SaveGuideAudioRequest,
  Transcript: () => Transcript,
  deleteAudio: () => deleteAudio_exports2,
  favoriteAudio: () => favoriteAudio_exports2,
  finishCreateBackgroundAudioUpload: () => finishCreateBackgroundAudioUpload_exports2,
  initiateBackgroundAudioUpload: () => initiateBackgroundAudioUpload_exports2,
  saveAudio: () => saveAudio_exports2,
  saveGuideAudio: () => saveGuideAudio_exports2,
  saveGuideAudioUpdated: () => saveGuideAudioUpdated_exports2,
  unfavoriteAudio: () => unfavoriteAudio_exports2
});
var init_audio2 = __esm({
  "src/serialization/resources/audio/index.ts"() {
    "use strict";
    init_types36();
    init_client40();
  }
});

// src/serialization/resources/auth/types/CreateUserRequest.ts
var CreateUserRequest;
var init_CreateUserRequest2 = __esm({
  "src/serialization/resources/auth/types/CreateUserRequest.ts"() {
    "use strict";
    init_core();
    CreateUserRequest = schemas_exports.object({
      email: schemas_exports.string(),
      emailConfirmed: schemas_exports.property("email_confirmed", schemas_exports.boolean()),
      eventType: schemas_exports.property("event_type", schemas_exports.string()),
      firstName: schemas_exports.property("first_name", schemas_exports.string().optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.string().optional()),
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional()),
      username: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/auth/types/UpdateUserRequest.ts
var UpdateUserRequest;
var init_UpdateUserRequest2 = __esm({
  "src/serialization/resources/auth/types/UpdateUserRequest.ts"() {
    "use strict";
    init_core();
    UpdateUserRequest = schemas_exports.object({
      eventType: schemas_exports.property("event_type", schemas_exports.string()),
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/auth/types/UserInOrg.ts
var UserInOrg;
var init_UserInOrg2 = __esm({
  "src/serialization/resources/auth/types/UserInOrg.ts"() {
    "use strict";
    init_core();
    UserInOrg = schemas_exports.object({
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      name: schemas_exports.string().optional(),
      email: schemas_exports.string(),
      signupDate: schemas_exports.property("signup_date", schemas_exports.date()),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional()),
      role: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Role)
    });
  }
});

// src/serialization/resources/auth/types/AuthenticatedUser.ts
var AuthenticatedUser;
var init_AuthenticatedUser2 = __esm({
  "src/serialization/resources/auth/types/AuthenticatedUser.ts"() {
    "use strict";
    init_core();
    AuthenticatedUser = schemas_exports.object({
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      name: schemas_exports.string(),
      email: schemas_exports.string(),
      signupDate: schemas_exports.property("signup_date", schemas_exports.date()),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional()),
      propelUserId: schemas_exports.property(
        "propel_user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/auth/types/AuthenticatedUserWithOrg.ts
var AuthenticatedUserWithOrg;
var init_AuthenticatedUserWithOrg2 = __esm({
  "src/serialization/resources/auth/types/AuthenticatedUserWithOrg.ts"() {
    "use strict";
    init_core();
    AuthenticatedUserWithOrg = schemas_exports.object({
      user: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthenticatedUser),
      org: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization),
      role: schemas_exports.string()
    });
  }
});

// src/serialization/resources/auth/types/UpdateUserRoleRequest.ts
var UpdateUserRoleRequest;
var init_UpdateUserRoleRequest2 = __esm({
  "src/serialization/resources/auth/types/UpdateUserRoleRequest.ts"() {
    "use strict";
    init_core();
    UpdateUserRoleRequest = schemas_exports.object({
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      role: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Role)
    });
  }
});

// src/serialization/resources/auth/types/Role.ts
var Role2;
var init_Role2 = __esm({
  "src/serialization/resources/auth/types/Role.ts"() {
    "use strict";
    init_core();
    Role2 = schemas_exports.enum_([
      "admin",
      "editor",
      "viewer"
    ]);
  }
});

// src/serialization/resources/auth/types/index.ts
var init_types37 = __esm({
  "src/serialization/resources/auth/types/index.ts"() {
    "use strict";
    init_CreateUserRequest2();
    init_UpdateUserRequest2();
    init_UserInOrg2();
    init_AuthenticatedUser2();
    init_AuthenticatedUserWithOrg2();
    init_UpdateUserRoleRequest2();
    init_Role2();
  }
});

// src/serialization/resources/auth/client/createUserWebhook.ts
var createUserWebhook_exports2 = {};
__export(createUserWebhook_exports2, {
  Error: () => Error252,
  Response: () => Response15
});
var Response15, Error252;
var init_createUserWebhook2 = __esm({
  "src/serialization/resources/auth/client/createUserWebhook.ts"() {
    "use strict";
    init_core();
    init_src();
    Response15 = schemas_exports.string();
    Error252 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UserEntryAlreadyExistsError: schemas_exports.object({}),
      InvalidEventTypeForWebhookError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.auth.createUserWebhook.Error.queryFailedError();
          case "UserEntryAlreadyExistsError":
            return api_exports.auth.createUserWebhook.Error.userEntryAlreadyExistsError();
          case "InvalidEventTypeForWebhookError":
            return api_exports.auth.createUserWebhook.Error.invalidEventTypeForWebhookError();
          case "UsageLimitExceededError":
            return api_exports.auth.createUserWebhook.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.auth.createUserWebhook.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/auth/client/updateUserWebhook.ts
var updateUserWebhook_exports2 = {};
__export(updateUserWebhook_exports2, {
  Error: () => Error253,
  Response: () => Response16
});
var Response16, Error253;
var init_updateUserWebhook2 = __esm({
  "src/serialization/resources/auth/client/updateUserWebhook.ts"() {
    "use strict";
    init_core();
    init_src();
    Response16 = schemas_exports.string();
    Error253 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UserEntryAlreadyExistsError: schemas_exports.object({}),
      InvalidEventTypeForWebhookError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.auth.updateUserWebhook.Error.queryFailedError();
          case "UserEntryAlreadyExistsError":
            return api_exports.auth.updateUserWebhook.Error.userEntryAlreadyExistsError();
          case "InvalidEventTypeForWebhookError":
            return api_exports.auth.updateUserWebhook.Error.invalidEventTypeForWebhookError();
          case "UsageLimitExceededError":
            return api_exports.auth.updateUserWebhook.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.auth.updateUserWebhook.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/auth/client/updateUserRoleInOrg.ts
var updateUserRoleInOrg_exports2 = {};
__export(updateUserRoleInOrg_exports2, {
  Error: () => Error254,
  Response: () => Response17
});
var Response17, Error254;
var init_updateUserRoleInOrg2 = __esm({
  "src/serialization/resources/auth/client/updateUserRoleInOrg.ts"() {
    "use strict";
    init_src();
    init_core();
    Response17 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserInOrg));
    Error254 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UserNotInOrganizationError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.auth.updateUserRoleInOrg.Error.queryFailedError();
          case "UserNotInOrganizationError":
            return api_exports.auth.updateUserRoleInOrg.Error.userNotInOrganizationError(value.content);
          case "UsageLimitExceededError":
            return api_exports.auth.updateUserRoleInOrg.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.auth.updateUserRoleInOrg.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/auth/client/index.ts
var init_client41 = __esm({
  "src/serialization/resources/auth/client/index.ts"() {
    "use strict";
    init_createUserWebhook2();
    init_updateUserWebhook2();
    init_updateUserRoleInOrg2();
  }
});

// src/serialization/resources/auth/index.ts
var auth_exports2 = {};
__export(auth_exports2, {
  AuthenticatedUser: () => AuthenticatedUser,
  AuthenticatedUserWithOrg: () => AuthenticatedUserWithOrg,
  CreateUserRequest: () => CreateUserRequest,
  Role: () => Role2,
  UpdateUserRequest: () => UpdateUserRequest,
  UpdateUserRoleRequest: () => UpdateUserRoleRequest,
  UserInOrg: () => UserInOrg,
  createUserWebhook: () => createUserWebhook_exports2,
  updateUserRoleInOrg: () => updateUserRoleInOrg_exports2,
  updateUserWebhook: () => updateUserWebhook_exports2
});
var init_auth3 = __esm({
  "src/serialization/resources/auth/index.ts"() {
    "use strict";
    init_types37();
    init_client41();
  }
});

// src/serialization/resources/baseTypes/types/Id.ts
var Id2;
var init_Id2 = __esm({
  "src/serialization/resources/baseTypes/types/Id.ts"() {
    "use strict";
    init_src();
    init_core();
    Id2 = schemas_exports.string().transform({
      transform: api_exports.Id,
      untransform: (value) => value
    });
  }
});

// src/serialization/resources/baseTypes/types/PresignedUrl.ts
var PresignedUrl;
var init_PresignedUrl2 = __esm({
  "src/serialization/resources/baseTypes/types/PresignedUrl.ts"() {
    "use strict";
    init_core();
    PresignedUrl = schemas_exports.unknown();
  }
});

// src/serialization/resources/baseTypes/types/HelpCenterTab.ts
var HelpCenterTab;
var init_HelpCenterTab2 = __esm({
  "src/serialization/resources/baseTypes/types/HelpCenterTab.ts"() {
    "use strict";
    init_core();
    HelpCenterTab = schemas_exports.object({
      label: schemas_exports.string(),
      url: schemas_exports.string(),
      readFromLocalstorage: schemas_exports.boolean().optional(),
      localStorageLabel: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/baseTypes/types/HelpCenterConfig.ts
var HelpCenterConfig;
var init_HelpCenterConfig2 = __esm({
  "src/serialization/resources/baseTypes/types/HelpCenterConfig.ts"() {
    "use strict";
    init_core();
    HelpCenterConfig = schemas_exports.object({
      pageTitle: schemas_exports.property("page_title", schemas_exports.string().optional()),
      topbarTitle: schemas_exports.property("topbar_title", schemas_exports.string()),
      creatorVisibilityFlag: schemas_exports.property("creator_visibility_flag", schemas_exports.boolean()),
      themeToggleFlag: schemas_exports.property("theme_toggle_flag", schemas_exports.boolean()),
      backgroundColor: schemas_exports.property("background_color", schemas_exports.string().optional()),
      brandColor: schemas_exports.property("brand_color", schemas_exports.string().optional()),
      feedbackFlag: schemas_exports.property("feedback_flag", schemas_exports.boolean()),
      videoBrandingFlag: schemas_exports.property("video_branding_flag", schemas_exports.boolean()),
      logoSize: schemas_exports.property("logo_size", schemas_exports.number()),
      searchTitle: schemas_exports.property("search_title", schemas_exports.string()),
      openDocKeyword: schemas_exports.property("open_doc_keyword", schemas_exports.string()),
      homePageName: schemas_exports.property("home_page_name", schemas_exports.string()),
      subcollectionsKeyword: schemas_exports.property("subcollections_keyword", schemas_exports.string()),
      guidesKeyword: schemas_exports.property("guides_keyword", schemas_exports.string()),
      createdByKeyword: schemas_exports.property("created_by_keyword", schemas_exports.string()),
      feedbackPrompt: schemas_exports.property("feedback_prompt", schemas_exports.string()),
      feedbackQuestion: schemas_exports.property("feedback_question", schemas_exports.string()),
      feedbackPlaceholder: schemas_exports.property("feedback_placeholder", schemas_exports.string()),
      feedbackSubmitText: schemas_exports.property("feedback_submit_text", schemas_exports.string()),
      feedbackRevertText: schemas_exports.property("feedback_revert_text", schemas_exports.string()),
      disableDownload: schemas_exports.property("disable_download", schemas_exports.boolean()),
      leftTabs: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HelpCenterTab)
      ),
      rightTabs: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HelpCenterTab)
      ),
      defaultTheme: schemas_exports.property("default_theme", schemas_exports.string()),
      darkLogoUrl: schemas_exports.property("dark_logo_url", schemas_exports.string().optional()),
      lightLogoUrl: schemas_exports.property("light_logo_url", schemas_exports.string().optional()),
      faviconUrl: schemas_exports.property("favicon_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/baseTypes/types/SimpleResponse.ts
var SimpleResponse;
var init_SimpleResponse2 = __esm({
  "src/serialization/resources/baseTypes/types/SimpleResponse.ts"() {
    "use strict";
    init_core();
    SimpleResponse = schemas_exports.object({
      response: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/baseTypes/types/InitiateUploadResponse.ts
var InitiateUploadResponse;
var init_InitiateUploadResponse2 = __esm({
  "src/serialization/resources/baseTypes/types/InitiateUploadResponse.ts"() {
    "use strict";
    init_core();
    InitiateUploadResponse = schemas_exports.object({
      src: schemas_exports.string(),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl),
      getUrl: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl).optional(),
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/baseTypes/types/GetChildrenRequest.ts
var GetChildrenRequest;
var init_GetChildrenRequest2 = __esm({
  "src/serialization/resources/baseTypes/types/GetChildrenRequest.ts"() {
    "use strict";
    init_core();
    GetChildrenRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/baseTypes/types/Coordinates.ts
var Coordinates;
var init_Coordinates2 = __esm({
  "src/serialization/resources/baseTypes/types/Coordinates.ts"() {
    "use strict";
    init_core();
    Coordinates = schemas_exports.object({
      x: schemas_exports.number(),
      y: schemas_exports.number()
    });
  }
});

// src/serialization/resources/baseTypes/types/IdRequest.ts
var IdRequest;
var init_IdRequest2 = __esm({
  "src/serialization/resources/baseTypes/types/IdRequest.ts"() {
    "use strict";
    init_core();
    IdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/baseTypes/types/Token.ts
var Token;
var init_Token2 = __esm({
  "src/serialization/resources/baseTypes/types/Token.ts"() {
    "use strict";
    init_core();
    Token = schemas_exports.object({
      tokenId: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/VideoFormat.ts
var VideoFormat;
var init_VideoFormat2 = __esm({
  "src/serialization/resources/baseTypes/types/VideoFormat.ts"() {
    "use strict";
    init_core();
    VideoFormat = schemas_exports.object({
      container: schemas_exports.string(),
      codec: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/S3Object.ts
var S3Object;
var init_S3Object2 = __esm({
  "src/serialization/resources/baseTypes/types/S3Object.ts"() {
    "use strict";
    init_core();
    S3Object = schemas_exports.object({
      region: schemas_exports.string(),
      bucket: schemas_exports.string(),
      key: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/Language.ts
var Language;
var init_Language2 = __esm({
  "src/serialization/resources/baseTypes/types/Language.ts"() {
    "use strict";
    init_core();
    Language = schemas_exports.object({
      languageId: schemas_exports.property("language_id", schemas_exports.string()),
      name: schemas_exports.string(),
      dgModel: schemas_exports.property("dg_model", schemas_exports.string().optional()),
      transcriptable: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/baseTypes/types/UsageLimitExceededErrorBody.ts
var UsageLimitExceededErrorBody;
var init_UsageLimitExceededErrorBody2 = __esm({
  "src/serialization/resources/baseTypes/types/UsageLimitExceededErrorBody.ts"() {
    "use strict";
    init_core();
    UsageLimitExceededErrorBody = schemas_exports.object({
      limitName: schemas_exports.property("limit_name", schemas_exports.string()),
      requiredUsage: schemas_exports.property("required_usage", schemas_exports.number()),
      limitValue: schemas_exports.property("limit_value", schemas_exports.number()),
      currentUsage: schemas_exports.property("current_usage", schemas_exports.number())
    });
  }
});

// src/serialization/resources/baseTypes/types/index.ts
var init_types38 = __esm({
  "src/serialization/resources/baseTypes/types/index.ts"() {
    "use strict";
    init_Id2();
    init_PresignedUrl2();
    init_HelpCenterTab2();
    init_HelpCenterConfig2();
    init_SimpleResponse2();
    init_InitiateUploadResponse2();
    init_GetChildrenRequest2();
    init_Coordinates2();
    init_IdRequest2();
    init_Token2();
    init_VideoFormat2();
    init_S3Object2();
    init_Language2();
    init_UsageLimitExceededErrorBody2();
  }
});

// src/serialization/resources/baseTypes/index.ts
var baseTypes_exports2 = {};
__export(baseTypes_exports2, {
  Coordinates: () => Coordinates,
  GetChildrenRequest: () => GetChildrenRequest,
  HelpCenterConfig: () => HelpCenterConfig,
  HelpCenterTab: () => HelpCenterTab,
  Id: () => Id2,
  IdRequest: () => IdRequest,
  InitiateUploadResponse: () => InitiateUploadResponse,
  Language: () => Language,
  PresignedUrl: () => PresignedUrl,
  S3Object: () => S3Object,
  SimpleResponse: () => SimpleResponse,
  Token: () => Token,
  UsageLimitExceededErrorBody: () => UsageLimitExceededErrorBody,
  VideoFormat: () => VideoFormat
});
var init_baseTypes2 = __esm({
  "src/serialization/resources/baseTypes/index.ts"() {
    "use strict";
    init_types38();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts
var MoveCollectionRequest;
var init_MoveCollectionRequest2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts"() {
    "use strict";
    init_core();
    MoveCollectionRequest = schemas_exports.object({
      collection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection),
      newParentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/GetChildGuidesCreationStatusResponse.ts
var GetChildGuidesCreationStatusResponse;
var init_GetChildGuidesCreationStatusResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/GetChildGuidesCreationStatusResponse.ts"() {
    "use strict";
    init_core();
    GetChildGuidesCreationStatusResponse = schemas_exports.object({
      guideCreationStatuses: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.GuideCreationStatus)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/GuideCreationStatus.ts
var GuideCreationStatus;
var init_GuideCreationStatus2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/GuideCreationStatus.ts"() {
    "use strict";
    init_core();
    GuideCreationStatus = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      completed: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/index.ts
var init_types39 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/index.ts"() {
    "use strict";
    init_MoveCollectionRequest2();
    init_GetChildGuidesCreationStatusResponse2();
    init_GuideCreationStatus2();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/createCollection.ts
var createCollection_exports2 = {};
__export(createCollection_exports2, {
  Error: () => Error255
});
var Error255;
var init_createCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/createCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error255 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.createCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.createCollection.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.createCollection.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.createCollection.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/updateCollection.ts
var updateCollection_exports2 = {};
__export(updateCollection_exports2, {
  Error: () => Error256
});
var Error256;
var init_updateCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/updateCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error256 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.updateCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.updateCollection.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.updateCollection.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.updateCollection.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/moveCollection.ts
var moveCollection_exports2 = {};
__export(moveCollection_exports2, {
  Error: () => Error257
});
var Error257;
var init_moveCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/moveCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error257 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.moveCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.moveCollection.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.moveCollection.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.moveCollection.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/deleteCollection.ts
var deleteCollection_exports2 = {};
__export(deleteCollection_exports2, {
  Error: () => Error258
});
var Error258;
var init_deleteCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/deleteCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error258 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/reorderCollection.ts
var reorderCollection_exports2 = {};
__export(reorderCollection_exports2, {
  Error: () => Error259
});
var Error259;
var init_reorderCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/reorderCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error259 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts
var setCollectionVisibility_exports2 = {};
__export(setCollectionVisibility_exports2, {
  Error: () => Error260
});
var Error260;
var init_setCollectionVisibility2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts"() {
    "use strict";
    init_src();
    init_core();
    Error260 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/fetchCollectionData.ts
var fetchCollectionData_exports2 = {};
__export(fetchCollectionData_exports2, {
  Error: () => Error261
});
var Error261;
var init_fetchCollectionData2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/fetchCollectionData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error261 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.fetchCollectionData.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.fetchCollectionData.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.fetchCollectionData.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.fetchCollectionData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/getChildGuidesCreationStatus.ts
var getChildGuidesCreationStatus_exports2 = {};
__export(getChildGuidesCreationStatus_exports2, {
  Error: () => Error262
});
var Error262;
var init_getChildGuidesCreationStatus2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/getChildGuidesCreationStatus.ts"() {
    "use strict";
    init_src();
    init_core();
    Error262 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/DeleteCollectionRequest.ts
var DeleteCollectionRequest;
var init_DeleteCollectionRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/DeleteCollectionRequest.ts"() {
    "use strict";
    init_core();
    DeleteCollectionRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/ReorderCollectionRequest.ts
var ReorderCollectionRequest;
var init_ReorderCollectionRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/ReorderCollectionRequest.ts"() {
    "use strict";
    init_core();
    ReorderCollectionRequest = schemas_exports.object({
      succeedingCollection: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection
      ),
      precedingCollection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection).optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/SetCollectionVisibility.ts
var SetCollectionVisibility;
var init_SetCollectionVisibility = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/SetCollectionVisibility.ts"() {
    "use strict";
    init_core();
    SetCollectionVisibility = schemas_exports.object({
      collection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection),
      private: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/FetchCollectionDataRequest.ts
var FetchCollectionDataRequest;
var init_FetchCollectionDataRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/FetchCollectionDataRequest.ts"() {
    "use strict";
    init_core();
    FetchCollectionDataRequest = schemas_exports.object({
      collectionId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      withPresignedUrl: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/GetChildGuidesCreationStatusRequest.ts
var GetChildGuidesCreationStatusRequest;
var init_GetChildGuidesCreationStatusRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/GetChildGuidesCreationStatusRequest.ts"() {
    "use strict";
    init_core();
    GetChildGuidesCreationStatusRequest = schemas_exports.object({
      collectionId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/index.ts
var init_requests18 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/index.ts"() {
    "use strict";
    init_DeleteCollectionRequest();
    init_ReorderCollectionRequest();
    init_SetCollectionVisibility();
    init_FetchCollectionDataRequest();
    init_GetChildGuidesCreationStatusRequest();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/index.ts
var init_client42 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/index.ts"() {
    "use strict";
    init_createCollection2();
    init_updateCollection2();
    init_moveCollection2();
    init_deleteCollection2();
    init_reorderCollection2();
    init_setCollectionVisibility2();
    init_fetchCollectionData2();
    init_getChildGuidesCreationStatus2();
    init_requests18();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/index.ts
var collectionMutations_exports2 = {};
__export(collectionMutations_exports2, {
  DeleteCollectionRequest: () => DeleteCollectionRequest,
  FetchCollectionDataRequest: () => FetchCollectionDataRequest,
  GetChildGuidesCreationStatusRequest: () => GetChildGuidesCreationStatusRequest,
  GetChildGuidesCreationStatusResponse: () => GetChildGuidesCreationStatusResponse,
  GuideCreationStatus: () => GuideCreationStatus,
  MoveCollectionRequest: () => MoveCollectionRequest,
  ReorderCollectionRequest: () => ReorderCollectionRequest,
  SetCollectionVisibility: () => SetCollectionVisibility,
  createCollection: () => createCollection_exports2,
  deleteCollection: () => deleteCollection_exports2,
  fetchCollectionData: () => fetchCollectionData_exports2,
  getChildGuidesCreationStatus: () => getChildGuidesCreationStatus_exports2,
  moveCollection: () => moveCollection_exports2,
  reorderCollection: () => reorderCollection_exports2,
  setCollectionVisibility: () => setCollectionVisibility_exports2,
  updateCollection: () => updateCollection_exports2
});
var init_collectionMutations2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/index.ts"() {
    "use strict";
    init_types39();
    init_client42();
  }
});

// src/serialization/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathRequest.ts
var ValidateCollectionUrlPathRequest;
var init_ValidateCollectionUrlPathRequest2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathRequest.ts"() {
    "use strict";
    init_core();
    ValidateCollectionUrlPathRequest = schemas_exports.object({
      collectionUrlPath: schemas_exports.property("collection_url_path", schemas_exports.string()),
      currentCollectionId: schemas_exports.property("current_collection_id", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathResponse.ts
var ValidateCollectionUrlPathResponse;
var init_ValidateCollectionUrlPathResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/types/ValidateCollectionUrlPathResponse.ts"() {
    "use strict";
    init_core();
    ValidateCollectionUrlPathResponse = schemas_exports.object({
      available: schemas_exports.boolean(),
      conflictingCollections: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)).optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/types/index.ts
var init_types40 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/types/index.ts"() {
    "use strict";
    init_ValidateCollectionUrlPathRequest2();
    init_ValidateCollectionUrlPathResponse2();
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getCollections.ts
var getCollections_exports3 = {};
__export(getCollections_exports3, {
  Error: () => Error263
});
var Error263;
var init_getCollections3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Error263 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getCollections.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.getCollections.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.getCollections.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getAllChildren.ts
var getAllChildren_exports3 = {};
__export(getAllChildren_exports3, {
  Error: () => Error264
});
var Error264;
var init_getAllChildren3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    init_core();
    Error264 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getAllChildren.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.getAllChildren.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.getAllChildren.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getAllCollections.ts
var getAllCollections_exports3 = {};
__export(getAllCollections_exports3, {
  Error: () => Error265,
  Response: () => Response18
});
var Response18, Error265;
var init_getAllCollections3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Response18 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
    );
    Error265 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getAllCollections.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.getAllCollections.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.getAllCollections.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getAllActiveCutsCollections.ts
var getAllActiveCutsCollections_exports2 = {};
__export(getAllActiveCutsCollections_exports2, {
  Error: () => Error266,
  Response: () => Response19
});
var Response19, Error266;
var init_getAllActiveCutsCollections2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getAllActiveCutsCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Response19 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
    );
    Error266 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getPath.ts
var getPath_exports3 = {};
__export(getPath_exports3, {
  Error: () => Error267
});
var Error267;
var init_getPath3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error267 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getPath.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionQueries.getPath.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.getPath.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.getPath.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/validateCollectionUrlPath.ts
var validateCollectionUrlPath_exports2 = {};
__export(validateCollectionUrlPath_exports2, {
  Error: () => Error268
});
var Error268;
var init_validateCollectionUrlPath2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/validateCollectionUrlPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error268 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.collections.collectionQueries.validateCollectionUrlPath.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/index.ts
var init_client43 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/index.ts"() {
    "use strict";
    init_getCollections3();
    init_getAllChildren3();
    init_getAllCollections3();
    init_getAllActiveCutsCollections2();
    init_getPath3();
    init_validateCollectionUrlPath2();
  }
});

// src/serialization/resources/collections/resources/collectionQueries/index.ts
var collectionQueries_exports2 = {};
__export(collectionQueries_exports2, {
  ValidateCollectionUrlPathRequest: () => ValidateCollectionUrlPathRequest,
  ValidateCollectionUrlPathResponse: () => ValidateCollectionUrlPathResponse,
  getAllActiveCutsCollections: () => getAllActiveCutsCollections_exports2,
  getAllChildren: () => getAllChildren_exports3,
  getAllCollections: () => getAllCollections_exports3,
  getCollections: () => getCollections_exports3,
  getPath: () => getPath_exports3,
  validateCollectionUrlPath: () => validateCollectionUrlPath_exports2
});
var init_collectionQueries2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/index.ts"() {
    "use strict";
    init_types40();
    init_client43();
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/CollectionInput.ts
var CollectionInput;
var init_CollectionInput2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/CollectionInput.ts"() {
    "use strict";
    init_core();
    CollectionInput = schemas_exports.object({
      name: schemas_exports.string(),
      description: schemas_exports.string().optional(),
      sequenceNumber: schemas_exports.property("sequence_number", schemas_exports.number().optional()),
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      private: schemas_exports.boolean().optional(),
      collectionUrlPath: schemas_exports.property("collection_url_path", schemas_exports.string().optional()),
      authorId: schemas_exports.property(
        "author_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      splitsState: schemas_exports.property(
        "splits_state",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.SplitsState).optional()
      ),
      splits: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CutsVideoChapters).optional(),
      presignedVideoUrl: schemas_exports.property("presigned_video_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/Collection.ts
var Collection;
var init_Collection2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/Collection.ts"() {
    "use strict";
    init_core();
    Collection = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      deleted: schemas_exports.boolean().optional()
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CollectionInput));
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts
var GetCollectionsResponse;
var init_GetCollectionsResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts"() {
    "use strict";
    init_core();
    GetCollectionsResponse = schemas_exports.object({
      collections: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts
var GetAllChildrenResponse;
var init_GetAllChildrenResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts"() {
    "use strict";
    init_core();
    GetAllChildrenResponse = schemas_exports.object({
      collections: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
      ),
      guides: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/CutsVideoSection.ts
var CutsVideoSection;
var init_CutsVideoSection2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/CutsVideoSection.ts"() {
    "use strict";
    init_core();
    CutsVideoSection = schemas_exports.object({
      start: schemas_exports.number(),
      end: schemas_exports.number(),
      title: schemas_exports.string(),
      subSections: schemas_exports.property(
        "sub_sections",
        schemas_exports.list(
          schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CutsVideoSection)
        ).optional()
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/CutsVideoChapters.ts
var CutsVideoChapters;
var init_CutsVideoChapters2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/CutsVideoChapters.ts"() {
    "use strict";
    init_core();
    CutsVideoChapters = schemas_exports.object({
      chapters: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CutsVideoSection)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/SplitsState.ts
var SplitsState2;
var init_SplitsState2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/SplitsState.ts"() {
    "use strict";
    init_core();
    SplitsState2 = schemas_exports.enum_(["splitting", "splits_ready", "generating_guides"]);
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/index.ts
var init_types41 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/index.ts"() {
    "use strict";
    init_CollectionInput2();
    init_Collection2();
    init_GetCollectionsResponse2();
    init_GetAllChildrenResponse2();
    init_CutsVideoSection2();
    init_CutsVideoChapters2();
    init_SplitsState2();
  }
});

// src/serialization/resources/collections/resources/collectionTypes/index.ts
var collectionTypes_exports2 = {};
__export(collectionTypes_exports2, {
  Collection: () => Collection,
  CollectionInput: () => CollectionInput,
  CutsVideoChapters: () => CutsVideoChapters,
  CutsVideoSection: () => CutsVideoSection,
  GetAllChildrenResponse: () => GetAllChildrenResponse,
  GetCollectionsResponse: () => GetCollectionsResponse,
  SplitsState: () => SplitsState2
});
var init_collectionTypes2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/index.ts"() {
    "use strict";
    init_types41();
  }
});

// src/serialization/resources/collections/resources/index.ts
var init_resources9 = __esm({
  "src/serialization/resources/collections/resources/index.ts"() {
    "use strict";
    init_collectionMutations2();
    init_types39();
    init_collectionQueries2();
    init_types40();
    init_collectionTypes2();
    init_types41();
    init_requests18();
  }
});

// src/serialization/resources/collections/index.ts
var collections_exports2 = {};
__export(collections_exports2, {
  Collection: () => Collection,
  CollectionInput: () => CollectionInput,
  CutsVideoChapters: () => CutsVideoChapters,
  CutsVideoSection: () => CutsVideoSection,
  DeleteCollectionRequest: () => DeleteCollectionRequest,
  FetchCollectionDataRequest: () => FetchCollectionDataRequest,
  GetAllChildrenResponse: () => GetAllChildrenResponse,
  GetChildGuidesCreationStatusRequest: () => GetChildGuidesCreationStatusRequest,
  GetChildGuidesCreationStatusResponse: () => GetChildGuidesCreationStatusResponse,
  GetCollectionsResponse: () => GetCollectionsResponse,
  GuideCreationStatus: () => GuideCreationStatus,
  MoveCollectionRequest: () => MoveCollectionRequest,
  ReorderCollectionRequest: () => ReorderCollectionRequest,
  SetCollectionVisibility: () => SetCollectionVisibility,
  SplitsState: () => SplitsState2,
  ValidateCollectionUrlPathRequest: () => ValidateCollectionUrlPathRequest,
  ValidateCollectionUrlPathResponse: () => ValidateCollectionUrlPathResponse,
  collectionMutations: () => collectionMutations_exports2,
  collectionQueries: () => collectionQueries_exports2,
  collectionTypes: () => collectionTypes_exports2
});
var init_collections2 = __esm({
  "src/serialization/resources/collections/index.ts"() {
    "use strict";
    init_resources9();
  }
});

// src/serialization/resources/elementEdit/types/ElementGeo.ts
var ElementGeo2;
var init_ElementGeo2 = __esm({
  "src/serialization/resources/elementEdit/types/ElementGeo.ts"() {
    "use strict";
    init_core();
    ElementGeo2 = schemas_exports.enum_(["rectangle", "blur", "text", "image", "callout", "arrow", "spotlight"]);
  }
});

// src/serialization/resources/elementEdit/types/ElementEdit.ts
var ElementEdit;
var init_ElementEdit2 = __esm({
  "src/serialization/resources/elementEdit/types/ElementEdit.ts"() {
    "use strict";
    init_core();
    ElementEdit = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      startTime: schemas_exports.number(),
      endTime: schemas_exports.number(),
      geo: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ElementGeo),
      position: schemas_exports.list(schemas_exports.number()),
      size: schemas_exports.list(schemas_exports.number()),
      textdata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).TextData).optional(),
      shapedata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ShapeData).optional(),
      imagedata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ImageData).optional()
    });
  }
});

// src/serialization/resources/elementEdit/types/TextData.ts
var TextData;
var init_TextData2 = __esm({
  "src/serialization/resources/elementEdit/types/TextData.ts"() {
    "use strict";
    init_core();
    TextData = schemas_exports.object({
      text: schemas_exports.string(),
      lines: schemas_exports.list(schemas_exports.string()),
      fontSize: schemas_exports.number(),
      alignment: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).TextAlignment),
      backgroundColor: schemas_exports.string().optional(),
      backgroundOpacity: schemas_exports.number().optional(),
      textColor: schemas_exports.string(),
      font: schemas_exports.string().optional(),
      lineHeight: schemas_exports.number().optional(),
      textStartTime: schemas_exports.property("text_start_time", schemas_exports.number().optional()),
      textEndTime: schemas_exports.property("text_end_time", schemas_exports.number().optional()),
      hideText: schemas_exports.property("hide_text", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/elementEdit/types/TextAlignment.ts
var TextAlignment2;
var init_TextAlignment2 = __esm({
  "src/serialization/resources/elementEdit/types/TextAlignment.ts"() {
    "use strict";
    init_core();
    TextAlignment2 = schemas_exports.enum_(["left", "right", "center"]);
  }
});

// src/serialization/resources/elementEdit/types/Crop.ts
var Crop;
var init_Crop3 = __esm({
  "src/serialization/resources/elementEdit/types/Crop.ts"() {
    "use strict";
    init_core();
    Crop = schemas_exports.object({
      position: schemas_exports.list(schemas_exports.number()),
      size: schemas_exports.list(schemas_exports.number())
    });
  }
});

// src/serialization/resources/elementEdit/types/ImageType.ts
var ImageType2;
var init_ImageType2 = __esm({
  "src/serialization/resources/elementEdit/types/ImageType.ts"() {
    "use strict";
    init_core();
    ImageType2 = schemas_exports.enum_(["frame", "logo", "upload"]);
  }
});

// src/serialization/resources/elementEdit/types/ShapeData.ts
var ShapeData;
var init_ShapeData2 = __esm({
  "src/serialization/resources/elementEdit/types/ShapeData.ts"() {
    "use strict";
    init_core();
    ShapeData = schemas_exports.object({
      backgroundColor: schemas_exports.string().optional(),
      backgroundOpacity: schemas_exports.number().optional(),
      strokeColor: schemas_exports.string().optional(),
      strokeWidth: schemas_exports.number().optional(),
      borderRadius: schemas_exports.number().optional(),
      drawTime: schemas_exports.number().optional(),
      transitionType: schemas_exports.string().optional(),
      transitionTime: schemas_exports.number().optional(),
      scaleFactor: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/elementEdit/types/ImageData.ts
var ImageData;
var init_ImageData2 = __esm({
  "src/serialization/resources/elementEdit/types/ImageData.ts"() {
    "use strict";
    init_core();
    ImageData = schemas_exports.object({
      src: schemas_exports.string(),
      naturalHeight: schemas_exports.number(),
      naturalWidth: schemas_exports.number(),
      shadow: schemas_exports.number().optional(),
      cornerRadius: schemas_exports.number().optional(),
      crop: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Crop).optional(),
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ImageType).optional(),
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      logoImmutableName: schemas_exports.property("logo_immutable_name", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/elementEdit/types/index.ts
var init_types42 = __esm({
  "src/serialization/resources/elementEdit/types/index.ts"() {
    "use strict";
    init_ElementGeo2();
    init_ElementEdit2();
    init_TextData2();
    init_TextAlignment2();
    init_Crop3();
    init_ImageType2();
    init_ShapeData2();
    init_ImageData2();
  }
});

// src/serialization/resources/elementEdit/index.ts
var elementEdit_exports2 = {};
__export(elementEdit_exports2, {
  Crop: () => Crop,
  ElementEdit: () => ElementEdit,
  ElementGeo: () => ElementGeo2,
  ImageData: () => ImageData,
  ImageType: () => ImageType2,
  ShapeData: () => ShapeData,
  TextAlignment: () => TextAlignment2,
  TextData: () => TextData
});
var init_elementEdit2 = __esm({
  "src/serialization/resources/elementEdit/index.ts"() {
    "use strict";
    init_types42();
  }
});

// src/serialization/resources/guides/resources/aiEnhance/types/TranslateGuideRequest.ts
var TranslateGuideRequest;
var init_TranslateGuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/types/TranslateGuideRequest.ts"() {
    "use strict";
    init_core();
    TranslateGuideRequest = schemas_exports.object({
      guideId: schemas_exports.property(
        "guide_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      sourceLanguage: schemas_exports.property(
        "source_language",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      destinationLanguage: schemas_exports.property(
        "destination_language",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Language)
      )
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/types/EnhanceTextRequest.ts
var EnhanceTextRequest;
var init_EnhanceTextRequest2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/types/EnhanceTextRequest.ts"() {
    "use strict";
    init_core();
    EnhanceTextRequest = schemas_exports.object({
      text: schemas_exports.string(),
      prompt: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/types/index.ts
var init_types43 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/types/index.ts"() {
    "use strict";
    init_TranslateGuideRequest2();
    init_EnhanceTextRequest2();
  }
});

// src/serialization/resources/guides/resources/aiEnhance/client/enhanceArticleAsync.ts
var enhanceArticleAsync_exports2 = {};
__export(enhanceArticleAsync_exports2, {
  Error: () => Error269,
  Response: () => Response20
});
var Response20, Error269;
var init_enhanceArticleAsync2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/client/enhanceArticleAsync.ts"() {
    "use strict";
    init_core();
    init_src();
    Response20 = schemas_exports.boolean();
    Error269 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.aiEnhance.enhanceArticleAsync.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/client/enhanceVideoTranscriptAsync.ts
var enhanceVideoTranscriptAsync_exports2 = {};
__export(enhanceVideoTranscriptAsync_exports2, {
  Error: () => Error270,
  Response: () => Response21
});
var Response21, Error270;
var init_enhanceVideoTranscriptAsync2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/client/enhanceVideoTranscriptAsync.ts"() {
    "use strict";
    init_core();
    init_src();
    Response21 = schemas_exports.boolean();
    Error270 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/client/translateGuideAndDuplicate.ts
var translateGuideAndDuplicate_exports2 = {};
__export(translateGuideAndDuplicate_exports2, {
  Error: () => Error271
});
var Error271;
var init_translateGuideAndDuplicate2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/client/translateGuideAndDuplicate.ts"() {
    "use strict";
    init_src();
    init_core();
    Error271 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/client/inlineEnhanceText.ts
var inlineEnhanceText_exports2 = {};
__export(inlineEnhanceText_exports2, {
  Error: () => Error272,
  Response: () => Response22
});
var Response22, Error272;
var init_inlineEnhanceText2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/client/inlineEnhanceText.ts"() {
    "use strict";
    init_core();
    init_src();
    Response22 = schemas_exports.string();
    Error272 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.aiEnhance.inlineEnhanceText.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/aiEnhance/client/index.ts
var init_client44 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/client/index.ts"() {
    "use strict";
    init_enhanceArticleAsync2();
    init_enhanceVideoTranscriptAsync2();
    init_translateGuideAndDuplicate2();
    init_inlineEnhanceText2();
  }
});

// src/serialization/resources/guides/resources/aiEnhance/index.ts
var aiEnhance_exports2 = {};
__export(aiEnhance_exports2, {
  EnhanceTextRequest: () => EnhanceTextRequest,
  TranslateGuideRequest: () => TranslateGuideRequest,
  enhanceArticleAsync: () => enhanceArticleAsync_exports2,
  enhanceVideoTranscriptAsync: () => enhanceVideoTranscriptAsync_exports2,
  inlineEnhanceText: () => inlineEnhanceText_exports2,
  translateGuideAndDuplicate: () => translateGuideAndDuplicate_exports2
});
var init_aiEnhance2 = __esm({
  "src/serialization/resources/guides/resources/aiEnhance/index.ts"() {
    "use strict";
    init_types43();
    init_client44();
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/BroadcastPlatform.ts
var BroadcastPlatform2;
var init_BroadcastPlatform2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/BroadcastPlatform.ts"() {
    "use strict";
    init_core();
    BroadcastPlatform2 = schemas_exports.enum_(["slack", "discord", "whatsapp", "teams"]);
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/BroadcastStatus.ts
var BroadcastStatus2;
var init_BroadcastStatus2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/BroadcastStatus.ts"() {
    "use strict";
    init_core();
    BroadcastStatus2 = schemas_exports.enum_(["scheduled", "sent", "draft", "sending"]);
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/Broadcast.ts
var Broadcast;
var init_Broadcast2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/Broadcast.ts"() {
    "use strict";
    init_core();
    Broadcast = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      title: schemas_exports.string().optional(),
      message: schemas_exports.unknown(),
      platforms: schemas_exports.list(
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BroadcastPlatform)
      ),
      status: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BroadcastStatus),
      sendingStatus: schemas_exports.property("sending_status", schemas_exports.string().optional()),
      sentAt: schemas_exports.property("sent_at", schemas_exports.date().optional()),
      scheduledAt: schemas_exports.property("scheduled_at", schemas_exports.date().optional()),
      createdAt: schemas_exports.property("created_at", schemas_exports.date().optional()),
      updatedAt: schemas_exports.property("updated_at", schemas_exports.date().optional())
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/BroadcastBot.ts
var BroadcastBot;
var init_BroadcastBot2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/BroadcastBot.ts"() {
    "use strict";
    init_core();
    BroadcastBot = schemas_exports.object({
      botName: schemas_exports.property("bot_name", schemas_exports.string().optional()),
      botIcon: schemas_exports.property("bot_icon", schemas_exports.string().optional()),
      removeWatermark: schemas_exports.property("remove_watermark", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/GetBroadcastResponse.ts
var GetBroadcastResponse;
var init_GetBroadcastResponse2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/GetBroadcastResponse.ts"() {
    "use strict";
    init_core();
    GetBroadcastResponse = schemas_exports.object({
      broadcast: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Broadcast),
      broadcastBot: schemas_exports.property(
        "broadcast_bot",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BroadcastBot).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/types/index.ts
var init_types44 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/types/index.ts"() {
    "use strict";
    init_BroadcastPlatform2();
    init_BroadcastStatus2();
    init_Broadcast2();
    init_BroadcastBot2();
    init_GetBroadcastResponse2();
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/getBroadcasts.ts
var getBroadcasts_exports2 = {};
__export(getBroadcasts_exports2, {
  Error: () => Error273,
  Response: () => Response23
});
var Response23, Error273;
var init_getBroadcasts2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/getBroadcasts.ts"() {
    "use strict";
    init_src();
    init_core();
    Response23 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Broadcast)
    );
    Error273 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.getBroadcasts.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.getBroadcasts.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.getBroadcasts.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/getBroadcast.ts
var getBroadcast_exports2 = {};
__export(getBroadcast_exports2, {
  Error: () => Error274
});
var Error274;
var init_getBroadcast2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/getBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error274 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.getBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.getBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.getBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/createBroadcast.ts
var createBroadcast_exports2 = {};
__export(createBroadcast_exports2, {
  Error: () => Error275
});
var Error275;
var init_createBroadcast2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/createBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error275 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.createBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.createBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.createBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/deleteBroadcast.ts
var deleteBroadcast_exports2 = {};
__export(deleteBroadcast_exports2, {
  Error: () => Error276
});
var Error276;
var init_deleteBroadcast2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/deleteBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error276 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.deleteBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.deleteBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.deleteBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/updateBroadcast.ts
var updateBroadcast_exports2 = {};
__export(updateBroadcast_exports2, {
  Error: () => Error277
});
var Error277;
var init_updateBroadcast2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/updateBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error277 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.updateBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.updateBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.updateBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/sendBroadcast.ts
var sendBroadcast_exports3 = {};
__export(sendBroadcast_exports3, {
  Error: () => Error278
});
var Error278;
var init_sendBroadcast3 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/sendBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error278 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.sendBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.sendBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.sendBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/initiateBroadcastIconUpload.ts
var initiateBroadcastIconUpload_exports2 = {};
__export(initiateBroadcastIconUpload_exports2, {
  Error: () => Error279
});
var Error279;
var init_initiateBroadcastIconUpload2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/initiateBroadcastIconUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error279 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/customizeBroadcastBot.ts
var customizeBroadcastBot_exports2 = {};
__export(customizeBroadcastBot_exports2, {
  Error: () => Error280
});
var Error280;
var init_customizeBroadcastBot2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/customizeBroadcastBot.ts"() {
    "use strict";
    init_src();
    init_core();
    Error280 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.broadcasts.customizeBroadcastBot.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/requests/CreateBroadcastRequest.ts
var CreateBroadcastRequest;
var init_CreateBroadcastRequest = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/requests/CreateBroadcastRequest.ts"() {
    "use strict";
    init_core();
    CreateBroadcastRequest = schemas_exports.object({
      title: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/requests/UpdateBroadcastRequest.ts
var UpdateBroadcastRequest;
var init_UpdateBroadcastRequest = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/requests/UpdateBroadcastRequest.ts"() {
    "use strict";
    init_core();
    UpdateBroadcastRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      message: schemas_exports.unknown(),
      platforms: schemas_exports.list(
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BroadcastPlatform)
      ),
      title: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/requests/SendBroadcastRequest.ts
var SendBroadcastRequest;
var init_SendBroadcastRequest = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/requests/SendBroadcastRequest.ts"() {
    "use strict";
    init_core();
    SendBroadcastRequest = schemas_exports.object({
      broadcastId: schemas_exports.property(
        "broadcast_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      channels: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.SlackChannel)
      )
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/requests/CustomizeBroadcastBotRequest.ts
var CustomizeBroadcastBotRequest;
var init_CustomizeBroadcastBotRequest = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/requests/CustomizeBroadcastBotRequest.ts"() {
    "use strict";
    init_core();
    CustomizeBroadcastBotRequest = schemas_exports.object({
      iconId: schemas_exports.property(
        "icon_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      bot: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BroadcastBot)
    });
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/requests/index.ts
var init_requests19 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/requests/index.ts"() {
    "use strict";
    init_CreateBroadcastRequest();
    init_UpdateBroadcastRequest();
    init_SendBroadcastRequest();
    init_CustomizeBroadcastBotRequest();
  }
});

// src/serialization/resources/guides/resources/broadcasts/client/index.ts
var init_client45 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/client/index.ts"() {
    "use strict";
    init_getBroadcasts2();
    init_getBroadcast2();
    init_createBroadcast2();
    init_deleteBroadcast2();
    init_updateBroadcast2();
    init_sendBroadcast3();
    init_initiateBroadcastIconUpload2();
    init_customizeBroadcastBot2();
    init_requests19();
  }
});

// src/serialization/resources/guides/resources/broadcasts/index.ts
var broadcasts_exports2 = {};
__export(broadcasts_exports2, {
  Broadcast: () => Broadcast,
  BroadcastBot: () => BroadcastBot,
  BroadcastPlatform: () => BroadcastPlatform2,
  BroadcastStatus: () => BroadcastStatus2,
  CreateBroadcastRequest: () => CreateBroadcastRequest,
  CustomizeBroadcastBotRequest: () => CustomizeBroadcastBotRequest,
  GetBroadcastResponse: () => GetBroadcastResponse,
  SendBroadcastRequest: () => SendBroadcastRequest,
  UpdateBroadcastRequest: () => UpdateBroadcastRequest,
  createBroadcast: () => createBroadcast_exports2,
  customizeBroadcastBot: () => customizeBroadcastBot_exports2,
  deleteBroadcast: () => deleteBroadcast_exports2,
  getBroadcast: () => getBroadcast_exports2,
  getBroadcasts: () => getBroadcasts_exports2,
  initiateBroadcastIconUpload: () => initiateBroadcastIconUpload_exports2,
  sendBroadcast: () => sendBroadcast_exports3,
  updateBroadcast: () => updateBroadcast_exports2
});
var init_broadcasts2 = __esm({
  "src/serialization/resources/guides/resources/broadcasts/index.ts"() {
    "use strict";
    init_types44();
    init_client45();
  }
});

// src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatMessage.ts
var GuideAiChatMessage;
var init_GuideAiChatMessage2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatMessage.ts"() {
    "use strict";
    init_core();
    GuideAiChatMessage = schemas_exports.object({
      messageId: schemas_exports.property(
        "message_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      messageText: schemas_exports.property("message_text", schemas_exports.string()),
      senderRole: schemas_exports.property(
        "sender_role",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatSenderRole)
      ),
      contentType: schemas_exports.property(
        "content_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatContentType)
      ),
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      userPictureUrl: schemas_exports.property("user_picture_url", schemas_exports.string().optional()),
      userName: schemas_exports.property("user_name", schemas_exports.string()),
      isRequestValid: schemas_exports.property("is_request_valid", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatContentType.ts
var GuideAiChatContentType2;
var init_GuideAiChatContentType2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatContentType.ts"() {
    "use strict";
    init_core();
    GuideAiChatContentType2 = schemas_exports.enum_(["article", "video"]);
  }
});

// src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatSenderRole.ts
var GuideAiChatSenderRole2;
var init_GuideAiChatSenderRole2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/types/GuideAiChatSenderRole.ts"() {
    "use strict";
    init_core();
    GuideAiChatSenderRole2 = schemas_exports.enum_(["ai", "user"]);
  }
});

// src/serialization/resources/guides/resources/guideAiChat/types/index.ts
var init_types45 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/types/index.ts"() {
    "use strict";
    init_GuideAiChatMessage2();
    init_GuideAiChatContentType2();
    init_GuideAiChatSenderRole2();
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/sendMessage.ts
var sendMessage_exports2 = {};
__export(sendMessage_exports2, {
  Error: () => Error281
});
var Error281;
var init_sendMessage2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/sendMessage.ts"() {
    "use strict";
    init_src();
    init_core();
    Error281 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideAiChat.sendMessage.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideAiChat.sendMessage.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideAiChat.sendMessage.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/deleteChatForAGuide.ts
var deleteChatForAGuide_exports2 = {};
__export(deleteChatForAGuide_exports2, {
  Error: () => Error282
});
var Error282;
var init_deleteChatForAGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/deleteChatForAGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error282 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideAiChat.deleteChatForAGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/deleteMessageById.ts
var deleteMessageById_exports2 = {};
__export(deleteMessageById_exports2, {
  Error: () => Error283
});
var Error283;
var init_deleteMessageById2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/deleteMessageById.ts"() {
    "use strict";
    init_src();
    init_core();
    Error283 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideAiChat.deleteMessageById.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideAiChat.deleteMessageById.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideAiChat.deleteMessageById.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/requests/SendMessageRequest.ts
var SendMessageRequest;
var init_SendMessageRequest = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/requests/SendMessageRequest.ts"() {
    "use strict";
    init_core();
    SendMessageRequest = schemas_exports.object({
      messageText: schemas_exports.property("message_text", schemas_exports.string()),
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      senderRole: schemas_exports.property(
        "sender_role",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatSenderRole)
      ),
      contentType: schemas_exports.property(
        "content_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatContentType)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/requests/DeleteChatForAGuideRequest.ts
var DeleteChatForAGuideRequest;
var init_DeleteChatForAGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/requests/DeleteChatForAGuideRequest.ts"() {
    "use strict";
    init_core();
    DeleteChatForAGuideRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/requests/DeleteMessageByIdRequest.ts
var DeleteMessageByIdRequest;
var init_DeleteMessageByIdRequest = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/requests/DeleteMessageByIdRequest.ts"() {
    "use strict";
    init_core();
    DeleteMessageByIdRequest = schemas_exports.object({
      messageId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/requests/index.ts
var init_requests20 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/requests/index.ts"() {
    "use strict";
    init_SendMessageRequest();
    init_DeleteChatForAGuideRequest();
    init_DeleteMessageByIdRequest();
  }
});

// src/serialization/resources/guides/resources/guideAiChat/client/index.ts
var init_client46 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/client/index.ts"() {
    "use strict";
    init_sendMessage2();
    init_deleteChatForAGuide2();
    init_deleteMessageById2();
    init_requests20();
  }
});

// src/serialization/resources/guides/resources/guideAiChat/index.ts
var guideAiChat_exports2 = {};
__export(guideAiChat_exports2, {
  DeleteChatForAGuideRequest: () => DeleteChatForAGuideRequest,
  DeleteMessageByIdRequest: () => DeleteMessageByIdRequest,
  GuideAiChatContentType: () => GuideAiChatContentType2,
  GuideAiChatMessage: () => GuideAiChatMessage,
  GuideAiChatSenderRole: () => GuideAiChatSenderRole2,
  SendMessageRequest: () => SendMessageRequest,
  deleteChatForAGuide: () => deleteChatForAGuide_exports2,
  deleteMessageById: () => deleteMessageById_exports2,
  sendMessage: () => sendMessage_exports2
});
var init_guideAiChat2 = __esm({
  "src/serialization/resources/guides/resources/guideAiChat/index.ts"() {
    "use strict";
    init_types45();
    init_client46();
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportRequest.ts
var ExportRequest;
var init_ExportRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportRequest.ts"() {
    "use strict";
    init_core();
    ExportRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      captions: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportGifRequest.ts
var ExportGifRequest;
var init_ExportGifRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportGifRequest.ts"() {
    "use strict";
    init_core();
    ExportGifRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      gifSettings: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GifSettings)
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/GifSettings.ts
var GifSettings;
var init_GifSettings2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/GifSettings.ts"() {
    "use strict";
    init_core();
    GifSettings = schemas_exports.object({
      length: schemas_exports.number().optional(),
      start: schemas_exports.number().optional(),
      end: schemas_exports.number().optional(),
      zoomFactor: schemas_exports.number().optional(),
      zoomCenter: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Coordinates).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/VideoSettings.ts
var VideoSettings;
var init_VideoSettings2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/VideoSettings.ts"() {
    "use strict";
    init_core();
    VideoSettings = schemas_exports.object({
      fps: schemas_exports.number(),
      resolution: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/GetPastExportsRequest.ts
var GetPastExportsRequest;
var init_GetPastExportsRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/GetPastExportsRequest.ts"() {
    "use strict";
    init_core();
    GetPastExportsRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/GetPastExportsResponse.ts
var GetPastExportsResponse;
var init_GetPastExportsResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/GetPastExportsResponse.ts"() {
    "use strict";
    init_core();
    GetPastExportsResponse = schemas_exports.object({
      exports: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportDetails)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportProcess.ts
var ExportProcess2;
var init_ExportProcess2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportProcess.ts"() {
    "use strict";
    init_core();
    ExportProcess2 = schemas_exports.enum_(["export", "publish"]);
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportArticleResponse.ts
var ExportArticleResponse;
var init_ExportArticleResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportArticleResponse.ts"() {
    "use strict";
    init_core();
    ExportArticleResponse = schemas_exports.object({
      imagePresignedUrls: schemas_exports.list(
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
      ),
      hostedImageUrls: schemas_exports.list(schemas_exports.string())
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ConvertToGifResponse.ts
var ConvertToGifResponse;
var init_ConvertToGifResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ConvertToGifResponse.ts"() {
    "use strict";
    init_core();
    ConvertToGifResponse = schemas_exports.object({
      url: schemas_exports.string(),
      s3ObjectId: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/MasterDataForVideoExporter.ts
var MasterDataForVideoExporter;
var init_MasterDataForVideoExporter2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/MasterDataForVideoExporter.ts"() {
    "use strict";
    init_core();
    MasterDataForVideoExporter = schemas_exports.object({
      guide: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Guide),
      subtitles: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportDetails.ts
var ExportDetails;
var init_ExportDetails2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportDetails.ts"() {
    "use strict";
    init_core();
    ExportDetails = schemas_exports.object({
      exportId: schemas_exports.string(),
      exportStatus: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportStatus),
      progressStatus: schemas_exports.number(),
      videoUrl: schemas_exports.string().optional(),
      executionSpeed: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportExecutionSpeed).optional(),
      processType: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportProcessType),
      exitedAt: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportProcessType.ts
var ExportProcessType2;
var init_ExportProcessType2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportProcessType.ts"() {
    "use strict";
    init_core();
    ExportProcessType2 = schemas_exports.enum_(["export", "publish"]);
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportStatus.ts
var ExportStatus2;
var init_ExportStatus2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportStatus.ts"() {
    "use strict";
    init_core();
    ExportStatus2 = schemas_exports.enum_(["queued", "waitlisted", "inprogress", "pending", "completed", "failed"]);
  }
});

// src/serialization/resources/guides/resources/guideExports/types/ExportExecutionSpeed.ts
var ExportExecutionSpeed2;
var init_ExportExecutionSpeed2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/ExportExecutionSpeed.ts"() {
    "use strict";
    init_core();
    ExportExecutionSpeed2 = schemas_exports.enum_(["slow", "medium", "fast"]);
  }
});

// src/serialization/resources/guides/resources/guideExports/types/index.ts
var init_types46 = __esm({
  "src/serialization/resources/guides/resources/guideExports/types/index.ts"() {
    "use strict";
    init_ExportRequest2();
    init_ExportGifRequest2();
    init_GifSettings2();
    init_VideoSettings2();
    init_GetPastExportsRequest2();
    init_GetPastExportsResponse2();
    init_ExportProcess2();
    init_ExportArticleResponse2();
    init_ConvertToGifResponse2();
    init_MasterDataForVideoExporter2();
    init_ExportDetails2();
    init_ExportProcessType2();
    init_ExportStatus2();
    init_ExportExecutionSpeed2();
  }
});

// src/serialization/resources/guides/resources/guideExports/client/exportVideo.ts
var exportVideo_exports2 = {};
__export(exportVideo_exports2, {
  Error: () => Error284,
  Response: () => Response24
});
var Response24, Error284;
var init_exportVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/exportVideo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response24 = schemas_exports.string();
    Error284 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.exportVideo.Error.unauthorizedError();
          case "UnsubscribedOrgError":
            return api_exports.guides.guideExports.exportVideo.Error.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.exportVideo.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.exportVideo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/exportVideoV2.ts
var exportVideoV2_exports2 = {};
__export(exportVideoV2_exports2, {
  Error: () => Error285,
  Response: () => Response25
});
var Response25, Error285;
var init_exportVideoV22 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/exportVideoV2.ts"() {
    "use strict";
    init_core();
    init_src();
    Response25 = schemas_exports.string();
    Error285 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      ErrorWhileProcessingVideoExportRequest: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.exportVideoV2.Error.unauthorizedError();
          case "UnsubscribedOrgError":
            return api_exports.guides.guideExports.exportVideoV2.Error.unsubscribedOrgError(value.content);
          case "ErrorWhileProcessingVideoExportRequest":
            return api_exports.guides.guideExports.exportVideoV2.Error.errorWhileProcessingVideoExportRequest();
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.exportVideoV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.exportVideoV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/convertToGif.ts
var convertToGif_exports2 = {};
__export(convertToGif_exports2, {
  Error: () => Error286
});
var Error286;
var init_convertToGif2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/convertToGif.ts"() {
    "use strict";
    init_src();
    init_core();
    Error286 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.convertToGif.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.convertToGif.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.convertToGif.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/exportGif.ts
var exportGif_exports2 = {};
__export(exportGif_exports2, {
  Error: () => Error287,
  Response: () => Response26
});
var Response26, Error287;
var init_exportGif2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/exportGif.ts"() {
    "use strict";
    init_core();
    init_src();
    Response26 = schemas_exports.string();
    Error287 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.exportGif.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.exportGif.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/exportGifV2.ts
var exportGifV2_exports2 = {};
__export(exportGifV2_exports2, {
  Error: () => Error288,
  Response: () => Response27
});
var Response27, Error288;
var init_exportGifV22 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/exportGifV2.ts"() {
    "use strict";
    init_core();
    init_src();
    Response27 = schemas_exports.string();
    Error288 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      ErrorWhileProcessingVideoExportRequest: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.exportGifV2.Error.unauthorizedError();
          case "UnsubscribedOrgError":
            return api_exports.guides.guideExports.exportGifV2.Error.unsubscribedOrgError(value.content);
          case "ErrorWhileProcessingVideoExportRequest":
            return api_exports.guides.guideExports.exportGifV2.Error.errorWhileProcessingVideoExportRequest();
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.exportGifV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.exportGifV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/exportArticle.ts
var exportArticle_exports2 = {};
__export(exportArticle_exports2, {
  Error: () => Error289
});
var Error289;
var init_exportArticle2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/exportArticle.ts"() {
    "use strict";
    init_src();
    init_core();
    Error289 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.exportArticle.Error.unauthorizedError();
          case "UnsubscribedOrgError":
            return api_exports.guides.guideExports.exportArticle.Error.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.exportArticle.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.exportArticle.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/getPastExports.ts
var getPastExports_exports2 = {};
__export(getPastExports_exports2, {
  Error: () => Error290
});
var Error290;
var init_getPastExports2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/getPastExports.ts"() {
    "use strict";
    init_src();
    init_core();
    Error290 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideExports.getPastExports.Error.unauthorizedError();
          case "UnsubscribedOrgError":
            return api_exports.guides.guideExports.getPastExports.Error.unsubscribedOrgError(value.content);
          case "UsageLimitExceededError":
            return api_exports.guides.guideExports.getPastExports.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideExports.getPastExports.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideExports/client/index.ts
var init_client47 = __esm({
  "src/serialization/resources/guides/resources/guideExports/client/index.ts"() {
    "use strict";
    init_exportVideo2();
    init_exportVideoV22();
    init_convertToGif2();
    init_exportGif2();
    init_exportGifV22();
    init_exportArticle2();
    init_getPastExports2();
  }
});

// src/serialization/resources/guides/resources/guideExports/index.ts
var guideExports_exports2 = {};
__export(guideExports_exports2, {
  ConvertToGifResponse: () => ConvertToGifResponse,
  ExportArticleResponse: () => ExportArticleResponse,
  ExportDetails: () => ExportDetails,
  ExportExecutionSpeed: () => ExportExecutionSpeed2,
  ExportGifRequest: () => ExportGifRequest,
  ExportProcess: () => ExportProcess2,
  ExportProcessType: () => ExportProcessType2,
  ExportRequest: () => ExportRequest,
  ExportStatus: () => ExportStatus2,
  GetPastExportsRequest: () => GetPastExportsRequest,
  GetPastExportsResponse: () => GetPastExportsResponse,
  GifSettings: () => GifSettings,
  MasterDataForVideoExporter: () => MasterDataForVideoExporter,
  VideoSettings: () => VideoSettings,
  convertToGif: () => convertToGif_exports2,
  exportArticle: () => exportArticle_exports2,
  exportGif: () => exportGif_exports2,
  exportGifV2: () => exportGifV2_exports2,
  exportVideo: () => exportVideo_exports2,
  exportVideoV2: () => exportVideoV2_exports2,
  getPastExports: () => getPastExports_exports2
});
var init_guideExports2 = __esm({
  "src/serialization/resources/guides/resources/guideExports/index.ts"() {
    "use strict";
    init_types46();
    init_client47();
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsRequest.ts
var InitiateUploadAndSuggestSplitsRequest;
var init_InitiateUploadAndSuggestSplitsRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsRequest.ts"() {
    "use strict";
    init_core();
    InitiateUploadAndSuggestSplitsRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      userTime: schemas_exports.property("user_time", schemas_exports.string()),
      fileFormat: schemas_exports.property(
        "file_format",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.FileFormat)
      ),
      videoFileName: schemas_exports.property("video_file_name", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsResponse.ts
var InitiateUploadAndSuggestSplitsResponse;
var init_InitiateUploadAndSuggestSplitsResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadAndSuggestSplitsResponse.ts"() {
    "use strict";
    init_core();
    InitiateUploadAndSuggestSplitsResponse = schemas_exports.object({
      collectionId: schemas_exports.property(
        "collection_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/RestoreVersionResponse.ts
var RestoreVersionResponse;
var init_RestoreVersionResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/RestoreVersionResponse.ts"() {
    "use strict";
    init_core();
    RestoreVersionResponse = schemas_exports.object({
      guideData: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideData),
      version: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts
var InitiateCreateGuideRequest;
var init_InitiateCreateGuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts"() {
    "use strict";
    init_core();
    InitiateCreateGuideRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadCreateRequest.ts
var InitiateUploadCreateRequest;
var init_InitiateUploadCreateRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadCreateRequest.ts"() {
    "use strict";
    init_core();
    InitiateUploadCreateRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      fileFormats: schemas_exports.property(
        "file_formats",
        schemas_exports.list(schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.FileFormat))
      ),
      guideCreationType: schemas_exports.property(
        "guide_creation_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideCreationType)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/AdvancedSettings.ts
var AdvancedSettings2;
var init_AdvancedSettings2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/AdvancedSettings.ts"() {
    "use strict";
    init_src();
    init_core();
    AdvancedSettings2 = schemas_exports.union("type", {
      ppt: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PptAdvancedSettings)
    }).transform({
      transform: (value) => {
        switch (value.type) {
          case "ppt":
            return api_exports.guides.AdvancedSettings.ppt(value);
          default:
            return api_exports.guides.AdvancedSettings._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/PptAdvancedSettings.ts
var PptAdvancedSettings;
var init_PptAdvancedSettings2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/PptAdvancedSettings.ts"() {
    "use strict";
    init_core();
    PptAdvancedSettings = schemas_exports.object({
      pptContentMode: schemas_exports.property(
        "ppt_content_mode",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PptContentMode)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/PptContentMode.ts
var PptContentMode2;
var init_PptContentMode2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/PptContentMode.ts"() {
    "use strict";
    init_core();
    PptContentMode2 = schemas_exports.enum_(["SPEAKER_NOTES_ONLY", "SPEAKER_NOTES_AND_SLIDES", "SLIDES_ONLY", "NONE"]);
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadCreateResponse.ts
var InitiateUploadCreateResponse;
var init_InitiateUploadCreateResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateUploadCreateResponse.ts"() {
    "use strict";
    init_core();
    InitiateUploadCreateResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      urls: schemas_exports.list(schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl))
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts
var InitiateCreateVideoGuideResponse;
var init_InitiateCreateVideoGuideResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts"() {
    "use strict";
    init_core();
    InitiateCreateVideoGuideResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts
var MoveGuideRequest;
var init_MoveGuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts"() {
    "use strict";
    init_core();
    MoveGuideRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      newParentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/PlainDocRequest.ts
var PlainDocRequest;
var init_PlainDocRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/PlainDocRequest.ts"() {
    "use strict";
    init_core();
    PlainDocRequest = schemas_exports.object({
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts
var GenerateVideoRequest;
var init_GenerateVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts"() {
    "use strict";
    init_core();
    GenerateVideoRequest = schemas_exports.object({
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts
var GenerateBookendsVideoRequest;
var init_GenerateBookendsVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts"() {
    "use strict";
    init_core();
    GenerateBookendsVideoRequest = schemas_exports.object({
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      outroSmallText: schemas_exports.string().optional(),
      outroLargeText: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/UpdateOriginalEditsRequest.ts
var UpdateOriginalEditsRequest;
var init_UpdateOriginalEditsRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/UpdateOriginalEditsRequest.ts"() {
    "use strict";
    init_core();
    UpdateOriginalEditsRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      originalEdits: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.OriginalEdits)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts
var UploadChunkRequest;
var init_UploadChunkRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts"() {
    "use strict";
    init_core();
    UploadChunkRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      chunkNumber: schemas_exports.number(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      updateId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts
var CompileVideoRequest;
var init_CompileVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts"() {
    "use strict";
    init_core();
    CompileVideoRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      totalChunks: schemas_exports.number(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      updateId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      onlyCheck: schemas_exports.property("only_check", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts
var CompileVideoResponse;
var init_CompileVideoResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts"() {
    "use strict";
    init_core();
    CompileVideoResponse = schemas_exports.object({
      status: schemas_exports.boolean(),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts
var ExportGuideResponse;
var init_ExportGuideResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts"() {
    "use strict";
    init_core();
    ExportGuideResponse = schemas_exports.object({
      imagePresignedUrls: schemas_exports.list(
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
      ),
      hostedImageUrls: schemas_exports.list(schemas_exports.string()),
      hostedVideoUrl: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/ValidateGuideUrlRequest.ts
var ValidateGuideUrlRequest;
var init_ValidateGuideUrlRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/ValidateGuideUrlRequest.ts"() {
    "use strict";
    init_core();
    ValidateGuideUrlRequest = schemas_exports.object({
      guideUrlPath: schemas_exports.property("guide_url_path", schemas_exports.string()),
      currentGuideId: schemas_exports.property("current_guide_id", schemas_exports.string())
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/ValidateGuideUrlResponse.ts
var ValidateGuideUrlResponse;
var init_ValidateGuideUrlResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/ValidateGuideUrlResponse.ts"() {
    "use strict";
    init_core();
    ValidateGuideUrlResponse = schemas_exports.object({
      available: schemas_exports.boolean(),
      conflictingGuides: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/UpdateLatestThumbnailRequest.ts
var UpdateLatestThumbnailRequest;
var init_UpdateLatestThumbnailRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/UpdateLatestThumbnailRequest.ts"() {
    "use strict";
    init_core();
    UpdateLatestThumbnailRequest = schemas_exports.object({
      data: schemas_exports.string(),
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      languageId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/PublishGuideV2Response.ts
var PublishGuideV2Response;
var init_PublishGuideV2Response2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/PublishGuideV2Response.ts"() {
    "use strict";
    init_core();
    PublishGuideV2Response = schemas_exports.object({
      reExporting: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/index.ts
var init_types47 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/index.ts"() {
    "use strict";
    init_InitiateUploadAndSuggestSplitsRequest2();
    init_InitiateUploadAndSuggestSplitsResponse2();
    init_RestoreVersionResponse2();
    init_InitiateCreateGuideRequest2();
    init_InitiateUploadCreateRequest2();
    init_AdvancedSettings2();
    init_PptAdvancedSettings2();
    init_PptContentMode2();
    init_InitiateUploadCreateResponse2();
    init_InitiateCreateVideoGuideResponse2();
    init_MoveGuideRequest2();
    init_PlainDocRequest2();
    init_GenerateVideoRequest2();
    init_GenerateBookendsVideoRequest2();
    init_UpdateOriginalEditsRequest2();
    init_UploadChunkRequest2();
    init_CompileVideoRequest2();
    init_CompileVideoResponse2();
    init_ExportGuideResponse2();
    init_ValidateGuideUrlRequest2();
    init_ValidateGuideUrlResponse2();
    init_UpdateLatestThumbnailRequest2();
    init_PublishGuideV2Response2();
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/generateVoiceover.ts
var generateVoiceover_exports2 = {};
__export(generateVoiceover_exports2, {
  Error: () => Error291,
  Response: () => Response28
});
var Response28, Error291;
var init_generateVoiceover2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/generateVoiceover.ts"() {
    "use strict";
    init_core();
    init_src();
    Response28 = schemas_exports.string();
    Error291 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      GuideIncompatibleError: schemas_exports.object({}),
      TranscriptionMatchingError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TranscriptionMatchingErrorBody
        )
      }),
      ScreenshotOrderingError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ScreenshotOrderingErrorBody
        )
      }),
      UnsubscribedOrgError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
        )
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.unauthorizedError();
          case "GuideIncompatibleError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.guideIncompatibleError();
          case "TranscriptionMatchingError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.transcriptionMatchingError(
              value.content
            );
          case "ScreenshotOrderingError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.screenshotOrderingError(
              value.content
            );
          case "UnsubscribedOrgError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.unsubscribedOrgError(
              value.content
            );
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.generateVoiceover.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/publishGuide.ts
var publishGuide_exports2 = {};
__export(publishGuide_exports2, {
  Error: () => Error292,
  Response: () => Response29
});
var Response29, Error292;
var init_publishGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/publishGuide.ts"() {
    "use strict";
    init_core();
    init_src();
    Response29 = schemas_exports.string();
    Error292 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      GuideIncompatibleError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.publishGuide.Error.unauthorizedError();
          case "GuideIncompatibleError":
            return api_exports.guides.guideMutations.publishGuide.Error.guideIncompatibleError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.publishGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.publishGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/publishGuideV2.ts
var publishGuideV2_exports2 = {};
__export(publishGuideV2_exports2, {
  Error: () => Error293
});
var Error293;
var init_publishGuideV22 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/publishGuideV2.ts"() {
    "use strict";
    init_src();
    init_core();
    Error293 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.publishGuideV2.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.publishGuideV2.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.publishGuideV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishCreateGuide.ts
var finishCreateGuide_exports2 = {};
__export(finishCreateGuide_exports2, {
  Error: () => Error294,
  Response: () => Response30
});
var Response30, Error294;
var init_finishCreateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishCreateGuide.ts"() {
    "use strict";
    init_core();
    init_src();
    Response30 = schemas_exports.boolean();
    Error294 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishCreateGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.finishCreateGuide.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.finishCreateGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/autoUpdateGuideVideo.ts
var autoUpdateGuideVideo_exports2 = {};
__export(autoUpdateGuideVideo_exports2, {
  Error: () => Error295,
  Response: () => Response31
});
var Response31, Error295;
var init_autoUpdateGuideVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/autoUpdateGuideVideo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response31 = schemas_exports.boolean();
    Error295 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.autoUpdateGuideVideo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts
var initiateCreateGuide_exports2 = {};
__export(initiateCreateGuide_exports2, {
  Error: () => Error296
});
var Error296;
var init_initiateCreateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error296 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateCreateGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.initiateCreateGuide.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.initiateCreateGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateUploadCreate.ts
var initiateUploadCreate_exports2 = {};
__export(initiateUploadCreate_exports2, {
  Error: () => Error297
});
var Error297;
var init_initiateUploadCreate2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateUploadCreate.ts"() {
    "use strict";
    init_src();
    init_core();
    Error297 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateUploadCreate.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.initiateUploadCreate.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.initiateUploadCreate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/uploadImage.ts
var uploadImage_exports2 = {};
__export(uploadImage_exports2, {
  Error: () => Error298
});
var Error298;
var init_uploadImage2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/uploadImage.ts"() {
    "use strict";
    init_src();
    init_core();
    Error298 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.uploadImage.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.uploadImage.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.uploadImage.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts
var uploadVideoChunk_exports2 = {};
__export(uploadVideoChunk_exports2, {
  Error: () => Error299
});
var Error299;
var init_uploadVideoChunk2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts"() {
    "use strict";
    init_src();
    init_core();
    Error299 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.uploadVideoChunk.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.uploadVideoChunk.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.uploadVideoChunk.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/compileVideo.ts
var compileVideo_exports2 = {};
__export(compileVideo_exports2, {
  Error: () => Error300
});
var Error300;
var init_compileVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/compileVideo.ts"() {
    "use strict";
    init_src();
    init_core();
    Error300 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.compileVideo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.compileVideo.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.compileVideo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateGuideData.ts
var updateGuideData_exports2 = {};
__export(updateGuideData_exports2, {
  Error: () => Error301
});
var Error301;
var init_updateGuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error301 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateGuideData.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.updateGuideData.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.updateGuideData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateOriginalEdits.ts
var updateOriginalEdits_exports2 = {};
__export(updateOriginalEdits_exports2, {
  Error: () => Error302
});
var Error302;
var init_updateOriginalEdits2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateOriginalEdits.ts"() {
    "use strict";
    init_src();
    init_core();
    Error302 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateOriginalEdits.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.updateOriginalEdits.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.updateOriginalEdits.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.updateOriginalEdits.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateUploadSource.ts
var initiateUploadSource_exports2 = {};
__export(initiateUploadSource_exports2, {
  Error: () => Error303
});
var Error303;
var init_initiateUploadSource2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateUploadSource.ts"() {
    "use strict";
    init_src();
    init_core();
    Error303 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateUploadSource.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.initiateUploadSource.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.initiateUploadSource.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUploadSource.ts
var finishUploadSource_exports2 = {};
__export(finishUploadSource_exports2, {
  Error: () => Error304,
  Response: () => Response32
});
var Response32, Error304;
var init_finishUploadSource2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUploadSource.ts"() {
    "use strict";
    init_core();
    init_src();
    Response32 = schemas_exports.boolean();
    Error304 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUploadSource.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.finishUploadSource.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.finishUploadSource.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts
var finishUpdateGuideData_exports2 = {};
__export(finishUpdateGuideData_exports2, {
  Error: () => Error305,
  Response: () => Response33
});
var Response33, Error305;
var init_finishUpdateGuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts"() {
    "use strict";
    init_core();
    init_src();
    Response33 = schemas_exports.number();
    Error305 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts
var createEmptyTextGuide_exports2 = {};
__export(createEmptyTextGuide_exports2, {
  Error: () => Error306
});
var Error306;
var init_createEmptyTextGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error306 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateGuidePreview.ts
var updateGuidePreview_exports2 = {};
__export(updateGuidePreview_exports2, {
  Error: () => Error307
});
var Error307;
var init_updateGuidePreview2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error307 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateGuidePreview.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.updateGuidePreview.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.updateGuidePreview.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/pinGuide.ts
var pinGuide_exports2 = {};
__export(pinGuide_exports2, {
  Error: () => Error308
});
var Error308;
var init_pinGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/pinGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error308 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.pinGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.pinGuide.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.pinGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.pinGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/deleteGuide.ts
var deleteGuide_exports2 = {};
__export(deleteGuide_exports2, {
  Error: () => Error309
});
var Error309;
var init_deleteGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/deleteGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error309 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.deleteGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.deleteGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/moveGuide.ts
var moveGuide_exports2 = {};
__export(moveGuide_exports2, {
  Error: () => Error310
});
var Error310;
var init_moveGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/moveGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error310 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.moveGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.moveGuide.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.moveGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.moveGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/reorderGuide.ts
var reorderGuide_exports2 = {};
__export(reorderGuide_exports2, {
  Error: () => Error311
});
var Error311;
var init_reorderGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/reorderGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error311 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.reorderGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.reorderGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUploadCreate.ts
var finishUploadCreate_exports2 = {};
__export(finishUploadCreate_exports2, {
  Error: () => Error312,
  Response: () => Response34
});
var Response34, Error312;
var init_finishUploadCreate2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUploadCreate.ts"() {
    "use strict";
    init_core();
    init_src();
    Response34 = schemas_exports.boolean();
    Error312 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUploadCreate.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.guides.guideMutations.finishUploadCreate.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.finishUploadCreate.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.finishUploadCreate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/duplicateGuide.ts
var duplicateGuide_exports2 = {};
__export(duplicateGuide_exports2, {
  Error: () => Error313
});
var Error313;
var init_duplicateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/duplicateGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error313 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.duplicateGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.duplicateGuide.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.duplicateGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/restoreVersion.ts
var restoreVersion_exports2 = {};
__export(restoreVersion_exports2, {
  Error: () => Error314
});
var Error314;
var init_restoreVersion2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/restoreVersion.ts"() {
    "use strict";
    init_src();
    init_core();
    Error314 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.restoreVersion.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.restoreVersion.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.restoreVersion.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.restoreVersion.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/validateGuideUrlPath.ts
var validateGuideUrlPath_exports2 = {};
__export(validateGuideUrlPath_exports2, {
  Error: () => Error315
});
var Error315;
var init_validateGuideUrlPath2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/validateGuideUrlPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error315 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.validateGuideUrlPath.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updatedLatestThumbnail.ts
var updatedLatestThumbnail_exports2 = {};
__export(updatedLatestThumbnail_exports2, {
  Error: () => Error316,
  Response: () => Response35
});
var Response35, Error316;
var init_updatedLatestThumbnail2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updatedLatestThumbnail.ts"() {
    "use strict";
    init_core();
    init_src();
    Response35 = schemas_exports.boolean();
    Error316 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.updatedLatestThumbnail.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateUploadAndSuggestSplits.ts
var initiateUploadAndSuggestSplits_exports2 = {};
__export(initiateUploadAndSuggestSplits_exports2, {
  Error: () => Error317
});
var Error317;
var init_initiateUploadAndSuggestSplits2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateUploadAndSuggestSplits.ts"() {
    "use strict";
    init_src();
    init_core();
    Error317 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUploadAndSuggestSplits.ts
var finishUploadAndSuggestSplits_exports2 = {};
__export(finishUploadAndSuggestSplits_exports2, {
  Error: () => Error318,
  Response: () => Response36
});
var Response36, Error318;
var init_finishUploadAndSuggestSplits2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUploadAndSuggestSplits.ts"() {
    "use strict";
    init_core();
    init_src();
    Response36 = schemas_exports.boolean();
    Error318 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/generateGuidesBasedOnSplits.ts
var generateGuidesBasedOnSplits_exports2 = {};
__export(generateGuidesBasedOnSplits_exports2, {
  Error: () => Error319,
  Response: () => Response37
});
var Response37, Error319;
var init_generateGuidesBasedOnSplits2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/generateGuidesBasedOnSplits.ts"() {
    "use strict";
    init_core();
    init_src();
    Response37 = schemas_exports.boolean();
    Error319 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/GenerateVoiceoverRequest.ts
var GenerateVoiceoverRequest;
var init_GenerateVoiceoverRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/GenerateVoiceoverRequest.ts"() {
    "use strict";
    init_core();
    GenerateVoiceoverRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/PublishGuideRequest.ts
var PublishGuideRequest;
var init_PublishGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/PublishGuideRequest.ts"() {
    "use strict";
    init_core();
    PublishGuideRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/PublishGuideV2Request.ts
var PublishGuideV2Request;
var init_PublishGuideV2Request = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/PublishGuideV2Request.ts"() {
    "use strict";
    init_core();
    PublishGuideV2Request = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishCreateGuideRequest.ts
var FinishCreateGuideRequest;
var init_FinishCreateGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishCreateGuideRequest.ts"() {
    "use strict";
    init_core();
    FinishCreateGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      tourSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStep)
      ),
      docSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DocStep)
      ),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      zoomFactor: schemas_exports.number().optional(),
      dotColor: schemas_exports.string().optional(),
      addDotsInPost: schemas_exports.string().optional(),
      totalChunks: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/AutoUpdateGuideRequest.ts
var AutoUpdateGuideRequest;
var init_AutoUpdateGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/AutoUpdateGuideRequest.ts"() {
    "use strict";
    init_core();
    AutoUpdateGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      updateId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      tourSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStep)
      ),
      docSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DocStep)
      ),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      zoomFactor: schemas_exports.number().optional(),
      dotColor: schemas_exports.string().optional(),
      addDotsInPost: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/InitiateUploadSourceRequest.ts
var InitiateUploadSourceRequest;
var init_InitiateUploadSourceRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/InitiateUploadSourceRequest.ts"() {
    "use strict";
    init_core();
    InitiateUploadSourceRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      fileType: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadSourceRequest.ts
var FinishUploadSourceRequest;
var init_FinishUploadSourceRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadSourceRequest.ts"() {
    "use strict";
    init_core();
    FinishUploadSourceRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      source: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoSource)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUpdateGuideDataRequest.ts
var FinishUpdateGuideDataRequest;
var init_FinishUpdateGuideDataRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUpdateGuideDataRequest.ts"() {
    "use strict";
    init_core();
    FinishUpdateGuideDataRequest = schemas_exports.object({
      guide: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Guide),
      incrementVersion: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/CreateEmptyTextGuideRequest.ts
var CreateEmptyTextGuideRequest;
var init_CreateEmptyTextGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/CreateEmptyTextGuideRequest.ts"() {
    "use strict";
    init_core();
    CreateEmptyTextGuideRequest = schemas_exports.object({
      parentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/PinGuideRequest.ts
var PinGuideRequest;
var init_PinGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/PinGuideRequest.ts"() {
    "use strict";
    init_core();
    PinGuideRequest = schemas_exports.object({
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      isPinned: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/DeleteGuideRequest.ts
var DeleteGuideRequest;
var init_DeleteGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/DeleteGuideRequest.ts"() {
    "use strict";
    init_core();
    DeleteGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/ReorderGuideRequest.ts
var ReorderGuideRequest;
var init_ReorderGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/ReorderGuideRequest.ts"() {
    "use strict";
    init_core();
    ReorderGuideRequest = schemas_exports.object({
      succeedingGuideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      precedingGuideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadCreate.ts
var FinishUploadCreate;
var init_FinishUploadCreate = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadCreate.ts"() {
    "use strict";
    init_core();
    FinishUploadCreate = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      languageId: schemas_exports.string().optional(),
      outputLanguageId: schemas_exports.string().optional(),
      guideCreationType: schemas_exports.property(
        "guide_creation_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideCreationType)
      ),
      fileFormats: schemas_exports.property(
        "file_formats",
        schemas_exports.list(
          schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.FileFormat)
        )
      ),
      advancedSettings: schemas_exports.property(
        "advanced_settings",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.AdvancedSettings).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/RestoreVersionRequest.ts
var RestoreVersionRequest;
var init_RestoreVersionRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/RestoreVersionRequest.ts"() {
    "use strict";
    init_core();
    RestoreVersionRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      version: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadAndSuggestSplitsRequest.ts
var FinishUploadAndSuggestSplitsRequest;
var init_FinishUploadAndSuggestSplitsRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadAndSuggestSplitsRequest.ts"() {
    "use strict";
    init_core();
    FinishUploadAndSuggestSplitsRequest = schemas_exports.object({
      collectionId: schemas_exports.property(
        "collection_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      languageId: schemas_exports.property("language_id", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/GenerateGuidesBasedonSplitsRequest.ts
var GenerateGuidesBasedonSplitsRequest;
var init_GenerateGuidesBasedonSplitsRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/GenerateGuidesBasedonSplitsRequest.ts"() {
    "use strict";
    init_core();
    GenerateGuidesBasedonSplitsRequest = schemas_exports.object({
      collectionId: schemas_exports.property(
        "collection_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      videoChapters: schemas_exports.property(
        "video_chapters",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CutsVideoChapters)
      ),
      languageId: schemas_exports.property("language_id", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/index.ts
var init_requests21 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/index.ts"() {
    "use strict";
    init_GenerateVoiceoverRequest();
    init_PublishGuideRequest();
    init_PublishGuideV2Request();
    init_FinishCreateGuideRequest();
    init_AutoUpdateGuideRequest();
    init_InitiateUploadSourceRequest();
    init_FinishUploadSourceRequest();
    init_FinishUpdateGuideDataRequest();
    init_CreateEmptyTextGuideRequest();
    init_PinGuideRequest();
    init_DeleteGuideRequest();
    init_ReorderGuideRequest();
    init_FinishUploadCreate();
    init_RestoreVersionRequest();
    init_FinishUploadAndSuggestSplitsRequest();
    init_GenerateGuidesBasedonSplitsRequest();
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/index.ts
var init_client48 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/index.ts"() {
    "use strict";
    init_generateVoiceover2();
    init_publishGuide2();
    init_publishGuideV22();
    init_finishCreateGuide2();
    init_autoUpdateGuideVideo2();
    init_initiateCreateGuide2();
    init_initiateUploadCreate2();
    init_uploadImage2();
    init_uploadVideoChunk2();
    init_compileVideo2();
    init_updateGuideData2();
    init_updateOriginalEdits2();
    init_initiateUploadSource2();
    init_finishUploadSource2();
    init_finishUpdateGuideData2();
    init_createEmptyTextGuide2();
    init_updateGuidePreview2();
    init_pinGuide2();
    init_deleteGuide2();
    init_moveGuide2();
    init_reorderGuide2();
    init_finishUploadCreate2();
    init_duplicateGuide2();
    init_restoreVersion2();
    init_validateGuideUrlPath2();
    init_updatedLatestThumbnail2();
    init_initiateUploadAndSuggestSplits2();
    init_finishUploadAndSuggestSplits2();
    init_generateGuidesBasedOnSplits2();
    init_requests21();
  }
});

// src/serialization/resources/guides/resources/guideMutations/index.ts
var guideMutations_exports2 = {};
__export(guideMutations_exports2, {
  AdvancedSettings: () => AdvancedSettings2,
  AutoUpdateGuideRequest: () => AutoUpdateGuideRequest,
  CompileVideoRequest: () => CompileVideoRequest,
  CompileVideoResponse: () => CompileVideoResponse,
  CreateEmptyTextGuideRequest: () => CreateEmptyTextGuideRequest,
  DeleteGuideRequest: () => DeleteGuideRequest,
  ExportGuideResponse: () => ExportGuideResponse,
  FinishCreateGuideRequest: () => FinishCreateGuideRequest,
  FinishUpdateGuideDataRequest: () => FinishUpdateGuideDataRequest,
  FinishUploadAndSuggestSplitsRequest: () => FinishUploadAndSuggestSplitsRequest,
  FinishUploadCreate: () => FinishUploadCreate,
  FinishUploadSourceRequest: () => FinishUploadSourceRequest,
  GenerateBookendsVideoRequest: () => GenerateBookendsVideoRequest,
  GenerateGuidesBasedonSplitsRequest: () => GenerateGuidesBasedonSplitsRequest,
  GenerateVideoRequest: () => GenerateVideoRequest,
  GenerateVoiceoverRequest: () => GenerateVoiceoverRequest,
  InitiateCreateGuideRequest: () => InitiateCreateGuideRequest,
  InitiateCreateVideoGuideResponse: () => InitiateCreateVideoGuideResponse,
  InitiateUploadAndSuggestSplitsRequest: () => InitiateUploadAndSuggestSplitsRequest,
  InitiateUploadAndSuggestSplitsResponse: () => InitiateUploadAndSuggestSplitsResponse,
  InitiateUploadCreateRequest: () => InitiateUploadCreateRequest,
  InitiateUploadCreateResponse: () => InitiateUploadCreateResponse,
  InitiateUploadSourceRequest: () => InitiateUploadSourceRequest,
  MoveGuideRequest: () => MoveGuideRequest,
  PinGuideRequest: () => PinGuideRequest,
  PlainDocRequest: () => PlainDocRequest,
  PptAdvancedSettings: () => PptAdvancedSettings,
  PptContentMode: () => PptContentMode2,
  PublishGuideRequest: () => PublishGuideRequest,
  PublishGuideV2Request: () => PublishGuideV2Request,
  PublishGuideV2Response: () => PublishGuideV2Response,
  ReorderGuideRequest: () => ReorderGuideRequest,
  RestoreVersionRequest: () => RestoreVersionRequest,
  RestoreVersionResponse: () => RestoreVersionResponse,
  UpdateLatestThumbnailRequest: () => UpdateLatestThumbnailRequest,
  UpdateOriginalEditsRequest: () => UpdateOriginalEditsRequest,
  UploadChunkRequest: () => UploadChunkRequest,
  ValidateGuideUrlRequest: () => ValidateGuideUrlRequest,
  ValidateGuideUrlResponse: () => ValidateGuideUrlResponse,
  autoUpdateGuideVideo: () => autoUpdateGuideVideo_exports2,
  compileVideo: () => compileVideo_exports2,
  createEmptyTextGuide: () => createEmptyTextGuide_exports2,
  deleteGuide: () => deleteGuide_exports2,
  duplicateGuide: () => duplicateGuide_exports2,
  finishCreateGuide: () => finishCreateGuide_exports2,
  finishUpdateGuideData: () => finishUpdateGuideData_exports2,
  finishUploadAndSuggestSplits: () => finishUploadAndSuggestSplits_exports2,
  finishUploadCreate: () => finishUploadCreate_exports2,
  finishUploadSource: () => finishUploadSource_exports2,
  generateGuidesBasedOnSplits: () => generateGuidesBasedOnSplits_exports2,
  generateVoiceover: () => generateVoiceover_exports2,
  initiateCreateGuide: () => initiateCreateGuide_exports2,
  initiateUploadAndSuggestSplits: () => initiateUploadAndSuggestSplits_exports2,
  initiateUploadCreate: () => initiateUploadCreate_exports2,
  initiateUploadSource: () => initiateUploadSource_exports2,
  moveGuide: () => moveGuide_exports2,
  pinGuide: () => pinGuide_exports2,
  publishGuide: () => publishGuide_exports2,
  publishGuideV2: () => publishGuideV2_exports2,
  reorderGuide: () => reorderGuide_exports2,
  restoreVersion: () => restoreVersion_exports2,
  updateGuideData: () => updateGuideData_exports2,
  updateGuidePreview: () => updateGuidePreview_exports2,
  updateOriginalEdits: () => updateOriginalEdits_exports2,
  updatedLatestThumbnail: () => updatedLatestThumbnail_exports2,
  uploadImage: () => uploadImage_exports2,
  uploadVideoChunk: () => uploadVideoChunk_exports2,
  validateGuideUrlPath: () => validateGuideUrlPath_exports2
});
var init_guideMutations2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/index.ts"() {
    "use strict";
    init_types47();
    init_client48();
  }
});

// src/serialization/resources/guides/resources/guideQueryCore/types/GetGuidePreviewRequest.ts
var GetGuidePreviewRequest;
var init_GetGuidePreviewRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideQueryCore/types/GetGuidePreviewRequest.ts"() {
    "use strict";
    init_core();
    GetGuidePreviewRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideQueryCore/types/GetGuideDataRequest.ts
var GetGuideDataRequest;
var init_GetGuideDataRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideQueryCore/types/GetGuideDataRequest.ts"() {
    "use strict";
    init_core();
    GetGuideDataRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      version: schemas_exports.number().optional(),
      sdkVersion: schemas_exports.property("sdk_version", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideQueryCore/types/index.ts
var init_types48 = __esm({
  "src/serialization/resources/guides/resources/guideQueryCore/types/index.ts"() {
    "use strict";
    init_GetGuidePreviewRequest2();
    init_GetGuideDataRequest2();
  }
});

// src/serialization/resources/guides/resources/guideQueryCore/index.ts
var guideQueryCore_exports2 = {};
__export(guideQueryCore_exports2, {
  GetGuideDataRequest: () => GetGuideDataRequest,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest
});
var init_guideQueryCore2 = __esm({
  "src/serialization/resources/guides/resources/guideQueryCore/index.ts"() {
    "use strict";
    init_types48();
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoObject.ts
var VideoObject;
var init_VideoObject2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoObject.ts"() {
    "use strict";
    init_core();
    VideoObject = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      src: schemas_exports.string(),
      metadata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoMetadata),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      key: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoRecordingType.ts
var VideoRecordingType2;
var init_VideoRecordingType2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoRecordingType.ts"() {
    "use strict";
    init_core();
    VideoRecordingType2 = schemas_exports.enum_(["default", "loom"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PublishedVideoType.ts
var PublishedVideoType2;
var init_PublishedVideoType2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PublishedVideoType.ts"() {
    "use strict";
    init_core();
    PublishedVideoType2 = schemas_exports.enum_(["ai", "original", "none"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoMetadata.ts
var VideoMetadata;
var init_VideoMetadata2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoMetadata.ts"() {
    "use strict";
    init_core();
    VideoMetadata = schemas_exports.object({
      recorderType: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoRecordingType).optional(),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      generatedVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GeneratedVideo).optional(),
      editedVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.EditedVideo).optional(),
      decoratedAiVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.EditedVideo).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts
var PresignedUrlsForGuide;
var init_PresignedUrlsForGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts"() {
    "use strict";
    init_core();
    PresignedUrlsForGuide = schemas_exports.object({
      guide: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl),
      video: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl).optional(),
      images: schemas_exports.list(schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts
var PresignedUrlsResponse;
var init_PresignedUrlsResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts"() {
    "use strict";
    init_core();
    PresignedUrlsResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      presignedUrls: schemas_exports.property(
        "presigned_urls",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PresignedUrlsForGuide)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Guide.ts
var Guide;
var init_Guide2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Guide.ts"() {
    "use strict";
    init_core();
    Guide = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      guideData: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideData)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideHeader.ts
var GuideHeader;
var init_GuideHeader2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideHeader.ts"() {
    "use strict";
    init_core();
    GuideHeader = schemas_exports.object({
      name: schemas_exports.string(),
      description: schemas_exports.string().optional(),
      published: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuidePreview.ts
var GuidePreview;
var init_GuidePreview2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuidePreview.ts"() {
    "use strict";
    init_core();
    GuidePreview = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      guideUrlPath: schemas_exports.property("guide_url_path", schemas_exports.string().optional()),
      header: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideHeader),
      sequenceNumber: schemas_exports.property("sequence_number", schemas_exports.number().optional()),
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      isPinned: schemas_exports.boolean().optional(),
      deleted: schemas_exports.boolean().optional(),
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      versionPublished: schemas_exports.property("version_published", schemas_exports.number()),
      versionSaved: schemas_exports.property("version_saved", schemas_exports.number()),
      versionGenerated: schemas_exports.property("version_generated", schemas_exports.number()),
      author: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Author),
      createdAt: schemas_exports.property("created_at", schemas_exports.date().optional()),
      deleteAt: schemas_exports.property("delete_at", schemas_exports.date().optional()),
      lastModified: schemas_exports.property("last_modified", schemas_exports.date().optional()),
      latestThumbnail: schemas_exports.property("latest_thumbnail", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuidePlatformStatus.ts
var GuidePlatformStatus;
var init_GuidePlatformStatus2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuidePlatformStatus.ts"() {
    "use strict";
    init_core();
    GuidePlatformStatus = schemas_exports.object({
      generatingVoiceover: schemas_exports.property("generating_voiceover", schemas_exports.boolean().optional()),
      exportingVideo: schemas_exports.property("exporting_video", schemas_exports.boolean().optional()),
      publishingGuide: schemas_exports.property("publishing_guide", schemas_exports.boolean().optional()),
      aiEnhancingVideo: schemas_exports.property("ai_enhancing_video", schemas_exports.boolean().optional()),
      aiEnhancingArticle: schemas_exports.property("ai_enhancing_article", schemas_exports.boolean().optional()),
      autoUpdatingGuide: schemas_exports.property("auto_updating_guide", schemas_exports.boolean().optional()),
      trimmingVideo: schemas_exports.property("trimming_video", schemas_exports.boolean().optional()),
      creatingGuide: schemas_exports.property("creating_guide", schemas_exports.boolean().optional()),
      operationError: schemas_exports.property(
        "operation_error",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.OperationError).optional()
      ),
      publishingYoutube: schemas_exports.property("publishing_youtube", schemas_exports.boolean().optional()),
      exportDetails: schemas_exports.property(
        "export_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportDetails).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/OperationError.ts
var OperationError;
var init_OperationError2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/OperationError.ts"() {
    "use strict";
    init_core();
    OperationError = schemas_exports.object({
      viewed: schemas_exports.boolean(),
      details: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.AsyncOperationError)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/AsyncOperationError.ts
var AsyncOperationError2;
var init_AsyncOperationError2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/AsyncOperationError.ts"() {
    "use strict";
    init_src();
    init_core();
    AsyncOperationError2 = schemas_exports.union("type", {
      generating_voiceover: schemas_exports.object({
        value: schemas_exports.lazy(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GeneratingVoiceoverError
        )
      }),
      exporting_video: schemas_exports.object({
        value: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportingVideoError)
      }),
      youtube_publish: schemas_exports.object({
        value: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.YouTubePublishError)
      })
    }).transform({
      transform: (value) => {
        switch (value.type) {
          case "generating_voiceover":
            return api_exports.guides.AsyncOperationError.generatingVoiceover(value.value);
          case "exporting_video":
            return api_exports.guides.AsyncOperationError.exportingVideo(value.value);
          case "youtube_publish":
            return api_exports.guides.AsyncOperationError.youtubePublish(value.value);
          default:
            return api_exports.guides.AsyncOperationError._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/YouTubePublishError.ts
var YouTubePublishError2;
var init_YouTubePublishError2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/YouTubePublishError.ts"() {
    "use strict";
    init_src();
    init_core();
    YouTubePublishError2 = schemas_exports.union("errorType", {
      uploadLimitExceeded: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.YouTubeUploadErrorBody
      ),
      exportVideoError: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportingVideoYoutubeErrorBody
      ),
      other: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.YouTubeUploadErrorBody
      )
    }).transform({
      transform: (value) => {
        switch (value.errorType) {
          case "uploadLimitExceeded":
            return api_exports.guides.YouTubePublishError.uploadLimitExceeded(value);
          case "exportVideoError":
            return api_exports.guides.YouTubePublishError.exportVideoError(value);
          case "other":
            return api_exports.guides.YouTubePublishError.other(value);
          default:
            return api_exports.guides.YouTubePublishError._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/ExportingVideoYoutubeErrorBody.ts
var ExportingVideoYoutubeErrorBody;
var init_ExportingVideoYoutubeErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/ExportingVideoYoutubeErrorBody.ts"() {
    "use strict";
    init_core();
    ExportingVideoYoutubeErrorBody = schemas_exports.object({
      message: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/ExportingVideoError.ts
var ExportingVideoError2;
var init_ExportingVideoError2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/ExportingVideoError.ts"() {
    "use strict";
    init_src();
    init_core();
    ExportingVideoError2 = schemas_exports.union("errorType", {
      blurEffects: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.BlurringErrorBody
      ),
      unsubscribedOrg: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
      ),
      errorRenderingVideo: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ErrorRenderingVideoBody
      )
    }).transform({
      transform: (value) => {
        switch (value.errorType) {
          case "blurEffects":
            return api_exports.guides.ExportingVideoError.blurEffects(value);
          case "unsubscribedOrg":
            return api_exports.guides.ExportingVideoError.unsubscribedOrg(value);
          case "errorRenderingVideo":
            return api_exports.guides.ExportingVideoError.errorRenderingVideo(value);
          default:
            return api_exports.guides.ExportingVideoError._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/YouTubeUploadErrorBody.ts
var YouTubeUploadErrorBody;
var init_YouTubeUploadErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/YouTubeUploadErrorBody.ts"() {
    "use strict";
    init_core();
    YouTubeUploadErrorBody = schemas_exports.object({
      message: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GeneratingVoiceoverError.ts
var GeneratingVoiceoverError2;
var init_GeneratingVoiceoverError2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GeneratingVoiceoverError.ts"() {
    "use strict";
    init_src();
    init_core();
    GeneratingVoiceoverError2 = schemas_exports.union("errorType", {
      transcriptionMatching: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TranscriptionMatchingErrorBody
      ),
      screenshotOrdering: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ScreenshotOrderingErrorBody
      ),
      unsubscribedOrg: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.UnsubscribedErrorBody
      ),
      unknown: schemas_exports.object({
        value: schemas_exports.string()
      })
    }).transform({
      transform: (value) => {
        switch (value.errorType) {
          case "transcriptionMatching":
            return api_exports.guides.GeneratingVoiceoverError.transcriptionMatching(value);
          case "screenshotOrdering":
            return api_exports.guides.GeneratingVoiceoverError.screenshotOrdering(value);
          case "unsubscribedOrg":
            return api_exports.guides.GeneratingVoiceoverError.unsubscribedOrg(value);
          case "unknown":
            return api_exports.guides.GeneratingVoiceoverError.unknown(value.value);
          default:
            return api_exports.guides.GeneratingVoiceoverError._unknown(value);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideData.ts
var GuideData;
var init_GuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideData.ts"() {
    "use strict";
    init_core();
    GuideData = schemas_exports.object({
      settings: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideSettings),
      video: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.NewVideoObject),
      plainDoc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuidePlatformData.ts
var GuidePlatformData;
var init_GuidePlatformData2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuidePlatformData.ts"() {
    "use strict";
    init_core();
    GuidePlatformData = schemas_exports.object({
      guideData: schemas_exports.property(
        "guide_data",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideData)
      ),
      articleSelectedPromptData: schemas_exports.property(
        "article_selected_prompt_data",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptOption).optional()
      ),
      videoSelectedPromptData: schemas_exports.property(
        "video_selected_prompt_data",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptOption).optional()
      ),
      articleAiChatMessages: schemas_exports.property(
        "article_ai_chat_messages",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatMessage)).optional()
      ),
      videoAiChatMessages: schemas_exports.property(
        "video_ai_chat_messages",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideAiChatMessage)).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideVersion.ts
var GuideVersion;
var init_GuideVersion2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideVersion.ts"() {
    "use strict";
    init_core();
    GuideVersion = schemas_exports.object({
      versionNumber: schemas_exports.property("version_number", schemas_exports.number()),
      changeAuthor: schemas_exports.property(
        "change_author",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Author)
      ),
      updatedAt: schemas_exports.property("updated_at", schemas_exports.date())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoObjectVersion.ts
var VideoObjectVersion2;
var init_VideoObjectVersion2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoObjectVersion.ts"() {
    "use strict";
    init_core();
    VideoObjectVersion2 = schemas_exports.enum_(["dec152023"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/NewVideoObject.ts
var NewVideoObject;
var init_NewVideoObject2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/NewVideoObject.ts"() {
    "use strict";
    init_core();
    NewVideoObject = schemas_exports.object({
      objVersion: schemas_exports.property(
        "obj_version",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoObjectVersion).optional()
      ),
      originalSrc: schemas_exports.property("original_src", schemas_exports.string().optional()),
      generatedSrc: schemas_exports.property("generated_src", schemas_exports.string().optional()),
      generated: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GeneratedVideo).optional(),
      publishedVideoSrc: schemas_exports.property("published_video_src", schemas_exports.string().optional()),
      videoEdits: schemas_exports.property(
        "video_edits",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.VideoEdits).optional()
      ),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      export: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.ExportedVideo).optional(),
      originalEdits: schemas_exports.property(
        "original_edits",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.OriginalEdits).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideSettings.ts
var GuideSettings;
var init_GuideSettings2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideSettings.ts"() {
    "use strict";
    init_core();
    GuideSettings = schemas_exports.object({
      hideArticle: schemas_exports.property("hide_article", schemas_exports.boolean().optional()),
      publishedVideo: schemas_exports.property(
        "published_video",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PublishedVideoType).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PlainDoc.ts
var PlainDoc;
var init_PlainDoc2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PlainDoc.ts"() {
    "use strict";
    init_core();
    PlainDoc = schemas_exports.object({
      version: schemas_exports.string(),
      data: schemas_exports.unknown()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/DocStep.ts
var DocStep;
var init_DocStep2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/DocStep.ts"() {
    "use strict";
    init_core();
    DocStep = schemas_exports.object({
      stepId: schemas_exports.property(
        "step_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      text: schemas_exports.string(),
      timestamp: schemas_exports.number(),
      s3ObjectId: schemas_exports.string(),
      zoomCenter: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Coordinates).optional(),
      naturalDimensions: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Coordinates).optional(),
      domElementData: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/AutoProgressable.ts
var AutoProgressable2;
var init_AutoProgressable2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/AutoProgressable.ts"() {
    "use strict";
    init_core();
    AutoProgressable2 = schemas_exports.enum_(["auto", "newButton"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TourStep.ts
var TourStep;
var init_TourStep2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TourStep.ts"() {
    "use strict";
    init_core();
    TourStep = schemas_exports.object({
      stepId: schemas_exports.property(
        "step_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      domElementData: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData
      ),
      metadata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStepMetadata)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TourStepMetadata.ts
var TourStepMetadata;
var init_TourStepMetadata2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TourStepMetadata.ts"() {
    "use strict";
    init_core();
    TourStepMetadata = schemas_exports.object({
      title: schemas_exports.string().optional(),
      text: schemas_exports.string(),
      ancestor: schemas_exports.number(),
      skippable: schemas_exports.boolean(),
      autoProgressable: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.AutoProgressable),
      parents: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData)
      ),
      customSelector: schemas_exports.property(
        "custom_selector",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.CustomSelector).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/CustomSelector.ts
var CustomSelector;
var init_CustomSelector2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/CustomSelector.ts"() {
    "use strict";
    init_core();
    CustomSelector = schemas_exports.object({
      name: schemas_exports.string(),
      value: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/DomElementData.ts
var DomElementData;
var init_DomElementData2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/DomElementData.ts"() {
    "use strict";
    init_core();
    DomElementData = schemas_exports.object({
      id: schemas_exports.string(),
      textContent: schemas_exports.string(),
      className: schemas_exports.string(),
      tagName: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GeneratedVideo.ts
var GeneratedVideo;
var init_GeneratedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GeneratedVideo.ts"() {
    "use strict";
    init_core();
    GeneratedVideo = schemas_exports.object({
      transcript: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      subtitles: schemas_exports.string().optional(),
      audio: schemas_exports.string().optional(),
      originalTimestamps: schemas_exports.property(
        "original_timestamps",
        schemas_exports.list(schemas_exports.number()).optional()
      ),
      generatedTimestamps: schemas_exports.property(
        "generated_timestamps",
        schemas_exports.list(schemas_exports.number()).optional()
      ),
      transcribedWords: schemas_exports.property(
        "transcribed_words",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TranscribedWord)).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TranscribedWord.ts
var TranscribedWord;
var init_TranscribedWord2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TranscribedWord.ts"() {
    "use strict";
    init_core();
    TranscribedWord = schemas_exports.object({
      word: schemas_exports.string(),
      start: schemas_exports.number(),
      end: schemas_exports.number(),
      punctuatedWord: schemas_exports.property("punctuated_word", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/ExportedVideo.ts
var ExportedVideo;
var init_ExportedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/ExportedVideo.ts"() {
    "use strict";
    init_core();
    ExportedVideo = schemas_exports.object({
      createdAt: schemas_exports.property("created_at", schemas_exports.string()),
      exportedVideoSrc: schemas_exports.property("exported_video_src", schemas_exports.string())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoSource.ts
var VideoSource;
var init_VideoSource2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoSource.ts"() {
    "use strict";
    init_core();
    VideoSource = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      src: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/OriginalEdits.ts
var OriginalEdits;
var init_OriginalEdits2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/OriginalEdits.ts"() {
    "use strict";
    init_core();
    OriginalEdits = schemas_exports.object({
      version: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.OriginalEditsVersion).optional(),
      sources: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoSource)
      ),
      clips: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoClip)).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoClip.ts
var VideoClip;
var init_VideoClip2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoClip.ts"() {
    "use strict";
    init_core();
    VideoClip = schemas_exports.object({
      srcId: schemas_exports.property(
        "src_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      startTime: schemas_exports.number(),
      endTime: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/EditedVideo.ts
var EditedVideo;
var init_EditedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/EditedVideo.ts"() {
    "use strict";
    init_core();
    EditedVideo = schemas_exports.object({
      src: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Gender.ts
var Gender2;
var init_Gender2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Gender.ts"() {
    "use strict";
    init_core();
    Gender2 = schemas_exports.enum_(["male", "female"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VoiceEdits.ts
var VoiceEdits;
var init_VoiceEdits2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VoiceEdits.ts"() {
    "use strict";
    init_core();
    VoiceEdits = schemas_exports.object({
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice),
      speed: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Voice.ts
var Voice;
var init_Voice2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Voice.ts"() {
    "use strict";
    init_core();
    Voice = schemas_exports.object({
      code: schemas_exports.string(),
      language: schemas_exports.string().optional(),
      name: schemas_exports.string().optional(),
      gender: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Gender).optional(),
      tags: schemas_exports.list(schemas_exports.string()).optional(),
      engine: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VoiceEngine),
      model: schemas_exports.string().optional(),
      languageCountryId: schemas_exports.property("language_country_id", schemas_exports.string().optional()),
      accent: schemas_exports.string().optional(),
      sample: schemas_exports.string().optional(),
      apiVersion: schemas_exports.property("api_version", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VoiceEngine.ts
var VoiceEngine2;
var init_VoiceEngine2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VoiceEngine.ts"() {
    "use strict";
    init_core();
    VoiceEngine2 = schemas_exports.enum_(["google", "play", "eleven", "wellsaid", "cartesia", "openai"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideRequest.ts
var GuideRequest;
var init_GuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideRequest.ts"() {
    "use strict";
    init_core();
    GuideRequest = schemas_exports.object({
      language: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      guideId: schemas_exports.property(
        "guide_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TranscriptionMatchingErrorBody.ts
var TranscriptionMatchingErrorBody;
var init_TranscriptionMatchingErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TranscriptionMatchingErrorBody.ts"() {
    "use strict";
    init_core();
    TranscriptionMatchingErrorBody = schemas_exports.object({
      words: schemas_exports.list(schemas_exports.string())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/ScreenshotOrderingErrorBody.ts
var ScreenshotOrderingErrorBody;
var init_ScreenshotOrderingErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/ScreenshotOrderingErrorBody.ts"() {
    "use strict";
    init_core();
    ScreenshotOrderingErrorBody = schemas_exports.object({
      screenshotNumber: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/UnsubscribedErrorBody.ts
var UnsubscribedErrorBody;
var init_UnsubscribedErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/UnsubscribedErrorBody.ts"() {
    "use strict";
    init_core();
    UnsubscribedErrorBody = schemas_exports.object({
      orgId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      admins: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserInOrg)).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/UploadFailedErrorBody.ts
var UploadFailedErrorBody;
var init_UploadFailedErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/UploadFailedErrorBody.ts"() {
    "use strict";
    init_core();
    UploadFailedErrorBody = schemas_exports.object({
      reason: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/BlurringErrorBody.ts
var BlurringErrorBody;
var init_BlurringErrorBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/BlurringErrorBody.ts"() {
    "use strict";
    init_core();
    BlurringErrorBody = schemas_exports.object({
      message: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/ErrorRenderingVideoBody.ts
var ErrorRenderingVideoBody;
var init_ErrorRenderingVideoBody2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/ErrorRenderingVideoBody.ts"() {
    "use strict";
    init_core();
    ErrorRenderingVideoBody = schemas_exports.object({
      message: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/OriginalEditsVersion.ts
var OriginalEditsVersion2;
var init_OriginalEditsVersion2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/OriginalEditsVersion.ts"() {
    "use strict";
    init_core();
    OriginalEditsVersion2 = schemas_exports.enum_(["july082024"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Author.ts
var Author;
var init_Author2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Author.ts"() {
    "use strict";
    init_core();
    Author = schemas_exports.object({
      name: schemas_exports.string().optional(),
      email: schemas_exports.string(),
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideCreationType.ts
var GuideCreationType2;
var init_GuideCreationType2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideCreationType.ts"() {
    "use strict";
    init_core();
    GuideCreationType2 = schemas_exports.enum_(["SLIDE_DECK", "VIDEO"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/FileFormat.ts
var FileFormat2;
var init_FileFormat2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/FileFormat.ts"() {
    "use strict";
    init_core();
    FileFormat2 = schemas_exports.enum_(["jpeg", "jpg", "mov", "mp4", "pdf", "png", "ppt", "pptx", "wav", "webm"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/index.ts
var init_types49 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/index.ts"() {
    "use strict";
    init_VideoObject2();
    init_VideoRecordingType2();
    init_PublishedVideoType2();
    init_VideoMetadata2();
    init_PresignedUrlsForGuide2();
    init_PresignedUrlsResponse2();
    init_Guide2();
    init_GuideHeader2();
    init_GuidePreview2();
    init_GuidePlatformStatus2();
    init_OperationError2();
    init_AsyncOperationError2();
    init_YouTubePublishError2();
    init_ExportingVideoYoutubeErrorBody2();
    init_ExportingVideoError2();
    init_YouTubeUploadErrorBody2();
    init_GeneratingVoiceoverError2();
    init_GuideData2();
    init_GuidePlatformData2();
    init_GuideVersion2();
    init_VideoObjectVersion2();
    init_NewVideoObject2();
    init_GuideSettings2();
    init_PlainDoc2();
    init_DocStep2();
    init_AutoProgressable2();
    init_TourStep2();
    init_TourStepMetadata2();
    init_CustomSelector2();
    init_DomElementData2();
    init_GeneratedVideo2();
    init_TranscribedWord2();
    init_ExportedVideo2();
    init_VideoSource2();
    init_OriginalEdits2();
    init_VideoClip2();
    init_EditedVideo2();
    init_Gender2();
    init_VoiceEdits2();
    init_Voice2();
    init_VoiceEngine2();
    init_GuideRequest2();
    init_TranscriptionMatchingErrorBody2();
    init_ScreenshotOrderingErrorBody2();
    init_UnsubscribedErrorBody2();
    init_UploadFailedErrorBody2();
    init_BlurringErrorBody2();
    init_ErrorRenderingVideoBody2();
    init_OriginalEditsVersion2();
    init_Author2();
    init_GuideCreationType2();
    init_FileFormat2();
  }
});

// src/serialization/resources/guides/resources/guideTypes/index.ts
var guideTypes_exports2 = {};
__export(guideTypes_exports2, {
  AsyncOperationError: () => AsyncOperationError2,
  Author: () => Author,
  AutoProgressable: () => AutoProgressable2,
  BlurringErrorBody: () => BlurringErrorBody,
  CustomSelector: () => CustomSelector,
  DocStep: () => DocStep,
  DomElementData: () => DomElementData,
  EditedVideo: () => EditedVideo,
  ErrorRenderingVideoBody: () => ErrorRenderingVideoBody,
  ExportedVideo: () => ExportedVideo,
  ExportingVideoError: () => ExportingVideoError2,
  ExportingVideoYoutubeErrorBody: () => ExportingVideoYoutubeErrorBody,
  FileFormat: () => FileFormat2,
  Gender: () => Gender2,
  GeneratedVideo: () => GeneratedVideo,
  GeneratingVoiceoverError: () => GeneratingVoiceoverError2,
  Guide: () => Guide,
  GuideCreationType: () => GuideCreationType2,
  GuideData: () => GuideData,
  GuideHeader: () => GuideHeader,
  GuidePlatformData: () => GuidePlatformData,
  GuidePlatformStatus: () => GuidePlatformStatus,
  GuidePreview: () => GuidePreview,
  GuideRequest: () => GuideRequest,
  GuideSettings: () => GuideSettings,
  GuideVersion: () => GuideVersion,
  NewVideoObject: () => NewVideoObject,
  OperationError: () => OperationError,
  OriginalEdits: () => OriginalEdits,
  OriginalEditsVersion: () => OriginalEditsVersion2,
  PlainDoc: () => PlainDoc,
  PresignedUrlsForGuide: () => PresignedUrlsForGuide,
  PresignedUrlsResponse: () => PresignedUrlsResponse,
  PublishedVideoType: () => PublishedVideoType2,
  ScreenshotOrderingErrorBody: () => ScreenshotOrderingErrorBody,
  TourStep: () => TourStep,
  TourStepMetadata: () => TourStepMetadata,
  TranscribedWord: () => TranscribedWord,
  TranscriptionMatchingErrorBody: () => TranscriptionMatchingErrorBody,
  UnsubscribedErrorBody: () => UnsubscribedErrorBody,
  UploadFailedErrorBody: () => UploadFailedErrorBody,
  VideoClip: () => VideoClip,
  VideoMetadata: () => VideoMetadata,
  VideoObject: () => VideoObject,
  VideoObjectVersion: () => VideoObjectVersion2,
  VideoRecordingType: () => VideoRecordingType2,
  VideoSource: () => VideoSource,
  Voice: () => Voice,
  VoiceEdits: () => VoiceEdits,
  VoiceEngine: () => VoiceEngine2,
  YouTubePublishError: () => YouTubePublishError2,
  YouTubeUploadErrorBody: () => YouTubeUploadErrorBody
});
var init_guideTypes2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/index.ts"() {
    "use strict";
    init_types49();
  }
});

// src/serialization/resources/guides/resources/prompts/types/GetPromptsResponse.ts
var GetPromptsResponse;
var init_GetPromptsResponse2 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/GetPromptsResponse.ts"() {
    "use strict";
    init_core();
    GetPromptsResponse = schemas_exports.object({
      prompts: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptOption)
      ),
      selectedPrompt: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/prompts/types/PromptType.ts
var PromptType2;
var init_PromptType2 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/PromptType.ts"() {
    "use strict";
    init_core();
    PromptType2 = schemas_exports.enum_(["enhance_article", "enhance_video", "translate_video", "translate_article"]);
  }
});

// src/serialization/resources/guides/resources/prompts/types/Prompt.ts
var Prompt;
var init_Prompt2 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/Prompt.ts"() {
    "use strict";
    init_core();
    Prompt = schemas_exports.object({
      title: schemas_exports.string(),
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      language: schemas_exports.string().optional(),
      prompt: schemas_exports.string(),
      promptType: schemas_exports.property(
        "prompt_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptType)
      )
    });
  }
});

// src/serialization/resources/guides/resources/prompts/types/PromptOption.ts
var PromptOption;
var init_PromptOption2 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/PromptOption.ts"() {
    "use strict";
    init_core();
    PromptOption = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      prompt: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Prompt)
    });
  }
});

// src/serialization/resources/guides/resources/prompts/types/Logo.ts
var Logo;
var init_Logo3 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/Logo.ts"() {
    "use strict";
    init_core();
    Logo = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      src: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/prompts/types/index.ts
var init_types50 = __esm({
  "src/serialization/resources/guides/resources/prompts/types/index.ts"() {
    "use strict";
    init_GetPromptsResponse2();
    init_PromptType2();
    init_Prompt2();
    init_PromptOption2();
    init_Logo3();
  }
});

// src/serialization/resources/guides/resources/prompts/client/getPrompts.ts
var getPrompts_exports2 = {};
__export(getPrompts_exports2, {
  Error: () => Error320
});
var Error320;
var init_getPrompts2 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/getPrompts.ts"() {
    "use strict";
    init_src();
    init_core();
    Error320 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.prompts.getPrompts.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.prompts.getPrompts.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.prompts.getPrompts.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/createPrompt.ts
var createPrompt_exports2 = {};
__export(createPrompt_exports2, {
  Error: () => Error321
});
var Error321;
var init_createPrompt2 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/createPrompt.ts"() {
    "use strict";
    init_src();
    init_core();
    Error321 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.prompts.createPrompt.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.prompts.createPrompt.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.prompts.createPrompt.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/deletePrompt.ts
var deletePrompt_exports2 = {};
__export(deletePrompt_exports2, {
  Error: () => Error322
});
var Error322;
var init_deletePrompt2 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/deletePrompt.ts"() {
    "use strict";
    init_src();
    init_core();
    Error322 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.prompts.deletePrompt.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.prompts.deletePrompt.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.prompts.deletePrompt.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/updatePrompt.ts
var updatePrompt_exports2 = {};
__export(updatePrompt_exports2, {
  Error: () => Error323
});
var Error323;
var init_updatePrompt2 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/updatePrompt.ts"() {
    "use strict";
    init_src();
    init_core();
    Error323 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.prompts.updatePrompt.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.prompts.updatePrompt.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.prompts.updatePrompt.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/applyPrompt.ts
var applyPrompt_exports2 = {};
__export(applyPrompt_exports2, {
  Error: () => Error324
});
var Error324;
var init_applyPrompt2 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/applyPrompt.ts"() {
    "use strict";
    init_src();
    init_core();
    Error324 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.prompts.applyPrompt.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.prompts.applyPrompt.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.prompts.applyPrompt.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/GetPromptsRequest.ts
var GetPromptsRequest;
var init_GetPromptsRequest = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/GetPromptsRequest.ts"() {
    "use strict";
    init_core();
    GetPromptsRequest = schemas_exports.object({
      promptType: schemas_exports.property(
        "prompt_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptType)
      ),
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/CreatePromptRequest.ts
var CreatePromptRequest;
var init_CreatePromptRequest = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/CreatePromptRequest.ts"() {
    "use strict";
    init_core();
    CreatePromptRequest = schemas_exports.object({
      prompt: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Prompt)
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/DeletePromptRequest.ts
var DeletePromptRequest;
var init_DeletePromptRequest = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/DeletePromptRequest.ts"() {
    "use strict";
    init_core();
    DeletePromptRequest = schemas_exports.object({
      prompt: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptOption)
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/UpdatePromptRequest.ts
var UpdatePromptRequest;
var init_UpdatePromptRequest = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/UpdatePromptRequest.ts"() {
    "use strict";
    init_core();
    UpdatePromptRequest = schemas_exports.object({
      prompt: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptOption)
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/ApplyPromptRequest.ts
var ApplyPromptRequest;
var init_ApplyPromptRequest = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/ApplyPromptRequest.ts"() {
    "use strict";
    init_core();
    ApplyPromptRequest = schemas_exports.object({
      promptId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      promptType: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PromptType),
      makeDefault: schemas_exports.property("make_default", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/guides/resources/prompts/client/requests/index.ts
var init_requests22 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/requests/index.ts"() {
    "use strict";
    init_GetPromptsRequest();
    init_CreatePromptRequest();
    init_DeletePromptRequest();
    init_UpdatePromptRequest();
    init_ApplyPromptRequest();
  }
});

// src/serialization/resources/guides/resources/prompts/client/index.ts
var init_client49 = __esm({
  "src/serialization/resources/guides/resources/prompts/client/index.ts"() {
    "use strict";
    init_getPrompts2();
    init_createPrompt2();
    init_deletePrompt2();
    init_updatePrompt2();
    init_applyPrompt2();
    init_requests22();
  }
});

// src/serialization/resources/guides/resources/prompts/index.ts
var prompts_exports2 = {};
__export(prompts_exports2, {
  ApplyPromptRequest: () => ApplyPromptRequest,
  CreatePromptRequest: () => CreatePromptRequest,
  DeletePromptRequest: () => DeletePromptRequest,
  GetPromptsRequest: () => GetPromptsRequest,
  GetPromptsResponse: () => GetPromptsResponse,
  Logo: () => Logo,
  Prompt: () => Prompt,
  PromptOption: () => PromptOption,
  PromptType: () => PromptType2,
  UpdatePromptRequest: () => UpdatePromptRequest,
  applyPrompt: () => applyPrompt_exports2,
  createPrompt: () => createPrompt_exports2,
  deletePrompt: () => deletePrompt_exports2,
  getPrompts: () => getPrompts_exports2,
  updatePrompt: () => updatePrompt_exports2
});
var init_prompts2 = __esm({
  "src/serialization/resources/guides/resources/prompts/index.ts"() {
    "use strict";
    init_types50();
    init_client49();
  }
});

// src/serialization/resources/guides/resources/guidePlatformStatus/client/getStatus.ts
var getStatus_exports2 = {};
__export(getStatus_exports2, {
  Error: () => Error325
});
var Error325;
var init_getStatus2 = __esm({
  "src/serialization/resources/guides/resources/guidePlatformStatus/client/getStatus.ts"() {
    "use strict";
    init_src();
    init_core();
    Error325 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guidePlatformStatus.getStatus.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guidePlatformStatus.getStatus.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guidePlatformStatus.getStatus.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guidePlatformStatus/client/markErrorViewed.ts
var markErrorViewed_exports2 = {};
__export(markErrorViewed_exports2, {
  Error: () => Error326,
  Response: () => Response38
});
var Response38, Error326;
var init_markErrorViewed2 = __esm({
  "src/serialization/resources/guides/resources/guidePlatformStatus/client/markErrorViewed.ts"() {
    "use strict";
    init_core();
    init_src();
    Response38 = schemas_exports.boolean();
    Error326 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guidePlatformStatus.markErrorViewed.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guidePlatformStatus/client/index.ts
var init_client50 = __esm({
  "src/serialization/resources/guides/resources/guidePlatformStatus/client/index.ts"() {
    "use strict";
    init_getStatus2();
    init_markErrorViewed2();
  }
});

// src/serialization/resources/guides/resources/guidePlatformStatus/index.ts
var guidePlatformStatus_exports2 = {};
__export(guidePlatformStatus_exports2, {
  getStatus: () => getStatus_exports2,
  markErrorViewed: () => markErrorViewed_exports2
});
var init_guidePlatformStatus2 = __esm({
  "src/serialization/resources/guides/resources/guidePlatformStatus/index.ts"() {
    "use strict";
    init_client50();
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/search.ts
var search_exports3 = {};
__export(search_exports3, {
  Error: () => Error327,
  Response: () => Response39
});
var Response39, Error327;
var init_search3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/search.ts"() {
    "use strict";
    init_src();
    init_core();
    Response39 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error327 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.search.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.search.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.search.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports3 = {};
__export(getGuidePreviews_exports3, {
  Error: () => Error328,
  Response: () => Response40
});
var Response40, Error328;
var init_getGuidePreviews3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response40 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error328 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuidePreviews.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getGuidePreviews.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getGuidePreviews.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports3 = {};
__export(getAllGuidePreviews_exports3, {
  Error: () => Error329,
  Response: () => Response41
});
var Response41, Error329;
var init_getAllGuidePreviews3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response41 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error329 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getRecentGuidePreviews.ts
var getRecentGuidePreviews_exports2 = {};
__export(getRecentGuidePreviews_exports2, {
  Error: () => Error330,
  Response: () => Response42
});
var Response42, Error330;
var init_getRecentGuidePreviews2 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getRecentGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response42 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error330 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getRecentGuidePreviews.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuideData.ts
var getGuideData_exports3 = {};
__export(getGuideData_exports3, {
  Error: () => Error331
});
var Error331;
var init_getGuideData3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error331 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuideData.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getGuideData.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getGuideData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuidePlatformData.ts
var getGuidePlatformData_exports2 = {};
__export(getGuidePlatformData_exports2, {
  Error: () => Error332
});
var Error332;
var init_getGuidePlatformData2 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuidePlatformData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error332 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuidePlatformData.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getGuidePlatformData.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getGuidePlatformData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuidePreview.ts
var getGuidePreview_exports3 = {};
__export(getGuidePreview_exports3, {
  Error: () => Error333
});
var Error333;
var init_getGuidePreview3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error333 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      NoAccessError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.queryFailedError();
          case "NoAccessError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.noAccessError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getAllVersions.ts
var getAllVersions_exports2 = {};
__export(getAllVersions_exports2, {
  Error: () => Error334,
  Response: () => Response43
});
var Response43, Error334;
var init_getAllVersions2 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getAllVersions.ts"() {
    "use strict";
    init_src();
    init_core();
    Response43 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideVersion)
    );
    Error334 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getAllVersions.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideQueries.getAllVersions.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.guides.guideQueries.getAllVersions.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.guides.guideQueries.getAllVersions.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/SearchRequest.ts
var SearchRequest;
var init_SearchRequest = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/SearchRequest.ts"() {
    "use strict";
    init_core();
    SearchRequest = schemas_exports.object({
      text: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/index.ts
var init_requests23 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/index.ts"() {
    "use strict";
    init_SearchRequest();
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/index.ts
var init_client51 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/index.ts"() {
    "use strict";
    init_search3();
    init_getGuidePreviews3();
    init_getAllGuidePreviews3();
    init_getRecentGuidePreviews2();
    init_getGuideData3();
    init_getGuidePlatformData2();
    init_getGuidePreview3();
    init_getAllVersions2();
    init_requests23();
  }
});

// src/serialization/resources/guides/resources/guideQueries/index.ts
var guideQueries_exports2 = {};
__export(guideQueries_exports2, {
  SearchRequest: () => SearchRequest,
  getAllGuidePreviews: () => getAllGuidePreviews_exports3,
  getAllVersions: () => getAllVersions_exports2,
  getGuideData: () => getGuideData_exports3,
  getGuidePlatformData: () => getGuidePlatformData_exports2,
  getGuidePreview: () => getGuidePreview_exports3,
  getGuidePreviews: () => getGuidePreviews_exports3,
  getRecentGuidePreviews: () => getRecentGuidePreviews_exports2,
  search: () => search_exports3
});
var init_guideQueries2 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/index.ts"() {
    "use strict";
    init_client51();
  }
});

// src/serialization/resources/guides/resources/index.ts
var init_resources10 = __esm({
  "src/serialization/resources/guides/resources/index.ts"() {
    "use strict";
    init_aiEnhance2();
    init_types43();
    init_broadcasts2();
    init_types44();
    init_guideAiChat2();
    init_types45();
    init_guideExports2();
    init_types46();
    init_guideMutations2();
    init_types47();
    init_guideQueryCore2();
    init_types48();
    init_guideTypes2();
    init_types49();
    init_prompts2();
    init_types50();
    init_guidePlatformStatus2();
    init_guideQueries2();
    init_requests19();
    init_requests20();
    init_requests21();
    init_requests23();
    init_requests22();
  }
});

// src/serialization/resources/guides/index.ts
var guides_exports2 = {};
__export(guides_exports2, {
  AdvancedSettings: () => AdvancedSettings2,
  ApplyPromptRequest: () => ApplyPromptRequest,
  AsyncOperationError: () => AsyncOperationError2,
  Author: () => Author,
  AutoProgressable: () => AutoProgressable2,
  AutoUpdateGuideRequest: () => AutoUpdateGuideRequest,
  BlurringErrorBody: () => BlurringErrorBody,
  Broadcast: () => Broadcast,
  BroadcastBot: () => BroadcastBot,
  BroadcastPlatform: () => BroadcastPlatform2,
  BroadcastStatus: () => BroadcastStatus2,
  CompileVideoRequest: () => CompileVideoRequest,
  CompileVideoResponse: () => CompileVideoResponse,
  ConvertToGifResponse: () => ConvertToGifResponse,
  CreateBroadcastRequest: () => CreateBroadcastRequest,
  CreateEmptyTextGuideRequest: () => CreateEmptyTextGuideRequest,
  CreatePromptRequest: () => CreatePromptRequest,
  CustomSelector: () => CustomSelector,
  CustomizeBroadcastBotRequest: () => CustomizeBroadcastBotRequest,
  DeleteChatForAGuideRequest: () => DeleteChatForAGuideRequest,
  DeleteGuideRequest: () => DeleteGuideRequest,
  DeleteMessageByIdRequest: () => DeleteMessageByIdRequest,
  DeletePromptRequest: () => DeletePromptRequest,
  DocStep: () => DocStep,
  DomElementData: () => DomElementData,
  EditedVideo: () => EditedVideo,
  EnhanceTextRequest: () => EnhanceTextRequest,
  ErrorRenderingVideoBody: () => ErrorRenderingVideoBody,
  ExportArticleResponse: () => ExportArticleResponse,
  ExportDetails: () => ExportDetails,
  ExportExecutionSpeed: () => ExportExecutionSpeed2,
  ExportGifRequest: () => ExportGifRequest,
  ExportGuideResponse: () => ExportGuideResponse,
  ExportProcess: () => ExportProcess2,
  ExportProcessType: () => ExportProcessType2,
  ExportRequest: () => ExportRequest,
  ExportStatus: () => ExportStatus2,
  ExportedVideo: () => ExportedVideo,
  ExportingVideoError: () => ExportingVideoError2,
  ExportingVideoYoutubeErrorBody: () => ExportingVideoYoutubeErrorBody,
  FileFormat: () => FileFormat2,
  FinishCreateGuideRequest: () => FinishCreateGuideRequest,
  FinishUpdateGuideDataRequest: () => FinishUpdateGuideDataRequest,
  FinishUploadAndSuggestSplitsRequest: () => FinishUploadAndSuggestSplitsRequest,
  FinishUploadCreate: () => FinishUploadCreate,
  FinishUploadSourceRequest: () => FinishUploadSourceRequest,
  Gender: () => Gender2,
  GenerateBookendsVideoRequest: () => GenerateBookendsVideoRequest,
  GenerateGuidesBasedonSplitsRequest: () => GenerateGuidesBasedonSplitsRequest,
  GenerateVideoRequest: () => GenerateVideoRequest,
  GenerateVoiceoverRequest: () => GenerateVoiceoverRequest,
  GeneratedVideo: () => GeneratedVideo,
  GeneratingVoiceoverError: () => GeneratingVoiceoverError2,
  GetBroadcastResponse: () => GetBroadcastResponse,
  GetGuideDataRequest: () => GetGuideDataRequest,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest,
  GetPastExportsRequest: () => GetPastExportsRequest,
  GetPastExportsResponse: () => GetPastExportsResponse,
  GetPromptsRequest: () => GetPromptsRequest,
  GetPromptsResponse: () => GetPromptsResponse,
  GifSettings: () => GifSettings,
  Guide: () => Guide,
  GuideAiChatContentType: () => GuideAiChatContentType2,
  GuideAiChatMessage: () => GuideAiChatMessage,
  GuideAiChatSenderRole: () => GuideAiChatSenderRole2,
  GuideCreationType: () => GuideCreationType2,
  GuideData: () => GuideData,
  GuideHeader: () => GuideHeader,
  GuidePlatformData: () => GuidePlatformData,
  GuidePlatformStatus: () => GuidePlatformStatus,
  GuidePreview: () => GuidePreview,
  GuideRequest: () => GuideRequest,
  GuideSettings: () => GuideSettings,
  GuideVersion: () => GuideVersion,
  InitiateCreateGuideRequest: () => InitiateCreateGuideRequest,
  InitiateCreateVideoGuideResponse: () => InitiateCreateVideoGuideResponse,
  InitiateUploadAndSuggestSplitsRequest: () => InitiateUploadAndSuggestSplitsRequest,
  InitiateUploadAndSuggestSplitsResponse: () => InitiateUploadAndSuggestSplitsResponse,
  InitiateUploadCreateRequest: () => InitiateUploadCreateRequest,
  InitiateUploadCreateResponse: () => InitiateUploadCreateResponse,
  InitiateUploadSourceRequest: () => InitiateUploadSourceRequest,
  Logo: () => Logo,
  MasterDataForVideoExporter: () => MasterDataForVideoExporter,
  MoveGuideRequest: () => MoveGuideRequest,
  NewVideoObject: () => NewVideoObject,
  OperationError: () => OperationError,
  OriginalEdits: () => OriginalEdits,
  OriginalEditsVersion: () => OriginalEditsVersion2,
  PinGuideRequest: () => PinGuideRequest,
  PlainDoc: () => PlainDoc,
  PlainDocRequest: () => PlainDocRequest,
  PptAdvancedSettings: () => PptAdvancedSettings,
  PptContentMode: () => PptContentMode2,
  PresignedUrlsForGuide: () => PresignedUrlsForGuide,
  PresignedUrlsResponse: () => PresignedUrlsResponse,
  Prompt: () => Prompt,
  PromptOption: () => PromptOption,
  PromptType: () => PromptType2,
  PublishGuideRequest: () => PublishGuideRequest,
  PublishGuideV2Request: () => PublishGuideV2Request,
  PublishGuideV2Response: () => PublishGuideV2Response,
  PublishedVideoType: () => PublishedVideoType2,
  ReorderGuideRequest: () => ReorderGuideRequest,
  RestoreVersionRequest: () => RestoreVersionRequest,
  RestoreVersionResponse: () => RestoreVersionResponse,
  ScreenshotOrderingErrorBody: () => ScreenshotOrderingErrorBody,
  SearchRequest: () => SearchRequest,
  SendBroadcastRequest: () => SendBroadcastRequest,
  SendMessageRequest: () => SendMessageRequest,
  TourStep: () => TourStep,
  TourStepMetadata: () => TourStepMetadata,
  TranscribedWord: () => TranscribedWord,
  TranscriptionMatchingErrorBody: () => TranscriptionMatchingErrorBody,
  TranslateGuideRequest: () => TranslateGuideRequest,
  UnsubscribedErrorBody: () => UnsubscribedErrorBody,
  UpdateBroadcastRequest: () => UpdateBroadcastRequest,
  UpdateLatestThumbnailRequest: () => UpdateLatestThumbnailRequest,
  UpdateOriginalEditsRequest: () => UpdateOriginalEditsRequest,
  UpdatePromptRequest: () => UpdatePromptRequest,
  UploadChunkRequest: () => UploadChunkRequest,
  UploadFailedErrorBody: () => UploadFailedErrorBody,
  ValidateGuideUrlRequest: () => ValidateGuideUrlRequest,
  ValidateGuideUrlResponse: () => ValidateGuideUrlResponse,
  VideoClip: () => VideoClip,
  VideoMetadata: () => VideoMetadata,
  VideoObject: () => VideoObject,
  VideoObjectVersion: () => VideoObjectVersion2,
  VideoRecordingType: () => VideoRecordingType2,
  VideoSettings: () => VideoSettings,
  VideoSource: () => VideoSource,
  Voice: () => Voice,
  VoiceEdits: () => VoiceEdits,
  VoiceEngine: () => VoiceEngine2,
  YouTubePublishError: () => YouTubePublishError2,
  YouTubeUploadErrorBody: () => YouTubeUploadErrorBody,
  aiEnhance: () => aiEnhance_exports2,
  broadcasts: () => broadcasts_exports2,
  guideAiChat: () => guideAiChat_exports2,
  guideExports: () => guideExports_exports2,
  guideMutations: () => guideMutations_exports2,
  guidePlatformStatus: () => guidePlatformStatus_exports2,
  guideQueries: () => guideQueries_exports2,
  guideQueryCore: () => guideQueryCore_exports2,
  guideTypes: () => guideTypes_exports2,
  prompts: () => prompts_exports2
});
var init_guides2 = __esm({
  "src/serialization/resources/guides/index.ts"() {
    "use strict";
    init_resources10();
  }
});

// src/serialization/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts
var InvalidSessionErrorBody;
var init_InvalidSessionErrorBody2 = __esm({
  "src/serialization/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts"() {
    "use strict";
    init_core();
    InvalidSessionErrorBody = schemas_exports.object({
      redirectUrl: schemas_exports.string().optional(),
      passwordRequired: schemas_exports.boolean().optional(),
      socialSignIn: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/helpcenterQueries/types/OrgAndConfig.ts
var OrgAndConfig;
var init_OrgAndConfig2 = __esm({
  "src/serialization/resources/helpcenterQueries/types/OrgAndConfig.ts"() {
    "use strict";
    init_core();
    OrgAndConfig = schemas_exports.object({
      organization: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization),
      config: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).HelpCenterConfig)
    });
  }
});

// src/serialization/resources/helpcenterQueries/types/index.ts
var init_types51 = __esm({
  "src/serialization/resources/helpcenterQueries/types/index.ts"() {
    "use strict";
    init_InvalidSessionErrorBody2();
    init_OrgAndConfig2();
  }
});

// src/serialization/resources/helpcenterQueries/client/validateToken.ts
var validateToken_exports2 = {};
__export(validateToken_exports2, {
  Error: () => Error335,
  Response: () => Response44
});
var Response44, Error335;
var init_validateToken2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/validateToken.ts"() {
    "use strict";
    init_core();
    init_src();
    Response44 = schemas_exports.string();
    Error335 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.helpcenterQueries.validateToken.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.validateToken.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.validateToken.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getOrganization.ts
var getOrganization_exports3 = {};
__export(getOrganization_exports3, {
  Error: () => Error336
});
var Error336;
var init_getOrganization3 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error336 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getOrganization.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getOrganization.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getOrgAndConfig.ts
var getOrgAndConfig_exports2 = {};
__export(getOrgAndConfig_exports2, {
  Error: () => Error337
});
var Error337;
var init_getOrgAndConfig2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getOrgAndConfig.ts"() {
    "use strict";
    init_src();
    init_core();
    Error337 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getOrgAndConfig.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getOrgAndConfig.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getOrgAndConfig.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/search.ts
var search_exports4 = {};
__export(search_exports4, {
  Error: () => Error338,
  Response: () => Response45
});
var Response45, Error338;
var init_search4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/search.ts"() {
    "use strict";
    init_src();
    init_core();
    Response45 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error338 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.search.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.search.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.search.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports4 = {};
__export(getGuidePreviews_exports4, {
  Error: () => Error339,
  Response: () => Response46
});
var Response46, Error339;
var init_getGuidePreviews4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response46 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error339 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuidePreviews.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getGuidePreviews.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getGuidePreviews.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports4 = {};
__export(getAllGuidePreviews_exports4, {
  Error: () => Error340,
  Response: () => Response47
});
var Response47, Error340;
var init_getAllGuidePreviews4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response47 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error340 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuideData.ts
var getGuideData_exports4 = {};
__export(getGuideData_exports4, {
  Error: () => Error341
});
var Error341;
var init_getGuideData4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error341 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuideData.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getGuideData.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getGuideData.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuidePreview.ts
var getGuidePreview_exports4 = {};
__export(getGuidePreview_exports4, {
  Error: () => Error342
});
var Error342;
var init_getGuidePreview4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error342 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.invalidSessionError(value.content);
          case "QueryFailedError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getCollections.ts
var getCollections_exports4 = {};
__export(getCollections_exports4, {
  Error: () => Error343
});
var Error343;
var init_getCollections4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Error343 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getCollections.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getCollections.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getCollections.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllChildren.ts
var getAllChildren_exports4 = {};
__export(getAllChildren_exports4, {
  Error: () => Error344
});
var Error344;
var init_getAllChildren4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    init_core();
    Error344 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllChildren.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getAllChildren.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getAllChildren.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllCollections.ts
var getAllCollections_exports4 = {};
__export(getAllCollections_exports4, {
  Error: () => Error345,
  Response: () => Response48
});
var Response48, Error345;
var init_getAllCollections4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Response48 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
    );
    Error345 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllCollections.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getAllCollections.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getAllCollections.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getPath.ts
var getPath_exports4 = {};
__export(getPath_exports4, {
  Error: () => Error346
});
var Error346;
var init_getPath4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error346 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getPath.Error.invalidSessionError(value.content);
          case "UsageLimitExceededError":
            return api_exports.helpcenterQueries.getPath.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.helpcenterQueries.getPath.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/SearchRequest.ts
var SearchRequest2;
var init_SearchRequest2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/SearchRequest.ts"() {
    "use strict";
    init_core();
    SearchRequest2 = schemas_exports.object({
      text: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/index.ts
var init_requests24 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/index.ts"() {
    "use strict";
    init_SearchRequest2();
  }
});

// src/serialization/resources/helpcenterQueries/client/index.ts
var init_client52 = __esm({
  "src/serialization/resources/helpcenterQueries/client/index.ts"() {
    "use strict";
    init_validateToken2();
    init_getOrganization3();
    init_getOrgAndConfig2();
    init_search4();
    init_getGuidePreviews4();
    init_getAllGuidePreviews4();
    init_getGuideData4();
    init_getGuidePreview4();
    init_getCollections4();
    init_getAllChildren4();
    init_getAllCollections4();
    init_getPath4();
    init_requests24();
  }
});

// src/serialization/resources/helpcenterQueries/index.ts
var helpcenterQueries_exports2 = {};
__export(helpcenterQueries_exports2, {
  InvalidSessionErrorBody: () => InvalidSessionErrorBody,
  OrgAndConfig: () => OrgAndConfig,
  SearchRequest: () => SearchRequest2,
  getAllChildren: () => getAllChildren_exports4,
  getAllCollections: () => getAllCollections_exports4,
  getAllGuidePreviews: () => getAllGuidePreviews_exports4,
  getCollections: () => getCollections_exports4,
  getGuideData: () => getGuideData_exports4,
  getGuidePreview: () => getGuidePreview_exports4,
  getGuidePreviews: () => getGuidePreviews_exports4,
  getOrgAndConfig: () => getOrgAndConfig_exports2,
  getOrganization: () => getOrganization_exports3,
  getPath: () => getPath_exports4,
  search: () => search_exports4,
  validateToken: () => validateToken_exports2
});
var init_helpcenterQueries2 = __esm({
  "src/serialization/resources/helpcenterQueries/index.ts"() {
    "use strict";
    init_types51();
    init_client52();
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupRequest.ts
var CustomDomainSetupRequest;
var init_CustomDomainSetupRequest2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupRequest.ts"() {
    "use strict";
    init_core();
    CustomDomainSetupRequest = schemas_exports.object({
      domain: schemas_exports.string(),
      helpcenterId: schemas_exports.property("helpcenter_id", schemas_exports.string())
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupResponse.ts
var CustomDomainSetupResponse;
var init_CustomDomainSetupResponse2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/CustomDomainSetupResponse.ts"() {
    "use strict";
    init_core();
    CustomDomainSetupResponse = schemas_exports.object({
      sslValidationEntry: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.DnsEntry),
      domainEntry: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.DnsEntry)
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/DnsEntry.ts
var DnsEntry;
var init_DnsEntry2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/DnsEntry.ts"() {
    "use strict";
    init_core();
    DnsEntry = schemas_exports.object({
      type: schemas_exports.string(),
      name: schemas_exports.string(),
      value: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/UpdateOrValidateDnsRecordRequest.ts
var UpdateOrValidateDnsRecordRequest;
var init_UpdateOrValidateDnsRecordRequest2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/UpdateOrValidateDnsRecordRequest.ts"() {
    "use strict";
    init_core();
    UpdateOrValidateDnsRecordRequest = schemas_exports.object({
      newRecord: schemas_exports.property("new_record", schemas_exports.string()),
      helpcenterId: schemas_exports.property("helpcenter_id", schemas_exports.string())
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/GetDnsStatusResponse.ts
var GetDnsStatusResponse;
var init_GetDnsStatusResponse2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/GetDnsStatusResponse.ts"() {
    "use strict";
    init_core();
    GetDnsStatusResponse = schemas_exports.object({
      status: schemas_exports.string(),
      hostname: schemas_exports.string(),
      verificationDetails: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.CustomDomainSetupResponse).optional()
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/GetHelpCentersUrlsResponse.ts
var GetHelpCentersUrlsResponse;
var init_GetHelpCentersUrlsResponse2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/GetHelpCentersUrlsResponse.ts"() {
    "use strict";
    init_core();
    GetHelpCentersUrlsResponse = schemas_exports.object({
      mainUrl: schemas_exports.string(),
      stagingUrl: schemas_exports.string(),
      helpcenterId: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/ValidateDnsRecordResponse.ts
var ValidateDnsRecordResponse;
var init_ValidateDnsRecordResponse2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/ValidateDnsRecordResponse.ts"() {
    "use strict";
    init_core();
    ValidateDnsRecordResponse = schemas_exports.object({
      isValid: schemas_exports.boolean(),
      isAvailable: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/VerifyDnsRecordResponse.ts
var VerifyDnsRecordResponse;
var init_VerifyDnsRecordResponse2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/VerifyDnsRecordResponse.ts"() {
    "use strict";
    init_core();
    VerifyDnsRecordResponse = schemas_exports.object({
      status: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.DnsVerificationStatus),
      message: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/DnsVerificationStatus.ts
var DnsVerificationStatus2;
var init_DnsVerificationStatus2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/DnsVerificationStatus.ts"() {
    "use strict";
    init_core();
    DnsVerificationStatus2 = schemas_exports.enum_(["VERIFIED", "FAILED", "PENDING"]);
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/types/index.ts
var init_types52 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/types/index.ts"() {
    "use strict";
    init_CustomDomainSetupRequest2();
    init_CustomDomainSetupResponse2();
    init_DnsEntry2();
    init_UpdateOrValidateDnsRecordRequest2();
    init_GetDnsStatusResponse2();
    init_GetHelpCentersUrlsResponse2();
    init_ValidateDnsRecordResponse2();
    init_VerifyDnsRecordResponse2();
    init_DnsVerificationStatus2();
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/getDnsStatus.ts
var getDnsStatus_exports2 = {};
__export(getDnsStatus_exports2, {
  Error: () => Error347,
  Response: () => Response49
});
var Response49, Error347;
var init_getDnsStatus2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/getDnsStatus.ts"() {
    "use strict";
    init_src();
    init_core();
    Response49 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.GetDnsStatusResponse)
    );
    Error347 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/validateDnsRecord.ts
var validateDnsRecord_exports2 = {};
__export(validateDnsRecord_exports2, {
  Error: () => Error348
});
var Error348;
var init_validateDnsRecord2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/validateDnsRecord.ts"() {
    "use strict";
    init_src();
    init_core();
    Error348 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/updateDnsRecord.ts
var updateDnsRecord_exports2 = {};
__export(updateDnsRecord_exports2, {
  Error: () => Error349,
  Response: () => Response50
});
var Response50, Error349;
var init_updateDnsRecord2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/updateDnsRecord.ts"() {
    "use strict";
    init_core();
    init_src();
    Response50 = schemas_exports.string();
    Error349 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      RecordAlreadyInUseError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error.unauthorizedError();
          case "RecordAlreadyInUseError":
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error.recordAlreadyInUseError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/customDomainSetup.ts
var customDomainSetup_exports2 = {};
__export(customDomainSetup_exports2, {
  Error: () => Error350
});
var Error350;
var init_customDomainSetup2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/customDomainSetup.ts"() {
    "use strict";
    init_src();
    init_core();
    Error350 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      RecordAlreadyInUseError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error.queryFailedError();
          case "RecordAlreadyInUseError":
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error.recordAlreadyInUseError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/deleteDomain.ts
var deleteDomain_exports2 = {};
__export(deleteDomain_exports2, {
  Error: () => Error351,
  Response: () => Response51
});
var Response51, Error351;
var init_deleteDomain2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/deleteDomain.ts"() {
    "use strict";
    init_core();
    init_src();
    Response51 = schemas_exports.boolean();
    Error351 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.deleteDomain.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/verifyDomainSetup.ts
var verifyDomainSetup_exports2 = {};
__export(verifyDomainSetup_exports2, {
  Error: () => Error352
});
var Error352;
var init_verifyDomainSetup2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/verifyDomainSetup.ts"() {
    "use strict";
    init_src();
    init_core();
    Error352 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/getHelpcenterUrls.ts
var getHelpcenterUrls_exports2 = {};
__export(getHelpcenterUrls_exports2, {
  Error: () => Error353,
  Response: () => Response52
});
var Response52, Error353;
var init_getHelpcenterUrls2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/getHelpcenterUrls.ts"() {
    "use strict";
    init_src();
    init_core();
    Response52 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).helpcenter.GetHelpCentersUrlsResponse)
    );
    Error353 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/client/index.ts
var init_client53 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/client/index.ts"() {
    "use strict";
    init_getDnsStatus2();
    init_validateDnsRecord2();
    init_updateDnsRecord2();
    init_customDomainSetup2();
    init_deleteDomain2();
    init_verifyDomainSetup2();
    init_getHelpcenterUrls2();
  }
});

// src/serialization/resources/helpcenter/resources/helpcenterMutations/index.ts
var helpcenterMutations_exports2 = {};
__export(helpcenterMutations_exports2, {
  CustomDomainSetupRequest: () => CustomDomainSetupRequest,
  CustomDomainSetupResponse: () => CustomDomainSetupResponse,
  DnsEntry: () => DnsEntry,
  DnsVerificationStatus: () => DnsVerificationStatus2,
  GetDnsStatusResponse: () => GetDnsStatusResponse,
  GetHelpCentersUrlsResponse: () => GetHelpCentersUrlsResponse,
  UpdateOrValidateDnsRecordRequest: () => UpdateOrValidateDnsRecordRequest,
  ValidateDnsRecordResponse: () => ValidateDnsRecordResponse,
  VerifyDnsRecordResponse: () => VerifyDnsRecordResponse,
  customDomainSetup: () => customDomainSetup_exports2,
  deleteDomain: () => deleteDomain_exports2,
  getDnsStatus: () => getDnsStatus_exports2,
  getHelpcenterUrls: () => getHelpcenterUrls_exports2,
  updateDnsRecord: () => updateDnsRecord_exports2,
  validateDnsRecord: () => validateDnsRecord_exports2,
  verifyDomainSetup: () => verifyDomainSetup_exports2
});
var init_helpcenterMutations2 = __esm({
  "src/serialization/resources/helpcenter/resources/helpcenterMutations/index.ts"() {
    "use strict";
    init_types52();
    init_client53();
  }
});

// src/serialization/resources/helpcenter/resources/index.ts
var init_resources11 = __esm({
  "src/serialization/resources/helpcenter/resources/index.ts"() {
    "use strict";
    init_helpcenterMutations2();
    init_types52();
  }
});

// src/serialization/resources/helpcenter/index.ts
var helpcenter_exports2 = {};
__export(helpcenter_exports2, {
  CustomDomainSetupRequest: () => CustomDomainSetupRequest,
  CustomDomainSetupResponse: () => CustomDomainSetupResponse,
  DnsEntry: () => DnsEntry,
  DnsVerificationStatus: () => DnsVerificationStatus2,
  GetDnsStatusResponse: () => GetDnsStatusResponse,
  GetHelpCentersUrlsResponse: () => GetHelpCentersUrlsResponse,
  UpdateOrValidateDnsRecordRequest: () => UpdateOrValidateDnsRecordRequest,
  ValidateDnsRecordResponse: () => ValidateDnsRecordResponse,
  VerifyDnsRecordResponse: () => VerifyDnsRecordResponse,
  helpcenterMutations: () => helpcenterMutations_exports2
});
var init_helpcenter2 = __esm({
  "src/serialization/resources/helpcenter/index.ts"() {
    "use strict";
    init_resources11();
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/GetIntegrationAuthUrlRequest.ts
var GetIntegrationAuthUrlRequest;
var init_GetIntegrationAuthUrlRequest2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/GetIntegrationAuthUrlRequest.ts"() {
    "use strict";
    init_core();
    GetIntegrationAuthUrlRequest = schemas_exports.object({
      sourceUrl: schemas_exports.string()
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationAuthUrlResponse.ts
var IntegrationAuthUrlResponse;
var init_IntegrationAuthUrlResponse2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationAuthUrlResponse.ts"() {
    "use strict";
    init_core();
    IntegrationAuthUrlResponse = schemas_exports.object({
      isConnected: schemas_exports.property("is_connected", schemas_exports.boolean()),
      integrationDetails: schemas_exports.property(
        "integration_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.IntegrationDetails).optional()
      ),
      authUrl: schemas_exports.property("auth_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationOAuthCallbackRequest.ts
var IntegrationOAuthCallbackRequest;
var init_IntegrationOAuthCallbackRequest2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationOAuthCallbackRequest.ts"() {
    "use strict";
    init_core();
    IntegrationOAuthCallbackRequest = schemas_exports.object({
      code: schemas_exports.string(),
      state: schemas_exports.string().optional(),
      sourceUrl: schemas_exports.string()
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/DisconnectIntegrationRequest.ts
var DisconnectIntegrationRequest;
var init_DisconnectIntegrationRequest2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/DisconnectIntegrationRequest.ts"() {
    "use strict";
    init_core();
    DisconnectIntegrationRequest = schemas_exports.object({
      sourceUrl: schemas_exports.property("source_url", schemas_exports.string())
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationDetails.ts
var IntegrationDetails;
var init_IntegrationDetails2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationDetails.ts"() {
    "use strict";
    init_core();
    IntegrationDetails = schemas_exports.object({
      accountEmail: schemas_exports.property("account_email", schemas_exports.string().optional()),
      accountName: schemas_exports.property("account_name", schemas_exports.string().optional()),
      accountIcon: schemas_exports.property("account_icon", schemas_exports.string().optional()),
      tokenExpiresAt: schemas_exports.property("token_expires_at", schemas_exports.date().optional())
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationApp.ts
var IntegrationApp2;
var init_IntegrationApp2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/IntegrationApp.ts"() {
    "use strict";
    init_core();
    IntegrationApp2 = schemas_exports.enum_(["slack", "youtube", "discord", "whatsapp", "teams"]);
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/LoadIntegrationsResponse.ts
var LoadIntegrationsResponse;
var init_LoadIntegrationsResponse2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/LoadIntegrationsResponse.ts"() {
    "use strict";
    init_core();
    LoadIntegrationsResponse = schemas_exports.object({
      connectedIntegrations: schemas_exports.property(
        "connected_integrations",
        schemas_exports.list(
          schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.IntegrationApp)
        )
      )
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/types/index.ts
var init_types53 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/types/index.ts"() {
    "use strict";
    init_GetIntegrationAuthUrlRequest2();
    init_IntegrationAuthUrlResponse2();
    init_IntegrationOAuthCallbackRequest2();
    init_DisconnectIntegrationRequest2();
    init_IntegrationDetails2();
    init_IntegrationApp2();
    init_LoadIntegrationsResponse2();
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/client/loadIntegrations.ts
var loadIntegrations_exports2 = {};
__export(loadIntegrations_exports2, {
  Error: () => Error354
});
var Error354;
var init_loadIntegrations2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/client/loadIntegrations.ts"() {
    "use strict";
    init_src();
    init_core();
    Error354 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.integrationSetup.loadIntegrations.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.integrationSetup.loadIntegrations.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.integrationSetup.loadIntegrations.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/client/index.ts
var init_client54 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/client/index.ts"() {
    "use strict";
    init_loadIntegrations2();
  }
});

// src/serialization/resources/integrations/resources/integrationSetup/index.ts
var integrationSetup_exports2 = {};
__export(integrationSetup_exports2, {
  DisconnectIntegrationRequest: () => DisconnectIntegrationRequest,
  GetIntegrationAuthUrlRequest: () => GetIntegrationAuthUrlRequest,
  IntegrationApp: () => IntegrationApp2,
  IntegrationAuthUrlResponse: () => IntegrationAuthUrlResponse,
  IntegrationDetails: () => IntegrationDetails,
  IntegrationOAuthCallbackRequest: () => IntegrationOAuthCallbackRequest,
  LoadIntegrationsResponse: () => LoadIntegrationsResponse,
  loadIntegrations: () => loadIntegrations_exports2
});
var init_integrationSetup2 = __esm({
  "src/serialization/resources/integrations/resources/integrationSetup/index.ts"() {
    "use strict";
    init_types53();
    init_client54();
  }
});

// src/serialization/resources/integrations/resources/slack/types/WorkspaceStatusResponse.ts
var WorkspaceStatusResponse;
var init_WorkspaceStatusResponse2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/WorkspaceStatusResponse.ts"() {
    "use strict";
    init_core();
    WorkspaceStatusResponse = schemas_exports.object({
      isConnected: schemas_exports.property("is_connected", schemas_exports.boolean()),
      workspaceInfo: schemas_exports.property(
        "workspace_info",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.WorkspaceInfo).optional()
      )
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/WorkspaceInfo.ts
var WorkspaceInfo;
var init_WorkspaceInfo2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/WorkspaceInfo.ts"() {
    "use strict";
    init_core();
    WorkspaceInfo = schemas_exports.object({
      teamId: schemas_exports.property("team_id", schemas_exports.string()),
      teamName: schemas_exports.property("team_name", schemas_exports.string()),
      teamUrl: schemas_exports.property("team_url", schemas_exports.string()),
      connectedAt: schemas_exports.property("connected_at", schemas_exports.date())
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/ChannelsResponse.ts
var ChannelsResponse;
var init_ChannelsResponse2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/ChannelsResponse.ts"() {
    "use strict";
    init_core();
    ChannelsResponse = schemas_exports.object({
      channels: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.SlackChannel)
      ),
      selectedChannels: schemas_exports.property(
        "selected_channels",
        schemas_exports.list(schemas_exports.string())
      )
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/SlackChannel.ts
var SlackChannel;
var init_SlackChannel2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/SlackChannel.ts"() {
    "use strict";
    init_core();
    SlackChannel = schemas_exports.object({
      id: schemas_exports.string(),
      name: schemas_exports.string(),
      isPrivate: schemas_exports.property("is_private", schemas_exports.boolean().optional()),
      memberCount: schemas_exports.property("member_count", schemas_exports.number().optional()),
      selected: schemas_exports.boolean().optional(),
      isExternal: schemas_exports.property("is_external", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/SlackChannelConfig.ts
var SlackChannelConfig;
var init_SlackChannelConfig2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/SlackChannelConfig.ts"() {
    "use strict";
    init_core();
    SlackChannelConfig = schemas_exports.object({
      channelId: schemas_exports.property("channel_id", schemas_exports.string()),
      enabledAnnouncements: schemas_exports.property(
        "enabled_announcements",
        schemas_exports.list(
          schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.AnnouncementType)
        )
      )
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/AppearanceSettings.ts
var AppearanceSettings;
var init_AppearanceSettings2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/AppearanceSettings.ts"() {
    "use strict";
    init_core();
    AppearanceSettings = schemas_exports.object({
      defaultBotName: schemas_exports.property("default_bot_name", schemas_exports.string()),
      iconUrl: schemas_exports.property("icon_url", schemas_exports.string().optional()),
      iconEmoji: schemas_exports.property("icon_emoji", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/MessageCustomization.ts
var MessageCustomization;
var init_MessageCustomization2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/MessageCustomization.ts"() {
    "use strict";
    init_core();
    MessageCustomization = schemas_exports.object({
      botName: schemas_exports.property("bot_name", schemas_exports.string().optional()),
      iconUrl: schemas_exports.property("icon_url", schemas_exports.string().optional()),
      iconEmoji: schemas_exports.property("icon_emoji", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/AnnouncementType.ts
var AnnouncementType2;
var init_AnnouncementType2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/AnnouncementType.ts"() {
    "use strict";
    init_core();
    AnnouncementType2 = schemas_exports.enum_(["new_guide_published", "guide_updated", "new_team_member", "custom_announcement"]);
  }
});

// src/serialization/resources/integrations/resources/slack/types/FailedChannel.ts
var FailedChannel;
var init_FailedChannel2 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/FailedChannel.ts"() {
    "use strict";
    init_core();
    FailedChannel = schemas_exports.object({
      channelId: schemas_exports.property("channel_id", schemas_exports.string()),
      errorMessage: schemas_exports.property("error_message", schemas_exports.string())
    });
  }
});

// src/serialization/resources/integrations/resources/slack/types/index.ts
var init_types54 = __esm({
  "src/serialization/resources/integrations/resources/slack/types/index.ts"() {
    "use strict";
    init_WorkspaceStatusResponse2();
    init_WorkspaceInfo2();
    init_ChannelsResponse2();
    init_SlackChannel2();
    init_SlackChannelConfig2();
    init_AppearanceSettings2();
    init_MessageCustomization2();
    init_AnnouncementType2();
    init_FailedChannel2();
  }
});

// src/serialization/resources/integrations/resources/slack/client/checkSlackIntegration.ts
var checkSlackIntegration_exports2 = {};
__export(checkSlackIntegration_exports2, {
  Error: () => Error355
});
var Error355;
var init_checkSlackIntegration2 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/checkSlackIntegration.ts"() {
    "use strict";
    init_src();
    init_core();
    Error355 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.checkSlackIntegration.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.checkSlackIntegration.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.checkSlackIntegration.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/getAuthUrl.ts
var getAuthUrl_exports3 = {};
__export(getAuthUrl_exports3, {
  Error: () => Error356
});
var Error356;
var init_getAuthUrl3 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/getAuthUrl.ts"() {
    "use strict";
    init_src();
    init_core();
    Error356 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.getAuthUrl.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.getAuthUrl.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.getAuthUrl.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/handleOAuthCallback.ts
var handleOAuthCallback_exports3 = {};
__export(handleOAuthCallback_exports3, {
  Error: () => Error357
});
var Error357;
var init_handleOAuthCallback3 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/handleOAuthCallback.ts"() {
    "use strict";
    init_src();
    init_core();
    Error357 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.handleOAuthCallback.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.handleOAuthCallback.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.handleOAuthCallback.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/disconnectIntegration.ts
var disconnectIntegration_exports3 = {};
__export(disconnectIntegration_exports3, {
  Error: () => Error358,
  Response: () => Response53
});
var Response53, Error358;
var init_disconnectIntegration3 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/disconnectIntegration.ts"() {
    "use strict";
    init_core();
    init_src();
    Response53 = schemas_exports.string();
    Error358 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.disconnectIntegration.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.disconnectIntegration.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.disconnectIntegration.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/getChannels.ts
var getChannels_exports2 = {};
__export(getChannels_exports2, {
  Error: () => Error359
});
var Error359;
var init_getChannels2 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/getChannels.ts"() {
    "use strict";
    init_src();
    init_core();
    Error359 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.getChannels.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.getChannels.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.getChannels.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/sendBroadcast.ts
var sendBroadcast_exports4 = {};
__export(sendBroadcast_exports4, {
  Error: () => Error360
});
var Error360;
var init_sendBroadcast4 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/sendBroadcast.ts"() {
    "use strict";
    init_src();
    init_core();
    Error360 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.slack.sendBroadcast.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.slack.sendBroadcast.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.integrations.slack.sendBroadcast.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/requests/SendBroadcastRequest.ts
var SendBroadcastRequest2;
var init_SendBroadcastRequest2 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/requests/SendBroadcastRequest.ts"() {
    "use strict";
    init_core();
    SendBroadcastRequest2 = schemas_exports.object({
      message: schemas_exports.unknown(),
      channels: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.SlackChannel)
      )
    });
  }
});

// src/serialization/resources/integrations/resources/slack/client/requests/index.ts
var init_requests25 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/requests/index.ts"() {
    "use strict";
    init_SendBroadcastRequest2();
  }
});

// src/serialization/resources/integrations/resources/slack/client/index.ts
var init_client55 = __esm({
  "src/serialization/resources/integrations/resources/slack/client/index.ts"() {
    "use strict";
    init_checkSlackIntegration2();
    init_getAuthUrl3();
    init_handleOAuthCallback3();
    init_disconnectIntegration3();
    init_getChannels2();
    init_sendBroadcast4();
    init_requests25();
  }
});

// src/serialization/resources/integrations/resources/slack/index.ts
var slack_exports2 = {};
__export(slack_exports2, {
  AnnouncementType: () => AnnouncementType2,
  AppearanceSettings: () => AppearanceSettings,
  ChannelsResponse: () => ChannelsResponse,
  FailedChannel: () => FailedChannel,
  MessageCustomization: () => MessageCustomization,
  SendBroadcastRequest: () => SendBroadcastRequest2,
  SlackChannel: () => SlackChannel,
  SlackChannelConfig: () => SlackChannelConfig,
  WorkspaceInfo: () => WorkspaceInfo,
  WorkspaceStatusResponse: () => WorkspaceStatusResponse,
  checkSlackIntegration: () => checkSlackIntegration_exports2,
  disconnectIntegration: () => disconnectIntegration_exports3,
  getAuthUrl: () => getAuthUrl_exports3,
  getChannels: () => getChannels_exports2,
  handleOAuthCallback: () => handleOAuthCallback_exports3,
  sendBroadcast: () => sendBroadcast_exports4
});
var init_slack2 = __esm({
  "src/serialization/resources/integrations/resources/slack/index.ts"() {
    "use strict";
    init_types54();
    init_client55();
  }
});

// src/serialization/resources/integrations/resources/youtube/types/GetPlaylistsResponse.ts
var GetPlaylistsResponse;
var init_GetPlaylistsResponse2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/types/GetPlaylistsResponse.ts"() {
    "use strict";
    init_core();
    GetPlaylistsResponse = schemas_exports.object({
      playlists: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.Playlist)
      )
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/types/Playlist.ts
var Playlist;
var init_Playlist2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/types/Playlist.ts"() {
    "use strict";
    init_core();
    Playlist = schemas_exports.object({
      id: schemas_exports.string(),
      title: schemas_exports.string(),
      description: schemas_exports.string().optional(),
      itemCount: schemas_exports.property("item_count", schemas_exports.number())
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/types/PublishToYouTubeRequest.ts
var PublishToYouTubeRequest;
var init_PublishToYouTubeRequest2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/types/PublishToYouTubeRequest.ts"() {
    "use strict";
    init_core();
    PublishToYouTubeRequest = schemas_exports.object({
      guideId: schemas_exports.property("guide_id", schemas_exports.string()),
      title: schemas_exports.string(),
      description: schemas_exports.string(),
      visibility: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).integrations.VisibilityStatus),
      playlistIds: schemas_exports.property(
        "playlist_ids",
        schemas_exports.list(schemas_exports.string()).optional()
      )
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/types/VisibilityStatus.ts
var VisibilityStatus2;
var init_VisibilityStatus2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/types/VisibilityStatus.ts"() {
    "use strict";
    init_core();
    VisibilityStatus2 = schemas_exports.enum_(["PUBLIC", "PRIVATE", "UNLISTED"]);
  }
});

// src/serialization/resources/integrations/resources/youtube/types/index.ts
var init_types55 = __esm({
  "src/serialization/resources/integrations/resources/youtube/types/index.ts"() {
    "use strict";
    init_GetPlaylistsResponse2();
    init_Playlist2();
    init_PublishToYouTubeRequest2();
    init_VisibilityStatus2();
  }
});

// src/serialization/resources/integrations/resources/youtube/client/getIntegrationDetails.ts
var getIntegrationDetails_exports2 = {};
__export(getIntegrationDetails_exports2, {
  Error: () => Error361
});
var Error361;
var init_getIntegrationDetails2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/getIntegrationDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error361 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.youtube.getIntegrationDetails.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.integrations.youtube.getIntegrationDetails.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.getIntegrationDetails.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.getIntegrationDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/getAuthUrl.ts
var getAuthUrl_exports4 = {};
__export(getAuthUrl_exports4, {
  Error: () => Error362
});
var Error362;
var init_getAuthUrl4 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/getAuthUrl.ts"() {
    "use strict";
    init_src();
    init_core();
    Error362 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.youtube.getAuthUrl.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.integrations.youtube.getAuthUrl.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.getAuthUrl.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.getAuthUrl.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/handleOAuthCallback.ts
var handleOAuthCallback_exports4 = {};
__export(handleOAuthCallback_exports4, {
  Error: () => Error363
});
var Error363;
var init_handleOAuthCallback4 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/handleOAuthCallback.ts"() {
    "use strict";
    init_src();
    init_core();
    Error363 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      NoChannelFoundError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.youtube.handleOAuthCallback.Error.unauthorizedError();
          case "NoChannelFoundError":
            return api_exports.integrations.youtube.handleOAuthCallback.Error.noChannelFoundError();
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.handleOAuthCallback.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.handleOAuthCallback.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/disconnectIntegration.ts
var disconnectIntegration_exports4 = {};
__export(disconnectIntegration_exports4, {
  Error: () => Error364,
  Response: () => Response54
});
var Response54, Error364;
var init_disconnectIntegration4 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/disconnectIntegration.ts"() {
    "use strict";
    init_core();
    init_src();
    Response54 = schemas_exports.string();
    Error364 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.youtube.disconnectIntegration.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.integrations.youtube.disconnectIntegration.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.disconnectIntegration.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.disconnectIntegration.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/getPlayListsDetails.ts
var getPlayListsDetails_exports2 = {};
__export(getPlayListsDetails_exports2, {
  Error: () => Error365
});
var Error365;
var init_getPlayListsDetails2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/getPlayListsDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error365 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.getPlayListsDetails.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.getPlayListsDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/publishToYouTube.ts
var publishToYouTube_exports2 = {};
__export(publishToYouTube_exports2, {
  Error: () => Error366,
  Response: () => Response55
});
var Response55, Error366;
var init_publishToYouTube2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/publishToYouTube.ts"() {
    "use strict";
    init_core();
    init_src();
    Response55 = schemas_exports.string();
    Error366 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.integrations.youtube.publishToYouTube.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.integrations.youtube.publishToYouTube.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.integrations.youtube.publishToYouTube.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.integrations.youtube.publishToYouTube.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/integrations/resources/youtube/client/index.ts
var init_client56 = __esm({
  "src/serialization/resources/integrations/resources/youtube/client/index.ts"() {
    "use strict";
    init_getIntegrationDetails2();
    init_getAuthUrl4();
    init_handleOAuthCallback4();
    init_disconnectIntegration4();
    init_getPlayListsDetails2();
    init_publishToYouTube2();
  }
});

// src/serialization/resources/integrations/resources/youtube/index.ts
var youtube_exports2 = {};
__export(youtube_exports2, {
  GetPlaylistsResponse: () => GetPlaylistsResponse,
  Playlist: () => Playlist,
  PublishToYouTubeRequest: () => PublishToYouTubeRequest,
  VisibilityStatus: () => VisibilityStatus2,
  disconnectIntegration: () => disconnectIntegration_exports4,
  getAuthUrl: () => getAuthUrl_exports4,
  getIntegrationDetails: () => getIntegrationDetails_exports2,
  getPlayListsDetails: () => getPlayListsDetails_exports2,
  handleOAuthCallback: () => handleOAuthCallback_exports4,
  publishToYouTube: () => publishToYouTube_exports2
});
var init_youtube2 = __esm({
  "src/serialization/resources/integrations/resources/youtube/index.ts"() {
    "use strict";
    init_types55();
    init_client56();
  }
});

// src/serialization/resources/integrations/resources/index.ts
var init_resources12 = __esm({
  "src/serialization/resources/integrations/resources/index.ts"() {
    "use strict";
    init_integrationSetup2();
    init_types53();
    init_slack2();
    init_types54();
    init_youtube2();
    init_types55();
    init_requests25();
  }
});

// src/serialization/resources/integrations/index.ts
var integrations_exports2 = {};
__export(integrations_exports2, {
  AnnouncementType: () => AnnouncementType2,
  AppearanceSettings: () => AppearanceSettings,
  ChannelsResponse: () => ChannelsResponse,
  DisconnectIntegrationRequest: () => DisconnectIntegrationRequest,
  FailedChannel: () => FailedChannel,
  GetIntegrationAuthUrlRequest: () => GetIntegrationAuthUrlRequest,
  GetPlaylistsResponse: () => GetPlaylistsResponse,
  IntegrationApp: () => IntegrationApp2,
  IntegrationAuthUrlResponse: () => IntegrationAuthUrlResponse,
  IntegrationDetails: () => IntegrationDetails,
  IntegrationOAuthCallbackRequest: () => IntegrationOAuthCallbackRequest,
  LoadIntegrationsResponse: () => LoadIntegrationsResponse,
  MessageCustomization: () => MessageCustomization,
  Playlist: () => Playlist,
  PublishToYouTubeRequest: () => PublishToYouTubeRequest,
  SendBroadcastRequest: () => SendBroadcastRequest2,
  SlackChannel: () => SlackChannel,
  SlackChannelConfig: () => SlackChannelConfig,
  VisibilityStatus: () => VisibilityStatus2,
  WorkspaceInfo: () => WorkspaceInfo,
  WorkspaceStatusResponse: () => WorkspaceStatusResponse,
  integrationSetup: () => integrationSetup_exports2,
  slack: () => slack_exports2,
  youtube: () => youtube_exports2
});
var init_integrations2 = __esm({
  "src/serialization/resources/integrations/index.ts"() {
    "use strict";
    init_resources12();
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/types/OrganizationLogo.ts
var OrganizationLogo;
var init_OrganizationLogo2 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/types/OrganizationLogo.ts"() {
    "use strict";
    init_core();
    OrganizationLogo = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      logoUrl: schemas_exports.property("logo_url", schemas_exports.string()),
      title: schemas_exports.string(),
      width: schemas_exports.number(),
      height: schemas_exports.number(),
      immutableName: schemas_exports.property("immutable_name", schemas_exports.string().optional()),
      isDeleted: schemas_exports.property("is_deleted", schemas_exports.boolean()),
      isPrimary: schemas_exports.property("is_primary", schemas_exports.boolean()),
      createdAt: schemas_exports.property("created_at", schemas_exports.date()),
      updatedAt: schemas_exports.property("updated_at", schemas_exports.date())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/types/index.ts
var init_types56 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/types/index.ts"() {
    "use strict";
    init_OrganizationLogo2();
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/initiateLogoUpload.ts
var initiateLogoUpload_exports3 = {};
__export(initiateLogoUpload_exports3, {
  Error: () => Error367
});
var Error367;
var init_initiateLogoUpload3 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/initiateLogoUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error367 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationBranding.initiateLogoUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/finishLogoUpload.ts
var finishLogoUpload_exports3 = {};
__export(finishLogoUpload_exports3, {
  Error: () => Error368
});
var Error368;
var init_finishLogoUpload3 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/finishLogoUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error368 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationBranding.finishLogoUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/deleteLogo.ts
var deleteLogo_exports2 = {};
__export(deleteLogo_exports2, {
  Error: () => Error369
});
var Error369;
var init_deleteLogo2 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/deleteLogo.ts"() {
    "use strict";
    init_src();
    init_core();
    Error369 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationBranding.deleteLogo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationBranding.deleteLogo.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationBranding.deleteLogo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/updateLogo.ts
var updateLogo_exports2 = {};
__export(updateLogo_exports2, {
  Error: () => Error370
});
var Error370;
var init_updateLogo2 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/updateLogo.ts"() {
    "use strict";
    init_src();
    init_core();
    Error370 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationBranding.updateLogo.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationBranding.updateLogo.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationBranding.updateLogo.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/getLogos.ts
var getLogos_exports2 = {};
__export(getLogos_exports2, {
  Error: () => Error371,
  Response: () => Response56
});
var Response56, Error371;
var init_getLogos2 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/getLogos.ts"() {
    "use strict";
    init_src();
    init_core();
    Response56 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.OrganizationLogo)
    );
    Error371 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationBranding.getLogos.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationBranding.getLogos.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationBranding.getLogos.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/requests/FinishLogoUploadRequest.ts
var FinishLogoUploadRequest;
var init_FinishLogoUploadRequest = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/requests/FinishLogoUploadRequest.ts"() {
    "use strict";
    init_core();
    FinishLogoUploadRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      logoUrl: schemas_exports.property("logo_url", schemas_exports.string()),
      title: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/requests/DeleteLogoRequest.ts
var DeleteLogoRequest;
var init_DeleteLogoRequest = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/requests/DeleteLogoRequest.ts"() {
    "use strict";
    init_core();
    DeleteLogoRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/requests/UpdateLogoRequest.ts
var UpdateLogoRequest;
var init_UpdateLogoRequest = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/requests/UpdateLogoRequest.ts"() {
    "use strict";
    init_core();
    UpdateLogoRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      newLogoUrl: schemas_exports.property("new_logo_url", schemas_exports.string()),
      newTitle: schemas_exports.property("new_title", schemas_exports.string())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/requests/index.ts
var init_requests26 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/requests/index.ts"() {
    "use strict";
    init_FinishLogoUploadRequest();
    init_DeleteLogoRequest();
    init_UpdateLogoRequest();
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/client/index.ts
var init_client57 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/client/index.ts"() {
    "use strict";
    init_initiateLogoUpload3();
    init_finishLogoUpload3();
    init_deleteLogo2();
    init_updateLogo2();
    init_getLogos2();
    init_requests26();
  }
});

// src/serialization/resources/organizations/resources/organizationBranding/index.ts
var organizationBranding_exports2 = {};
__export(organizationBranding_exports2, {
  DeleteLogoRequest: () => DeleteLogoRequest,
  FinishLogoUploadRequest: () => FinishLogoUploadRequest,
  OrganizationLogo: () => OrganizationLogo,
  UpdateLogoRequest: () => UpdateLogoRequest,
  deleteLogo: () => deleteLogo_exports2,
  finishLogoUpload: () => finishLogoUpload_exports3,
  getLogos: () => getLogos_exports2,
  initiateLogoUpload: () => initiateLogoUpload_exports3,
  updateLogo: () => updateLogo_exports2
});
var init_organizationBranding2 = __esm({
  "src/serialization/resources/organizations/resources/organizationBranding/index.ts"() {
    "use strict";
    init_types56();
    init_client57();
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/CreateOrganizationRequest.ts
var CreateOrganizationRequest;
var init_CreateOrganizationRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/CreateOrganizationRequest.ts"() {
    "use strict";
    init_core();
    CreateOrganizationRequest = schemas_exports.object({
      organizationDetails: schemas_exports.property(
        "organization_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.CreateOrganizationDetails).optional()
      ),
      analyticalData: schemas_exports.property(
        "analytical_data",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AnalyticsForSignupWorkflow).optional()
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForNewOrg.ts
var AnalyticsForNewOrg;
var init_AnalyticsForNewOrg2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForNewOrg.ts"() {
    "use strict";
    init_core();
    AnalyticsForNewOrg = schemas_exports.object({
      teamSize: schemas_exports.property("team_size", schemas_exports.string().optional()),
      organizationName: schemas_exports.property("organization_name", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForNewUser.ts
var AnalyticsForNewUser;
var init_AnalyticsForNewUser2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForNewUser.ts"() {
    "use strict";
    init_core();
    AnalyticsForNewUser = schemas_exports.object({
      roleInTeam: schemas_exports.property("role_in_team", schemas_exports.string().optional()),
      howDidYouHearAboutClueso: schemas_exports.property(
        "how_did_you_hear_about_clueso",
        schemas_exports.string().optional()
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForSignupWorkflow.ts
var AnalyticsForSignupWorkflow;
var init_AnalyticsForSignupWorkflow2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/AnalyticsForSignupWorkflow.ts"() {
    "use strict";
    init_core();
    AnalyticsForSignupWorkflow = schemas_exports.object({
      orgRelatedDetails: schemas_exports.property(
        "org_related_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AnalyticsForNewOrg)
      ),
      userRelatedDetails: schemas_exports.property(
        "user_related_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AnalyticsForNewUser)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/CreateOrganizationDetails.ts
var CreateOrganizationDetails;
var init_CreateOrganizationDetails2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/CreateOrganizationDetails.ts"() {
    "use strict";
    init_core();
    CreateOrganizationDetails = schemas_exports.object({
      name: schemas_exports.string(),
      openDoor: schemas_exports.property("open_door", schemas_exports.boolean()),
      canExternalMemberJoin: schemas_exports.property("can_external_member_join", schemas_exports.boolean()),
      logoFile: schemas_exports.property("logo_file", schemas_exports.string().optional()),
      brandColor: schemas_exports.property("brand_color", schemas_exports.string().optional()),
      personal: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/JoinOrganizationRequest.ts
var JoinOrganizationRequest;
var init_JoinOrganizationRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/JoinOrganizationRequest.ts"() {
    "use strict";
    init_core();
    JoinOrganizationRequest = schemas_exports.object({
      organizationDetails: schemas_exports.property(
        "organization_details",
        schemas_exports.list(
          schemas_exports.lazyObject(
            async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.JoinOrganizationDetails
          )
        )
      ),
      analyticalData: schemas_exports.property(
        "analytical_data",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AnalyticsForSignupWorkflow).optional()
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/JoinOrganizationDetails.ts
var JoinOrganizationDetails;
var init_JoinOrganizationDetails2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/JoinOrganizationDetails.ts"() {
    "use strict";
    init_core();
    JoinOrganizationDetails = schemas_exports.object({
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/AddUserToOrganizationRequest.ts
var AddUserToOrganizationRequest;
var init_AddUserToOrganizationRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/AddUserToOrganizationRequest.ts"() {
    "use strict";
    init_core();
    AddUserToOrganizationRequest = schemas_exports.object({
      userEmail: schemas_exports.property("user_email", schemas_exports.string())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/RemoveUserFromOrgRequest.ts
var RemoveUserFromOrgRequest;
var init_RemoveUserFromOrgRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/RemoveUserFromOrgRequest.ts"() {
    "use strict";
    init_core();
    RemoveUserFromOrgRequest = schemas_exports.object({
      email: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/CreatorInCurrentOrganization.ts
var CreatorInCurrentOrganization;
var init_CreatorInCurrentOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/CreatorInCurrentOrganization.ts"() {
    "use strict";
    init_core();
    CreatorInCurrentOrganization = schemas_exports.object({
      numberOfProjects: schemas_exports.property("number_of_projects", schemas_exports.number())
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserInOrg));
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/ChangeOpenDoorPolicyRequest.ts
var ChangeOpenDoorPolicyRequest;
var init_ChangeOpenDoorPolicyRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/ChangeOpenDoorPolicyRequest.ts"() {
    "use strict";
    init_core();
    ChangeOpenDoorPolicyRequest = schemas_exports.object({
      openDoor: schemas_exports.property("open_door", schemas_exports.boolean())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/ChangeRoleForUserRequest.ts
var ChangeRoleForUserRequest;
var init_ChangeRoleForUserRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/ChangeRoleForUserRequest.ts"() {
    "use strict";
    init_core();
    ChangeRoleForUserRequest = schemas_exports.object({
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      role: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Role)
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/ChangeNameRequest.ts
var ChangeNameRequest;
var init_ChangeNameRequest2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/ChangeNameRequest.ts"() {
    "use strict";
    init_core();
    ChangeNameRequest = schemas_exports.object({
      name: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/types/index.ts
var init_types57 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/types/index.ts"() {
    "use strict";
    init_CreateOrganizationRequest2();
    init_AnalyticsForNewOrg2();
    init_AnalyticsForNewUser2();
    init_AnalyticsForSignupWorkflow2();
    init_CreateOrganizationDetails2();
    init_JoinOrganizationRequest2();
    init_JoinOrganizationDetails2();
    init_AddUserToOrganizationRequest2();
    init_RemoveUserFromOrgRequest2();
    init_CreatorInCurrentOrganization2();
    init_ChangeOpenDoorPolicyRequest2();
    init_ChangeRoleForUserRequest2();
    init_ChangeNameRequest2();
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/createOrganization.ts
var createOrganization_exports2 = {};
__export(createOrganization_exports2, {
  Error: () => Error372
});
var Error372;
var init_createOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/createOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error372 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      OrganizationAlreadyExistsError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.createOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.createOrganization.Error.unauthorizedError();
          case "OrganizationAlreadyExistsError":
            return api_exports.organizations.organizationMutations.createOrganization.Error.organizationAlreadyExistsError(
              value.content
            );
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.createOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.createOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/listEligibleOrganizations.ts
var listEligibleOrganizations_exports2 = {};
__export(listEligibleOrganizations_exports2, {
  Error: () => Error373,
  Response: () => Response57
});
var Response57, Error373;
var init_listEligibleOrganizations2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/listEligibleOrganizations.ts"() {
    "use strict";
    init_src();
    init_core();
    Response57 = schemas_exports.list(
      schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.OrganizationWithListOfUsers
      )
    );
    Error373 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.listEligibleOrganizations.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/joinOrganization.ts
var joinOrganization_exports2 = {};
__export(joinOrganization_exports2, {
  Error: () => Error374
});
var Error374;
var init_joinOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/joinOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error374 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      LimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LimitExceededErrorBody)
      }),
      UserAlreadyInOrganizationError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.unauthorizedError();
          case "LimitExceededError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.limitExceededError(
              value.content
            );
          case "UserAlreadyInOrganizationError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.userAlreadyInOrganizationError(
              value.content
            );
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.joinOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/addUserToOrganization.ts
var addUserToOrganization_exports2 = {};
__export(addUserToOrganization_exports2, {
  Error: () => Error375
});
var Error375;
var init_addUserToOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/addUserToOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error375 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      LimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LimitExceededErrorBody)
      }),
      UserAlreadyInOrganizationError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      SSOEnabledOrg_ExternalInviteError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.unauthorizedError();
          case "LimitExceededError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.limitExceededError(
              value.content
            );
          case "UserAlreadyInOrganizationError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.userAlreadyInOrganizationError(
              value.content
            );
          case "SSOEnabledOrg_ExternalInviteError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.ssoEnabledOrgExternalInviteError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.addUserToOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/listOrganizationsUserIsIn.ts
var listOrganizationsUserIsIn_exports2 = {};
__export(listOrganizationsUserIsIn_exports2, {
  Error: () => Error376,
  Response: () => Response58
});
var Response58, Error376;
var init_listOrganizationsUserIsIn2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/listOrganizationsUserIsIn.ts"() {
    "use strict";
    init_src();
    init_core();
    Response58 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization)
    );
    Error376 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/leaveOrganization.ts
var leaveOrganization_exports2 = {};
__export(leaveOrganization_exports2, {
  Error: () => Error377,
  Response: () => Response59
});
var Response59, Error377;
var init_leaveOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/leaveOrganization.ts"() {
    "use strict";
    init_core();
    init_src();
    Response59 = schemas_exports.string();
    Error377 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UserNotInOrganizationError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.leaveOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.leaveOrganization.Error.unauthorizedError();
          case "UserNotInOrganizationError":
            return api_exports.organizations.organizationMutations.leaveOrganization.Error.userNotInOrganizationError(
              value.content
            );
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.leaveOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.leaveOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/removeUserFromOrganization.ts
var removeUserFromOrganization_exports2 = {};
__export(removeUserFromOrganization_exports2, {
  Error: () => Error378,
  Response: () => Response60
});
var Response60, Error378;
var init_removeUserFromOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/removeUserFromOrganization.ts"() {
    "use strict";
    init_core();
    init_src();
    Response60 = schemas_exports.string();
    Error378 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UserNotInOrganizationError: schemas_exports.object({
        content: schemas_exports.string()
      }),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error.unauthorizedError();
          case "UserNotInOrganizationError":
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error.userNotInOrganizationError(
              value.content
            );
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.removeUserFromOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/listCreatorsInCurrentOrganization.ts
var listCreatorsInCurrentOrganization_exports2 = {};
__export(listCreatorsInCurrentOrganization_exports2, {
  Error: () => Error379,
  Response: () => Response61
});
var Response61, Error379;
var init_listCreatorsInCurrentOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/listCreatorsInCurrentOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Response61 = schemas_exports.list(
      schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.CreatorInCurrentOrganization
      )
    );
    Error379 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/listInvitedUsersInCurrentOrganization.ts
var listInvitedUsersInCurrentOrganization_exports2 = {};
__export(listInvitedUsersInCurrentOrganization_exports2, {
  Error: () => Error380,
  Response: () => Response62
});
var Response62, Error380;
var init_listInvitedUsersInCurrentOrganization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/listInvitedUsersInCurrentOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Response62 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserInOrg));
    Error380 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/getOpenDoorPolicy.ts
var getOpenDoorPolicy_exports2 = {};
__export(getOpenDoorPolicy_exports2, {
  Error: () => Error381,
  Response: () => Response63
});
var Response63, Error381;
var init_getOpenDoorPolicy2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/getOpenDoorPolicy.ts"() {
    "use strict";
    init_core();
    init_src();
    Response63 = schemas_exports.boolean();
    Error381 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/changeOpenDoorPolicy.ts
var changeOpenDoorPolicy_exports2 = {};
__export(changeOpenDoorPolicy_exports2, {
  Error: () => Error382,
  Response: () => Response64
});
var Response64, Error382;
var init_changeOpenDoorPolicy2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/changeOpenDoorPolicy.ts"() {
    "use strict";
    init_core();
    init_src();
    Response64 = schemas_exports.string();
    Error382 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/changeRoleForUser.ts
var changeRoleForUser_exports2 = {};
__export(changeRoleForUser_exports2, {
  Error: () => Error383,
  Response: () => Response65
});
var Response65, Error383;
var init_changeRoleForUser2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/changeRoleForUser.ts"() {
    "use strict";
    init_core();
    init_src();
    Response65 = schemas_exports.string();
    Error383 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.changeRoleForUser.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/getName.ts
var getName_exports2 = {};
__export(getName_exports2, {
  Error: () => Error384,
  Response: () => Response66
});
var Response66, Error384;
var init_getName2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/getName.ts"() {
    "use strict";
    init_core();
    init_src();
    Response66 = schemas_exports.string();
    Error384 = schemas_exports.union("error", {
      QueryFailedError: schemas_exports.object({}),
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.getName.Error.queryFailedError();
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.getName.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.getName.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.getName.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/changeName.ts
var changeName_exports2 = {};
__export(changeName_exports2, {
  Error: () => Error385,
  Response: () => Response67
});
var Response67, Error385;
var init_changeName2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/changeName.ts"() {
    "use strict";
    init_core();
    init_src();
    Response67 = schemas_exports.string();
    Error385 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organizationMutations.changeName.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.organizations.organizationMutations.changeName.Error.queryFailedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organizationMutations.changeName.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organizationMutations.changeName.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/client/index.ts
var init_client58 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/client/index.ts"() {
    "use strict";
    init_createOrganization2();
    init_listEligibleOrganizations2();
    init_joinOrganization2();
    init_addUserToOrganization2();
    init_listOrganizationsUserIsIn2();
    init_leaveOrganization2();
    init_removeUserFromOrganization2();
    init_listCreatorsInCurrentOrganization2();
    init_listInvitedUsersInCurrentOrganization2();
    init_getOpenDoorPolicy2();
    init_changeOpenDoorPolicy2();
    init_changeRoleForUser2();
    init_getName2();
    init_changeName2();
  }
});

// src/serialization/resources/organizations/resources/organizationMutations/index.ts
var organizationMutations_exports2 = {};
__export(organizationMutations_exports2, {
  AddUserToOrganizationRequest: () => AddUserToOrganizationRequest,
  AnalyticsForNewOrg: () => AnalyticsForNewOrg,
  AnalyticsForNewUser: () => AnalyticsForNewUser,
  AnalyticsForSignupWorkflow: () => AnalyticsForSignupWorkflow,
  ChangeNameRequest: () => ChangeNameRequest,
  ChangeOpenDoorPolicyRequest: () => ChangeOpenDoorPolicyRequest,
  ChangeRoleForUserRequest: () => ChangeRoleForUserRequest,
  CreateOrganizationDetails: () => CreateOrganizationDetails,
  CreateOrganizationRequest: () => CreateOrganizationRequest,
  CreatorInCurrentOrganization: () => CreatorInCurrentOrganization,
  JoinOrganizationDetails: () => JoinOrganizationDetails,
  JoinOrganizationRequest: () => JoinOrganizationRequest,
  RemoveUserFromOrgRequest: () => RemoveUserFromOrgRequest,
  addUserToOrganization: () => addUserToOrganization_exports2,
  changeName: () => changeName_exports2,
  changeOpenDoorPolicy: () => changeOpenDoorPolicy_exports2,
  changeRoleForUser: () => changeRoleForUser_exports2,
  createOrganization: () => createOrganization_exports2,
  getName: () => getName_exports2,
  getOpenDoorPolicy: () => getOpenDoorPolicy_exports2,
  joinOrganization: () => joinOrganization_exports2,
  leaveOrganization: () => leaveOrganization_exports2,
  listCreatorsInCurrentOrganization: () => listCreatorsInCurrentOrganization_exports2,
  listEligibleOrganizations: () => listEligibleOrganizations_exports2,
  listInvitedUsersInCurrentOrganization: () => listInvitedUsersInCurrentOrganization_exports2,
  listOrganizationsUserIsIn: () => listOrganizationsUserIsIn_exports2,
  removeUserFromOrganization: () => removeUserFromOrganization_exports2
});
var init_organizationMutations2 = __esm({
  "src/serialization/resources/organizations/resources/organizationMutations/index.ts"() {
    "use strict";
    init_types57();
    init_client58();
  }
});

// src/serialization/resources/organizations/resources/organizationTypes/types/OrganizationInput.ts
var OrganizationInput;
var init_OrganizationInput2 = __esm({
  "src/serialization/resources/organizations/resources/organizationTypes/types/OrganizationInput.ts"() {
    "use strict";
    init_core();
    OrganizationInput = schemas_exports.object({
      name: schemas_exports.string(),
      brandColor: schemas_exports.property("brand_color", schemas_exports.string()),
      tourEnabled: schemas_exports.property("tour_enabled", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/organizations/resources/organizationTypes/types/Organization.ts
var Organization;
var init_Organization2 = __esm({
  "src/serialization/resources/organizations/resources/organizationTypes/types/Organization.ts"() {
    "use strict";
    init_core();
    Organization = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      domain: schemas_exports.string(),
      customLogin: schemas_exports.property("custom_login", schemas_exports.boolean().optional()),
      deactivated: schemas_exports.boolean().optional(),
      createdAt: schemas_exports.property("created_at", schemas_exports.date().optional()),
      trial: schemas_exports.boolean().optional()
    }).extend(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.OrganizationInput)
    );
  }
});

// src/serialization/resources/organizations/resources/organizationTypes/types/OrganizationWithListOfUsers.ts
var OrganizationWithListOfUsers;
var init_OrganizationWithListOfUsers2 = __esm({
  "src/serialization/resources/organizations/resources/organizationTypes/types/OrganizationWithListOfUsers.ts"() {
    "use strict";
    init_core();
    OrganizationWithListOfUsers = schemas_exports.object({
      maxSeats: schemas_exports.property("max_seats", schemas_exports.number()),
      filledSeats: schemas_exports.property("filled_seats", schemas_exports.number()),
      creators: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserInOrg)
      )
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization));
  }
});

// src/serialization/resources/organizations/resources/organizationTypes/types/index.ts
var init_types58 = __esm({
  "src/serialization/resources/organizations/resources/organizationTypes/types/index.ts"() {
    "use strict";
    init_OrganizationInput2();
    init_Organization2();
    init_OrganizationWithListOfUsers2();
  }
});

// src/serialization/resources/organizations/resources/organizationTypes/index.ts
var organizationTypes_exports2 = {};
__export(organizationTypes_exports2, {
  Organization: () => Organization,
  OrganizationInput: () => OrganizationInput,
  OrganizationWithListOfUsers: () => OrganizationWithListOfUsers
});
var init_organizationTypes2 = __esm({
  "src/serialization/resources/organizations/resources/organizationTypes/index.ts"() {
    "use strict";
    init_types58();
  }
});

// src/serialization/resources/organizations/resources/organization/types/GetAllDefaultVoicesResponse.ts
var GetAllDefaultVoicesResponse;
var init_GetAllDefaultVoicesResponse2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/GetAllDefaultVoicesResponse.ts"() {
    "use strict";
    init_core();
    GetAllDefaultVoicesResponse = schemas_exports.object({
      defaultVoices: schemas_exports.property(
        "default_voices",
        schemas_exports.list(
          schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice)
        )
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/OrganizationPlatform.ts
var OrganizationPlatform;
var init_OrganizationPlatform2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/OrganizationPlatform.ts"() {
    "use strict";
    init_core();
    OrganizationPlatform = schemas_exports.object({
      platformDetails: schemas_exports.property(
        "platform_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.PlatformDetails).optional()
      )
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization));
  }
});

// src/serialization/resources/organizations/resources/organization/types/GetAllOrganizationsResponse.ts
var GetAllOrganizationsResponse;
var init_GetAllOrganizationsResponse2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/GetAllOrganizationsResponse.ts"() {
    "use strict";
    init_core();
    GetAllOrganizationsResponse = schemas_exports.object({
      organizations: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/PlatformDetails.ts
var PlatformDetails;
var init_PlatformDetails2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/PlatformDetails.ts"() {
    "use strict";
    init_core();
    PlatformDetails = schemas_exports.object({
      audioTracks: schemas_exports.property(
        "audio_tracks",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AudioTrack)).optional()
      ),
      favoriteAudioTracks: schemas_exports.property(
        "favorite_audio_tracks",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.AudioTrack)).optional()
      ),
      logos: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Logo)).optional(),
      translatableLanguages: schemas_exports.property(
        "translatable_languages",
        schemas_exports.list(schemas_exports.string()).optional()
      ),
      intro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.CoverList).optional(),
      outro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.CoverList).optional(),
      premadeIntros: schemas_exports.property(
        "premade_intros",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverOption)).optional()
      ),
      premadeOutros: schemas_exports.property(
        "premade_outros",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverOption)).optional()
      ),
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BackgroundList).optional(),
      organizationLogos: schemas_exports.property(
        "organization_logos",
        schemas_exports.list(
          schemas_exports.lazyObject(
            async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.OrganizationLogo
          )
        ).optional()
      ),
      organizationBackgrounds: schemas_exports.property(
        "organization_backgrounds",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationBackground)).optional()
      ),
      premadeBackgrounds: schemas_exports.property(
        "premade_backgrounds",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PremadeBackground)).optional()
      ),
      organizationTemplates: schemas_exports.property(
        "organization_templates",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationTemplate)).optional()
      ),
      premadeTemplates: schemas_exports.property(
        "premade_templates",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationTemplate)).optional()
      ),
      defaultIntro: schemas_exports.property(
        "default_intro",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      defaultOutro: schemas_exports.property(
        "default_outro",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      defaultBackground: schemas_exports.property(
        "default_background",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/OrganizationBackgroundDataToReturn.ts
var OrganizationBackgroundDataToReturn;
var init_OrganizationBackgroundDataToReturn2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/OrganizationBackgroundDataToReturn.ts"() {
    "use strict";
    init_core();
    OrganizationBackgroundDataToReturn = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      premadeBackgroundId: schemas_exports.property(
        "premade_background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      src: schemas_exports.string(),
      color: schemas_exports.string().optional(),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType)
      ),
      category: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BackgroundsCategory)
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/BackgroundsCategory.ts
var BackgroundsCategory2;
var init_BackgroundsCategory2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/BackgroundsCategory.ts"() {
    "use strict";
    init_core();
    BackgroundsCategory2 = schemas_exports.enum_(["starred", "patterns", "images"]);
  }
});

// src/serialization/resources/organizations/resources/organization/types/GetAllLanguagesResponse.ts
var GetAllLanguagesResponse;
var init_GetAllLanguagesResponse2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/GetAllLanguagesResponse.ts"() {
    "use strict";
    init_core();
    GetAllLanguagesResponse = schemas_exports.object({
      languages: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Language)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/GetVoicesResponse.ts
var GetVoicesResponse;
var init_GetVoicesResponse2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/GetVoicesResponse.ts"() {
    "use strict";
    init_core();
    GetVoicesResponse = schemas_exports.object({
      voices: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/AudioTrack.ts
var AudioTrack;
var init_AudioTrack2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/AudioTrack.ts"() {
    "use strict";
    init_core();
    AudioTrack = schemas_exports.object({
      src: schemas_exports.string(),
      description: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/CoverList.ts
var CoverList;
var init_CoverList2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/CoverList.ts"() {
    "use strict";
    init_core();
    CoverList = schemas_exports.object({
      default: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      options: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverOption)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/BackgroundList.ts
var BackgroundList;
var init_BackgroundList2 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/BackgroundList.ts"() {
    "use strict";
    init_core();
    BackgroundList = schemas_exports.object({
      default: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      options: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundOption)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/organization/types/index.ts
var init_types59 = __esm({
  "src/serialization/resources/organizations/resources/organization/types/index.ts"() {
    "use strict";
    init_GetAllDefaultVoicesResponse2();
    init_OrganizationPlatform2();
    init_GetAllOrganizationsResponse2();
    init_PlatformDetails2();
    init_OrganizationBackgroundDataToReturn2();
    init_BackgroundsCategory2();
    init_GetAllLanguagesResponse2();
    init_GetVoicesResponse2();
    init_AudioTrack2();
    init_CoverList2();
    init_BackgroundList2();
  }
});

// src/serialization/resources/organizations/resources/organization/client/getOrganization.ts
var getOrganization_exports4 = {};
__export(getOrganization_exports4, {
  Error: () => Error386
});
var Error386;
var init_getOrganization4 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error386 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getOrganization.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getHostname.ts
var getHostname_exports2 = {};
__export(getHostname_exports2, {
  Error: () => Error387,
  Response: () => Response68
});
var Response68, Error387;
var init_getHostname2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getHostname.ts"() {
    "use strict";
    init_core();
    init_src();
    Response68 = schemas_exports.string();
    Error387 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getHostname.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getHostname.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getHostname.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getPlatformDetails.ts
var getPlatformDetails_exports2 = {};
__export(getPlatformDetails_exports2, {
  Error: () => Error388
});
var Error388;
var init_getPlatformDetails2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getPlatformDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error388 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getPlatformDetails.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getPlatformDetails.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getPlatformDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getAllLanguages.ts
var getAllLanguages_exports2 = {};
__export(getAllLanguages_exports2, {
  Error: () => Error389
});
var Error389;
var init_getAllLanguages2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getAllLanguages.ts"() {
    "use strict";
    init_src();
    init_core();
    Error389 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getAllLanguages.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getAllLanguages.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getAllLanguages.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getAllLanguagesChrext.ts
var getAllLanguagesChrext_exports2 = {};
__export(getAllLanguagesChrext_exports2, {
  Error: () => Error390
});
var Error390;
var init_getAllLanguagesChrext2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getAllLanguagesChrext.ts"() {
    "use strict";
    init_src();
    init_core();
    Error390 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getAllLanguagesChrext.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getAllLanguagesChrext.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getAllLanguagesChrext.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getVoices.ts
var getVoices_exports2 = {};
__export(getVoices_exports2, {
  Error: () => Error391
});
var Error391;
var init_getVoices2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getVoices.ts"() {
    "use strict";
    init_src();
    init_core();
    Error391 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getVoices.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getVoices.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getVoices.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getOrganizationFromId.ts
var getOrganizationFromId_exports2 = {};
__export(getOrganizationFromId_exports2, {
  Error: () => Error392
});
var Error392;
var init_getOrganizationFromId2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getOrganizationFromId.ts"() {
    "use strict";
    init_src();
    init_core();
    Error392 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getOrganizationFromId.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getOrganizationFromId.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getOrganizationFromId.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getHostnameFromId.ts
var getHostnameFromId_exports2 = {};
__export(getHostnameFromId_exports2, {
  Error: () => Error393,
  Response: () => Response69
});
var Response69, Error393;
var init_getHostnameFromId2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getHostnameFromId.ts"() {
    "use strict";
    init_core();
    init_src();
    Response69 = schemas_exports.string();
    Error393 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getHostnameFromId.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getHostnameFromId.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getHostnameFromId.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getOrganizationFromHostName.ts
var getOrganizationFromHostName_exports2 = {};
__export(getOrganizationFromHostName_exports2, {
  Error: () => Error394
});
var Error394;
var init_getOrganizationFromHostName2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getOrganizationFromHostName.ts"() {
    "use strict";
    init_src();
    init_core();
    Error394 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getOrganizationFromHostName.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getOrganizationFromHostName.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getOrganizationFromHostName.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/setDefaultVoice.ts
var setDefaultVoice_exports2 = {};
__export(setDefaultVoice_exports2, {
  Error: () => Error395,
  Response: () => Response70
});
var Response70, Error395;
var init_setDefaultVoice2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/setDefaultVoice.ts"() {
    "use strict";
    init_core();
    init_src();
    Response70 = schemas_exports.string();
    Error395 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      MutationFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.setDefaultVoice.Error.unauthorizedError();
          case "MutationFailedError":
            return api_exports.organizations.organization.setDefaultVoice.Error.mutationFailedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.setDefaultVoice.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.setDefaultVoice.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/getAllDefaultVoices.ts
var getAllDefaultVoices_exports2 = {};
__export(getAllDefaultVoices_exports2, {
  Error: () => Error396
});
var Error396;
var init_getAllDefaultVoices2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/getAllDefaultVoices.ts"() {
    "use strict";
    init_src();
    init_core();
    Error396 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.getAllDefaultVoices.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.getAllDefaultVoices.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.getAllDefaultVoices.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/deleteDefaultVoice.ts
var deleteDefaultVoice_exports2 = {};
__export(deleteDefaultVoice_exports2, {
  Error: () => Error397,
  Response: () => Response71
});
var Response71, Error397;
var init_deleteDefaultVoice2 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/deleteDefaultVoice.ts"() {
    "use strict";
    init_core();
    init_src();
    Response71 = schemas_exports.boolean();
    Error397 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      MutationFailedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.organization.deleteDefaultVoice.Error.unauthorizedError();
          case "MutationFailedError":
            return api_exports.organizations.organization.deleteDefaultVoice.Error.mutationFailedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.organization.deleteDefaultVoice.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.organization.deleteDefaultVoice.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/GetVoicesRequest.ts
var GetVoicesRequest;
var init_GetVoicesRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/GetVoicesRequest.ts"() {
    "use strict";
    init_core();
    GetVoicesRequest = schemas_exports.object({
      language: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/GetOrganizationFromIdRequest.ts
var GetOrganizationFromIdRequest;
var init_GetOrganizationFromIdRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/GetOrganizationFromIdRequest.ts"() {
    "use strict";
    init_core();
    GetOrganizationFromIdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/GetHostnameFromIdRequest.ts
var GetHostnameFromIdRequest;
var init_GetHostnameFromIdRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/GetHostnameFromIdRequest.ts"() {
    "use strict";
    init_core();
    GetHostnameFromIdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/GetOrganizationFromHostNameRequest.ts
var GetOrganizationFromHostNameRequest;
var init_GetOrganizationFromHostNameRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/GetOrganizationFromHostNameRequest.ts"() {
    "use strict";
    init_core();
    GetOrganizationFromHostNameRequest = schemas_exports.object({
      hostname: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/SetDefaultVoiceRequest.ts
var SetDefaultVoiceRequest;
var init_SetDefaultVoiceRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/SetDefaultVoiceRequest.ts"() {
    "use strict";
    init_core();
    SetDefaultVoiceRequest = schemas_exports.object({
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice)
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/DeleteDefaultVoiceRequest.ts
var DeleteDefaultVoiceRequest;
var init_DeleteDefaultVoiceRequest = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/DeleteDefaultVoiceRequest.ts"() {
    "use strict";
    init_core();
    DeleteDefaultVoiceRequest = schemas_exports.object({
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice)
    });
  }
});

// src/serialization/resources/organizations/resources/organization/client/requests/index.ts
var init_requests27 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/requests/index.ts"() {
    "use strict";
    init_GetVoicesRequest();
    init_GetOrganizationFromIdRequest();
    init_GetHostnameFromIdRequest();
    init_GetOrganizationFromHostNameRequest();
    init_SetDefaultVoiceRequest();
    init_DeleteDefaultVoiceRequest();
  }
});

// src/serialization/resources/organizations/resources/organization/client/index.ts
var init_client59 = __esm({
  "src/serialization/resources/organizations/resources/organization/client/index.ts"() {
    "use strict";
    init_getOrganization4();
    init_getHostname2();
    init_getPlatformDetails2();
    init_getAllLanguages2();
    init_getAllLanguagesChrext2();
    init_getVoices2();
    init_getOrganizationFromId2();
    init_getHostnameFromId2();
    init_getOrganizationFromHostName2();
    init_setDefaultVoice2();
    init_getAllDefaultVoices2();
    init_deleteDefaultVoice2();
    init_requests27();
  }
});

// src/serialization/resources/organizations/resources/organization/index.ts
var organization_exports2 = {};
__export(organization_exports2, {
  AudioTrack: () => AudioTrack,
  BackgroundList: () => BackgroundList,
  BackgroundsCategory: () => BackgroundsCategory2,
  CoverList: () => CoverList,
  DeleteDefaultVoiceRequest: () => DeleteDefaultVoiceRequest,
  GetAllDefaultVoicesResponse: () => GetAllDefaultVoicesResponse,
  GetAllLanguagesResponse: () => GetAllLanguagesResponse,
  GetAllOrganizationsResponse: () => GetAllOrganizationsResponse,
  GetHostnameFromIdRequest: () => GetHostnameFromIdRequest,
  GetOrganizationFromHostNameRequest: () => GetOrganizationFromHostNameRequest,
  GetOrganizationFromIdRequest: () => GetOrganizationFromIdRequest,
  GetVoicesRequest: () => GetVoicesRequest,
  GetVoicesResponse: () => GetVoicesResponse,
  OrganizationBackgroundDataToReturn: () => OrganizationBackgroundDataToReturn,
  OrganizationPlatform: () => OrganizationPlatform,
  PlatformDetails: () => PlatformDetails,
  SetDefaultVoiceRequest: () => SetDefaultVoiceRequest,
  deleteDefaultVoice: () => deleteDefaultVoice_exports2,
  getAllDefaultVoices: () => getAllDefaultVoices_exports2,
  getAllLanguages: () => getAllLanguages_exports2,
  getAllLanguagesChrext: () => getAllLanguagesChrext_exports2,
  getHostname: () => getHostname_exports2,
  getHostnameFromId: () => getHostnameFromId_exports2,
  getOrganization: () => getOrganization_exports4,
  getOrganizationFromHostName: () => getOrganizationFromHostName_exports2,
  getOrganizationFromId: () => getOrganizationFromId_exports2,
  getPlatformDetails: () => getPlatformDetails_exports2,
  getVoices: () => getVoices_exports2,
  setDefaultVoice: () => setDefaultVoice_exports2
});
var init_organization2 = __esm({
  "src/serialization/resources/organizations/resources/organization/index.ts"() {
    "use strict";
    init_types59();
    init_client59();
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/BasePlanStatus.ts
var BasePlanStatus;
var init_BasePlanStatus2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/BasePlanStatus.ts"() {
    "use strict";
    init_core();
    BasePlanStatus = schemas_exports.object({
      status: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BasePlanType),
      expirationDate: schemas_exports.property("expiration_date", schemas_exports.date().optional()),
      name: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BasePlanName)
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/BasePlanDetails.ts
var BasePlanDetails;
var init_BasePlanDetails2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/BasePlanDetails.ts"() {
    "use strict";
    init_core();
    BasePlanDetails = schemas_exports.object({
      paymentStatus: schemas_exports.property("payment_status", schemas_exports.string().optional()),
      recurring: schemas_exports.boolean(),
      cycleType: schemas_exports.property("cycle_type", schemas_exports.string()),
      price: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.PricingDetails).optional(),
      isThereUpcomingPlan: schemas_exports.property("is_there_upcoming_plan", schemas_exports.boolean()),
      customerManagedPayment: schemas_exports.property("customer_managed_payment", schemas_exports.boolean())
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BasePlanStatus));
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/PricingDetails.ts
var PricingDetails;
var init_PricingDetails2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/PricingDetails.ts"() {
    "use strict";
    init_core();
    PricingDetails = schemas_exports.object({
      amount: schemas_exports.number(),
      currency: schemas_exports.string(),
      paymentInterval: schemas_exports.property("payment_interval", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/BasePlanType.ts
var BasePlanType2;
var init_BasePlanType2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/BasePlanType.ts"() {
    "use strict";
    init_core();
    BasePlanType2 = schemas_exports.enum_(["TRIAL", "PRO", "NONE"]);
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/BasePlanName.ts
var BasePlanName2;
var init_BasePlanName2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/BasePlanName.ts"() {
    "use strict";
    init_core();
    BasePlanName2 = schemas_exports.enum_(["STARTER", "GROWTH", "ENTERPRISE", "LEGACY", "NONE", "TRIAL"]);
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/CheckoutRequest.ts
var CheckoutRequest;
var init_CheckoutRequest2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/CheckoutRequest.ts"() {
    "use strict";
    init_core();
    CheckoutRequest = schemas_exports.object({
      planId: schemas_exports.property("plan_id", schemas_exports.string()),
      path: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/CheckoutResponse.ts
var CheckoutResponse;
var init_CheckoutResponse2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/CheckoutResponse.ts"() {
    "use strict";
    init_core();
    CheckoutResponse = schemas_exports.object({
      checkoutUrl: schemas_exports.property("checkout_url", schemas_exports.string().optional()),
      paymentPageRequired: schemas_exports.property("payment_page_required", schemas_exports.boolean())
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/types/index.ts
var init_types60 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/types/index.ts"() {
    "use strict";
    init_BasePlanStatus2();
    init_BasePlanDetails2();
    init_PricingDetails2();
    init_BasePlanType2();
    init_BasePlanName2();
    init_CheckoutRequest2();
    init_CheckoutResponse2();
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/getBasePlanDetails.ts
var getBasePlanDetails_exports2 = {};
__export(getBasePlanDetails_exports2, {
  Error: () => Error398
});
var Error398;
var init_getBasePlanDetails2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/getBasePlanDetails.ts"() {
    "use strict";
    init_src();
    init_core();
    Error398 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.getBasePlanDetails.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/checkout.ts
var checkout_exports2 = {};
__export(checkout_exports2, {
  Error: () => Error399
});
var Error399;
var init_checkout2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/checkout.ts"() {
    "use strict";
    init_src();
    init_core();
    Error399 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      InvalidPlanError: schemas_exports.object({}),
      DowngradedPlanExistsForNextCycleError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.subscriptions.checkout.Error.unauthorizedError();
          case "InvalidPlanError":
            return api_exports.organizations.subscriptions.checkout.Error.invalidPlanError();
          case "DowngradedPlanExistsForNextCycleError":
            return api_exports.organizations.subscriptions.checkout.Error.downgradedPlanExistsForNextCycleError();
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.checkout.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.checkout.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/viewStripePortal.ts
var viewStripePortal_exports2 = {};
__export(viewStripePortal_exports2, {
  Error: () => Error400,
  Response: () => Response72
});
var Response72, Error400;
var init_viewStripePortal2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/viewStripePortal.ts"() {
    "use strict";
    init_core();
    init_src();
    Response72 = schemas_exports.string();
    Error400 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.subscriptions.viewStripePortal.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.viewStripePortal.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.viewStripePortal.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/validateCheckout.ts
var validateCheckout_exports2 = {};
__export(validateCheckout_exports2, {
  Error: () => Error401,
  Request: () => Request2,
  Response: () => Response73
});
var Request2, Response73, Error401;
var init_validateCheckout2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/validateCheckout.ts"() {
    "use strict";
    init_core();
    init_src();
    Request2 = schemas_exports.string();
    Response73 = schemas_exports.boolean();
    Error401 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.subscriptions.validateCheckout.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.validateCheckout.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.validateCheckout.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/isSingleUseAvailable.ts
var isSingleUseAvailable_exports2 = {};
__export(isSingleUseAvailable_exports2, {
  Error: () => Error402,
  Response: () => Response74
});
var Response74, Error402;
var init_isSingleUseAvailable2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/isSingleUseAvailable.ts"() {
    "use strict";
    init_core();
    init_src();
    Response74 = schemas_exports.boolean();
    Error402 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.isSingleUseAvailable.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.isSingleUseAvailable.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/checkFeatureAvailablity.ts
var checkFeatureAvailablity_exports2 = {};
__export(checkFeatureAvailablity_exports2, {
  Error: () => Error403,
  Response: () => Response75
});
var Response75, Error403;
var init_checkFeatureAvailablity2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/checkFeatureAvailablity.ts"() {
    "use strict";
    init_core();
    init_src();
    Response75 = schemas_exports.boolean();
    Error403 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.subscriptions.checkFeatureAvailablity.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/requests/CheckFeatureAvailablityRequest.ts
var CheckFeatureAvailablityRequest;
var init_CheckFeatureAvailablityRequest = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/requests/CheckFeatureAvailablityRequest.ts"() {
    "use strict";
    init_core();
    CheckFeatureAvailablityRequest = schemas_exports.object({
      featureName: schemas_exports.property("feature_name", schemas_exports.string())
    });
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/requests/index.ts
var init_requests28 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/requests/index.ts"() {
    "use strict";
    init_CheckFeatureAvailablityRequest();
  }
});

// src/serialization/resources/organizations/resources/subscriptions/client/index.ts
var init_client60 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/client/index.ts"() {
    "use strict";
    init_getBasePlanDetails2();
    init_checkout2();
    init_viewStripePortal2();
    init_validateCheckout2();
    init_isSingleUseAvailable2();
    init_checkFeatureAvailablity2();
    init_requests28();
  }
});

// src/serialization/resources/organizations/resources/subscriptions/index.ts
var subscriptions_exports2 = {};
__export(subscriptions_exports2, {
  BasePlanDetails: () => BasePlanDetails,
  BasePlanName: () => BasePlanName2,
  BasePlanStatus: () => BasePlanStatus,
  BasePlanType: () => BasePlanType2,
  CheckFeatureAvailablityRequest: () => CheckFeatureAvailablityRequest,
  CheckoutRequest: () => CheckoutRequest,
  CheckoutResponse: () => CheckoutResponse,
  PricingDetails: () => PricingDetails,
  checkFeatureAvailablity: () => checkFeatureAvailablity_exports2,
  checkout: () => checkout_exports2,
  getBasePlanDetails: () => getBasePlanDetails_exports2,
  isSingleUseAvailable: () => isSingleUseAvailable_exports2,
  validateCheckout: () => validateCheckout_exports2,
  viewStripePortal: () => viewStripePortal_exports2
});
var init_subscriptions2 = __esm({
  "src/serialization/resources/organizations/resources/subscriptions/index.ts"() {
    "use strict";
    init_types60();
    init_client60();
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/BasicUsageInActivePlan.ts
var BasicUsageInActivePlan;
var init_BasicUsageInActivePlan2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/BasicUsageInActivePlan.ts"() {
    "use strict";
    init_core();
    BasicUsageInActivePlan = schemas_exports.object({
      basePlanName: schemas_exports.property("base_plan_name", schemas_exports.string()),
      totalAvailableMinutes: schemas_exports.property("total_available_minutes", schemas_exports.number()),
      totalUsedMinutes: schemas_exports.property("total_used_minutes", schemas_exports.number())
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationRequest.ts
var UtilizationRequest;
var init_UtilizationRequest2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationRequest.ts"() {
    "use strict";
    init_core();
    UtilizationRequest = schemas_exports.object({
      subscriptionIds: schemas_exports.property(
        "subscription_ids",
        schemas_exports.list(schemas_exports.number())
      )
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationResponse.ts
var UtilizationResponse;
var init_UtilizationResponse2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationResponse.ts"() {
    "use strict";
    init_core();
    UtilizationResponse = schemas_exports.object({
      data: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.UtilizationLog)
      )
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationLog.ts
var UtilizationLog;
var init_UtilizationLog2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UtilizationLog.ts"() {
    "use strict";
    init_core();
    UtilizationLog = schemas_exports.object({
      guideId: schemas_exports.property(
        "guide_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      timestamp: schemas_exports.date(),
      userEmail: schemas_exports.property("user_email", schemas_exports.string()),
      guideName: schemas_exports.property("guide_name", schemas_exports.string()),
      utilizationInMins: schemas_exports.property("utilization_in_mins", schemas_exports.number())
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UsageMetricsRequest.ts
var UsageMetricsRequest;
var init_UsageMetricsRequest2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UsageMetricsRequest.ts"() {
    "use strict";
    init_core();
    UsageMetricsRequest = schemas_exports.object({
      baseSubscriptionId: schemas_exports.property("base_subscription_id", schemas_exports.number())
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UsageMetricsResponse.ts
var UsageMetricsResponse;
var init_UsageMetricsResponse2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UsageMetricsResponse.ts"() {
    "use strict";
    init_core();
    UsageMetricsResponse = schemas_exports.object({
      exportedSeconds: schemas_exports.property(
        "exported_seconds",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.UsageValue)
      ),
      adminsEditors: schemas_exports.property(
        "admins_editors",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.UsageValue)
      ),
      viewers: schemas_exports.number()
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/UsageValue.ts
var UsageValue;
var init_UsageValue2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/UsageValue.ts"() {
    "use strict";
    init_core();
    UsageValue = schemas_exports.object({
      limit: schemas_exports.number(),
      utilization: schemas_exports.number()
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/SubscriptionCycle.ts
var SubscriptionCycle;
var init_SubscriptionCycle2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/SubscriptionCycle.ts"() {
    "use strict";
    init_core();
    SubscriptionCycle = schemas_exports.object({
      startDate: schemas_exports.property("start_date", schemas_exports.date()),
      endDate: schemas_exports.property("end_date", schemas_exports.date()),
      basePlan: schemas_exports.property(
        "base_plan",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.PlanWithSubscription)
      ),
      addonPlans: schemas_exports.property(
        "addon_plans",
        schemas_exports.list(
          schemas_exports.lazyObject(
            async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.PlanWithSubscription
          )
        )
      ),
      active: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/PlanWithSubscription.ts
var PlanWithSubscription;
var init_PlanWithSubscription2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/PlanWithSubscription.ts"() {
    "use strict";
    init_core();
    PlanWithSubscription = schemas_exports.object({
      planId: schemas_exports.property("plan_id", schemas_exports.number()),
      subscriptionId: schemas_exports.property("subscription_id", schemas_exports.number()),
      startDate: schemas_exports.property("start_date", schemas_exports.date()),
      endDate: schemas_exports.property("end_date", schemas_exports.date()),
      name: schemas_exports.string(),
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.PlanType),
      cycle: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BillingCycle),
      messaging: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/PlanType.ts
var PlanType2;
var init_PlanType2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/PlanType.ts"() {
    "use strict";
    init_core();
    PlanType2 = schemas_exports.enum_(["base", "addon"]);
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/BillingCycle.ts
var BillingCycle2;
var init_BillingCycle2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/BillingCycle.ts"() {
    "use strict";
    init_core();
    BillingCycle2 = schemas_exports.enum_(["monthly", "quarterly", "half-yearly", "annually"]);
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/types/index.ts
var init_types61 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/types/index.ts"() {
    "use strict";
    init_BasicUsageInActivePlan2();
    init_UtilizationRequest2();
    init_UtilizationResponse2();
    init_UtilizationLog2();
    init_UsageMetricsRequest2();
    init_UsageMetricsResponse2();
    init_UsageValue2();
    init_SubscriptionCycle2();
    init_PlanWithSubscription2();
    init_PlanType2();
    init_BillingCycle2();
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/client/getBasicUsageInActivePlan.ts
var getBasicUsageInActivePlan_exports2 = {};
__export(getBasicUsageInActivePlan_exports2, {
  Error: () => Error404
});
var Error404;
var init_getBasicUsageInActivePlan2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/client/getBasicUsageInActivePlan.ts"() {
    "use strict";
    init_src();
    init_core();
    Error404 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/client/getSubscriptionCycles.ts
var getSubscriptionCycles_exports2 = {};
__export(getSubscriptionCycles_exports2, {
  Error: () => Error405,
  Response: () => Response76
});
var Response76, Error405;
var init_getSubscriptionCycles2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/client/getSubscriptionCycles.ts"() {
    "use strict";
    init_src();
    init_core();
    Response76 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.SubscriptionCycle)
    );
    Error405 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.usageMetrics.getSubscriptionCycles.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.usageMetrics.getSubscriptionCycles.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/client/getUsageInSubscriptionCycle.ts
var getUsageInSubscriptionCycle_exports2 = {};
__export(getUsageInSubscriptionCycle_exports2, {
  Error: () => Error406
});
var Error406;
var init_getUsageInSubscriptionCycle2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/client/getUsageInSubscriptionCycle.ts"() {
    "use strict";
    init_src();
    init_core();
    Error406 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/client/getUtilizationInACycle.ts
var getUtilizationInACycle_exports2 = {};
__export(getUtilizationInACycle_exports2, {
  Error: () => Error407
});
var Error407;
var init_getUtilizationInACycle2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/client/getUtilizationInACycle.ts"() {
    "use strict";
    init_src();
    init_core();
    Error407 = schemas_exports.union("error", {
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UsageLimitExceededError":
            return api_exports.organizations.usageMetrics.getUtilizationInACycle.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.organizations.usageMetrics.getUtilizationInACycle.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/client/index.ts
var init_client61 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/client/index.ts"() {
    "use strict";
    init_getBasicUsageInActivePlan2();
    init_getSubscriptionCycles2();
    init_getUsageInSubscriptionCycle2();
    init_getUtilizationInACycle2();
  }
});

// src/serialization/resources/organizations/resources/usageMetrics/index.ts
var usageMetrics_exports2 = {};
__export(usageMetrics_exports2, {
  BasicUsageInActivePlan: () => BasicUsageInActivePlan,
  BillingCycle: () => BillingCycle2,
  PlanType: () => PlanType2,
  PlanWithSubscription: () => PlanWithSubscription,
  SubscriptionCycle: () => SubscriptionCycle,
  UsageMetricsRequest: () => UsageMetricsRequest,
  UsageMetricsResponse: () => UsageMetricsResponse,
  UsageValue: () => UsageValue,
  UtilizationLog: () => UtilizationLog,
  UtilizationRequest: () => UtilizationRequest,
  UtilizationResponse: () => UtilizationResponse,
  getBasicUsageInActivePlan: () => getBasicUsageInActivePlan_exports2,
  getSubscriptionCycles: () => getSubscriptionCycles_exports2,
  getUsageInSubscriptionCycle: () => getUsageInSubscriptionCycle_exports2,
  getUtilizationInACycle: () => getUtilizationInACycle_exports2
});
var init_usageMetrics2 = __esm({
  "src/serialization/resources/organizations/resources/usageMetrics/index.ts"() {
    "use strict";
    init_types61();
    init_client61();
  }
});

// src/serialization/resources/organizations/resources/index.ts
var init_resources13 = __esm({
  "src/serialization/resources/organizations/resources/index.ts"() {
    "use strict";
    init_organizationBranding2();
    init_types56();
    init_organizationMutations2();
    init_types57();
    init_organizationTypes2();
    init_types58();
    init_organization2();
    init_types59();
    init_subscriptions2();
    init_types60();
    init_usageMetrics2();
    init_types61();
    init_requests26();
    init_requests27();
    init_requests28();
  }
});

// src/serialization/resources/organizations/index.ts
var organizations_exports2 = {};
__export(organizations_exports2, {
  AddUserToOrganizationRequest: () => AddUserToOrganizationRequest,
  AnalyticsForNewOrg: () => AnalyticsForNewOrg,
  AnalyticsForNewUser: () => AnalyticsForNewUser,
  AnalyticsForSignupWorkflow: () => AnalyticsForSignupWorkflow,
  AudioTrack: () => AudioTrack,
  BackgroundList: () => BackgroundList,
  BackgroundsCategory: () => BackgroundsCategory2,
  BasePlanDetails: () => BasePlanDetails,
  BasePlanName: () => BasePlanName2,
  BasePlanStatus: () => BasePlanStatus,
  BasePlanType: () => BasePlanType2,
  BasicUsageInActivePlan: () => BasicUsageInActivePlan,
  BillingCycle: () => BillingCycle2,
  ChangeNameRequest: () => ChangeNameRequest,
  ChangeOpenDoorPolicyRequest: () => ChangeOpenDoorPolicyRequest,
  ChangeRoleForUserRequest: () => ChangeRoleForUserRequest,
  CheckFeatureAvailablityRequest: () => CheckFeatureAvailablityRequest,
  CheckoutRequest: () => CheckoutRequest,
  CheckoutResponse: () => CheckoutResponse,
  CoverList: () => CoverList,
  CreateOrganizationDetails: () => CreateOrganizationDetails,
  CreateOrganizationRequest: () => CreateOrganizationRequest,
  CreatorInCurrentOrganization: () => CreatorInCurrentOrganization,
  DeleteDefaultVoiceRequest: () => DeleteDefaultVoiceRequest,
  DeleteLogoRequest: () => DeleteLogoRequest,
  FinishLogoUploadRequest: () => FinishLogoUploadRequest,
  GetAllDefaultVoicesResponse: () => GetAllDefaultVoicesResponse,
  GetAllLanguagesResponse: () => GetAllLanguagesResponse,
  GetAllOrganizationsResponse: () => GetAllOrganizationsResponse,
  GetHostnameFromIdRequest: () => GetHostnameFromIdRequest,
  GetOrganizationFromHostNameRequest: () => GetOrganizationFromHostNameRequest,
  GetOrganizationFromIdRequest: () => GetOrganizationFromIdRequest,
  GetVoicesRequest: () => GetVoicesRequest,
  GetVoicesResponse: () => GetVoicesResponse,
  JoinOrganizationDetails: () => JoinOrganizationDetails,
  JoinOrganizationRequest: () => JoinOrganizationRequest,
  Organization: () => Organization,
  OrganizationBackgroundDataToReturn: () => OrganizationBackgroundDataToReturn,
  OrganizationInput: () => OrganizationInput,
  OrganizationLogo: () => OrganizationLogo,
  OrganizationPlatform: () => OrganizationPlatform,
  OrganizationWithListOfUsers: () => OrganizationWithListOfUsers,
  PlanType: () => PlanType2,
  PlanWithSubscription: () => PlanWithSubscription,
  PlatformDetails: () => PlatformDetails,
  PricingDetails: () => PricingDetails,
  RemoveUserFromOrgRequest: () => RemoveUserFromOrgRequest,
  SetDefaultVoiceRequest: () => SetDefaultVoiceRequest,
  SubscriptionCycle: () => SubscriptionCycle,
  UpdateLogoRequest: () => UpdateLogoRequest,
  UsageMetricsRequest: () => UsageMetricsRequest,
  UsageMetricsResponse: () => UsageMetricsResponse,
  UsageValue: () => UsageValue,
  UtilizationLog: () => UtilizationLog,
  UtilizationRequest: () => UtilizationRequest,
  UtilizationResponse: () => UtilizationResponse,
  organization: () => organization_exports2,
  organizationBranding: () => organizationBranding_exports2,
  organizationMutations: () => organizationMutations_exports2,
  organizationTypes: () => organizationTypes_exports2,
  subscriptions: () => subscriptions_exports2,
  usageMetrics: () => usageMetrics_exports2
});
var init_organizations2 = __esm({
  "src/serialization/resources/organizations/index.ts"() {
    "use strict";
    init_resources13();
  }
});

// src/serialization/resources/posthog/types/CaputreEventRequest.ts
var CaputreEventRequest;
var init_CaputreEventRequest2 = __esm({
  "src/serialization/resources/posthog/types/CaputreEventRequest.ts"() {
    "use strict";
    init_core();
    CaputreEventRequest = schemas_exports.object({
      eventName: schemas_exports.string(),
      properties: schemas_exports.record(schemas_exports.string(), schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/posthog/types/index.ts
var init_types62 = __esm({
  "src/serialization/resources/posthog/types/index.ts"() {
    "use strict";
    init_CaputreEventRequest2();
  }
});

// src/serialization/resources/posthog/client/captureEvent.ts
var captureEvent_exports2 = {};
__export(captureEvent_exports2, {
  Error: () => Error408
});
var Error408;
var init_captureEvent2 = __esm({
  "src/serialization/resources/posthog/client/captureEvent.ts"() {
    "use strict";
    init_src();
    init_core();
    Error408 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.posthog.captureEvent.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.posthog.captureEvent.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.posthog.captureEvent.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/posthog/client/index.ts
var init_client62 = __esm({
  "src/serialization/resources/posthog/client/index.ts"() {
    "use strict";
    init_captureEvent2();
  }
});

// src/serialization/resources/posthog/index.ts
var posthog_exports2 = {};
__export(posthog_exports2, {
  CaputreEventRequest: () => CaputreEventRequest,
  captureEvent: () => captureEvent_exports2
});
var init_posthog2 = __esm({
  "src/serialization/resources/posthog/index.ts"() {
    "use strict";
    init_types62();
    init_client62();
  }
});

// src/serialization/resources/settings/types/FeatureFlags.ts
var FeatureFlags;
var init_FeatureFlags2 = __esm({
  "src/serialization/resources/settings/types/FeatureFlags.ts"() {
    "use strict";
    init_core();
    FeatureFlags = schemas_exports.object({
      autoAiEnhance: schemas_exports.property("auto_ai_enhance", schemas_exports.boolean().optional()),
      autoGenerateVoice: schemas_exports.property("auto_generate_voice", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/settings/types/GetFeatureFlagsResponse.ts
var GetFeatureFlagsResponse;
var init_GetFeatureFlagsResponse2 = __esm({
  "src/serialization/resources/settings/types/GetFeatureFlagsResponse.ts"() {
    "use strict";
    init_core();
    GetFeatureFlagsResponse = schemas_exports.object({
      featureFlags: schemas_exports.property(
        "feature_flags",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).FeatureFlags)
      )
    });
  }
});

// src/serialization/resources/settings/types/SetFeatureFlagsRequest.ts
var SetFeatureFlagsRequest;
var init_SetFeatureFlagsRequest2 = __esm({
  "src/serialization/resources/settings/types/SetFeatureFlagsRequest.ts"() {
    "use strict";
    init_core();
    SetFeatureFlagsRequest = schemas_exports.object({
      featureFlags: schemas_exports.property(
        "feature_flags",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).FeatureFlags)
      )
    });
  }
});

// src/serialization/resources/settings/types/GetPronDictRequest.ts
var GetPronDictRequest;
var init_GetPronDictRequest2 = __esm({
  "src/serialization/resources/settings/types/GetPronDictRequest.ts"() {
    "use strict";
    init_core();
    GetPronDictRequest = schemas_exports.object({
      language: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/settings/types/PronDictEntry.ts
var PronDictEntry;
var init_PronDictEntry2 = __esm({
  "src/serialization/resources/settings/types/PronDictEntry.ts"() {
    "use strict";
    init_core();
    PronDictEntry = schemas_exports.object({
      actualWord: schemas_exports.property("actual_word", schemas_exports.string()),
      phoneticSpelling: schemas_exports.property("phonetic_spelling", schemas_exports.string()),
      language: schemas_exports.string()
    });
  }
});

// src/serialization/resources/settings/types/GeneratePreviewAudioRequest.ts
var GeneratePreviewAudioRequest;
var init_GeneratePreviewAudioRequest2 = __esm({
  "src/serialization/resources/settings/types/GeneratePreviewAudioRequest.ts"() {
    "use strict";
    init_core();
    GeneratePreviewAudioRequest = schemas_exports.object({
      word: schemas_exports.string(),
      language: schemas_exports.string().optional(),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional()
    });
  }
});

// src/serialization/resources/settings/types/PronDictEntryRequest.ts
var PronDictEntryRequest;
var init_PronDictEntryRequest2 = __esm({
  "src/serialization/resources/settings/types/PronDictEntryRequest.ts"() {
    "use strict";
    init_core();
    PronDictEntryRequest = schemas_exports.object({
      actualWord: schemas_exports.property("actual_word", schemas_exports.string()),
      phoneticSpelling: schemas_exports.property("phonetic_spelling", schemas_exports.string()),
      language: schemas_exports.string(),
      applyToAll: schemas_exports.property("apply_to_all", schemas_exports.boolean())
    });
  }
});

// src/serialization/resources/settings/types/GetPronDictEntryRequest.ts
var GetPronDictEntryRequest;
var init_GetPronDictEntryRequest2 = __esm({
  "src/serialization/resources/settings/types/GetPronDictEntryRequest.ts"() {
    "use strict";
    init_core();
    GetPronDictEntryRequest = schemas_exports.object({
      language: schemas_exports.string().optional(),
      actualWord: schemas_exports.property("actual_word", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/settings/types/index.ts
var init_types63 = __esm({
  "src/serialization/resources/settings/types/index.ts"() {
    "use strict";
    init_FeatureFlags2();
    init_GetFeatureFlagsResponse2();
    init_SetFeatureFlagsRequest2();
    init_GetPronDictRequest2();
    init_PronDictEntry2();
    init_GeneratePreviewAudioRequest2();
    init_PronDictEntryRequest2();
    init_GetPronDictEntryRequest2();
  }
});

// src/serialization/resources/settings/client/fetchPronDict.ts
var fetchPronDict_exports2 = {};
__export(fetchPronDict_exports2, {
  Error: () => Error409,
  Response: () => Response77
});
var Response77, Error409;
var init_fetchPronDict2 = __esm({
  "src/serialization/resources/settings/client/fetchPronDict.ts"() {
    "use strict";
    init_src();
    init_core();
    Response77 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PronDictEntry));
    Error409 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.fetchPronDict.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.settings.fetchPronDict.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.fetchPronDict.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/addPronDictEntry.ts
var addPronDictEntry_exports2 = {};
__export(addPronDictEntry_exports2, {
  Error: () => Error410,
  Response: () => Response78
});
var Response78, Error410;
var init_addPronDictEntry2 = __esm({
  "src/serialization/resources/settings/client/addPronDictEntry.ts"() {
    "use strict";
    init_core();
    init_src();
    Response78 = schemas_exports.list(schemas_exports.string());
    Error410 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      EntryAlreadyExistsError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.addPronDictEntry.Error.unauthorizedError();
          case "EntryAlreadyExistsError":
            return api_exports.settings.addPronDictEntry.Error.entryAlreadyExistsError();
          case "UsageLimitExceededError":
            return api_exports.settings.addPronDictEntry.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.addPronDictEntry.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/getPronDictEntry.ts
var getPronDictEntry_exports2 = {};
__export(getPronDictEntry_exports2, {
  Error: () => Error411
});
var Error411;
var init_getPronDictEntry2 = __esm({
  "src/serialization/resources/settings/client/getPronDictEntry.ts"() {
    "use strict";
    init_src();
    init_core();
    Error411 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      EntryNotFoundError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.getPronDictEntry.Error.unauthorizedError();
          case "EntryNotFoundError":
            return api_exports.settings.getPronDictEntry.Error.entryNotFoundError();
          case "UsageLimitExceededError":
            return api_exports.settings.getPronDictEntry.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.getPronDictEntry.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/deletePronDictEntry.ts
var deletePronDictEntry_exports2 = {};
__export(deletePronDictEntry_exports2, {
  Error: () => Error412
});
var Error412;
var init_deletePronDictEntry2 = __esm({
  "src/serialization/resources/settings/client/deletePronDictEntry.ts"() {
    "use strict";
    init_src();
    init_core();
    Error412 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.deletePronDictEntry.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.settings.deletePronDictEntry.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.deletePronDictEntry.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/returnPreviewAudioBytes.ts
var returnPreviewAudioBytes_exports2 = {};
__export(returnPreviewAudioBytes_exports2, {
  Error: () => Error413,
  Response: () => Response79
});
var Response79, Error413;
var init_returnPreviewAudioBytes2 = __esm({
  "src/serialization/resources/settings/client/returnPreviewAudioBytes.ts"() {
    "use strict";
    init_core();
    init_src();
    Response79 = schemas_exports.string();
    Error413 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.returnPreviewAudioBytes.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.settings.returnPreviewAudioBytes.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.returnPreviewAudioBytes.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/getFeatureFlags.ts
var getFeatureFlags_exports2 = {};
__export(getFeatureFlags_exports2, {
  Error: () => Error414
});
var Error414;
var init_getFeatureFlags2 = __esm({
  "src/serialization/resources/settings/client/getFeatureFlags.ts"() {
    "use strict";
    init_src();
    init_core();
    Error414 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.getFeatureFlags.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.settings.getFeatureFlags.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.getFeatureFlags.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/setFeatureFlags.ts
var setFeatureFlags_exports2 = {};
__export(setFeatureFlags_exports2, {
  Error: () => Error415,
  Response: () => Response80
});
var Response80, Error415;
var init_setFeatureFlags2 = __esm({
  "src/serialization/resources/settings/client/setFeatureFlags.ts"() {
    "use strict";
    init_core();
    init_src();
    Response80 = schemas_exports.boolean();
    Error415 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.settings.setFeatureFlags.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.settings.setFeatureFlags.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.settings.setFeatureFlags.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/settings/client/index.ts
var init_client63 = __esm({
  "src/serialization/resources/settings/client/index.ts"() {
    "use strict";
    init_fetchPronDict2();
    init_addPronDictEntry2();
    init_getPronDictEntry2();
    init_deletePronDictEntry2();
    init_returnPreviewAudioBytes2();
    init_getFeatureFlags2();
    init_setFeatureFlags2();
  }
});

// src/serialization/resources/settings/index.ts
var settings_exports2 = {};
__export(settings_exports2, {
  FeatureFlags: () => FeatureFlags,
  GeneratePreviewAudioRequest: () => GeneratePreviewAudioRequest,
  GetFeatureFlagsResponse: () => GetFeatureFlagsResponse,
  GetPronDictEntryRequest: () => GetPronDictEntryRequest,
  GetPronDictRequest: () => GetPronDictRequest,
  PronDictEntry: () => PronDictEntry,
  PronDictEntryRequest: () => PronDictEntryRequest,
  SetFeatureFlagsRequest: () => SetFeatureFlagsRequest,
  addPronDictEntry: () => addPronDictEntry_exports2,
  deletePronDictEntry: () => deletePronDictEntry_exports2,
  fetchPronDict: () => fetchPronDict_exports2,
  getFeatureFlags: () => getFeatureFlags_exports2,
  getPronDictEntry: () => getPronDictEntry_exports2,
  returnPreviewAudioBytes: () => returnPreviewAudioBytes_exports2,
  setFeatureFlags: () => setFeatureFlags_exports2
});
var init_settings2 = __esm({
  "src/serialization/resources/settings/index.ts"() {
    "use strict";
    init_types63();
    init_client63();
  }
});

// src/serialization/resources/templates/types/CoverVersion.ts
var CoverVersion2;
var init_CoverVersion2 = __esm({
  "src/serialization/resources/templates/types/CoverVersion.ts"() {
    "use strict";
    init_core();
    CoverVersion2 = schemas_exports.enum_(["aug012024"]);
  }
});

// src/serialization/resources/templates/types/BackgroundType.ts
var BackgroundType2;
var init_BackgroundType2 = __esm({
  "src/serialization/resources/templates/types/BackgroundType.ts"() {
    "use strict";
    init_core();
    BackgroundType2 = schemas_exports.enum_(["image", "pattern"]);
  }
});

// src/serialization/resources/templates/types/Logo.ts
var Logo2;
var init_Logo4 = __esm({
  "src/serialization/resources/templates/types/Logo.ts"() {
    "use strict";
    init_core();
    Logo2 = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      src: schemas_exports.string()
    });
  }
});

// src/serialization/resources/templates/types/CoverFormat.ts
var CoverFormat2;
var init_CoverFormat2 = __esm({
  "src/serialization/resources/templates/types/CoverFormat.ts"() {
    "use strict";
    init_core();
    CoverFormat2 = schemas_exports.enum_(["video", "image"]);
  }
});

// src/serialization/resources/templates/types/CoverType.ts
var CoverType2;
var init_CoverType2 = __esm({
  "src/serialization/resources/templates/types/CoverType.ts"() {
    "use strict";
    init_core();
    CoverType2 = schemas_exports.enum_(["intro", "outro"]);
  }
});

// src/serialization/resources/templates/types/CoverOption.ts
var CoverOption;
var init_CoverOption2 = __esm({
  "src/serialization/resources/templates/types/CoverOption.ts"() {
    "use strict";
    init_core();
    CoverOption = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      tags: schemas_exports.list(schemas_exports.string()).optional(),
      cover: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Cover)
    });
  }
});

// src/serialization/resources/templates/types/BackgroundOption.ts
var BackgroundOption;
var init_BackgroundOption2 = __esm({
  "src/serialization/resources/templates/types/BackgroundOption.ts"() {
    "use strict";
    init_core();
    BackgroundOption = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      tags: schemas_exports.list(schemas_exports.string()).optional(),
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Background)
    });
  }
});

// src/serialization/resources/templates/types/Cover.ts
var Cover;
var init_Cover2 = __esm({
  "src/serialization/resources/templates/types/Cover.ts"() {
    "use strict";
    init_core();
    Cover = schemas_exports.object({
      version: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverVersion).optional(),
      visible: schemas_exports.boolean(),
      duration: schemas_exports.number(),
      intersectionDuration: schemas_exports.number().optional(),
      text1: schemas_exports.string().optional(),
      text2: schemas_exports.string().optional(),
      alignment: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).TextAlignment).optional(),
      fontColor: schemas_exports.string().optional(),
      font: schemas_exports.string().optional(),
      textStartTime: schemas_exports.number().optional(),
      textEndTime: schemas_exports.number().optional(),
      hideText: schemas_exports.boolean().optional(),
      showLogo: schemas_exports.boolean().optional(),
      logo: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      logoPosition: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Coordinates).optional(),
      logoSize: schemas_exports.number().optional(),
      backgroundSrc: schemas_exports.string().optional(),
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationBackground).optional(),
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverFormat).optional(),
      fixDimensions: schemas_exports.boolean().optional(),
      naturalWidth: schemas_exports.number().optional(),
      naturalHeight: schemas_exports.number().optional(),
      coverEdits: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ElementEdit)).optional(),
      transition: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Transition).optional(),
      referenceTemplate: schemas_exports.property(
        "reference_template",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationTemplate).optional()
      )
    });
  }
});

// src/serialization/resources/templates/types/Background.ts
var Background;
var init_Background2 = __esm({
  "src/serialization/resources/templates/types/Background.ts"() {
    "use strict";
    init_core();
    Background = schemas_exports.object({
      visible: schemas_exports.boolean(),
      src: schemas_exports.string().optional(),
      id: schemas_exports.string().optional(),
      padding: schemas_exports.number().optional(),
      borderRadius: schemas_exports.number().optional(),
      shadow: schemas_exports.number().optional(),
      primaryColor: schemas_exports.string().optional(),
      audio: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Audio).optional(),
      isStarred: schemas_exports.property("is_starred", schemas_exports.boolean().optional()),
      premadeBackgroundId: schemas_exports.property(
        "premade_background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType).optional()
      )
    });
  }
});

// src/serialization/resources/templates/types/Border.ts
var Border;
var init_Border2 = __esm({
  "src/serialization/resources/templates/types/Border.ts"() {
    "use strict";
    init_core();
    Border = schemas_exports.object({
      color: schemas_exports.string().optional(),
      borderWidth: schemas_exports.number().optional(),
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BorderType).optional(),
      title: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/templates/types/BorderType.ts
var BorderType2;
var init_BorderType2 = __esm({
  "src/serialization/resources/templates/types/BorderType.ts"() {
    "use strict";
    init_core();
    BorderType2 = schemas_exports.enum_(["browser", "solid", "glass", "animated", "none", "notch"]);
  }
});

// src/serialization/resources/templates/types/Transition.ts
var Transition;
var init_Transition2 = __esm({
  "src/serialization/resources/templates/types/Transition.ts"() {
    "use strict";
    init_core();
    Transition = schemas_exports.object({
      type: schemas_exports.string(),
      duration: schemas_exports.number(),
      direction: schemas_exports.string().optional(),
      color: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/templates/types/Audio.ts
var Audio;
var init_Audio2 = __esm({
  "src/serialization/resources/templates/types/Audio.ts"() {
    "use strict";
    init_core();
    Audio = schemas_exports.object({
      visible: schemas_exports.boolean(),
      src: schemas_exports.string().optional(),
      volume: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/templates/types/OrganizationBackground.ts
var OrganizationBackground;
var init_OrganizationBackground2 = __esm({
  "src/serialization/resources/templates/types/OrganizationBackground.ts"() {
    "use strict";
    init_core();
    OrganizationBackground = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      src: schemas_exports.string(),
      isStarred: schemas_exports.property("is_starred", schemas_exports.boolean()),
      premadeBackgroundId: schemas_exports.property(
        "premade_background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType).optional()
      ),
      color: schemas_exports.string().optional(),
      width: schemas_exports.number().optional(),
      height: schemas_exports.number().optional(),
      padding: schemas_exports.number().optional(),
      borderRadius: schemas_exports.property("border_radius", schemas_exports.number().optional()),
      shadow: schemas_exports.number().optional(),
      isDeleted: schemas_exports.property("is_deleted", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/templates/types/PremadeBackground.ts
var PremadeBackground;
var init_PremadeBackground2 = __esm({
  "src/serialization/resources/templates/types/PremadeBackground.ts"() {
    "use strict";
    init_core();
    PremadeBackground = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      src: schemas_exports.string(),
      width: schemas_exports.number().optional(),
      height: schemas_exports.number().optional(),
      padding: schemas_exports.number().optional(),
      borderRadius: schemas_exports.property("border_radius", schemas_exports.number().optional()),
      shadow: schemas_exports.number().optional(),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType)
      ),
      isDeleted: schemas_exports.property("is_deleted", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/templates/types/OrganizationTemplate.ts
var OrganizationTemplate;
var init_OrganizationTemplate2 = __esm({
  "src/serialization/resources/templates/types/OrganizationTemplate.ts"() {
    "use strict";
    init_core();
    OrganizationTemplate = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      clipLabel: schemas_exports.property("clip_label", schemas_exports.string()),
      elementEdits: schemas_exports.property(
        "element_edits",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ElementEdit)).optional()
      ),
      aspectRatio: schemas_exports.property(
        "aspect_ratio",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AspectRatio)
      ),
      backgroundUrl: schemas_exports.property("background_url", schemas_exports.string()),
      width: schemas_exports.number(),
      height: schemas_exports.number(),
      templateMediaType: schemas_exports.property(
        "template_media_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverFormat)
      ),
      backgroundId: schemas_exports.property(
        "background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType).optional()
      ),
      color: schemas_exports.string().optional(),
      transition: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Transition).optional(),
      isDeleted: schemas_exports.property("is_deleted", schemas_exports.boolean()),
      createdAt: schemas_exports.property("created_at", schemas_exports.date().optional()),
      duration: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/templates/types/AspectRatio.ts
var AspectRatio;
var init_AspectRatio2 = __esm({
  "src/serialization/resources/templates/types/AspectRatio.ts"() {
    "use strict";
    init_core();
    AspectRatio = schemas_exports.object({
      width: schemas_exports.number(),
      height: schemas_exports.number()
    });
  }
});

// src/serialization/resources/templates/types/index.ts
var init_types64 = __esm({
  "src/serialization/resources/templates/types/index.ts"() {
    "use strict";
    init_CoverVersion2();
    init_BackgroundType2();
    init_Logo4();
    init_CoverFormat2();
    init_CoverType2();
    init_CoverOption2();
    init_BackgroundOption2();
    init_Cover2();
    init_Background2();
    init_Border2();
    init_BorderType2();
    init_Transition2();
    init_Audio2();
    init_OrganizationBackground2();
    init_PremadeBackground2();
    init_OrganizationTemplate2();
    init_AspectRatio2();
  }
});

// src/serialization/resources/templates/client/initiateLogoUpload.ts
var initiateLogoUpload_exports4 = {};
__export(initiateLogoUpload_exports4, {
  Error: () => Error416
});
var Error416;
var init_initiateLogoUpload4 = __esm({
  "src/serialization/resources/templates/client/initiateLogoUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error416 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.initiateLogoUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.initiateLogoUpload.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.initiateLogoUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/finishLogoUpload.ts
var finishLogoUpload_exports4 = {};
__export(finishLogoUpload_exports4, {
  Error: () => Error417,
  Response: () => Response81
});
var Response81, Error417;
var init_finishLogoUpload4 = __esm({
  "src/serialization/resources/templates/client/finishLogoUpload.ts"() {
    "use strict";
    init_core();
    init_src();
    Response81 = schemas_exports.boolean();
    Error417 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.finishLogoUpload.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.templates.finishLogoUpload.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.templates.finishLogoUpload.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.finishLogoUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/initiateAssetUpload.ts
var initiateAssetUpload_exports2 = {};
__export(initiateAssetUpload_exports2, {
  Error: () => Error418
});
var Error418;
var init_initiateAssetUpload2 = __esm({
  "src/serialization/resources/templates/client/initiateAssetUpload.ts"() {
    "use strict";
    init_src();
    init_core();
    Error418 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.initiateAssetUpload.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.initiateAssetUpload.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.initiateAssetUpload.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/createCover.ts
var createCover_exports2 = {};
__export(createCover_exports2, {
  Error: () => Error419
});
var Error419;
var init_createCover2 = __esm({
  "src/serialization/resources/templates/client/createCover.ts"() {
    "use strict";
    init_src();
    init_core();
    Error419 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.createCover.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.templates.createCover.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.templates.createCover.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.createCover.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/setDefaultCover.ts
var setDefaultCover_exports2 = {};
__export(setDefaultCover_exports2, {
  Error: () => Error420
});
var Error420;
var init_setDefaultCover2 = __esm({
  "src/serialization/resources/templates/client/setDefaultCover.ts"() {
    "use strict";
    init_src();
    init_core();
    Error420 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.setDefaultCover.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.setDefaultCover.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.setDefaultCover.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/createBackground.ts
var createBackground_exports2 = {};
__export(createBackground_exports2, {
  Error: () => Error421
});
var Error421;
var init_createBackground2 = __esm({
  "src/serialization/resources/templates/client/createBackground.ts"() {
    "use strict";
    init_src();
    init_core();
    Error421 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.createBackground.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.templates.createBackground.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.templates.createBackground.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.createBackground.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/setDefaultBackground.ts
var setDefaultBackground_exports2 = {};
__export(setDefaultBackground_exports2, {
  Error: () => Error422
});
var Error422;
var init_setDefaultBackground2 = __esm({
  "src/serialization/resources/templates/client/setDefaultBackground.ts"() {
    "use strict";
    init_src();
    init_core();
    Error422 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.setDefaultBackground.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.setDefaultBackground.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.setDefaultBackground.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/setDefaultTransition.ts
var setDefaultTransition_exports2 = {};
__export(setDefaultTransition_exports2, {
  Error: () => Error423
});
var Error423;
var init_setDefaultTransition2 = __esm({
  "src/serialization/resources/templates/client/setDefaultTransition.ts"() {
    "use strict";
    init_src();
    init_core();
    Error423 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.setDefaultTransition.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.setDefaultTransition.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.setDefaultTransition.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/deleteCover.ts
var deleteCover_exports2 = {};
__export(deleteCover_exports2, {
  Error: () => Error424
});
var Error424;
var init_deleteCover2 = __esm({
  "src/serialization/resources/templates/client/deleteCover.ts"() {
    "use strict";
    init_src();
    init_core();
    Error424 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.deleteCover.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.deleteCover.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.deleteCover.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/deleteBackground.ts
var deleteBackground_exports2 = {};
__export(deleteBackground_exports2, {
  Error: () => Error425
});
var Error425;
var init_deleteBackground2 = __esm({
  "src/serialization/resources/templates/client/deleteBackground.ts"() {
    "use strict";
    init_src();
    init_core();
    Error425 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.deleteBackground.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.deleteBackground.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.deleteBackground.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/updateCover.ts
var updateCover_exports2 = {};
__export(updateCover_exports2, {
  Error: () => Error426
});
var Error426;
var init_updateCover2 = __esm({
  "src/serialization/resources/templates/client/updateCover.ts"() {
    "use strict";
    init_src();
    init_core();
    Error426 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      CorruptedFileError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.updateCover.Error.unauthorizedError();
          case "CorruptedFileError":
            return api_exports.templates.updateCover.Error.corruptedFileError();
          case "UsageLimitExceededError":
            return api_exports.templates.updateCover.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.updateCover.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/addBackgroundToOrganization.ts
var addBackgroundToOrganization_exports2 = {};
__export(addBackgroundToOrganization_exports2, {
  Error: () => Error427
});
var Error427;
var init_addBackgroundToOrganization2 = __esm({
  "src/serialization/resources/templates/client/addBackgroundToOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error427 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.addBackgroundToOrganization.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.addBackgroundToOrganization.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.templates.addBackgroundToOrganization.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/toggleStarBackground.ts
var toggleStarBackground_exports2 = {};
__export(toggleStarBackground_exports2, {
  Error: () => Error428
});
var Error428;
var init_toggleStarBackground2 = __esm({
  "src/serialization/resources/templates/client/toggleStarBackground.ts"() {
    "use strict";
    init_src();
    init_core();
    Error428 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.toggleStarBackground.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.toggleStarBackground.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.toggleStarBackground.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/deleteBackgroundV2.ts
var deleteBackgroundV2_exports2 = {};
__export(deleteBackgroundV2_exports2, {
  Error: () => Error429
});
var Error429;
var init_deleteBackgroundV22 = __esm({
  "src/serialization/resources/templates/client/deleteBackgroundV2.ts"() {
    "use strict";
    init_src();
    init_core();
    Error429 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.deleteBackgroundV2.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.deleteBackgroundV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.deleteBackgroundV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/createOrganizationTemplate.ts
var createOrganizationTemplate_exports2 = {};
__export(createOrganizationTemplate_exports2, {
  Error: () => Error430
});
var Error430;
var init_createOrganizationTemplate2 = __esm({
  "src/serialization/resources/templates/client/createOrganizationTemplate.ts"() {
    "use strict";
    init_src();
    init_core();
    Error430 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.createOrganizationTemplate.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.createOrganizationTemplate.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.templates.createOrganizationTemplate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/deleteOrganizationTemplate.ts
var deleteOrganizationTemplate_exports2 = {};
__export(deleteOrganizationTemplate_exports2, {
  Error: () => Error431
});
var Error431;
var init_deleteOrganizationTemplate2 = __esm({
  "src/serialization/resources/templates/client/deleteOrganizationTemplate.ts"() {
    "use strict";
    init_src();
    init_core();
    Error431 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.deleteOrganizationTemplate.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.deleteOrganizationTemplate.Error.usageLimitExceededError(
              value.content
            );
          case "ActionNotPermittedError":
            return api_exports.templates.deleteOrganizationTemplate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/setDefaultTemplate.ts
var setDefaultTemplate_exports2 = {};
__export(setDefaultTemplate_exports2, {
  Error: () => Error432
});
var Error432;
var init_setDefaultTemplate2 = __esm({
  "src/serialization/resources/templates/client/setDefaultTemplate.ts"() {
    "use strict";
    init_src();
    init_core();
    Error432 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.setDefaultTemplate.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.setDefaultTemplate.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.setDefaultTemplate.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/setDefaultBackgroundV2.ts
var setDefaultBackgroundV2_exports2 = {};
__export(setDefaultBackgroundV2_exports2, {
  Error: () => Error433
});
var Error433;
var init_setDefaultBackgroundV22 = __esm({
  "src/serialization/resources/templates/client/setDefaultBackgroundV2.ts"() {
    "use strict";
    init_src();
    init_core();
    Error433 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.templates.setDefaultBackgroundV2.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.templates.setDefaultBackgroundV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.templates.setDefaultBackgroundV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/templates/client/requests/CreateCoverRequest.ts
var CreateCoverRequest;
var init_CreateCoverRequest = __esm({
  "src/serialization/resources/templates/client/requests/CreateCoverRequest.ts"() {
    "use strict";
    init_core();
    CreateCoverRequest = schemas_exports.object({
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverType),
      cover: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Cover)
    });
  }
});

// src/serialization/resources/templates/client/requests/SetDefaultCoverRequest.ts
var SetDefaultCoverRequest;
var init_SetDefaultCoverRequest = __esm({
  "src/serialization/resources/templates/client/requests/SetDefaultCoverRequest.ts"() {
    "use strict";
    init_core();
    SetDefaultCoverRequest = schemas_exports.object({
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverType),
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/CreateBackgroundRequest.ts
var CreateBackgroundRequest;
var init_CreateBackgroundRequest = __esm({
  "src/serialization/resources/templates/client/requests/CreateBackgroundRequest.ts"() {
    "use strict";
    init_core();
    CreateBackgroundRequest = schemas_exports.object({
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Background)
    });
  }
});

// src/serialization/resources/templates/client/requests/SetDefaultBackgroundRequest.ts
var SetDefaultBackgroundRequest;
var init_SetDefaultBackgroundRequest = __esm({
  "src/serialization/resources/templates/client/requests/SetDefaultBackgroundRequest.ts"() {
    "use strict";
    init_core();
    SetDefaultBackgroundRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/SetDefaultTransitionRequest.ts
var SetDefaultTransitionRequest;
var init_SetDefaultTransitionRequest = __esm({
  "src/serialization/resources/templates/client/requests/SetDefaultTransitionRequest.ts"() {
    "use strict";
    init_core();
    SetDefaultTransitionRequest = schemas_exports.object({
      transitionStage: schemas_exports.string(),
      transitionType: schemas_exports.string(),
      duration: schemas_exports.number(),
      direction: schemas_exports.string(),
      color: schemas_exports.string()
    });
  }
});

// src/serialization/resources/templates/client/requests/DeleteCoverRequest.ts
var DeleteCoverRequest;
var init_DeleteCoverRequest = __esm({
  "src/serialization/resources/templates/client/requests/DeleteCoverRequest.ts"() {
    "use strict";
    init_core();
    DeleteCoverRequest = schemas_exports.object({
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverType),
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/DeleteBackgroundRequest.ts
var DeleteBackgroundRequest;
var init_DeleteBackgroundRequest = __esm({
  "src/serialization/resources/templates/client/requests/DeleteBackgroundRequest.ts"() {
    "use strict";
    init_core();
    DeleteBackgroundRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/UpdateCoverRequest.ts
var UpdateCoverRequest;
var init_UpdateCoverRequest = __esm({
  "src/serialization/resources/templates/client/requests/UpdateCoverRequest.ts"() {
    "use strict";
    init_core();
    UpdateCoverRequest = schemas_exports.object({
      type: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverType),
      coverOption: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverOption)
    });
  }
});

// src/serialization/resources/templates/client/requests/AddBackgroundToOrganizationRequest.ts
var AddBackgroundToOrganizationRequest;
var init_AddBackgroundToOrganizationRequest = __esm({
  "src/serialization/resources/templates/client/requests/AddBackgroundToOrganizationRequest.ts"() {
    "use strict";
    init_core();
    AddBackgroundToOrganizationRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      src: schemas_exports.string(),
      premadeBackgroundId: schemas_exports.property(
        "premade_background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType)
      ),
      color: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/templates/client/requests/ToggleStarBackgroundRequest.ts
var ToggleStarBackgroundRequest;
var init_ToggleStarBackgroundRequest = __esm({
  "src/serialization/resources/templates/client/requests/ToggleStarBackgroundRequest.ts"() {
    "use strict";
    init_core();
    ToggleStarBackgroundRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/DeleteBackgroundV2Request.ts
var DeleteBackgroundV2Request;
var init_DeleteBackgroundV2Request = __esm({
  "src/serialization/resources/templates/client/requests/DeleteBackgroundV2Request.ts"() {
    "use strict";
    init_core();
    DeleteBackgroundV2Request = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/CreateOrganizationTemplateRequest.ts
var CreateOrganizationTemplateRequest;
var init_CreateOrganizationTemplateRequest = __esm({
  "src/serialization/resources/templates/client/requests/CreateOrganizationTemplateRequest.ts"() {
    "use strict";
    init_core();
    CreateOrganizationTemplateRequest = schemas_exports.object({
      backgroundId: schemas_exports.property(
        "background_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      backgroundUrl: schemas_exports.property("background_url", schemas_exports.string()),
      clipLabel: schemas_exports.property("clip_label", schemas_exports.string()),
      elementEdits: schemas_exports.property(
        "element_edits",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ElementEdit)).optional()
      ),
      aspectRatio: schemas_exports.property(
        "aspect_ratio",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AspectRatio)
      ),
      templateMediaType: schemas_exports.property(
        "template_media_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CoverFormat)
      ),
      transition: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Transition).optional(),
      backgroundType: schemas_exports.property(
        "background_type",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BackgroundType)
      ),
      color: schemas_exports.string().optional(),
      duration: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/templates/client/requests/DeleteOrganizationTemplateRequest.ts
var DeleteOrganizationTemplateRequest;
var init_DeleteOrganizationTemplateRequest = __esm({
  "src/serialization/resources/templates/client/requests/DeleteOrganizationTemplateRequest.ts"() {
    "use strict";
    init_core();
    DeleteOrganizationTemplateRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/templates/client/requests/SetDefaultTemplateRequest.ts
var SetDefaultTemplateRequest;
var init_SetDefaultTemplateRequest = __esm({
  "src/serialization/resources/templates/client/requests/SetDefaultTemplateRequest.ts"() {
    "use strict";
    init_core();
    SetDefaultTemplateRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      clipLabel: schemas_exports.property("clip_label", schemas_exports.string())
    });
  }
});

// src/serialization/resources/templates/client/requests/SetDefaultBackgroundV2Request.ts
var SetDefaultBackgroundV2Request;
var init_SetDefaultBackgroundV2Request = __esm({
  "src/serialization/resources/templates/client/requests/SetDefaultBackgroundV2Request.ts"() {
    "use strict";
    init_core();
    SetDefaultBackgroundV2Request = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      padding: schemas_exports.number().optional(),
      borderRadius: schemas_exports.property("border_radius", schemas_exports.number().optional()),
      shadow: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/templates/client/requests/index.ts
var init_requests29 = __esm({
  "src/serialization/resources/templates/client/requests/index.ts"() {
    "use strict";
    init_CreateCoverRequest();
    init_SetDefaultCoverRequest();
    init_CreateBackgroundRequest();
    init_SetDefaultBackgroundRequest();
    init_SetDefaultTransitionRequest();
    init_DeleteCoverRequest();
    init_DeleteBackgroundRequest();
    init_UpdateCoverRequest();
    init_AddBackgroundToOrganizationRequest();
    init_ToggleStarBackgroundRequest();
    init_DeleteBackgroundV2Request();
    init_CreateOrganizationTemplateRequest();
    init_DeleteOrganizationTemplateRequest();
    init_SetDefaultTemplateRequest();
    init_SetDefaultBackgroundV2Request();
  }
});

// src/serialization/resources/templates/client/index.ts
var init_client64 = __esm({
  "src/serialization/resources/templates/client/index.ts"() {
    "use strict";
    init_initiateLogoUpload4();
    init_finishLogoUpload4();
    init_initiateAssetUpload2();
    init_createCover2();
    init_setDefaultCover2();
    init_createBackground2();
    init_setDefaultBackground2();
    init_setDefaultTransition2();
    init_deleteCover2();
    init_deleteBackground2();
    init_updateCover2();
    init_addBackgroundToOrganization2();
    init_toggleStarBackground2();
    init_deleteBackgroundV22();
    init_createOrganizationTemplate2();
    init_deleteOrganizationTemplate2();
    init_setDefaultTemplate2();
    init_setDefaultBackgroundV22();
    init_requests29();
  }
});

// src/serialization/resources/templates/index.ts
var templates_exports2 = {};
__export(templates_exports2, {
  AddBackgroundToOrganizationRequest: () => AddBackgroundToOrganizationRequest,
  AspectRatio: () => AspectRatio,
  Audio: () => Audio,
  Background: () => Background,
  BackgroundOption: () => BackgroundOption,
  BackgroundType: () => BackgroundType2,
  Border: () => Border,
  BorderType: () => BorderType2,
  Cover: () => Cover,
  CoverFormat: () => CoverFormat2,
  CoverOption: () => CoverOption,
  CoverType: () => CoverType2,
  CoverVersion: () => CoverVersion2,
  CreateBackgroundRequest: () => CreateBackgroundRequest,
  CreateCoverRequest: () => CreateCoverRequest,
  CreateOrganizationTemplateRequest: () => CreateOrganizationTemplateRequest,
  DeleteBackgroundRequest: () => DeleteBackgroundRequest,
  DeleteBackgroundV2Request: () => DeleteBackgroundV2Request,
  DeleteCoverRequest: () => DeleteCoverRequest,
  DeleteOrganizationTemplateRequest: () => DeleteOrganizationTemplateRequest,
  Logo: () => Logo2,
  OrganizationBackground: () => OrganizationBackground,
  OrganizationTemplate: () => OrganizationTemplate,
  PremadeBackground: () => PremadeBackground,
  SetDefaultBackgroundRequest: () => SetDefaultBackgroundRequest,
  SetDefaultBackgroundV2Request: () => SetDefaultBackgroundV2Request,
  SetDefaultCoverRequest: () => SetDefaultCoverRequest,
  SetDefaultTemplateRequest: () => SetDefaultTemplateRequest,
  SetDefaultTransitionRequest: () => SetDefaultTransitionRequest,
  ToggleStarBackgroundRequest: () => ToggleStarBackgroundRequest,
  Transition: () => Transition,
  UpdateCoverRequest: () => UpdateCoverRequest,
  addBackgroundToOrganization: () => addBackgroundToOrganization_exports2,
  createBackground: () => createBackground_exports2,
  createCover: () => createCover_exports2,
  createOrganizationTemplate: () => createOrganizationTemplate_exports2,
  deleteBackground: () => deleteBackground_exports2,
  deleteBackgroundV2: () => deleteBackgroundV2_exports2,
  deleteCover: () => deleteCover_exports2,
  deleteOrganizationTemplate: () => deleteOrganizationTemplate_exports2,
  finishLogoUpload: () => finishLogoUpload_exports4,
  initiateAssetUpload: () => initiateAssetUpload_exports2,
  initiateLogoUpload: () => initiateLogoUpload_exports4,
  setDefaultBackground: () => setDefaultBackground_exports2,
  setDefaultBackgroundV2: () => setDefaultBackgroundV2_exports2,
  setDefaultCover: () => setDefaultCover_exports2,
  setDefaultTemplate: () => setDefaultTemplate_exports2,
  setDefaultTransition: () => setDefaultTransition_exports2,
  toggleStarBackground: () => toggleStarBackground_exports2,
  updateCover: () => updateCover_exports2
});
var init_templates2 = __esm({
  "src/serialization/resources/templates/index.ts"() {
    "use strict";
    init_types64();
    init_client64();
  }
});

// src/serialization/resources/users/types/UserRole.ts
var UserRole2;
var init_UserRole2 = __esm({
  "src/serialization/resources/users/types/UserRole.ts"() {
    "use strict";
    init_core();
    UserRole2 = schemas_exports.enum_(["editor", "admin"]);
  }
});

// src/serialization/resources/users/types/User.ts
var User;
var init_User2 = __esm({
  "src/serialization/resources/users/types/User.ts"() {
    "use strict";
    init_core();
    User = schemas_exports.object({
      name: schemas_exports.string().optional(),
      email: schemas_exports.string(),
      role: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Role),
      organizationId: schemas_exports.property(
        "organization_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/users/types/LoginResponse.ts
var LoginResponse;
var init_LoginResponse2 = __esm({
  "src/serialization/resources/users/types/LoginResponse.ts"() {
    "use strict";
    init_core();
    LoginResponse = schemas_exports.object({
      associatedToOrg: schemas_exports.property("associated_to_org", schemas_exports.boolean()),
      ssoLogin: schemas_exports.property("sso_login", schemas_exports.boolean())
    });
  }
});

// src/serialization/resources/users/types/InitRequest.ts
var InitRequest;
var init_InitRequest2 = __esm({
  "src/serialization/resources/users/types/InitRequest.ts"() {
    "use strict";
    init_core();
    InitRequest = schemas_exports.object({
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      )
    });
  }
});

// src/serialization/resources/users/types/InitResponse.ts
var InitResponse;
var init_InitResponse2 = __esm({
  "src/serialization/resources/users/types/InitResponse.ts"() {
    "use strict";
    init_core();
    InitResponse = schemas_exports.object({
      userWithOrg: schemas_exports.property(
        "user_with_org",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthenticatedUserWithOrg)
      ),
      hostname: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/users/types/ExtendedInitResponse.ts
var ExtendedInitResponse;
var init_ExtendedInitResponse2 = __esm({
  "src/serialization/resources/users/types/ExtendedInitResponse.ts"() {
    "use strict";
    init_core();
    ExtendedInitResponse = schemas_exports.object({
      userWithCurrentOrg: schemas_exports.property(
        "user_with_current_org",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthenticatedUserWithOrg)
      ),
      currentOrgHostname: schemas_exports.property("current_org_hostname", schemas_exports.string().optional()),
      basePlanDetails: schemas_exports.property(
        "base_plan_details",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.BasePlanDetails)
      ),
      languages: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Language)),
      voices: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice))
    });
  }
});

// src/serialization/resources/users/types/LoginResponseOldVersion.ts
var LoginResponseOldVersion;
var init_LoginResponseOldVersion2 = __esm({
  "src/serialization/resources/users/types/LoginResponseOldVersion.ts"() {
    "use strict";
    init_core();
    LoginResponseOldVersion = schemas_exports.object({
      associatedToOrg: schemas_exports.property("associated_to_org", schemas_exports.boolean())
    });
  }
});

// src/serialization/resources/users/types/index.ts
var init_types65 = __esm({
  "src/serialization/resources/users/types/index.ts"() {
    "use strict";
    init_UserRole2();
    init_User2();
    init_LoginResponse2();
    init_InitRequest2();
    init_InitResponse2();
    init_ExtendedInitResponse2();
    init_LoginResponseOldVersion2();
  }
});

// src/serialization/resources/users/client/login.ts
var login_exports2 = {};
__export(login_exports2, {
  Error: () => Error434
});
var Error434;
var init_login2 = __esm({
  "src/serialization/resources/users/client/login.ts"() {
    "use strict";
    init_src();
    init_core();
    Error434 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      SSOEnabledEmail_OrganizationCreationNotAllowed: schemas_exports.object({}),
      SSOEnabledEmail_ExternalEmailError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.login.Error.unauthorizedError();
          case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            return api_exports.users.login.Error.ssoEnabledEmailOrganizationCreationNotAllowed();
          case "SSOEnabledEmail_ExternalEmailError":
            return api_exports.users.login.Error.ssoEnabledEmailExternalEmailError();
          case "UsageLimitExceededError":
            return api_exports.users.login.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.login.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/loginV2.ts
var loginV2_exports2 = {};
__export(loginV2_exports2, {
  Error: () => Error435
});
var Error435;
var init_loginV22 = __esm({
  "src/serialization/resources/users/client/loginV2.ts"() {
    "use strict";
    init_src();
    init_core();
    Error435 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      SSOEnabledEmail_OrganizationCreationNotAllowed: schemas_exports.object({}),
      SSOEnabledEmail_ExternalEmailError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.loginV2.Error.unauthorizedError();
          case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            return api_exports.users.loginV2.Error.ssoEnabledEmailOrganizationCreationNotAllowed();
          case "SSOEnabledEmail_ExternalEmailError":
            return api_exports.users.loginV2.Error.ssoEnabledEmailExternalEmailError();
          case "UsageLimitExceededError":
            return api_exports.users.loginV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.loginV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/getUsers.ts
var getUsers_exports4 = {};
__export(getUsers_exports4, {
  Error: () => Error436,
  Response: () => Response82
});
var Response82, Error436;
var init_getUsers4 = __esm({
  "src/serialization/resources/users/client/getUsers.ts"() {
    "use strict";
    init_src();
    init_core();
    Response82 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InitResponse));
    Error436 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.getUsers.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.users.getUsers.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.getUsers.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/initialize.ts
var initialize_exports2 = {};
__export(initialize_exports2, {
  Error: () => Error437
});
var Error437;
var init_initialize2 = __esm({
  "src/serialization/resources/users/client/initialize.ts"() {
    "use strict";
    init_src();
    init_core();
    Error437 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.initialize.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.users.initialize.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.initialize.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/initializeV2.ts
var initializeV2_exports2 = {};
__export(initializeV2_exports2, {
  Error: () => Error438
});
var Error438;
var init_initializeV22 = __esm({
  "src/serialization/resources/users/client/initializeV2.ts"() {
    "use strict";
    init_src();
    init_core();
    Error438 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.initializeV2.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.users.initializeV2.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.initializeV2.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/getAssociatedOrgs.ts
var getAssociatedOrgs_exports2 = {};
__export(getAssociatedOrgs_exports2, {
  Error: () => Error439,
  Response: () => Response83
});
var Response83, Error439;
var init_getAssociatedOrgs2 = __esm({
  "src/serialization/resources/users/client/getAssociatedOrgs.ts"() {
    "use strict";
    init_src();
    init_core();
    Response83 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).organizations.Organization)
    );
    Error439 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.getAssociatedOrgs.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.users.getAssociatedOrgs.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.getAssociatedOrgs.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/getUserForGuide.ts
var getUserForGuide_exports2 = {};
__export(getUserForGuide_exports2, {
  Error: () => Error440
});
var Error440;
var init_getUserForGuide2 = __esm({
  "src/serialization/resources/users/client/getUserForGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error440 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.users.getUserForGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.users.getUserForGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.users.getUserForGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/users/client/index.ts
var init_client65 = __esm({
  "src/serialization/resources/users/client/index.ts"() {
    "use strict";
    init_login2();
    init_loginV22();
    init_getUsers4();
    init_initialize2();
    init_initializeV22();
    init_getAssociatedOrgs2();
    init_getUserForGuide2();
  }
});

// src/serialization/resources/users/index.ts
var users_exports2 = {};
__export(users_exports2, {
  ExtendedInitResponse: () => ExtendedInitResponse,
  InitRequest: () => InitRequest,
  InitResponse: () => InitResponse,
  LoginResponse: () => LoginResponse,
  LoginResponseOldVersion: () => LoginResponseOldVersion,
  User: () => User,
  UserRole: () => UserRole2,
  getAssociatedOrgs: () => getAssociatedOrgs_exports2,
  getUserForGuide: () => getUserForGuide_exports2,
  getUsers: () => getUsers_exports4,
  initialize: () => initialize_exports2,
  initializeV2: () => initializeV2_exports2,
  login: () => login_exports2,
  loginV2: () => loginV2_exports2
});
var init_users2 = __esm({
  "src/serialization/resources/users/index.ts"() {
    "use strict";
    init_types65();
    init_client65();
  }
});

// src/serialization/resources/video/resources/videoEdits/types/Version.ts
var Version2;
var init_Version2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/Version.ts"() {
    "use strict";
    init_core();
    Version2 = schemas_exports.enum_(["oct162023", "may012024", "aug012024"]);
  }
});

// src/serialization/resources/video/resources/videoEdits/types/ZoomEdit.ts
var ZoomEdit;
var init_ZoomEdit2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/ZoomEdit.ts"() {
    "use strict";
    init_core();
    ZoomEdit = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      startTime: schemas_exports.number(),
      endTime: schemas_exports.number(),
      zoomCenter: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Coordinates),
      zoomFactor: schemas_exports.number(),
      transitionTime: schemas_exports.number().optional()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/VideoEdits.ts
var VideoEdits;
var init_VideoEdits2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/VideoEdits.ts"() {
    "use strict";
    init_core();
    VideoEdits = schemas_exports.object({
      version: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Version),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VoiceEdits).optional(),
      intro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Cover).optional(),
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Background).optional(),
      border: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Border).optional(),
      outro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Cover).optional(),
      zooms: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.ZoomEdit)).optional(),
      elements: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ElementEdit)).optional(),
      crop: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Crop).optional(),
      aspectRatio: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AspectRatio).optional(),
      subtitlesSettings: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.SubtitlesSettings).optional()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/Crop.ts
var Crop2;
var init_Crop4 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/Crop.ts"() {
    "use strict";
    init_core();
    Crop2 = schemas_exports.object({
      position: schemas_exports.list(schemas_exports.number()),
      size: schemas_exports.list(schemas_exports.number())
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/SubtitlesSettings.ts
var SubtitlesSettings;
var init_SubtitlesSettings2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/SubtitlesSettings.ts"() {
    "use strict";
    init_core();
    SubtitlesSettings = schemas_exports.object({
      showSubtitles: schemas_exports.boolean(),
      size: schemas_exports.number()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/index.ts
var init_types66 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/index.ts"() {
    "use strict";
    init_Version2();
    init_ZoomEdit2();
    init_VideoEdits2();
    init_Crop4();
    init_SubtitlesSettings2();
  }
});

// src/serialization/resources/video/resources/videoEdits/index.ts
var videoEdits_exports2 = {};
__export(videoEdits_exports2, {
  Crop: () => Crop2,
  SubtitlesSettings: () => SubtitlesSettings,
  Version: () => Version2,
  VideoEdits: () => VideoEdits,
  ZoomEdit: () => ZoomEdit
});
var init_videoEdits2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/index.ts"() {
    "use strict";
    init_types66();
  }
});

// src/serialization/resources/video/resources/index.ts
var init_resources14 = __esm({
  "src/serialization/resources/video/resources/index.ts"() {
    "use strict";
    init_videoEdits2();
    init_types66();
  }
});

// src/serialization/resources/video/index.ts
var video_exports2 = {};
__export(video_exports2, {
  Crop: () => Crop2,
  SubtitlesSettings: () => SubtitlesSettings,
  Version: () => Version2,
  VideoEdits: () => VideoEdits,
  ZoomEdit: () => ZoomEdit,
  videoEdits: () => videoEdits_exports2
});
var init_video2 = __esm({
  "src/serialization/resources/video/index.ts"() {
    "use strict";
    init_resources14();
  }
});

// src/serialization/resources/externalAuth/client/createToken.ts
var createToken_exports2 = {};
__export(createToken_exports2, {
  Error: () => Error441
});
var Error441;
var init_createToken2 = __esm({
  "src/serialization/resources/externalAuth/client/createToken.ts"() {
    "use strict";
    init_src();
    init_core();
    Error441 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.externalAuth.createToken.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.externalAuth.createToken.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.externalAuth.createToken.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/externalAuth/client/requests/CreateTokenRequest.ts
var CreateTokenRequest;
var init_CreateTokenRequest = __esm({
  "src/serialization/resources/externalAuth/client/requests/CreateTokenRequest.ts"() {
    "use strict";
    init_core();
    CreateTokenRequest = schemas_exports.object({
      username: schemas_exports.string()
    });
  }
});

// src/serialization/resources/externalAuth/client/requests/index.ts
var init_requests30 = __esm({
  "src/serialization/resources/externalAuth/client/requests/index.ts"() {
    "use strict";
    init_CreateTokenRequest();
  }
});

// src/serialization/resources/externalAuth/client/index.ts
var init_client66 = __esm({
  "src/serialization/resources/externalAuth/client/index.ts"() {
    "use strict";
    init_createToken2();
    init_requests30();
  }
});

// src/serialization/resources/externalAuth/index.ts
var externalAuth_exports2 = {};
__export(externalAuth_exports2, {
  CreateTokenRequest: () => CreateTokenRequest,
  createToken: () => createToken_exports2
});
var init_externalAuth2 = __esm({
  "src/serialization/resources/externalAuth/index.ts"() {
    "use strict";
    init_client66();
  }
});

// src/serialization/resources/healthcheck/client/healthcheck.ts
var healthcheck_exports3 = {};
__export(healthcheck_exports3, {
  Error: () => Error442
});
var Error442;
var init_healthcheck3 = __esm({
  "src/serialization/resources/healthcheck/client/healthcheck.ts"() {
    "use strict";
    init_src();
    init_core();
    Error442 = schemas_exports.union("error", {
      UnavailabilityError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody)
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnavailabilityError":
            return api_exports.healthcheck.healthcheck.Error.unavailabilityError();
          case "UsageLimitExceededError":
            return api_exports.healthcheck.healthcheck.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.healthcheck.healthcheck.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/healthcheck/client/index.ts
var init_client67 = __esm({
  "src/serialization/resources/healthcheck/client/index.ts"() {
    "use strict";
    init_healthcheck3();
  }
});

// src/serialization/resources/healthcheck/index.ts
var healthcheck_exports4 = {};
__export(healthcheck_exports4, {
  healthcheck: () => healthcheck_exports3
});
var init_healthcheck4 = __esm({
  "src/serialization/resources/healthcheck/index.ts"() {
    "use strict";
    init_client67();
  }
});

// src/serialization/resources/internal/resources/exporter/client/getGuide.ts
var getGuide_exports2 = {};
__export(getGuide_exports2, {
  Error: () => Error443
});
var Error443;
var init_getGuide2 = __esm({
  "src/serialization/resources/internal/resources/exporter/client/getGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error443 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      UsageLimitExceededError: schemas_exports.object({
        content: schemas_exports.lazyObject(
          async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UsageLimitExceededErrorBody
        )
      }),
      ActionNotPermittedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.internal.exporter.getGuide.Error.unauthorizedError();
          case "UsageLimitExceededError":
            return api_exports.internal.exporter.getGuide.Error.usageLimitExceededError(value.content);
          case "ActionNotPermittedError":
            return api_exports.internal.exporter.getGuide.Error.actionNotPermittedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/internal/resources/exporter/client/index.ts
var init_client68 = __esm({
  "src/serialization/resources/internal/resources/exporter/client/index.ts"() {
    "use strict";
    init_getGuide2();
  }
});

// src/serialization/resources/internal/resources/exporter/index.ts
var exporter_exports2 = {};
__export(exporter_exports2, {
  getGuide: () => getGuide_exports2
});
var init_exporter2 = __esm({
  "src/serialization/resources/internal/resources/exporter/index.ts"() {
    "use strict";
    init_client68();
  }
});

// src/serialization/resources/internal/resources/index.ts
var init_resources15 = __esm({
  "src/serialization/resources/internal/resources/index.ts"() {
    "use strict";
    init_exporter2();
  }
});

// src/serialization/resources/internal/index.ts
var internal_exports2 = {};
__export(internal_exports2, {
  exporter: () => exporter_exports2
});
var init_internal2 = __esm({
  "src/serialization/resources/internal/index.ts"() {
    "use strict";
    init_resources15();
  }
});

// src/serialization/resources/index.ts
var init_resources16 = __esm({
  "src/serialization/resources/index.ts"() {
    "use strict";
    init_admin2();
    init_types34();
    init_analytics2();
    init_types35();
    init_audio2();
    init_types36();
    init_auth3();
    init_types37();
    init_baseTypes2();
    init_types38();
    init_collections2();
    init_elementEdit2();
    init_types42();
    init_guides2();
    init_helpcenterQueries2();
    init_types51();
    init_helpcenter2();
    init_integrations2();
    init_organizations2();
    init_posthog2();
    init_types62();
    init_settings2();
    init_types63();
    init_templates2();
    init_types64();
    init_users2();
    init_types65();
    init_video2();
    init_externalAuth2();
    init_healthcheck4();
    init_internal2();
    init_requests17();
    init_requests30();
    init_requests24();
    init_requests29();
  }
});

// src/serialization/index.ts
var serialization_exports = {};
__export(serialization_exports, {
  AddBackgroundToOrganizationRequest: () => AddBackgroundToOrganizationRequest,
  ApplicationAuthLogin: () => ApplicationAuthLogin,
  ArticleUsageEvent: () => ArticleUsageEvent,
  AspectRatio: () => AspectRatio,
  Audio: () => Audio,
  AuthType: () => AuthType2,
  AuthenticatedUser: () => AuthenticatedUser,
  AuthenticatedUserWithOrg: () => AuthenticatedUserWithOrg,
  Background: () => Background,
  BackgroundOption: () => BackgroundOption,
  BackgroundType: () => BackgroundType2,
  BaseResponse: () => BaseResponse,
  Border: () => Border,
  BorderType: () => BorderType2,
  CaputreEventRequest: () => CaputreEventRequest,
  Coordinates: () => Coordinates,
  Cover: () => Cover,
  CoverFormat: () => CoverFormat2,
  CoverOption: () => CoverOption,
  CoverType: () => CoverType2,
  CoverVersion: () => CoverVersion2,
  CreateBackgroundRequest: () => CreateBackgroundRequest,
  CreateCoverRequest: () => CreateCoverRequest,
  CreateOrganizationTemplateRequest: () => CreateOrganizationTemplateRequest,
  CreateTokenRequest: () => CreateTokenRequest,
  CreateUserRequest: () => CreateUserRequest,
  Crop: () => Crop,
  DeleteBackgroundRequest: () => DeleteBackgroundRequest,
  DeleteBackgroundV2Request: () => DeleteBackgroundV2Request,
  DeleteCoverRequest: () => DeleteCoverRequest,
  DeleteOrganizationTemplateRequest: () => DeleteOrganizationTemplateRequest,
  ElementEdit: () => ElementEdit,
  ElementGeo: () => ElementGeo2,
  EmailLogin: () => EmailLogin,
  EventsResponse: () => EventsResponse,
  ExtendedInitResponse: () => ExtendedInitResponse,
  FaviconInputType: () => FaviconInputType,
  FeatureFlags: () => FeatureFlags,
  FeedbacksTableResponse: () => FeedbacksTableResponse,
  FeedbacksTableResponseData: () => FeedbacksTableResponseData,
  FetchAppAuthDetailsRequest: () => FetchAppAuthDetailsRequest,
  FetchAppAuthDetailsResponse: () => FetchAppAuthDetailsResponse,
  FetchAuthTypeRequest: () => FetchAuthTypeRequest,
  FetchAuthTypeResponse: () => FetchAuthTypeResponse,
  FetchEmailAuthDetailsRequest: () => FetchEmailAuthDetailsRequest,
  FetchEmailAuthDetailsResponse: () => FetchEmailAuthDetailsResponse,
  FetchPasswordAuthDetailsRequest: () => FetchPasswordAuthDetailsRequest,
  FetchPasswordAuthDetailsResponse: () => FetchPasswordAuthDetailsResponse,
  GeneratePreviewAudioRequest: () => GeneratePreviewAudioRequest,
  GetArticleUsageResponse: () => GetArticleUsageResponse,
  GetChildrenRequest: () => GetChildrenRequest,
  GetFeatureFlagsResponse: () => GetFeatureFlagsResponse,
  GetHelpCenterConfigRequest: () => GetHelpCenterConfigRequest,
  GetPronDictEntryRequest: () => GetPronDictEntryRequest,
  GetPronDictRequest: () => GetPronDictRequest,
  GetUsageRequest: () => GetUsageRequest,
  GetVideoUsageResponse: () => GetVideoUsageResponse,
  GuidesTableResponse: () => GuidesTableResponse,
  GuidesTableResponseData: () => GuidesTableResponseData,
  HelpCenterConfig: () => HelpCenterConfig,
  HelpCenterTab: () => HelpCenterTab,
  HostingDetails: () => HostingDetails2,
  HostingInfo: () => HostingInfo,
  Id: () => Id2,
  IdRequest: () => IdRequest,
  ImageData: () => ImageData,
  ImageType: () => ImageType2,
  ImpressionsLineChartResponse: () => ImpressionsLineChartResponse,
  ImpressionsLineChartResponseData: () => ImpressionsLineChartResponseData,
  InitRequest: () => InitRequest,
  InitResponse: () => InitResponse,
  InitiateBackgroundAudioUploadResponse: () => InitiateBackgroundAudioUploadResponse,
  InitiateUploadResponse: () => InitiateUploadResponse,
  InvalidSessionErrorBody: () => InvalidSessionErrorBody,
  Language: () => Language,
  LimitExceededErrorBody: () => LimitExceededErrorBody,
  LoginResponse: () => LoginResponse,
  LoginResponseOldVersion: () => LoginResponseOldVersion,
  Logo: () => Logo2,
  LogoInputType: () => LogoInputType,
  OrgAndConfig: () => OrgAndConfig,
  OrganizationBackground: () => OrganizationBackground,
  OrganizationTemplate: () => OrganizationTemplate,
  PasswordLogin: () => PasswordLogin,
  PremadeBackground: () => PremadeBackground,
  PresignedUrl: () => PresignedUrl,
  ProjectAnalyticsTableResponse: () => ProjectAnalyticsTableResponse,
  ProjectAnalyticsTableResponseData: () => ProjectAnalyticsTableResponseData,
  ProjectRatingsTableResponse: () => ProjectRatingsTableResponse,
  ProjectRatingsTableResponseData: () => ProjectRatingsTableResponseData,
  ProjectsOpenedStackedBarGraphResponse: () => ProjectsOpenedStackedBarGraphResponse,
  PronDictEntry: () => PronDictEntry,
  PronDictEntryRequest: () => PronDictEntryRequest,
  Role: () => Role2,
  S3Object: () => S3Object,
  SaveGuideAudioRequest: () => SaveGuideAudioRequest,
  SearchAnalyticsTableResponse: () => SearchAnalyticsTableResponse,
  SearchAnalyticsTableResponseData: () => SearchAnalyticsTableResponseData,
  SearchRequest: () => SearchRequest2,
  SetAppAuthDetailsRequest: () => SetAppAuthDetailsRequest,
  SetAuthTypeRequest: () => SetAuthTypeRequest,
  SetDefaultBackgroundRequest: () => SetDefaultBackgroundRequest,
  SetDefaultBackgroundV2Request: () => SetDefaultBackgroundV2Request,
  SetDefaultCoverRequest: () => SetDefaultCoverRequest,
  SetDefaultTemplateRequest: () => SetDefaultTemplateRequest,
  SetDefaultTransitionRequest: () => SetDefaultTransitionRequest,
  SetEmailAuthDetailsRequest: () => SetEmailAuthDetailsRequest,
  SetFeatureFlagsRequest: () => SetFeatureFlagsRequest,
  SetHelpCenterConfigRequest: () => SetHelpCenterConfigRequest,
  SetPasswordAuthDetailsRequest: () => SetPasswordAuthDetailsRequest,
  ShapeData: () => ShapeData,
  SimpleResponse: () => SimpleResponse,
  TextAlignment: () => TextAlignment2,
  TextData: () => TextData,
  ToggleStarBackgroundRequest: () => ToggleStarBackgroundRequest,
  Token: () => Token,
  Transcript: () => Transcript,
  Transition: () => Transition,
  UpdateCoverRequest: () => UpdateCoverRequest,
  UpdateUserRequest: () => UpdateUserRequest,
  UpdateUserRoleRequest: () => UpdateUserRoleRequest,
  UsageLimitExceededErrorBody: () => UsageLimitExceededErrorBody,
  User: () => User,
  UserInOrg: () => UserInOrg,
  UserRole: () => UserRole2,
  VideoAnalyticsTableResponse: () => VideoAnalyticsTableResponse,
  VideoFormat: () => VideoFormat,
  VideoPlaysLineChartResponse: () => VideoPlaysLineChartResponse,
  VideoPlaysLineChartResponseData: () => VideoPlaysLineChartResponseData,
  VideoUsageEvent: () => VideoUsageEvent,
  VideosPlayedStackedBarGraphResponse: () => VideosPlayedStackedBarGraphResponse,
  admin: () => admin_exports2,
  analytics: () => analytics_exports2,
  audio: () => audio_exports2,
  auth: () => auth_exports2,
  baseTypes: () => baseTypes_exports2,
  collections: () => collections_exports2,
  elementEdit: () => elementEdit_exports2,
  externalAuth: () => externalAuth_exports2,
  guides: () => guides_exports2,
  healthcheck: () => healthcheck_exports4,
  helpcenter: () => helpcenter_exports2,
  helpcenterQueries: () => helpcenterQueries_exports2,
  integrations: () => integrations_exports2,
  internal: () => internal_exports2,
  organizations: () => organizations_exports2,
  posthog: () => posthog_exports2,
  settings: () => settings_exports2,
  templates: () => templates_exports2,
  users: () => users_exports2,
  video: () => video_exports2
});
var init_serialization = __esm({
  "src/serialization/index.ts"() {
    "use strict";
    init_resources16();
  }
});

// src/api/resources/admin/client/Client.ts
var import_url_join, Admin;
var init_Client = __esm({
  "src/api/resources/admin/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join = __toESM(require_url_join());
    init_serialization();
    Admin = class {
      constructor(options) {
        this.options = options;
      }
      async getStagingJwt(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getStagingJWT"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.getStagingJwt.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getStagingJwt.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getStagingJwt.Error._unknown(_response.error)
        };
      }
      async createUser(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/createUser"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await User.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await User.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "LimitExceededError":
            case "UserAlreadyExistsError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.createUser.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.createUser.Error._unknown(_response.error)
        };
      }
      async deleteUser(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/deleteUser"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await admin_exports2.deleteUser.Request.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.deleteUser.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.deleteUser.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.deleteUser.Error._unknown(_response.error)
        };
      }
      async getUsers() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getUsers"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.getUsers.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getUsers.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getUsers.Error._unknown(_response.error)
        };
      }
      async getHelpCenterConfig(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getHelpCenterConfig"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetHelpCenterConfigRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.getHelpCenterConfig.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getHelpCenterConfig.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getHelpCenterConfig.Error._unknown(_response.error)
        };
      }
      async setHelpCenterConfig(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setHelpCenterConfig"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetHelpCenterConfigRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await HelpCenterConfig.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setHelpCenterConfig.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setHelpCenterConfig.Error._unknown(_response.error)
        };
      }
      async setLogo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setLogo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await LogoInputType.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setLogo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setLogo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setLogo.Error._unknown(_response.error)
        };
      }
      async setFavicon(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setFavicon"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await FaviconInputType.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setFavicon.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setFavicon.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setFavicon.Error._unknown(_response.error)
        };
      }
      async getHostingDetails() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getHostingDetails"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await HostingDetails2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getHostingDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getHostingDetails.Error._unknown(_response.error)
        };
      }
      async setHostingDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setHostingDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await HostingDetails2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await HostingDetails2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setHostingDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setHostingDetails.Error._unknown(_response.error)
        };
      }
      async fetchAuthType(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/fetchAuthType"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await FetchAuthTypeRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await FetchAuthTypeResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.fetchAuthType.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.fetchAuthType.Error._unknown(_response.error)
        };
      }
      async setAuthType(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setAuthType"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetAuthTypeRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setAuthType.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setAuthType.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setAuthType.Error._unknown(_response.error)
        };
      }
      async fetchPasswordAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/fetchPasswordAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await FetchPasswordAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await FetchPasswordAuthDetailsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.fetchPasswordAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.fetchPasswordAuthDetails.Error._unknown(_response.error)
        };
      }
      async setPasswordAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setPasswordAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetPasswordAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setPasswordAuthDetails.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setPasswordAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setPasswordAuthDetails.Error._unknown(_response.error)
        };
      }
      async fetchAppAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/fetchAppAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await FetchAppAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await FetchAppAuthDetailsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.fetchAppAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.fetchAppAuthDetails.Error._unknown(_response.error)
        };
      }
      async setAppAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setAppAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetAppAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setAppAuthDetails.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setAppAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setAppAuthDetails.Error._unknown(_response.error)
        };
      }
      async fetchEmailAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/fetchEmailAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await FetchEmailAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await FetchEmailAuthDetailsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.fetchEmailAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.fetchEmailAuthDetails.Error._unknown(_response.error)
        };
      }
      async setEmailAuthDetails(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/setEmailAuthDetails"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetEmailAuthDetailsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await admin_exports2.setEmailAuthDetails.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.setEmailAuthDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.setEmailAuthDetails.Error._unknown(_response.error)
        };
      }
      async getUsageVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getUsageVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetUsageRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await GetVideoUsageResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getUsageVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getUsageVideo.Error._unknown(_response.error)
        };
      }
      async getUsageArticle(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/admin/getUsageArticle"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetUsageRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await GetArticleUsageResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await admin_exports2.getUsageArticle.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.admin.getUsageArticle.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/analytics/client/Client.ts
var import_url_join2, Analytics;
var init_Client2 = __esm({
  "src/api/resources/analytics/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join2 = __toESM(require_url_join());
    init_serialization();
    Analytics = class {
      constructor(options) {
        this.options = options;
      }
      async getEventData(request = {}) {
        const { startDate, endDate, guideId } = request;
        const _queryParams = new URLSearchParams();
        if (startDate != null) {
          _queryParams.append("start_date", startDate);
        }
        if (endDate != null) {
          _queryParams.append("end_date", endDate);
        }
        if (guideId != null) {
          _queryParams.append("guide_id", guideId);
        }
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join2.default)(this.options.environment, "/analytics/getEventData"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          queryParameters: _queryParams
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await EventsResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await analytics_exports2.getEventData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.analytics.getEventData.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/audio/client/Client.ts
var import_url_join3, Audio2;
var init_Client3 = __esm({
  "src/api/resources/audio/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join3 = __toESM(require_url_join());
    init_serialization();
    Audio2 = class {
      constructor(options) {
        this.options = options;
      }
      async initiateBackgroundAudioUpload() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/initiateBackgroundAudioUpload"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateBackgroundAudioUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.initiateBackgroundAudioUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.initiateBackgroundAudioUpload.Error._unknown(_response.error)
        };
      }
      async finishCreateBackgroundAudioUpload(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/finishCreateBackgroundAudioUpload"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.AudioTrack.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await audio_exports2.finishCreateBackgroundAudioUpload.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.finishCreateBackgroundAudioUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.finishCreateBackgroundAudioUpload.Error._unknown(_response.error)
        };
      }
      async deleteAudio(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/deleteAudio"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.AudioTrack.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await audio_exports2.deleteAudio.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.deleteAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.deleteAudio.Error._unknown(_response.error)
        };
      }
      async favoriteAudio(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/favoriteAudio"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.AudioTrack.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await audio_exports2.favoriteAudio.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "ExistsInFavoritesError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.favoriteAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.favoriteAudio.Error._unknown(_response.error)
        };
      }
      async unfavoriteAudio(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/unfavoriteAudio"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.AudioTrack.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await audio_exports2.unfavoriteAudio.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.unfavoriteAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.unfavoriteAudio.Error._unknown(_response.error)
        };
      }
      async saveAudio() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/saveAudio"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.saveAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.saveAudio.Error._unknown(_response.error)
        };
      }
      async saveGuideAudio(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/saveGuideAudio"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.saveGuideAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.saveGuideAudio.Error._unknown(_response.error)
        };
      }
      async saveGuideAudioUpdated(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/audio/saveGuideAudioUpdated"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SaveGuideAudioRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await audio_exports2.saveGuideAudioUpdated.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.saveGuideAudioUpdated.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/auth/client/Client.ts
var import_url_join4, Auth;
var init_Client4 = __esm({
  "src/api/resources/auth/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join4 = __toESM(require_url_join());
    init_serialization();
    Auth = class {
      constructor(options) {
        this.options = options;
      }
      async createUserWebhook(request) {
        const { svixId, svixSignature, svixTimestamp, body: _body } = request;
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/auth/createUser"),
          method: "POST",
          headers: {
            "svix-id": svixId,
            "svix-signature": svixSignature,
            "svix-timestamp": svixTimestamp,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateUserRequest.jsonOrThrow(_body)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await auth_exports2.createUserWebhook.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UserEntryAlreadyExistsError":
            case "InvalidEventTypeForWebhookError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await auth_exports2.createUserWebhook.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.auth.createUserWebhook.Error._unknown(_response.error)
        };
      }
      async updateUserWebhook(request) {
        const { svixId, svixSignature, svixTimestamp, body: _body } = request;
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/auth/updateUser"),
          method: "POST",
          headers: {
            "svix-id": svixId,
            "svix-signature": svixSignature,
            "svix-timestamp": svixTimestamp,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await UpdateUserRequest.jsonOrThrow(_body)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await auth_exports2.updateUserWebhook.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UserEntryAlreadyExistsError":
            case "InvalidEventTypeForWebhookError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await auth_exports2.updateUserWebhook.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.auth.updateUserWebhook.Error._unknown(_response.error)
        };
      }
      async updateUserRoleInOrg(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/auth/updateUserRoleInOrg"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await UpdateUserRoleRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await auth_exports2.updateUserRoleInOrg.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UserNotInOrganizationError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await auth_exports2.updateUserRoleInOrg.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.auth.updateUserRoleInOrg.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/Client.ts
var import_url_join5, CollectionMutations;
var init_Client5 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join5 = __toESM(require_url_join());
    init_serialization();
    CollectionMutations = class {
      constructor(options) {
        this.options = options;
      }
      async createCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/createCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.CollectionInput.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.Collection.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.createCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.createCollection.Error._unknown(_response.error)
        };
      }
      async updateCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/updateCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.Collection.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.updateCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.updateCollection.Error._unknown(_response.error)
        };
      }
      async moveCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/moveCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.MoveCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.Collection.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.moveCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.moveCollection.Error._unknown(_response.error)
        };
      }
      async deleteCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/deleteCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.DeleteCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.deleteCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.deleteCollection.Error._unknown(_response.error)
        };
      }
      async reorderCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/reorderCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.ReorderCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.reorderCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.reorderCollection.Error._unknown(_response.error)
        };
      }
      async setCollectionVisibility(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/setCollectionVisibility"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.SetCollectionVisibility.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.setCollectionVisibility.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.setCollectionVisibility.Error._unknown(_response.error)
        };
      }
      async fetchCollectionData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/fetchCollectionData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.FetchCollectionDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.Collection.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.fetchCollectionData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.fetchCollectionData.Error._unknown(_response.error)
        };
      }
      async getChildGuidesCreationStatus(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/collection_mutations/getChildGuidesCreationStatus"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.GetChildGuidesCreationStatusRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetChildGuidesCreationStatusResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.getChildGuidesCreationStatus.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.getChildGuidesCreationStatus.Error._unknown(
            _response.error
          )
        };
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/Client.ts
var import_url_join6, CollectionQueries;
var init_Client6 = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join6 = __toESM(require_url_join());
    init_serialization();
    CollectionQueries = class {
      constructor(options) {
        this.options = options;
      }
      async getCollections(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/getCollections"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getCollections.Error._unknown(_response.error)
        };
      }
      async getAllChildren(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/getAllChildren"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetAllChildrenResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getAllChildren.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getAllChildren.Error._unknown(_response.error)
        };
      }
      async getAllCollections() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/getAllCollections"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.collectionQueries.getAllCollections.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getAllCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getAllCollections.Error._unknown(_response.error)
        };
      }
      async getAllActiveCutsCollections() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/getAllActiveCutsCollections"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.collectionQueries.getAllActiveCutsCollections.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getAllActiveCutsCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getAllActiveCutsCollections.Error._unknown(
            _response.error
          )
        };
      }
      async getPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/getPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await IdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getPath.Error._unknown(_response.error)
        };
      }
      async validateCollectionUrlPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/collection_queries/validateCollectionUrlPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.ValidateCollectionUrlPathRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.ValidateCollectionUrlPathResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.validateCollectionUrlPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.validateCollectionUrlPath.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/collections/client/Client.ts
var Collections;
var init_Client7 = __esm({
  "src/api/resources/collections/client/Client.ts"() {
    "use strict";
    init_Client5();
    init_Client6();
    Collections = class {
      constructor(options) {
        this.options = options;
      }
      _collectionMutations;
      get collectionMutations() {
        return this._collectionMutations ??= new CollectionMutations(this.options);
      }
      _collectionQueries;
      get collectionQueries() {
        return this._collectionQueries ??= new CollectionQueries(this.options);
      }
    };
  }
});

// src/api/resources/externalAuth/client/Client.ts
var import_url_join7, ExternalAuth;
var init_Client8 = __esm({
  "src/api/resources/externalAuth/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join7 = __toESM(require_url_join());
    init_serialization();
    ExternalAuth = class {
      constructor(options) {
        this.options = options;
      }
      async createToken(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/externalAuth/createToken"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateTokenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Token.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await externalAuth_exports2.createToken.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.externalAuth.createToken.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/aiEnhance/client/Client.ts
var import_url_join8, AiEnhance;
var init_Client9 = __esm({
  "src/api/resources/guides/resources/aiEnhance/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join8 = __toESM(require_url_join());
    init_serialization();
    AiEnhance = class {
      constructor(options) {
        this.options = options;
      }
      async enhanceArticleAsync(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join8.default)(this.options.environment, "/ai_enhance/enhanceArticleAsync"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.aiEnhance.enhanceArticleAsync.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.aiEnhance.enhanceArticleAsync.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.aiEnhance.enhanceArticleAsync.Error._unknown(_response.error)
        };
      }
      async enhanceVideoTranscriptAsync(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join8.default)(this.options.environment, "/ai_enhance/enhanceVideoTranscriptAsync"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.aiEnhance.enhanceVideoTranscriptAsync.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.aiEnhance.enhanceVideoTranscriptAsync.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.aiEnhance.enhanceVideoTranscriptAsync.Error._unknown(_response.error)
        };
      }
      async translateGuideAndDuplicate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join8.default)(this.options.environment, "/ai_enhance/translateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.TranslateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.aiEnhance.translateGuideAndDuplicate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.aiEnhance.translateGuideAndDuplicate.Error._unknown(_response.error)
        };
      }
      async inlineEnhanceText(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join8.default)(this.options.environment, "/ai_enhance/inlineEnhanceText"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.EnhanceTextRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.aiEnhance.inlineEnhanceText.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.aiEnhance.inlineEnhanceText.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.aiEnhance.inlineEnhanceText.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/broadcasts/client/Client.ts
var import_url_join9, Broadcasts;
var init_Client10 = __esm({
  "src/api/resources/guides/resources/broadcasts/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join9 = __toESM(require_url_join());
    init_serialization();
    Broadcasts = class {
      constructor(options) {
        this.options = options;
      }
      async getBroadcasts() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/getBroadcasts"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.broadcasts.getBroadcasts.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.getBroadcasts.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.getBroadcasts.Error._unknown(_response.error)
        };
      }
      async getBroadcast(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/getBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GetBroadcastResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.getBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.getBroadcast.Error._unknown(_response.error)
        };
      }
      async createBroadcast(request = {}) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/createBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CreateBroadcastRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.createBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.createBroadcast.Error._unknown(_response.error)
        };
      }
      async deleteBroadcast(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/deleteBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.deleteBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.deleteBroadcast.Error._unknown(_response.error)
        };
      }
      async updateBroadcast(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/updateBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UpdateBroadcastRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.updateBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.updateBroadcast.Error._unknown(_response.error)
        };
      }
      async sendBroadcast(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/sendBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.SendBroadcastRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.sendBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.sendBroadcast.Error._unknown(_response.error)
        };
      }
      async initiateBroadcastIconUpload() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/initiateLogoUpload"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.initiateBroadcastIconUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.initiateBroadcastIconUpload.Error._unknown(_response.error)
        };
      }
      async customizeBroadcastBot(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/broadcasts/customizeBroadcastBot"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CustomizeBroadcastBotRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.broadcasts.customizeBroadcastBot.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.broadcasts.customizeBroadcastBot.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideAiChat/client/Client.ts
var import_url_join10, GuideAiChat;
var init_Client11 = __esm({
  "src/api/resources/guides/resources/guideAiChat/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join10 = __toESM(require_url_join());
    init_serialization();
    GuideAiChat = class {
      constructor(options) {
        this.options = options;
      }
      async sendMessage(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/guideAIChat/sendMessage"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.SendMessageRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideAiChat.sendMessage.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideAiChat.sendMessage.Error._unknown(_response.error)
        };
      }
      async deleteChatForAGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/guideAIChat/deleteChatForAGuide"),
          method: "PATCH",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DeleteChatForAGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideAiChat.deleteChatForAGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideAiChat.deleteChatForAGuide.Error._unknown(_response.error)
        };
      }
      async deleteMessageById(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/guideAIChat/deleteMessageById"),
          method: "PATCH",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DeleteMessageByIdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideAiChat.deleteMessageById.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideAiChat.deleteMessageById.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideExports/client/Client.ts
var import_url_join11, GuideExports;
var init_Client12 = __esm({
  "src/api/resources/guides/resources/guideExports/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join11 = __toESM(require_url_join());
    init_serialization();
    GuideExports = class {
      constructor(options) {
        this.options = options;
      }
      async exportVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/exportVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideExports.exportVideo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UnsubscribedOrgError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.exportVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.exportVideo.Error._unknown(_response.error)
        };
      }
      async exportVideoV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/exportVideoV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideExports.exportVideoV2.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UnsubscribedOrgError":
            case "ErrorWhileProcessingVideoExportRequest":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.exportVideoV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.exportVideoV2.Error._unknown(_response.error)
        };
      }
      async convertToGif(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/convertToGif"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportGifRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.ConvertToGifResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.convertToGif.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.convertToGif.Error._unknown(_response.error)
        };
      }
      async exportGif(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/exportGif"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportGifRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideExports.exportGif.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.exportGif.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.exportGif.Error._unknown(_response.error)
        };
      }
      async exportGifV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/exportGifV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportGifRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideExports.exportGifV2.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UnsubscribedOrgError":
            case "ErrorWhileProcessingVideoExportRequest":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.exportGifV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.exportGifV2.Error._unknown(_response.error)
        };
      }
      async exportArticle(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/exportArticle"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.ExportArticleResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UnsubscribedOrgError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.exportArticle.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.exportArticle.Error._unknown(_response.error)
        };
      }
      async getPastExports(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join11.default)(this.options.environment, "/guide_exports/getPastExports"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetPastExportsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GetPastExportsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UnsubscribedOrgError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideExports.getPastExports.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideExports.getPastExports.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/Client.ts
var import_url_join12, GuideMutations;
var init_Client13 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join12 = __toESM(require_url_join());
    init_serialization();
    GuideMutations = class {
      constructor(options) {
        this.options = options;
      }
      async generateVoiceover(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/generateVoiceover"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GenerateVoiceoverRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.generateVoiceover.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "GuideIncompatibleError":
            case "TranscriptionMatchingError":
            case "ScreenshotOrderingError":
            case "UnsubscribedOrgError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.generateVoiceover.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.generateVoiceover.Error._unknown(_response.error)
        };
      }
      async publishGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/publishGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PublishGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.publishGuide.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "GuideIncompatibleError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.publishGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.publishGuide.Error._unknown(_response.error)
        };
      }
      async publishGuideV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/publishGuideV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PublishGuideV2Request.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PublishGuideV2Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.publishGuideV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.publishGuideV2.Error._unknown(_response.error)
        };
      }
      async finishCreateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/finishCreateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishCreateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishCreateGuide.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishCreateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishCreateGuide.Error._unknown(_response.error)
        };
      }
      async autoUpdateGuideVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/autoUpdateGuideVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.AutoUpdateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.autoUpdateGuideVideo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.autoUpdateGuideVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.autoUpdateGuideVideo.Error._unknown(_response.error)
        };
      }
      async initiateCreateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/initiateCreateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateCreateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateCreateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateCreateGuide.Error._unknown(_response.error)
        };
      }
      async initiateUploadCreate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/initiateUploadCreate"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateUploadCreateRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.InitiateUploadCreateResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateUploadCreate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateUploadCreate.Error._unknown(_response.error)
        };
      }
      async uploadImage(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/uploadImage"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.uploadImage.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.uploadImage.Error._unknown(_response.error)
        };
      }
      async uploadVideoChunk(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/uploadVideoChunk"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UploadChunkRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.uploadVideoChunk.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.uploadVideoChunk.Error._unknown(_response.error)
        };
      }
      async compileVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/compileVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CompileVideoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.CompileVideoResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.compileVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.compileVideo.Error._unknown(_response.error)
        };
      }
      async updateGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/updateGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.Guide.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PresignedUrlsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateGuideData.Error._unknown(_response.error)
        };
      }
      async updateOriginalEdits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/updateOriginalEdits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UpdateOriginalEditsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateOriginalEdits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateOriginalEdits.Error._unknown(_response.error)
        };
      }
      async initiateUploadSource(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/initiateUploadSource"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateUploadSourceRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateUploadSource.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateUploadSource.Error._unknown(_response.error)
        };
      }
      async finishUploadSource(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/finishUploadSource"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishUploadSourceRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUploadSource.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUploadSource.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUploadSource.Error._unknown(_response.error)
        };
      }
      async finishUpdateGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/finishUpdateGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishUpdateGuideDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUpdateGuideData.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUpdateGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUpdateGuideData.Error._unknown(_response.error)
        };
      }
      async createEmptyTextGuide(request = {}) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/createEmptyTextGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CreateEmptyTextGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.createEmptyTextGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.createEmptyTextGuide.Error._unknown(_response.error)
        };
      }
      async updateGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/updateGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuidePreview.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateGuidePreview.Error._unknown(_response.error)
        };
      }
      async pinGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/pinGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PinGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.pinGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.pinGuide.Error._unknown(_response.error)
        };
      }
      async deleteGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/deleteGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DeleteGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.deleteGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.deleteGuide.Error._unknown(_response.error)
        };
      }
      async moveGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/moveGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.MoveGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.moveGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.moveGuide.Error._unknown(_response.error)
        };
      }
      async reorderGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/reorderGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ReorderGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.reorderGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.reorderGuide.Error._unknown(_response.error)
        };
      }
      async finishUploadCreate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/finishUploadCreate"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishUploadCreate.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUploadCreate.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUploadCreate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUploadCreate.Error._unknown(_response.error)
        };
      }
      async duplicateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/duplicateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.duplicateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.duplicateGuide.Error._unknown(_response.error)
        };
      }
      async restoreVersion(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/restoreVersion"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.RestoreVersionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.RestoreVersionResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.restoreVersion.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.restoreVersion.Error._unknown(_response.error)
        };
      }
      async validateGuideUrlPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/validateGuideUrlPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ValidateGuideUrlRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.ValidateGuideUrlResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.validateGuideUrlPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.validateGuideUrlPath.Error._unknown(_response.error)
        };
      }
      async updatedLatestThumbnail(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/updatedLatestThumbnail"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UpdateLatestThumbnailRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.updatedLatestThumbnail.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updatedLatestThumbnail.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updatedLatestThumbnail.Error._unknown(_response.error)
        };
      }
      async initiateUploadAndSuggestSplits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/initiateUploadAndSuggestSplits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateUploadAndSuggestSplitsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.InitiateUploadAndSuggestSplitsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateUploadAndSuggestSplits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateUploadAndSuggestSplits.Error._unknown(_response.error)
        };
      }
      async finishUploadAndSuggestSplits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/finishUploadAndSuggestSplits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishUploadAndSuggestSplitsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUploadAndSuggestSplits.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUploadAndSuggestSplits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUploadAndSuggestSplits.Error._unknown(_response.error)
        };
      }
      async generateGuidesBasedOnSplits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join12.default)(this.options.environment, "/guide_mutations/generateGuidesBasedOnSplits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GenerateGuidesBasedonSplitsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.generateGuidesBasedOnSplits.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.generateGuidesBasedOnSplits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.generateGuidesBasedOnSplits.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guidePlatformStatus/client/Client.ts
var import_url_join13, GuidePlatformStatus2;
var init_Client14 = __esm({
  "src/api/resources/guides/resources/guidePlatformStatus/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join13 = __toESM(require_url_join());
    init_serialization();
    GuidePlatformStatus2 = class {
      constructor(options) {
        this.options = options;
      }
      async getStatus(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join13.default)(this.options.environment, "/platformStatus/getStatus"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePlatformStatus.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guidePlatformStatus.getStatus.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guidePlatformStatus.getStatus.Error._unknown(_response.error)
        };
      }
      async markErrorViewed(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join13.default)(this.options.environment, "/platformStatus/markErrorViewed"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guidePlatformStatus.markErrorViewed.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guidePlatformStatus.markErrorViewed.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guidePlatformStatus.markErrorViewed.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/Client.ts
var import_url_join14, GuideQueries;
var init_Client15 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join14 = __toESM(require_url_join());
    init_serialization();
    GuideQueries = class {
      constructor(options) {
        this.options = options;
      }
      async search(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/search"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.SearchRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.search.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.search.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.search.Error._unknown(_response.error)
        };
      }
      async getGuidePreviews(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getGuidePreviews"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getAllGuidePreviews() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getAllGuidePreviews"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getAllGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getAllGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getAllGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getRecentGuidePreviews() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getRecentGuidePreviews"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getRecentGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getRecentGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getRecentGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuideDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuideData.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuideData.Error._unknown(_response.error)
        };
      }
      async getGuidePlatformData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getGuidePlatformData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuideDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePlatformData.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuidePlatformData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuidePlatformData.Error._unknown(_response.error)
        };
      }
      async getGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuidePreviewRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "NoAccessError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuidePreview.Error._unknown(_response.error)
        };
      }
      async getAllVersions(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join14.default)(this.options.environment, "/guide_queries/getAllVersions"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuidePreviewRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getAllVersions.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getAllVersions.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getAllVersions.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/prompts/client/Client.ts
var import_url_join15, Prompts;
var init_Client16 = __esm({
  "src/api/resources/guides/resources/prompts/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join15 = __toESM(require_url_join());
    init_serialization();
    Prompts = class {
      constructor(options) {
        this.options = options;
      }
      async getPrompts(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join15.default)(this.options.environment, "/prompts/getPrompts"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetPromptsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GetPromptsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.prompts.getPrompts.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.prompts.getPrompts.Error._unknown(_response.error)
        };
      }
      async createPrompt(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join15.default)(this.options.environment, "/prompts/createPrompt"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CreatePromptRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.prompts.createPrompt.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.prompts.createPrompt.Error._unknown(_response.error)
        };
      }
      async deletePrompt(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join15.default)(this.options.environment, "/prompts/deletePrompt"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DeletePromptRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.prompts.deletePrompt.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.prompts.deletePrompt.Error._unknown(_response.error)
        };
      }
      async updatePrompt(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join15.default)(this.options.environment, "/prompts/updatePrompt"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UpdatePromptRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.prompts.updatePrompt.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.prompts.updatePrompt.Error._unknown(_response.error)
        };
      }
      async applyPrompt(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join15.default)(this.options.environment, "/prompts/applyPrompt"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ApplyPromptRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await guides_exports2.prompts.applyPrompt.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.prompts.applyPrompt.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/client/Client.ts
var Guides;
var init_Client17 = __esm({
  "src/api/resources/guides/client/Client.ts"() {
    "use strict";
    init_Client9();
    init_Client10();
    init_Client11();
    init_Client12();
    init_Client13();
    init_Client14();
    init_Client15();
    init_Client16();
    Guides = class {
      constructor(options) {
        this.options = options;
      }
      _aiEnhance;
      get aiEnhance() {
        return this._aiEnhance ??= new AiEnhance(this.options);
      }
      _broadcasts;
      get broadcasts() {
        return this._broadcasts ??= new Broadcasts(this.options);
      }
      _guideAiChat;
      get guideAiChat() {
        return this._guideAiChat ??= new GuideAiChat(this.options);
      }
      _guideExports;
      get guideExports() {
        return this._guideExports ??= new GuideExports(this.options);
      }
      _guideMutations;
      get guideMutations() {
        return this._guideMutations ??= new GuideMutations(this.options);
      }
      _guidePlatformStatus;
      get guidePlatformStatus() {
        return this._guidePlatformStatus ??= new GuidePlatformStatus2(this.options);
      }
      _guideQueries;
      get guideQueries() {
        return this._guideQueries ??= new GuideQueries(this.options);
      }
      _prompts;
      get prompts() {
        return this._prompts ??= new Prompts(this.options);
      }
    };
  }
});

// src/api/resources/healthcheck/client/Client.ts
var import_url_join16, Healthcheck;
var init_Client18 = __esm({
  "src/api/resources/healthcheck/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join16 = __toESM(require_url_join());
    init_serialization();
    Healthcheck = class {
      constructor(options) {
        this.options = options;
      }
      async healthcheck() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join16.default)(this.options.environment, "/healthcheck"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnavailabilityError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await healthcheck_exports4.healthcheck.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.healthcheck.healthcheck.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/Client.ts
var import_url_join17, HelpcenterQueries;
var init_Client19 = __esm({
  "src/api/resources/helpcenterQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join17 = __toESM(require_url_join());
    init_serialization();
    HelpcenterQueries = class {
      constructor(options) {
        this.options = options;
      }
      async validateToken(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/validateToken"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Token.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.validateToken.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.validateToken.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.validateToken.Error._unknown(_response.error)
        };
      }
      async getOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getOrganization.Error._unknown(_response.error)
        };
      }
      async getOrgAndConfig() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getOrgAndConfig"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await OrgAndConfig.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getOrgAndConfig.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getOrgAndConfig.Error._unknown(_response.error)
        };
      }
      async search(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/search"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SearchRequest2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.search.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.search.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.search.Error._unknown(_response.error)
        };
      }
      async getGuidePreviews(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getGuidePreviews"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getAllGuidePreviews() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getAllGuidePreviews"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getAllGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuideDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuideData.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuideData.Error._unknown(_response.error)
        };
      }
      async getGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuidePreviewRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuidePreview.Error._unknown(_response.error)
        };
      }
      async getCollections(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getCollections"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getCollections.Error._unknown(_response.error)
        };
      }
      async getAllChildren(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getAllChildren"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetAllChildrenResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllChildren.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllChildren.Error._unknown(_response.error)
        };
      }
      async getAllCollections() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getAllCollections"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getAllCollections.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllCollections.Error._unknown(_response.error)
        };
      }
      async getPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join17.default)(this.options.environment, "/helpcenterQueries/getPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await IdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getPath.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/helpcenter/resources/helpcenterMutations/client/Client.ts
var import_url_join18, HelpcenterMutations;
var init_Client20 = __esm({
  "src/api/resources/helpcenter/resources/helpcenterMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join18 = __toESM(require_url_join());
    init_serialization();
    HelpcenterMutations = class {
      constructor(options) {
        this.options = options;
      }
      async getDnsStatus() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/getDnsStatus"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.helpcenterMutations.getDnsStatus.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.getDnsStatus.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.getDnsStatus.Error._unknown(_response.error)
        };
      }
      async validateDnsRecord(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/validateDnsRecord"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await helpcenter_exports2.UpdateOrValidateDnsRecordRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.ValidateDnsRecordResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.validateDnsRecord.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.validateDnsRecord.Error._unknown(_response.error)
        };
      }
      async updateDnsRecord(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/updateDnsRecord"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await helpcenter_exports2.UpdateOrValidateDnsRecordRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.helpcenterMutations.updateDnsRecord.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "RecordAlreadyInUseError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.updateDnsRecord.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.updateDnsRecord.Error._unknown(_response.error)
        };
      }
      async customDomainSetup(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/customDomainSetup"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await helpcenter_exports2.CustomDomainSetupRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.CustomDomainSetupResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "RecordAlreadyInUseError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.customDomainSetup.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.customDomainSetup.Error._unknown(_response.error)
        };
      }
      async deleteDomain(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/deleteDomain"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await helpcenter_exports2.CustomDomainSetupRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.helpcenterMutations.deleteDomain.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.deleteDomain.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.deleteDomain.Error._unknown(_response.error)
        };
      }
      async verifyDomainSetup(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/verifyDomainSetup"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await helpcenter_exports2.CustomDomainSetupRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.VerifyDnsRecordResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.verifyDomainSetup.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.verifyDomainSetup.Error._unknown(_response.error)
        };
      }
      async getHelpcenterUrls() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join18.default)(this.options.environment, "/helpcenterMutations/getHelpcenterUrls"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenter_exports2.helpcenterMutations.getHelpcenterUrls.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await helpcenter_exports2.helpcenterMutations.getHelpcenterUrls.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenter.helpcenterMutations.getHelpcenterUrls.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/helpcenter/client/Client.ts
var Helpcenter;
var init_Client21 = __esm({
  "src/api/resources/helpcenter/client/Client.ts"() {
    "use strict";
    init_Client20();
    Helpcenter = class {
      constructor(options) {
        this.options = options;
      }
      _helpcenterMutations;
      get helpcenterMutations() {
        return this._helpcenterMutations ??= new HelpcenterMutations(this.options);
      }
    };
  }
});

// src/api/resources/integrations/resources/integrationSetup/client/Client.ts
var import_url_join19, IntegrationSetup;
var init_Client22 = __esm({
  "src/api/resources/integrations/resources/integrationSetup/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join19 = __toESM(require_url_join());
    init_serialization();
    IntegrationSetup = class {
      constructor(options) {
        this.options = options;
      }
      async loadIntegrations() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join19.default)(this.options.environment, "/integration_setup/loadIntegrations"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.LoadIntegrationsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.integrationSetup.loadIntegrations.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.integrationSetup.loadIntegrations.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/integrations/resources/slack/client/Client.ts
var import_url_join20, Slack;
var init_Client23 = __esm({
  "src/api/resources/integrations/resources/slack/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join20 = __toESM(require_url_join());
    init_serialization();
    Slack = class {
      constructor(options) {
        this.options = options;
      }
      async checkSlackIntegration() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/checkSlackIntegration"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.checkSlackIntegration.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.checkSlackIntegration.Error._unknown(_response.error)
        };
      }
      async getAuthUrl(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/getAuthUrl"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.GetIntegrationAuthUrlRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.IntegrationAuthUrlResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.getAuthUrl.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.getAuthUrl.Error._unknown(_response.error)
        };
      }
      async handleOAuthCallback(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/handleOAuthCallback"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.IntegrationOAuthCallbackRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.handleOAuthCallback.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.handleOAuthCallback.Error._unknown(_response.error)
        };
      }
      async disconnectIntegration(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/disconnectIntegration"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.DisconnectIntegrationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.slack.disconnectIntegration.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.disconnectIntegration.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.disconnectIntegration.Error._unknown(_response.error)
        };
      }
      async getChannels() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/getChannels"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.ChannelsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.getChannels.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.getChannels.Error._unknown(_response.error)
        };
      }
      async sendBroadcast(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join20.default)(this.options.environment, "/slack/sendBroadcast"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.SendBroadcastRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.slack.sendBroadcast.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.slack.sendBroadcast.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/integrations/resources/youtube/client/Client.ts
var import_url_join21, Youtube;
var init_Client24 = __esm({
  "src/api/resources/integrations/resources/youtube/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join21 = __toESM(require_url_join());
    init_serialization();
    Youtube = class {
      constructor(options) {
        this.options = options;
      }
      async getIntegrationDetails() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/getIntegrationDetails"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.IntegrationDetails.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.getIntegrationDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.getIntegrationDetails.Error._unknown(_response.error)
        };
      }
      async getAuthUrl(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/getAuthUrl"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.GetIntegrationAuthUrlRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.IntegrationAuthUrlResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.getAuthUrl.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.getAuthUrl.Error._unknown(_response.error)
        };
      }
      async handleOAuthCallback(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/handleOAuthCallback"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.IntegrationOAuthCallbackRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "NoChannelFoundError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.handleOAuthCallback.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.handleOAuthCallback.Error._unknown(_response.error)
        };
      }
      async disconnectIntegration(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/disconnectIntegration"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.DisconnectIntegrationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.youtube.disconnectIntegration.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.disconnectIntegration.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.disconnectIntegration.Error._unknown(_response.error)
        };
      }
      async getPlayListsDetails() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/getPlayListsDetails"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.GetPlaylistsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.getPlayListsDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.getPlayListsDetails.Error._unknown(_response.error)
        };
      }
      async publishToYouTube(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join21.default)(this.options.environment, "/youtube/publishToYouTube"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await integrations_exports2.PublishToYouTubeRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await integrations_exports2.youtube.publishToYouTube.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await integrations_exports2.youtube.publishToYouTube.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.integrations.youtube.publishToYouTube.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/integrations/client/Client.ts
var Integrations;
var init_Client25 = __esm({
  "src/api/resources/integrations/client/Client.ts"() {
    "use strict";
    init_Client22();
    init_Client23();
    init_Client24();
    Integrations = class {
      constructor(options) {
        this.options = options;
      }
      _integrationSetup;
      get integrationSetup() {
        return this._integrationSetup ??= new IntegrationSetup(this.options);
      }
      _slack;
      get slack() {
        return this._slack ??= new Slack(this.options);
      }
      _youtube;
      get youtube() {
        return this._youtube ??= new Youtube(this.options);
      }
    };
  }
});

// src/api/resources/internal/resources/exporter/client/Client.ts
var import_url_join22, Exporter;
var init_Client26 = __esm({
  "src/api/resources/internal/resources/exporter/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join22 = __toESM(require_url_join());
    init_serialization();
    Exporter = class {
      constructor(options) {
        this.options = options;
      }
      async getGuide(guideId) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join22.default)(this.options.environment, `/exporter/getGuide/${guideId}`),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.Guide.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await internal_exports2.exporter.getGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.internal.exporter.getGuide.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/internal/client/Client.ts
var Internal;
var init_Client27 = __esm({
  "src/api/resources/internal/client/Client.ts"() {
    "use strict";
    init_Client26();
    Internal = class {
      constructor(options) {
        this.options = options;
      }
      _exporter;
      get exporter() {
        return this._exporter ??= new Exporter(this.options);
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationBranding/client/Client.ts
var import_url_join23, OrganizationBranding;
var init_Client28 = __esm({
  "src/api/resources/organizations/resources/organizationBranding/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join23 = __toESM(require_url_join());
    init_serialization();
    OrganizationBranding = class {
      constructor(options) {
        this.options = options;
      }
      async initiateLogoUpload() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join23.default)(this.options.environment, "/organization-branding/initiate-logo-upload"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationBranding.initiateLogoUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationBranding.initiateLogoUpload.Error._unknown(_response.error)
        };
      }
      async finishLogoUpload(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join23.default)(this.options.environment, "/organization-branding/finish-logo-upload"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.FinishLogoUploadRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.OrganizationLogo.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationBranding.finishLogoUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationBranding.finishLogoUpload.Error._unknown(_response.error)
        };
      }
      async deleteLogo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join23.default)(this.options.environment, "/organization-branding/delete-logo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.DeleteLogoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationBranding.deleteLogo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationBranding.deleteLogo.Error._unknown(_response.error)
        };
      }
      async updateLogo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join23.default)(this.options.environment, "/organization-branding/update-logo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.UpdateLogoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.OrganizationLogo.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationBranding.updateLogo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationBranding.updateLogo.Error._unknown(_response.error)
        };
      }
      async getLogos() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join23.default)(this.options.environment, "/organization-branding/get-logos"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationBranding.getLogos.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationBranding.getLogos.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationBranding.getLogos.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organizations/resources/organizationMutations/client/Client.ts
var import_url_join24, OrganizationMutations;
var init_Client29 = __esm({
  "src/api/resources/organizations/resources/organizationMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join24 = __toESM(require_url_join());
    init_serialization();
    OrganizationMutations = class {
      constructor(options) {
        this.options = options;
      }
      async createOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/createOrganization"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.CreateOrganizationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "OrganizationAlreadyExistsError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.createOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.createOrganization.Error._unknown(_response.error)
        };
      }
      async listEligibleOrganizations() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/listEligibleOrganizations"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.listEligibleOrganizations.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.listEligibleOrganizations.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.listEligibleOrganizations.Error._unknown(
            _response.error
          )
        };
      }
      async joinOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/joinOrganization"),
          method: "PUT",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.JoinOrganizationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "LimitExceededError":
            case "UserAlreadyInOrganizationError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.joinOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.joinOrganization.Error._unknown(_response.error)
        };
      }
      async addUserToOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/addUserToOrganization"),
          method: "PUT",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.AddUserToOrganizationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.OrganizationWithListOfUsers.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "LimitExceededError":
            case "UserAlreadyInOrganizationError":
            case "SSOEnabledOrg_ExternalInviteError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.addUserToOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.addUserToOrganization.Error._unknown(
            _response.error
          )
        };
      }
      async listOrganizationsUserIsIn() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/listOrganizationsUserIsIn"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.listOrganizationsUserIsIn.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.listOrganizationsUserIsIn.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.listOrganizationsUserIsIn.Error._unknown(
            _response.error
          )
        };
      }
      async leaveOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/leaveOrg"),
          method: "PUT",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.leaveOrganization.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UserNotInOrganizationError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.leaveOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.leaveOrganization.Error._unknown(_response.error)
        };
      }
      async removeUserFromOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/removeUserFromOrg"),
          method: "PUT",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.RemoveUserFromOrgRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.removeUserFromOrganization.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UserNotInOrganizationError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.removeUserFromOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.removeUserFromOrganization.Error._unknown(
            _response.error
          )
        };
      }
      async listCreatorsInCurrentOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/listCreatorsInCurrentOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.listCreatorsInCurrentOrganization.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.listCreatorsInCurrentOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.listCreatorsInCurrentOrganization.Error._unknown(
            _response.error
          )
        };
      }
      async listInvitedUsersInCurrentOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/listInvitedUsersInCurrentOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.listInvitedUsersInCurrentOrganization.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.listInvitedUsersInCurrentOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.listInvitedUsersInCurrentOrganization.Error._unknown(
            _response.error
          )
        };
      }
      async getOpenDoorPolicy() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/getOpenDoorPolicy"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.getOpenDoorPolicy.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.getOpenDoorPolicy.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.getOpenDoorPolicy.Error._unknown(_response.error)
        };
      }
      async changeOpenDoorPolicy(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/changeOpenDoorPolicy"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.ChangeOpenDoorPolicyRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.changeOpenDoorPolicy.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.changeOpenDoorPolicy.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.changeOpenDoorPolicy.Error._unknown(_response.error)
        };
      }
      async changeRoleForUser(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/changeRoleForUser"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.ChangeRoleForUserRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.changeRoleForUser.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.changeRoleForUser.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.changeRoleForUser.Error._unknown(_response.error)
        };
      }
      async getName() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/getName"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.getName.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "QueryFailedError":
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.getName.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.getName.Error._unknown(_response.error)
        };
      }
      async changeName(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join24.default)(this.options.environment, "/organizationMutations/changeName"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.ChangeNameRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organizationMutations.changeName.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organizationMutations.changeName.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organizationMutations.changeName.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organizations/resources/organization/client/Client.ts
var import_url_join25, Organization2;
var init_Client30 = __esm({
  "src/api/resources/organizations/resources/organization/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join25 = __toESM(require_url_join());
    init_serialization();
    Organization2 = class {
      constructor(options) {
        this.options = options;
      }
      async getOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getOrganization.Error._unknown(_response.error)
        };
      }
      async getHostname() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getHostname"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organization.getHostname.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getHostname.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getHostname.Error._unknown(_response.error)
        };
      }
      async getPlatformDetails() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getPlatformDetails"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.PlatformDetails.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getPlatformDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getPlatformDetails.Error._unknown(_response.error)
        };
      }
      async getAllLanguages() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getAllLanguages"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.GetAllLanguagesResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getAllLanguages.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getAllLanguages.Error._unknown(_response.error)
        };
      }
      async getAllLanguagesChrext() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getAllLanguagesChrext"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.GetAllLanguagesResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getAllLanguagesChrext.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getAllLanguagesChrext.Error._unknown(_response.error)
        };
      }
      async getVoices(request = {}) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getVoices"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.GetVoicesRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.GetVoicesResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getVoices.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getVoices.Error._unknown(_response.error)
        };
      }
      async getOrganizationFromId(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getOrganizationFromId"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.GetOrganizationFromIdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getOrganizationFromId.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getOrganizationFromId.Error._unknown(_response.error)
        };
      }
      async getHostnameFromId(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getHostnameFromId"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.GetHostnameFromIdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organization.getHostnameFromId.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getHostnameFromId.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getHostnameFromId.Error._unknown(_response.error)
        };
      }
      async getOrganizationFromHostName(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getOrganizationFromHostName"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.GetOrganizationFromHostNameRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.Organization.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getOrganizationFromHostName.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getOrganizationFromHostName.Error._unknown(_response.error)
        };
      }
      async setDefaultVoice(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/setDefaultVoice"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.SetDefaultVoiceRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organization.setDefaultVoice.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "MutationFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.setDefaultVoice.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.setDefaultVoice.Error._unknown(_response.error)
        };
      }
      async getAllDefaultVoices() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/getAllDefaultVoices"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.GetAllDefaultVoicesResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.getAllDefaultVoices.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.getAllDefaultVoices.Error._unknown(_response.error)
        };
      }
      async deleteDefaultVoice(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join25.default)(this.options.environment, "/organization/deleteDefaultVoice"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.DeleteDefaultVoiceRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.organization.deleteDefaultVoice.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "MutationFailedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.organization.deleteDefaultVoice.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.organization.deleteDefaultVoice.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organizations/resources/subscriptions/client/Client.ts
var import_url_join26, Subscriptions;
var init_Client31 = __esm({
  "src/api/resources/organizations/resources/subscriptions/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join26 = __toESM(require_url_join());
    init_serialization();
    Subscriptions = class {
      constructor(options) {
        this.options = options;
      }
      async getBasePlanDetails() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/getBasePlanDetails"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.BasePlanDetails.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.getBasePlanDetails.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.getBasePlanDetails.Error._unknown(_response.error)
        };
      }
      async checkout(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/checkout"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.CheckoutRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.CheckoutResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "InvalidPlanError":
            case "DowngradedPlanExistsForNextCycleError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.checkout.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.checkout.Error._unknown(_response.error)
        };
      }
      async viewStripePortal() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/viewStripePortal"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.subscriptions.viewStripePortal.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.viewStripePortal.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.viewStripePortal.Error._unknown(_response.error)
        };
      }
      async validateCheckout(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/validateCheckout"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.subscriptions.validateCheckout.Request.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.subscriptions.validateCheckout.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.validateCheckout.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.validateCheckout.Error._unknown(_response.error)
        };
      }
      async isSingleUseAvailable(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/isSingleUseAvailable"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.subscriptions.isSingleUseAvailable.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.isSingleUseAvailable.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.isSingleUseAvailable.Error._unknown(_response.error)
        };
      }
      async checkFeatureAvailablity(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join26.default)(this.options.environment, "/subscription/checkFeatureAvailablity"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.CheckFeatureAvailablityRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.subscriptions.checkFeatureAvailablity.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.subscriptions.checkFeatureAvailablity.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.subscriptions.checkFeatureAvailablity.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organizations/resources/usageMetrics/client/Client.ts
var import_url_join27, UsageMetrics;
var init_Client32 = __esm({
  "src/api/resources/organizations/resources/usageMetrics/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join27 = __toESM(require_url_join());
    init_serialization();
    UsageMetrics = class {
      constructor(options) {
        this.options = options;
      }
      async getBasicUsageInActivePlan() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join27.default)(this.options.environment, "/usage_metrics/getBasicUsageInActivePlan"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.BasicUsageInActivePlan.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.usageMetrics.getBasicUsageInActivePlan.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.usageMetrics.getBasicUsageInActivePlan.Error._unknown(_response.error)
        };
      }
      async getSubscriptionCycles() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join27.default)(this.options.environment, "/usage_metrics/getSubscriptionCycles"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.usageMetrics.getSubscriptionCycles.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.usageMetrics.getSubscriptionCycles.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.usageMetrics.getSubscriptionCycles.Error._unknown(_response.error)
        };
      }
      async getUsageInSubscriptionCycle(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join27.default)(this.options.environment, "/usage_metrics/getUsageInSubscriptionCycle"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.UsageMetricsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.UsageMetricsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.usageMetrics.getUsageInSubscriptionCycle.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.usageMetrics.getUsageInSubscriptionCycle.Error._unknown(_response.error)
        };
      }
      async getUtilizationInACycle(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join27.default)(this.options.environment, "/usage_metrics/getUtilizationForACycle"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await organizations_exports2.UtilizationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organizations_exports2.UtilizationResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await organizations_exports2.usageMetrics.getUtilizationInACycle.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organizations.usageMetrics.getUtilizationInACycle.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organizations/client/Client.ts
var Organizations;
var init_Client33 = __esm({
  "src/api/resources/organizations/client/Client.ts"() {
    "use strict";
    init_Client28();
    init_Client29();
    init_Client30();
    init_Client31();
    init_Client32();
    Organizations = class {
      constructor(options) {
        this.options = options;
      }
      _organizationBranding;
      get organizationBranding() {
        return this._organizationBranding ??= new OrganizationBranding(this.options);
      }
      _organizationMutations;
      get organizationMutations() {
        return this._organizationMutations ??= new OrganizationMutations(this.options);
      }
      _organization;
      get organization() {
        return this._organization ??= new Organization2(this.options);
      }
      _subscriptions;
      get subscriptions() {
        return this._subscriptions ??= new Subscriptions(this.options);
      }
      _usageMetrics;
      get usageMetrics() {
        return this._usageMetrics ??= new UsageMetrics(this.options);
      }
    };
  }
});

// src/api/resources/posthog/client/Client.ts
var import_url_join28, Posthog;
var init_Client34 = __esm({
  "src/api/resources/posthog/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join28 = __toESM(require_url_join());
    init_serialization();
    Posthog = class {
      constructor(options) {
        this.options = options;
      }
      async captureEvent(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join28.default)(this.options.environment, "/posthog/capture-event"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CaputreEventRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await posthog_exports2.captureEvent.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.posthog.captureEvent.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/settings/client/Client.ts
var import_url_join29, Settings;
var init_Client35 = __esm({
  "src/api/resources/settings/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join29 = __toESM(require_url_join());
    init_serialization();
    Settings = class {
      constructor(options) {
        this.options = options;
      }
      async fetchPronDict(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/fetchPronDict"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetPronDictRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await settings_exports2.fetchPronDict.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.fetchPronDict.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.fetchPronDict.Error._unknown(_response.error)
        };
      }
      async addPronDictEntry(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/addPronDictEntry"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await PronDictEntryRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await settings_exports2.addPronDictEntry.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "EntryAlreadyExistsError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.addPronDictEntry.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.addPronDictEntry.Error._unknown(_response.error)
        };
      }
      async getPronDictEntry(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/getPronDictEntry"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetPronDictEntryRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PronDictEntry.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "EntryNotFoundError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.getPronDictEntry.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.getPronDictEntry.Error._unknown(_response.error)
        };
      }
      async deletePronDictEntry(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/deletePronDictEntry"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await PronDictEntryRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.deletePronDictEntry.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.deletePronDictEntry.Error._unknown(_response.error)
        };
      }
      async returnPreviewAudioBytes(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/returnPreviewAudioBytes"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GeneratePreviewAudioRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await settings_exports2.returnPreviewAudioBytes.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.returnPreviewAudioBytes.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.returnPreviewAudioBytes.Error._unknown(_response.error)
        };
      }
      async getFeatureFlags() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/getFeatureFlags"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await GetFeatureFlagsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.getFeatureFlags.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.getFeatureFlags.Error._unknown(_response.error)
        };
      }
      async setFeatureFlags(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join29.default)(this.options.environment, "/settings/setFeatureFlags"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetFeatureFlagsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await settings_exports2.setFeatureFlags.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await settings_exports2.setFeatureFlags.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.settings.setFeatureFlags.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/templates/client/Client.ts
var import_url_join30, Templates;
var init_Client36 = __esm({
  "src/api/resources/templates/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join30 = __toESM(require_url_join());
    init_serialization();
    Templates = class {
      constructor(options) {
        this.options = options;
      }
      async initiateLogoUpload() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/initiateLogoUpload"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.initiateLogoUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.initiateLogoUpload.Error._unknown(_response.error)
        };
      }
      async finishLogoUpload(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/finishLogoUpload"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Logo2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await templates_exports2.finishLogoUpload.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.finishLogoUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.finishLogoUpload.Error._unknown(_response.error)
        };
      }
      async initiateAssetUpload() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/initiateAssetUpload"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitiateUploadResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.initiateAssetUpload.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.initiateAssetUpload.Error._unknown(_response.error)
        };
      }
      async createCover(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/createCover"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateCoverRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await CoverOption.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.createCover.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.createCover.Error._unknown(_response.error)
        };
      }
      async setDefaultCover(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/setDefaultCover"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetDefaultCoverRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.setDefaultCover.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.setDefaultCover.Error._unknown(_response.error)
        };
      }
      async createBackground(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/createBackground"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateBackgroundRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await BackgroundOption.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.createBackground.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.createBackground.Error._unknown(_response.error)
        };
      }
      async setDefaultBackground(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/setDefaultBackground"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetDefaultBackgroundRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.setDefaultBackground.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.setDefaultBackground.Error._unknown(_response.error)
        };
      }
      async setDefaultTransition(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/setDefaultTransition"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetDefaultTransitionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.setDefaultTransition.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.setDefaultTransition.Error._unknown(_response.error)
        };
      }
      async deleteCover(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/deleteCover"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await DeleteCoverRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.deleteCover.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.deleteCover.Error._unknown(_response.error)
        };
      }
      async deleteBackground(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/deleteBackground"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await DeleteBackgroundRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.deleteBackground.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.deleteBackground.Error._unknown(_response.error)
        };
      }
      async updateCover(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/updateCover"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await UpdateCoverRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await CoverOption.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "CorruptedFileError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.updateCover.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.updateCover.Error._unknown(_response.error)
        };
      }
      async addBackgroundToOrganization(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/addBackgroundToOrganization"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await AddBackgroundToOrganizationRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await OrganizationBackground.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.addBackgroundToOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.addBackgroundToOrganization.Error._unknown(_response.error)
        };
      }
      async toggleStarBackground(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/starBackground"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await ToggleStarBackgroundRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.toggleStarBackground.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.toggleStarBackground.Error._unknown(_response.error)
        };
      }
      async deleteBackgroundV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/deleteBackgroundV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await DeleteBackgroundV2Request.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.deleteBackgroundV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.deleteBackgroundV2.Error._unknown(_response.error)
        };
      }
      async createOrganizationTemplate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/createOrganizationTemplate"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateOrganizationTemplateRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await OrganizationTemplate.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.createOrganizationTemplate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.createOrganizationTemplate.Error._unknown(_response.error)
        };
      }
      async deleteOrganizationTemplate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/deleteOrganizationTemplate"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await DeleteOrganizationTemplateRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.deleteOrganizationTemplate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.deleteOrganizationTemplate.Error._unknown(_response.error)
        };
      }
      async setDefaultTemplate(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/setDefaultTemplate"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetDefaultTemplateRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.setDefaultTemplate.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.setDefaultTemplate.Error._unknown(_response.error)
        };
      }
      async setDefaultBackgroundV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join30.default)(this.options.environment, "/templates/setDefaultBackgroundV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SetDefaultBackgroundV2Request.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await templates_exports2.setDefaultBackgroundV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.templates.setDefaultBackgroundV2.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/users/client/Client.ts
var import_url_join31, Users;
var init_Client37 = __esm({
  "src/api/resources/users/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join31 = __toESM(require_url_join());
    init_serialization();
    Users = class {
      constructor(options) {
        this.options = options;
      }
      async login() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/login"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await LoginResponseOldVersion.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            case "SSOEnabledEmail_ExternalEmailError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.login.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.login.Error._unknown(_response.error)
        };
      }
      async loginV2() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/loginV2"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await LoginResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "SSOEnabledEmail_OrganizationCreationNotAllowed":
            case "SSOEnabledEmail_ExternalEmailError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.loginV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.loginV2.Error._unknown(_response.error)
        };
      }
      async getUsers() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/getUsers"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await users_exports2.getUsers.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.getUsers.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.getUsers.Error._unknown(_response.error)
        };
      }
      async initialize(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/initialize"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await InitRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.initialize.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.initialize.Error._unknown(_response.error)
        };
      }
      async initializeV2(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/initializeV2"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await InitRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await ExtendedInitResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.initializeV2.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.initializeV2.Error._unknown(_response.error)
        };
      }
      async getAssociatedOrgs() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/getAssociatedOrgs"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await users_exports2.getAssociatedOrgs.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.getAssociatedOrgs.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.getAssociatedOrgs.Error._unknown(_response.error)
        };
      }
      async getUserForGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join31.default)(this.options.environment, "/users/getUserForGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await InitResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "UsageLimitExceededError":
            case "ActionNotPermittedError":
              return {
                ok: false,
                error: await users_exports2.getUserForGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.users.getUserForGuide.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/Client.ts
var GigaUserApiClient;
var init_Client38 = __esm({
  "src/Client.ts"() {
    "use strict";
    init_Client();
    init_Client2();
    init_Client3();
    init_Client4();
    init_Client7();
    init_Client8();
    init_Client17();
    init_Client18();
    init_Client19();
    init_Client21();
    init_Client25();
    init_Client27();
    init_Client33();
    init_Client34();
    init_Client35();
    init_Client36();
    init_Client37();
    GigaUserApiClient = class {
      constructor(options) {
        this.options = options;
      }
      _admin;
      get admin() {
        return this._admin ??= new Admin(this.options);
      }
      _analytics;
      get analytics() {
        return this._analytics ??= new Analytics(this.options);
      }
      _audio;
      get audio() {
        return this._audio ??= new Audio2(this.options);
      }
      _auth;
      get auth() {
        return this._auth ??= new Auth(this.options);
      }
      _collections;
      get collections() {
        return this._collections ??= new Collections(this.options);
      }
      _externalAuth;
      get externalAuth() {
        return this._externalAuth ??= new ExternalAuth(this.options);
      }
      _guides;
      get guides() {
        return this._guides ??= new Guides(this.options);
      }
      _healthcheck;
      get healthcheck() {
        return this._healthcheck ??= new Healthcheck(this.options);
      }
      _helpcenterQueries;
      get helpcenterQueries() {
        return this._helpcenterQueries ??= new HelpcenterQueries(this.options);
      }
      _helpcenter;
      get helpcenter() {
        return this._helpcenter ??= new Helpcenter(this.options);
      }
      _integrations;
      get integrations() {
        return this._integrations ??= new Integrations(this.options);
      }
      _internal;
      get internal() {
        return this._internal ??= new Internal(this.options);
      }
      _organizations;
      get organizations() {
        return this._organizations ??= new Organizations(this.options);
      }
      _posthog;
      get posthog() {
        return this._posthog ??= new Posthog(this.options);
      }
      _settings;
      get settings() {
        return this._settings ??= new Settings(this.options);
      }
      _templates;
      get templates() {
        return this._templates ??= new Templates(this.options);
      }
      _users;
      get users() {
        return this._users ??= new Users(this.options);
      }
    };
  }
});

// src/index.ts
var init_src = __esm({
  "src/index.ts"() {
    init_api();
    init_Client38();
  }
});
init_src();
export {
  api_exports as GigaUserApi,
  GigaUserApiClient
};
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

basic-auth/index.js:
  (*!
   * basic-auth
   * Copyright(c) 2013 TJ Holowaychuk
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2015-2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
